  let json_ = [
    {
      id: 2558,
      Area: "North",
      States: "Chandigarh",
      City: "Chandigarh",
      Category: 1,
      Store_name: "Triveni Sales Corporation",
      Contact_name: "Mr. Arun Gupta",
      Store_Address: "Plot No. 131, Industrial Area, Phase-1, Chandigarh",
      Mobile_No: 9876202700,
      Landline_No: "",
      Email: "trisurya@gmail.com",
      Pin_Code: 160002,
      DT: "NULL",
      Active: 0,
      Latitude: 30.6973,
      Longitude: 76.800911,
    },
    {
      id: 2559,
      Area: "North",
      States: "Chandigarh",
      City: "Chandigarh",
      Category: 1,
      Store_name: "Bharat Enterprises",
      Contact_name: "Mr. Rohit",
      Store_Address: "Plot No. 440, Industrial Area, Phase-2, Chandigarh",
      Mobile_No: 9815294202,
      Landline_No: "0172-5030440",
      Email: "bharatenterprises440@gmail.com",
      Pin_Code: 160002,
      DT: "NULL",
      Active: 0,
      Latitude: 30.7092263,
      Longitude: 76.8040393,
    },
    {
      id: 2560,
      Area: "North",
      States: "Chandigarh",
      City: "Chandigarh",
      Category: 1,
      Store_name: "paras hometech",
      Contact_name: "paramjeet",
      Store_Address: "sco-357-358, sector 35-b, chandigarh",
      Mobile_No: 8872972999,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 30.723965,
      Longitude: 76.763971,
    },
    {
      id: 2561,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "AM2PM MODULAR FURNITURES",
      Contact_name: "MR. AURBINDO MALHOTRA",
      Store_Address: "252-B, Ground Floor, Iskon Temple Road (Opp. Churc",
      Mobile_No: 8860899476,
      Landline_No: "",
      Email: "am2pmmod.kitchens@gmail.Com",
      Pin_Code: 110065,
      DT: "NULL",
      Active: 0,
      Latitude: 28.55588,
      Longitude: 77.249904,
    },
    {
      id: 2562,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "AMRIT TRADERS",
      Contact_name: "MR. ASHISH CHANANA",
      Store_Address: "F-75, JAGATPURI",
      Mobile_No: 9810135354,
      Landline_No: "",
      Email: "amrittradersestd1987@gmail.com",
      Pin_Code: 110051,
      DT: "NULL",
      Active: 0,
      Latitude: 28.646948,
      Longitude: 77.294555,
    },
    {
      id: 2563,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "BANGAL ELECTROPLEX",
      Contact_name: "MR. RAJEEV MADAN",
      Store_Address: "Shop No M- 8, Kalkaji Main Road, Kalkaji",
      Mobile_No: "98106 70450",
      Landline_No: "",
      Email: "",
      Pin_Code: 110019,
      DT: "NULL",
      Active: 0,
      Latitude: 28.541925,
      Longitude: 77.253759,
    },
    {
      id: 2564,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Bhagwati Kitchen Gallery",
      Contact_name: "Anit",
      Store_Address: "221-A 2,Rama Market,Pitampura,Delhi",
      Mobile_No: 9210641639,
      Landline_No: "",
      Email: "bansalanit.92@gmail.com",
      Pin_Code: 110034,
      DT: "NULL",
      Active: 0,
      Latitude: 28.700349,
      Longitude: 77.128487,
    },
    {
      id: 2565,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CARADORN",
      Contact_name: "MR. VIKRAM GULATI",
      Store_Address: "A- 369, NEHRU APPARTMENTS, KALKAJI",
      Mobile_No: 9891657057,
      Landline_No: "",
      Email: "vikram12nov@gmail.com",
      Pin_Code: 110019,
      DT: "NULL",
      Active: 0,
      Latitude: 28.544443,
      Longitude: 77.24732,
    },
    {
      id: 2566,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Classic Steel",
      Contact_name: "Hitesh",
      Store_Address: "C-3 1,Wazirpur industrial area,Delhi",
      Mobile_No: 9811241365,
      Landline_No: "",
      Email: "",
      Pin_Code: 110052,
      DT: "NULL",
      Active: 0,
      Latitude: 28.700288,
      Longitude: 77.168269,
    },
    {
      id: 2567,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA Plaza",
      Contact_name: "",
      Store_Address: "Situated at C-10, Rajouri Garden Ring Road , New Delhi",
      Mobile_No: "",
      Landline_No: "011-64644524",
      Email: "",
      Pin_Code: 110027,
      DT: "NULL",
      Active: 0,
      Latitude: 28.64925,
      Longitude: 77.125443,
    },
    {
      id: 2568,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "DELHI ELECTRIC CO.",
      Contact_name: "MR. ROHIT",
      Store_Address: "B-1, Gurudwara Rd, Block C, South Extension I, New",
      Mobile_No: 9810395539,
      Landline_No: "",
      Email: "",
      Pin_Code: 110049,
      DT: "NULL",
      Active: 0,
      Latitude: 28.569206,
      Longitude: 77.223271,
    },
    {
      id: 2569,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Designer Kitchen",
      Contact_name: "Punnet",
      Store_Address: "C-26A,Basement,Mansarovar Garden,Delhi",
      Mobile_No: 9810148579,
      Landline_No: "",
      Email: "designerkitchen2003@yahoo.com",
      Pin_Code: 110015,
      DT: "NULL",
      Active: 0,
      Latitude: 28.639195,
      Longitude: 77.133342,
    },
    {
      id: 2570,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Harmoh Enterprise",
      Contact_name: "Kuldeep",
      Store_Address: "S-4 7,Mahavir Nagar,1st floor,Near Janakpuri East",
      Mobile_No: 8588848862,
      Landline_No: "",
      Email: "harmohenterprises@yahoo.com",
      Pin_Code: 110018,
      DT: "NULL",
      Active: 0,
      Latitude: 28.633447,
      Longitude: 77.086598,
    },
    {
      id: 2571,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "JSR DISTRIBUTORS PVT. LTD.",
      Contact_name: "MR. NEERAJ ROHIL",
      Store_Address: "B-72, OKHLA INDUSTRIAL AREA PHASE 2",
      Mobile_No: 9350657307,
      Landline_No: "",
      Email: "jsr@jsrdelhi.com",
      Pin_Code: 110020,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5384,
      Longitude: 77.27854,
    },
    {
      id: 2572,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Kitchen Kreation",
      Contact_name: "Pooran",
      Store_Address: "G-36,2nd floor,Palam Ext.,Near Ramphal Chowk,secto",
      Mobile_No: 9310455518,
      Landline_No: "",
      Email: "kitchenkreations7@gmail.com",
      Pin_Code: 110078,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5904221,
      Longitude: 77.0718565,
    },
    {
      id: 2573,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "KOHLI APPLIANCES MART",
      Contact_name: "MR. VIJAY KOHLI",
      Store_Address: "561 Patpar Road Jheel",
      Mobile_No: 9891011182,
      Landline_No: "",
      Email: "",
      Pin_Code: 110051,
      DT: "NULL",
      Active: 0,
      Latitude: 28.65573,
      Longitude: 77.27631,
    },
    {
      id: 2574,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Mayur Electronics & Electricals",
      Contact_name: "Vijay",
      Store_Address: "WZ-901,Fateh Nagar,Near Aasha park more,Jail road,",
      Mobile_No: 9910491459,
      Landline_No: "",
      Email: "",
      Pin_Code: 110018,
      DT: "NULL",
      Active: 0,
      Latitude: 28.629573,
      Longitude: 77.099711,
    },
    {
      id: 2575,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "NEERU ELECTRONICS",
      Contact_name: "MR. RAJESH",
      Store_Address: "D-71, MAIN ROAD, MALVIYA NAGAR",
      Mobile_No: 9873731819,
      Landline_No: "",
      Email: "",
      Pin_Code: 110017,
      DT: "NULL",
      Active: 0,
      Latitude: 28.536915,
      Longitude: 77.212042,
    },
    {
      id: 2576,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Northern Timber",
      Contact_name: "Devesh",
      Store_Address: "A-106,Mohan Garden,main Najafgarh Road,Uttam nagar",
      Mobile_No: 9873177759,
      Landline_No: "",
      Email: "northerntraders@gmail.com",
      Pin_Code: 110059,
      DT: "NULL",
      Active: 0,
      Latitude: 28.620373,
      Longitude: 77.04021,
    },
    {
      id: 2577,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "S K Refrigeration",
      Contact_name: "Preetak",
      Store_Address: "1 1,Prem nagar,Double story(Tilak Nagar) Main Naja",
      Mobile_No: 9811883216,
      Landline_No: "",
      Email: "",
      Pin_Code: 110058,
      DT: "NULL",
      Active: 0,
      Latitude: 28.634658,
      Longitude: 77.092043,
    },
    {
      id: 2578,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 2,
      Store_name: "Shri Mangla Electronic",
      Contact_name: "Sumit:",
      Store_Address: "3-Vaishali Enclave, Pitampura, Opp Metro Pillor No",
      Mobile_No: 9990029119,
      Landline_No: "",
      Email: "",
      Pin_Code: 110034,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6996465,
      Longitude: 77.1378314,
    },
    {
      id: 2579,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "SINGHAL MARBLE HOUSE",
      Contact_name: "MR. YOGESH",
      Store_Address: "98, Samman Bazar Rd, Bhogal, Jangpura",
      Mobile_No: 9654982191,
      Landline_No: "",
      Email: "",
      Pin_Code: 110014,
      DT: "NULL",
      Active: 0,
      Latitude: 28.581776,
      Longitude: 77.249345,
    },
    {
      id: 2580,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Uma Refrigeration",
      Contact_name: "Deepak",
      Store_Address: "D-452&D-478,Plam Ext.Sector-7,Dwarka,Delhi-110",
      Mobile_No: 9810478228,
      Landline_No: "",
      Email: "deepak_kumraengg@yahoo.co.in",
      Pin_Code: 110075,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5842915,
      Longitude: 77.0715564,
    },
    {
      id: 2581,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address: "D-14, South Ex .Part 2, New Delhi",
      Mobile_No: "",
      Landline_No: "011-64649311 12",
      Email: "",
      Pin_Code: 110049,
      DT: "NULL",
      Active: 0,
      Latitude: 28.56827,
      Longitude: 77.22274,
    },
    {
      id: 2582,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address: "Pusa Road -- Plot No.3B, Pusa Road, New Delhi-110 005",
      Mobile_No: "",
      Landline_No: "011-64670884",
      Email: "",
      Pin_Code: 110005,
      DT: "NULL",
      Active: 0,
      Latitude: 28.64549,
      Longitude: 77.19679,
    },
    {
      id: 2583,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Soul City Mall, Radisson Hotel, situated at , Plot No.4, Sector -13, Dwarka, New Delhi – 110075.",
      Mobile_No: "",
      Landline_No: "011-64691914",
      Email: "",
      Pin_Code: 110075,
      DT: "NULL",
      Active: 0,
      Latitude: 28.59785,
      Longitude: 77.03823,
    },
    {
      id: 2584,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "S-232,2nd FLR,Ambience Mall,Land Bearing No.2, Vasant Kunj,Phase 2, Nelson Mandela Road,New Delhi,110070",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 110070,
      DT: "NULL",
      Active: 0,
      Latitude: 28.51244,
      Longitude: 77.137009,
    },
    {
      id: 2585,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address: "27, Bunglow Road, Kamla Nagar, New Delhi - 110007",
      Mobile_No: "",
      Landline_No: "011-47124100 10",
      Email: "",
      Pin_Code: 110007,
      DT: "NULL",
      Active: 0,
      Latitude: 28.678583,
      Longitude: 77.191582,
    },
    {
      id: 2586,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unity one-janakpuri,Multilevel Car Parking ,Shop no G6,G7, F6 & F7 ,Janakpuri west metro station ,Near Metro Piller No :- 600 ,New Delhi Pin code :- 110058",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 110058,
      DT: "NULL",
      Active: 0,
      Latitude: 28.63096,
      Longitude: 77.08095,
    },
    {
      id: 2587,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Plot No.C-53, Preet Vihar, Vikas Marg, New Delhi-110 092.",
      Mobile_No: "",
      Landline_No: "011-64692182  8",
      Email: "",
      Pin_Code: 110092,
      DT: "NULL",
      Active: 0,
      Latitude: 28.627911,
      Longitude: 77.254822,
    },
    {
      id: 2588,
      Area: "North",
      States: "Delhi",
      City: "Rohini",
      Category: 1,
      Store_name: "Croma, Vikas Surya Shopping Mall",
      Contact_name: "",
      Store_Address: "Plot No. 18, Mangalam Place,Sector -3 ,Rohini ,Delhi",
      Mobile_No: "",
      Landline_No: "011-47124200 21",
      Email: "",
      Pin_Code: 110085,
      DT: "NULL",
      Active: 0,
      Latitude: 28.715345,
      Longitude: 77.108803,
    },
    {
      id: 2589,
      Area: "North",
      States: "Haryana",
      City: "Ambala",
      Category: 1,
      Store_name: "Royal Plywood",
      Contact_name: "Mr. Rishi Parwanda",
      Store_Address: "799 11, Sharda Nagar, Jalbera Road, Near Sai Baba",
      Mobile_No: 9999773333,
      Landline_No: "",
      Email: "royalplywood.amb@gmail.com",
      Pin_Code: 134003,
      DT: "NULL",
      Active: 0,
      Latitude: 28.640671,
      Longitude: 77.212761,
    },
    {
      id: 2590,
      Area: "North",
      States: "Haryana",
      City: "Ambala",
      Category: 1,
      Store_name: "Taneja Interiors",
      Contact_name: "Mr. Aman Taneja",
      Store_Address: "# 158, Gobind Nagar, Near Brahm Kumari Chowk, Amba",
      Mobile_No: "",
      Landline_No: "0171-4009199",
      Email: "tanejaaman466@gmail.com",
      Pin_Code: 133001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.53612,
      Longitude: 77.21138,
    },
    {
      id: 2591,
      Area: "North",
      States: "Haryana",
      City: "Faridabad",
      Category: 1,
      Store_name: "Croma Crown Faridabad",
      Contact_name: "",
      Store_Address:
        "Crown Faridabad, 1st Floor, Crown Mall 12 7, main Mathura Road, NH2, Faridabad - 121003",
      Mobile_No: "",
      Landline_No: "0129-4280418",
      Email: "",
      Pin_Code: 121003,
      DT: "NULL",
      Active: 0,
      Latitude: 28.453861,
      Longitude: 77.303276,
    },
    {
      id: 2592,
      Area: "North",
      States: "Haryana",
      City: "Faridabad",
      Category: 1,
      Store_name: "Kitchen Koncept",
      Contact_name: "mr. suresh kumar",
      Store_Address: "1-f 38, bp, 1st floor, nit 1, opp vaishno devi man",
      Mobile_No: 9818632266,
      Landline_No: "",
      Email: "ji.suresh@ymail.com",
      Pin_Code: 121001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.384596,
      Longitude: 77.29787,
    },
    {
      id: 2593,
      Area: "North",
      States: "Haryana",
      City: "Faridabad",
      Category: 1,
      Store_name: "Kitchen Koncept",
      Contact_name: "mr. suresh kumar",
      Store_Address: "tigaon road, sec 86, near village budena, greater",
      Mobile_No: 9818632266,
      Landline_No: "",
      Email: "kitchenkoncept385@gmail.com",
      Pin_Code: 121001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.384596,
      Longitude: 77.29787,
    },
    {
      id: 2594,
      Area: "North",
      States: "Haryana",
      City: "Faridabad",
      Category: 1,
      Store_name: "Satya ADS",
      Contact_name: "devender",
      Store_Address: "shop no 174 175 first floor nit faridabad",
      Mobile_No: 9810649744,
      Landline_No: "",
      Email: "ads77@yahoo.com",
      Pin_Code: 121001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.385305,
      Longitude: 77.298227,
    },
    {
      id: 2596,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground & Mezzanine Floor, Universal Trade Tower, Sector 49, Sohna Road, Gurgaon – 122018.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 122018,
      DT: "NULL",
      Active: 1,
      Latitude: 28.418081,
      Longitude: 77.05069,
    },
    {
      id: 2597,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground, First & Basement of SCO No.313 and First Floor,SCO No. 314, Sector 29, Gurgaon – 122002",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 122002,
      DT: "NULL",
      Active: 1,
      Latitude: 28.47468,
      Longitude: 77.104897,
    },
    {
      id: 2598,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Croma Ambience Mall",
      Contact_name: "",
      Store_Address:
        "Ambience Mall, S-207,208,2nd Floor,Ambience Mall,Ambience Island, NH-8,Gurgaon,122001",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 122001,
      DT: "NULL",
      Active: 1,
      Latitude: 28.455473,
      Longitude: 77.021904,
    },
    {
      id: 2599,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Himadri bath solutions",
      Contact_name: "bharat gupta",
      Store_Address: "sco 26 , huda jail complex sohna chowk , near sada",
      Mobile_No: 9910613355,
      Landline_No: "",
      Email: "himadri.bath@hotmail.com",
      Pin_Code: 122001,
      DT: "NULL",
      Active: 1,
      Latitude: 28.458101,
      Longitude: 77.026541,
    },
    {
      id: 2600,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Kamal Enterprises",
      Contact_name: "Mr.Kamal Ahmed",
      Store_Address: "CG-63, Arcadia South City -II, Gurgaon",
      Mobile_No: 7838380520,
      Landline_No: "",
      Email: "99kamal@gmail.com",
      Pin_Code: 122018,
      DT: "NULL",
      Active: 1,
      Latitude: 28.4601,
      Longitude: 77.02635,
    },
    {
      id: 2601,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "MGM CUCINE",
      Contact_name: "Gaurav Malik",
      Store_Address: "SCO 310, 2ND Floor, Sector 29 Gurgaon, Haryana",
      Mobile_No: 9999992220,
      Landline_No: "",
      Email: "mgmcucine@gmail.com",
      Pin_Code: 122009,
      DT: "NULL",
      Active: 1,
      Latitude: 28.47279,
      Longitude: 77.06324,
    },
    {
      id: 2602,
      Area: "North",
      States: "Haryana",
      City: "Hisar",
      Category: 1,
      Store_name: "aditya sales corporation",
      Contact_name: "mr. sc aggarwal",
      Store_Address: "jindal hospital road, model town",
      Mobile_No: "9034668444, 9812007244",
      Landline_No: "",
      Email: "adityasales.india@gmail.com",
      Pin_Code: 125001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2603,
      Area: "North",
      States: "Haryana",
      City: "Kaithal",
      Category: 1,
      Store_name: "Mann Home Décor",
      Contact_name: "Suresh",
      Store_Address: "1450 51,1st Floor,opp OBC Bank,Ambala road,kaithal",
      Mobile_No: 8950311101,
      Landline_No: "",
      Email: "",
      Pin_Code: 136027,
      DT: "NULL",
      Active: 0,
      Latitude: 29.8163036,
      Longitude: 76.4151866,
    },
    {
      id: 2604,
      Area: "North",
      States: "Haryana",
      City: "Kaithal",
      Category: 1,
      Store_name: "Pearl Plywood",
      Contact_name: "rajesh",
      Store_Address: "old Bye pass,kurukshetra raod,Near Royal Enfield a",
      Mobile_No: 8607508000,
      Landline_No: "",
      Email: "",
      Pin_Code: 136027,
      DT: "NULL",
      Active: 0,
      Latitude: 29.8066641,
      Longitude: 76.4093154,
    },
    {
      id: 2605,
      Area: "North",
      States: "Haryana",
      City: "Karnal",
      Category: 1,
      Store_name: "Madhav Stores",
      Contact_name: "Hemant",
      Store_Address: "Opp.K R Cinema,Meerut Road,Karnal",
      Mobile_No: 9813443978,
      Landline_No: "",
      Email: "madhavstores@gmail.com",
      Pin_Code: 132001,
      DT: "NULL",
      Active: 1,
      Latitude: 29.6773112,
      Longitude: 76.9977584,
    },
    {
      id: 2606,
      Area: "North",
      States: "Haryana",
      City: "Kurukshetra",
      Category: 1,
      Store_name: "Amir Chand & Sons",
      Contact_name: "Pankaj",
      Store_Address: "Shop No.-5,Baba Sharwan nath market,Near Birla Man",
      Mobile_No: 9812033848,
      Landline_No: "",
      Email: "",
      Pin_Code: 136118,
      DT: "NULL",
      Active: 0,
      Latitude: 29.9667678,
      Longitude: 76.8288027,
    },
    {
      id: 2607,
      Area: "North",
      States: "Haryana",
      City: "Kurukshetra",
      Category: 1,
      Store_name: "Sood Plywood Co.",
      Contact_name: "Sanjeev Sood",
      Store_Address: "opp sector-7,Pipli Road,Kurukshetra",
      Mobile_No: 9416035003,
      Landline_No: "",
      Email: "",
      Pin_Code: 136118,
      DT: "NULL",
      Active: 0,
      Latitude: 29.97465,
      Longitude: 76.8734922,
    },
    {
      id: 2608,
      Area: "North",
      States: "Haryana",
      City: "Kurukshetra",
      Category: 1,
      Store_name: "Swastik Buliding Material",
      Contact_name: "Hemant Garg",
      Store_Address: "Shop No.-93,sector-3,urban Estate,Kurukshetra",
      Mobile_No: 9813840322,
      Landline_No: "",
      Email: "",
      Pin_Code: 136118,
      DT: "NULL",
      Active: 0,
      Latitude: 29.9606631,
      Longitude: 76.8908563,
    },
    {
      id: 2609,
      Area: "North",
      States: "Haryana",
      City: "Panchkula",
      Category: 1,
      Store_name: "Ajay Electrical Store",
      Contact_name: "Mr. Ajay Gupta",
      Store_Address: "SCO 10, Sector 12-A, Rally, Panchkula (Haryana)",
      Mobile_No: 9872500511,
      Landline_No: "0172-2573418",
      Email: "ajayelectricstore@yahoo.com",
      Pin_Code: 134109,
      DT: "NULL",
      Active: 0,
      Latitude: 28.46895,
      Longitude: 77.02802,
    },
    {
      id: 2610,
      Area: "North",
      States: "Haryana",
      City: "Panchkula",
      Category: 1,
      Store_name: "Jainsons",
      Contact_name: "Mr. Pankaj Jain",
      Store_Address: "Plot No.192-93, Industrial Area, Phase-2, Panchkul",
      Mobile_No: 9814122963,
      Landline_No: "",
      Email: "jainsons193@gmail.com",
      Pin_Code: 134109,
      DT: "NULL",
      Active: 0,
      Latitude: 30.68378,
      Longitude: 76.83115,
    },
    {
      id: 2611,
      Area: "North",
      States: "Haryana",
      City: "Panipat",
      Category: 1,
      Store_name: "Arihant Ceramics Gallery",
      Contact_name: "Varun Jain",
      Store_Address: "sco12,Sector-25,Near Malik Petrol Pump,G T Road Pa",
      Mobile_No: 9254004234,
      Landline_No: "",
      Email: "arihantceramic.pnp@gmail.com",
      Pin_Code: 132103,
      DT: "NULL",
      Active: 0,
      Latitude: 29.3759217,
      Longitude: 76.9751383,
    },
    {
      id: 2612,
      Area: "North",
      States: "Haryana",
      City: "Panipat",
      Category: 1,
      Store_name: "Mahadev Sales Corporation",
      Contact_name: "Dheeraj Bareja",
      Store_Address: "Opp Petrol Pump,Barsat Road,Noorwala,Panipat",
      Mobile_No: 9812066686,
      Landline_No: "",
      Email: "",
      Pin_Code: 132103,
      DT: "NULL",
      Active: 0,
      Latitude: 29.4142563,
      Longitude: 76.9762702,
    },
    {
      id: 2613,
      Area: "North",
      States: "Haryana",
      City: "Rohtak",
      Category: 1,
      Store_name: "Ram ji Ply & Hardware Zone",
      Contact_name: "Sanchit Aeron",
      Store_Address:
        "Near Anand Plaza, Beside tanishq Showroom, Chhotu Raam Chowk, Rohtak",
      Mobile_No: "9034747108, 741",
      Landline_No: "",
      Email: "ramjirtk@gmail.com",
      Pin_Code: 124001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.893398,
      Longitude: 76.598785,
    },
    {
      id: 2614,
      Area: "North",
      States: "Haryana",
      City: "Yamuna Nagar",
      Category: 1,
      Store_name: "Maa Durga Hardware Store",
      Contact_name: "Mohit Bansal",
      Store_Address: "Railway Road,Jagaghari",
      Mobile_No: 9996193350,
      Landline_No: "",
      Email: "",
      Pin_Code: 135003,
      DT: "NULL",
      Active: 0,
      Latitude: 30.1637503,
      Longitude: 77.3022317,
    },
    {
      id: 2615,
      Area: "North",
      States: "Haryana",
      City: "Yamuna Nagar",
      Category: 1,
      Store_name: "New Perfect Electrocare",
      Contact_name: "gurvinder singh",
      Store_Address: "shop no 1, plot no 26, tagore garden, near dabra h",
      Mobile_No: 9671396623,
      Landline_No: "",
      Email: "kgurvindersingh77@yahoo.com",
      Pin_Code: 135001,
      DT: "NULL",
      Active: 0,
      Latitude: 30.137145,
      Longitude: 77.274983,
    },
    {
      id: 2616,
      Area: "North",
      States: "Haryana",
      City: "Yamuna Nagar",
      Category: 1,
      Store_name: "Sethi Hardware",
      Contact_name: "Vishwas Sethi",
      Store_Address: "Kanhaiya Sahib Chowk,Yamunnagar",
      Mobile_No: 9896999673,
      Landline_No: "",
      Email: "",
      Pin_Code: 135003,
      DT: "NULL",
      Active: 0,
      Latitude: 30.1290485,
      Longitude: 77.2673901,
    },
    {
      id: 2617,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Shimla",
      Category: 1,
      Store_name: "Furniture Care",
      Contact_name: "Mr. Parkash Chand",
      Store_Address: "Shop No. 30, Old Post Office, Boileauganj, Shimla",
      Mobile_No: 9418500087,
      Landline_No: "",
      Email: "furniturecare00087@gmail.com",
      Pin_Code: 171005,
      DT: "NULL",
      Active: 0,
      Latitude: 31.0995816,
      Longitude: 77.1378596,
    },
    {
      id: 2618,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Shimla",
      Category: 1,
      Store_name: "Sevti Associates",
      Contact_name: "Mr. Manoj Kumar Verma",
      Store_Address: "Near Central Bank of India, VPO Kasumpti, Distt. S",
      Mobile_No: 9418576885,
      Landline_No: "",
      Email: "sevti.associates@gmail.com",
      Pin_Code: 171009,
      DT: "NULL",
      Active: 0,
      Latitude: 31.0782275,
      Longitude: 77.1822719,
    },
    {
      id: 2619,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Jammu",
      Category: 1,
      Store_name: "Best Price Tiles and Sanitary",
      Contact_name: "",
      Store_Address: "Near Satwari Chowk, Airport Road, Jammu",
      Mobile_No: 9419174503,
      Landline_No: "",
      Email: "",
      Pin_Code: 180001,
      DT: "NULL",
      Active: 0,
      Latitude: 24.416786,
      Longitude: 54.461772,
    },
    {
      id: 2620,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "JAMMU",
      Category: 1,
      Store_name: "KAILASH TRADERS",
      Contact_name: "Mr. Munish",
      Store_Address: "jewel chowk canal road, jammu",
      Mobile_No: 9596885353,
      Landline_No: "",
      Email: "kailashtraders.jammu@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 32.7258065,
      Longitude: 74.8560006,
    },
    {
      id: 2621,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Jammu",
      Category: 1,
      Store_name: "MITTAL HOME STORE",
      Contact_name: "",
      Store_Address: "MARBLE MARKET, NEAR J&K BANK",
      Mobile_No: 9419195791,
      Landline_No: "",
      Email: "",
      Pin_Code: 180012,
      DT: "NULL",
      Active: 0,
      Latitude: 32.686117,
      Longitude: 74.883826,
    },
    {
      id: 2622,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Jammu",
      Category: 1,
      Store_name: "MITTAL HOME STORE",
      Contact_name: "",
      Store_Address: "MARBLE MARKET, NEAR J&K BANK",
      Mobile_No: 9419195791,
      Landline_No: "",
      Email: "",
      Pin_Code: 180012,
      DT: "NULL",
      Active: 1,
      Latitude: 32.686117,
      Longitude: 74.883826,
    },
    {
      id: 2623,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Jammu",
      Category: 1,
      Store_name: "Rahuldeep Electronics",
      Contact_name: "kuldeep singh",
      Store_Address: "sec 04, near janta floor mills, gangyal",
      Mobile_No: 9796210165,
      Landline_No: "",
      Email: "kuldeepjamwal72@gmail.com",
      Pin_Code: 180010,
      DT: "NULL",
      Active: 0,
      Latitude: 32.67086,
      Longitude: 74.864583,
    },
    {
      id: 2624,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Ladakh",
      Category: 1,
      Store_name: "Elegant Enterprises",
      Contact_name: "",
      Store_Address: "Shop no -3, Nima House, GH Road, Skara, Leh - Ladakh",
      Mobile_No: 9469548033,
      Landline_No: "",
      Email: "",
      Pin_Code: 194101,
      DT: "NULL",
      Active: 0,
      Latitude: 34.1560519,
      Longitude: 77.5704181,
    },
    {
      id: 2625,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Srinagar",
      Category: 1,
      Store_name: "Electronic Brain",
      Contact_name: "abdul majeed mir",
      Store_Address: "hari singh high street , near lal chowk , srinagar",
      Mobile_No: 9469773591,
      Landline_No: "",
      Email: "arif.bashir.mir.78@gmail.com",
      Pin_Code: 190001,
      DT: "NULL",
      Active: 1,
      Latitude: 34.069835,
      Longitude: 74.809036,
    },
    {
      id: 2626,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Srinagar",
      Category: 1,
      Store_name: "Electronic Brain",
      Contact_name: "abdul majeed mir",
      Store_Address: "hari singh high street , near lal chowk , srinagar",
      Mobile_No: 9469773591,
      Landline_No: "",
      Email: "arif.bashir.mir.78@gmail.com",
      Pin_Code: 190001,
      DT: "NULL",
      Active: 1,
      Latitude: 34.069835,
      Longitude: 74.809036,
    },
    {
      id: 2627,
      Area: "North",
      States: "Punjab",
      City: "Amritsar",
      Category: 1,
      Store_name: "VR Enterprises",
      Contact_name: "v r tiwary",
      Store_Address: "42, preet avenue, near hanuman temple, near spring",
      Mobile_No: 9988219923,
      Landline_No: "",
      Email: "vrenterprises.164@rediffmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 1,
      Latitude: 31.650152,
      Longitude: 74.874214,
    },
    {
      id: 2628,
      Area: "North",
      States: "Punjab",
      City: "Bhatinda",
      Category: 1,
      Store_name: "Parmar Marketing",
      Contact_name: "Mr. Sundip parmar",
      Store_Address: "Sco 56,Bharat Nagar, Bibi Wala Road, Bathinda.",
      Mobile_No: "",
      Landline_No: 1645000286,
      Email: "",
      Pin_Code: 151001,
      DT: "NULL",
      Active: 0,
      Latitude: 30.23579,
      Longitude: 74.97057,
    },
    {
      id: 2629,
      Area: "North",
      States: "Punjab",
      City: "Bhatinda",
      Category: 1,
      Store_name: "Aditya Electronics",
      Contact_name: "manoj maheshwary",
      Store_Address: "near annapurna mandir, amrik singh road. bathinda",
      Mobile_No: 9888604054,
      Landline_No: "",
      Email: "aditya.electronics@outlook.com",
      Pin_Code: 151001,
      DT: "NULL",
      Active: 0,
      Latitude: 30.217037,
      Longitude: 74.934795,
    },
    {
      id: 2630,
      Area: "North",
      States: "Punjab",
      City: "Bhatinda",
      Category: 1,
      Store_name: "Real Solution Point",
      Contact_name: "rajan singh",
      Store_Address: "St-9a, Ajit road",
      Mobile_No: 9041378242,
      Landline_No: "",
      Email: "rajanifb@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 30.210852,
      Longitude: 74.949595,
    },
    {
      id: 2631,
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 1,
      Store_name: "Triveni Sales Corporation",
      Contact_name: "Mr. Arun Gupta",
      Store_Address: "Plot No. 131, Industrial Area, Phase-1, Chandigarh",
      Mobile_No: 9876202700,
      Landline_No: "",
      Email: "trisurya@gmail.com",
      Pin_Code: 160002,
      DT: "NULL",
      Active: 0,
      Latitude: 30.6973,
      Longitude: 76.800911,
    },
    {
      id: 2632,
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 1,
      Store_name: "Bharat Enterprises",
      Contact_name: "Mr. Rohit",
      Store_Address: "Plot No. 440, Industrial Area, Phase-2, Chandigarh",
      Mobile_No: 9815294202,
      Landline_No: "0172-5030440",
      Email: "bharatenterprises440@gmail.com",
      Pin_Code: 160002,
      DT: "NULL",
      Active: 0,
      Latitude: 30.7092263,
      Longitude: 76.8040393,
    },
    {
      id: 2633,
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground and Basement, Building at SCO No-57,Sector 26,Madya Marg,Chandigarh-160101",
      Mobile_No: "",
      Landline_No: 9988594644,
      Email: "",
      Pin_Code: 160101,
      DT: "NULL",
      Active: 0,
      Latitude: 30.7649,
      Longitude: 76.77133,
    },
    {
      id: 2634,
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground &First Floor,Building SCO No.1094-1095,Sector 22B,Chandigarh-160022",
      Mobile_No: "",
      Landline_No: "0172-6050008",
      Email: "",
      Pin_Code: 160022,
      DT: "NULL",
      Active: 0,
      Latitude: 30.73335,
      Longitude: 76.77904,
    },
    {
      id: 2635,
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 1,
      Store_name: "Paras Hometech",
      Contact_name: "Mr. Sanjay",
      Store_Address: "SCO 357-58, Sector 35-B, Chandigarh",
      Mobile_No: 9814006404,
      Landline_No: "0172-2603617",
      Email: "sanjaymehta503@yahoo.co.in",
      Pin_Code: 160022,
      DT: "NULL",
      Active: 0,
      Latitude: 30.723965,
      Longitude: 76.763971,
    },
    {
      id: 2636,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "VK Trading Corporation",
      Contact_name: "mr. manik gupta",
      Store_Address: "jail road, jalandhar,jalandhar",
      Mobile_No: "",
      Landline_No: "",
      Email: "manikgupta18@gmail.com",
      Pin_Code: 144008,
      DT: "NULL",
      Active: 1,
      Latitude: 31.33174,
      Longitude: 75.56674,
    },
    {
      id: 2637,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "Bhandari Overses",
      Contact_name: "mr.bhupnder   mr. manmohan bhandari",
      Store_Address: "Kapurthala Chownk, Near Joshi hospital, Jalandhar",
      Mobile_No: "9888127788, 921",
      Landline_No: "",
      Email: "bhandari_overseas2008@yahoo.com",
      Pin_Code: 144001,
      DT: "NULL",
      Active: 1,
      Latitude: 31.334143,
      Longitude: 75.563249,
    },
    {
      id: 2638,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "Croma Jalandhar",
      Contact_name: "",
      Store_Address:
        "Jalandhar, Ground & First Floor260, LAJPAT NAGAR,Jalandhar,144001",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 144001,
      DT: "NULL",
      Active: 0,
      Latitude: 31.31818,
      Longitude: 75.57216,
    },
    {
      id: 2639,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "J K associates",
      Contact_name: "dhiraj bahree",
      Store_Address: "kotwali bazar, jalandhar",
      Mobile_No: 8872192900,
      Landline_No: "",
      Email: "dbahree@yahoo.co.in",
      Pin_Code: 144008,
      DT: "NULL",
      Active: 1,
      Latitude: 31.332265,
      Longitude: 75.571256,
    },
    {
      id: 2640,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "J K associates",
      Contact_name: "dhiraj bahree",
      Store_Address: "kotwali bazar, jalandhar",
      Mobile_No: 8872192900,
      Landline_No: "",
      Email: "dbahree@yahoo.co.in",
      Pin_Code: 144008,
      DT: "NULL",
      Active: 1,
      Latitude: 31.332265,
      Longitude: 75.571256,
    },
    {
      id: 2641,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "Punjab Electro World",
      Contact_name: "satnam singh",
      Store_Address: "shop no 12 (basement) , monika tower , milap chowk",
      Mobile_No: 9815669992,
      Landline_No: "",
      Email: "punjab_inalsa@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 1,
      Latitude: 31.327819,
      Longitude: 75.580471,
    },
    {
      id: 2642,
      Area: "North",
      States: "Punjab",
      City: "Kot Kapura",
      Category: 1,
      Store_name: "Nav Bharat Decorates",
      Contact_name: "",
      Store_Address: "Jaitu Road, Kot Kapura, Punjab",
      Mobile_No: 9915909990,
      Landline_No: "",
      Email: "",
      Pin_Code: 151204,
      DT: "NULL",
      Active: 0,
      Latitude: 30.610107,
      Longitude: 74.82937,
    },
    {
      id: 2644,
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 1,
      Store_name: "CHOUDHARY CROCKRY",
      Contact_name: "",
      Store_Address: "GHUMAR MANDI",
      Mobile_No: 9872800328,
      Landline_No: "",
      Email: "",
      Pin_Code: 141001,
      DT: "NULL",
      Active: 0,
      Latitude: 30.905256,
      Longitude: 75.832271,
    },
    {
      id: 2645,
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 1,
      Store_name: "choudhary crockry",
      Contact_name: "sumeet",
      Store_Address: "ghumar mandi, ludhiana",
      Mobile_No: 9872800328,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 30.905256,
      Longitude: 75.832271,
    },
    {
      id: 2649,
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 1,
      Store_name: "Rising Sun Furnishers",
      Contact_name: "Munish Beri and Mansi Beri",
      Store_Address: "SCO-23, Sector 32-A, Chandigarh Road, Ludhiana",
      Mobile_No: "8437024368, 987",
      Landline_No: "",
      Email: "risingsunfurnishers@gmail.com",
      Pin_Code: 141014,
      DT: "NULL",
      Active: 0,
      Latitude: 30.90015,
      Longitude: 75.85229,
    },
    {
      id: 2650,
      Area: "North",
      States: "Punjab",
      City: "Mohali",
      Category: 1,
      Store_name: "Kabir The Electronic Planet",
      Contact_name: "Mr. Manish Chug",
      Store_Address: "S.C.O 11, Kalgidhar Enclave, Zirakpur Kalka Highway",
      Mobile_No: 8872007363,
      Landline_No: "",
      Email: "kabirelectronics2003@gmail.com",
      Pin_Code: 140603,
      DT: "NULL",
      Active: 0,
      Latitude: 30.7048207,
      Longitude: 76.6648428,
    },
    {
      id: 2651,
      Area: "North",
      States: "Punjab",
      City: "Mohali",
      Category: 1,
      Store_name: "Kabir The Electronic Planet",
      Contact_name: "Mr. Manish Chug",
      Store_Address: "Jay Gee Tower, Chandigarh Kharar Highway, Opposite",
      Mobile_No: 8872007301,
      Landline_No: "",
      Email: "kabirelectronics2003@gmail.com",
      Pin_Code: 140301,
      DT: "NULL",
      Active: 0,
      Latitude: 30.7048207,
      Longitude: 76.6648428,
    },
    {
      id: 2652,
      Area: "North",
      States: "Punjab",
      City: "Mohali",
      Category: 1,
      Store_name: "Kabir The Electronic Planet",
      Contact_name: "Mr. Manish Chug",
      Store_Address: "SCF 95, Phase-7 Mohali (Punjab)",
      Mobile_No: 8872008839,
      Landline_No: "",
      Email: "kabirelectronics2003@gmail.com",
      Pin_Code: 160062,
      DT: "NULL",
      Active: 0,
      Latitude: 30.732274,
      Longitude: 76.6282467,
    },
    {
      id: 2653,
      Area: "North",
      States: "Punjab",
      City: "Mohali",
      Category: 1,
      Store_name: "Krishna Electronics",
      Contact_name: "Mr. Raj Agnihotri",
      Store_Address: "Shop No.182, Dashmesh Market, Balongi (Punjab)",
      Mobile_No: "",
      Landline_No: "0172-2277082",
      Email: "krishnaelectronics1@gmail.com",
      Pin_Code: 160055,
      DT: "NULL",
      Active: 0,
      Latitude: 30.7322649,
      Longitude: 76.6282467,
    },
    {
      id: 2654,
      Area: "North",
      States: "Punjab",
      City: "Mohali",
      Category: 1,
      Store_name: "Krishna Sales",
      Contact_name: "Mr. Arvind Kapoor",
      Store_Address: "Main Bazar, Derabassi (Punjab)",
      Mobile_No: "",
      Landline_No: "01762-281970",
      Email: "arvindkapoor.krishna sales@gmail.com",
      Pin_Code: 140507,
      DT: "NULL",
      Active: 0,
      Latitude: 30.5868354,
      Longitude: ",76.8432111",
    },
    {
      id: 2655,
      Area: "North",
      States: "Punjab",
      City: "Mohali",
      Category: 1,
      Store_name: "Vee Kay Distributors",
      Contact_name: "Mr. Kashish Gupta",
      Store_Address: "Shop No. 1-2 Block B, Near IDBI Bank, VIP Road, Zi",
      Mobile_No: "",
      Landline_No: "",
      Email: "veekay.retail@gmail.com",
      Pin_Code: 140603,
      DT: "NULL",
      Active: 0,
      Latitude: 30.637696,
      Longitude: 76.8110006,
    },
    {
      id: 2656,
      Area: "North",
      States: "Punjab",
      City: "Mohali",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No.G-17, 18, 19 and F-17, 18, 19, Ground and First Floor, VR Punjab, NH-21, Mohali Kharar Road, Mohali, S.A.S Nagar, Punjab- 160055",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 160055,
      DT: "NULL",
      Active: 0,
      Latitude: 30.72533,
      Longitude: 76.69768,
    },
    {
      id: 2657,
      Area: "North",
      States: "Punjab",
      City: "Sangrur",
      Category: 1,
      Store_name: "Woodgrace Modular Furniture Pvt Ltd",
      Contact_name: "",
      Store_Address: "Near Kaheroo, Sherpur Bye Pass Road, Dhuri, Sangrur",
      Mobile_No: 8437000180,
      Landline_No: "",
      Email: "",
      Pin_Code: 148024,
      DT: "NULL",
      Active: 0,
      Latitude: 30.37,
      Longitude: 75.87,
    },
    {
      id: 2658,
      Area: "North",
      States: "Punjab",
      City: "Zirakpur",
      Category: 1,
      Store_name: "Shri Hari Enterprises",
      Contact_name: "Mr. Pushkal Singhal",
      Store_Address: "Shop No. 1 ,Shree Krishna Complex, Behind Hotel Ro",
      Mobile_No: "",
      Landline_No: "",
      Email: "pushkalsinghal@gmail.com",
      Pin_Code: 140603,
      DT: "NULL",
      Active: 0,
      Latitude: 30.661321,
      Longitude: 76.8579523,
    },
    {
      id: 2659,
      Area: "North",
      States: "Rajasthan",
      City: "Ajmer",
      Category: 1,
      Store_name: "V.K.Hardware Store Ajmer",
      Contact_name: "mr. suresh madani",
      Store_Address: "6 7 bandanwara house, mahaveer market, madar gate",
      Mobile_No: 9351570700,
      Landline_No: "",
      Email: "vkstore@yahoo.co.in",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 26.4615435,
      Longitude: 74.6323312,
    },
    {
      id: 2660,
      Area: "North",
      States: "Rajasthan",
      City: "Bikaner",
      Category: 1,
      Store_name: "Gupta Sales Corporation Bikaner",
      Contact_name: "mr alok gupta",
      Store_Address: "63 sadul gunj bikanear",
      Mobile_No: 9413384800,
      Landline_No: "",
      Email: "guptasalesbkn@gmail.com",
      Pin_Code: 334001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.010599,
      Longitude: 73.3318828,
    },
    {
      id: 2661,
      Area: "North",
      States: "Rajasthan",
      City: "Jaipur",
      Category: 1,
      Store_name: "Home Style",
      Contact_name: "mr.nitin modi",
      Store_Address: "18-19 sunny mart ,new atish market jaipur",
      Mobile_No: 9413205222,
      Landline_No: "",
      Email: "nitin87modi@gmail.com",
      Pin_Code: 302020,
      DT: "NULL",
      Active: 0,
      Latitude: 26.879266,
      Longitude: 75.75887,
    },
    {
      id: 2662,
      Area: "North",
      States: "Rajasthan",
      City: "Jaipur",
      Category: 1,
      Store_name: "Kwality Ceramics",
      Contact_name: "Nikhil Aggrawal",
      Store_Address: "Shop No- 44, New Atish Market, Jaipur",
      Mobile_No: 7726978007,
      Landline_No: "",
      Email: "antiqueceramic20@gmail.com",
      Pin_Code: 302020,
      DT: "NULL",
      Active: 0,
      Latitude: 26.886819,
      Longitude: 75.76238,
    },
    {
      id: 2663,
      Area: "North",
      States: "Rajasthan",
      City: "Jaipur",
      Category: 1,
      Store_name: "Safex Technologies",
      Contact_name: "mr.laxman advani",
      Store_Address: "b 29 basement near barat khana govind marg, adarsh",
      Mobile_No: 9829084896,
      Landline_No: "",
      Email: "safextechnologies2002@yahoo.co.in",
      Pin_Code: 302005,
      DT: "NULL",
      Active: 0,
      Latitude: 26.877127,
      Longitude: 75.798057,
    },
    {
      id: 2664,
      Area: "North",
      States: "Rajasthan",
      City: "Kota",
      Category: 1,
      Store_name: "Kitchen Kraft Kota",
      Contact_name: "mr kapil dev juneja",
      Store_Address: "234,shopping center,behind mohsin manzil ,kota",
      Mobile_No: 9314020151,
      Landline_No: "",
      Email: "kitchenkraft_kota@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 25.1710013,
      Longitude: 75.8476847,
    },
    {
      id: 2666,
      Area: "North",
      States: "Rajasthan",
      City: "Ganganagar",
      Category: 1,
      Store_name: "SABHARWAL ELECTRICAL",
      Contact_name: "VIKAS SABHARWAL & NARENDER KUMAR",
      Store_Address:
        "32-33 A PUBLIC PARK AMBEDKAR CHOWK SRIGANGANAGAR, RAJASTHAN",
      Mobile_No: "9460141354, 941",
      Landline_No: "",
      Email: "",
      Pin_Code: 335001,
      DT: "NULL",
      Active: 0,
      Latitude: 29.9285434,
      Longitude: 73.869459,
    },
    {
      id: 2667,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Allahabad",
      Category: 1,
      Store_name: "Jain Electronics",
      Contact_name: "",
      Store_Address: "43 S P Marg Civil Lines, Allahabad",
      Mobile_No: 9452785468,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 18.96608,
      Longitude: 72.827751,
    },
    {
      id: 2668,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Allahabad",
      Category: 1,
      Store_name: "Reliable Kitchen Gallery",
      Contact_name: "reliable kitchen gallery",
      Store_Address: "shop no 8,krishna parisar, opp hotel milan, 31,m g",
      Mobile_No: 9305342828,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 25.451239,
      Longitude: 81.832784,
    },
    {
      id: 2669,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Gorakhpur",
      Category: 1,
      Store_name: "Tirupati Agencys Gorakhpur",
      Contact_name: "mr keshav jaiswal",
      Store_Address: "hazaripur opp agarwal timber gorakhpur",
      Mobile_No: 9670884052,
      Landline_No: "",
      Email: "jaiswal_keshav@yahoo.co.in",
      Pin_Code: 273001,
      DT: "NULL",
      Active: 0,
      Latitude: 26.760175,
      Longitude: 83.365669,
    },
    {
      id: 2670,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Jhansi",
      Category: 1,
      Store_name: "Garg Associate",
      Contact_name: "",
      Store_Address: "BKD Crossing, Jhanshi",
      Mobile_No: 9415412648,
      Landline_No: "",
      Email: "",
      Pin_Code: 284001,
      DT: "NULL",
      Active: 0,
      Latitude: 25.44876,
      Longitude: 78.57001,
    },
    {
      id: 2671,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Kanpur",
      Category: 1,
      Store_name: "A G Marketing",
      Contact_name: "",
      Store_Address: "80 Feet Road,Ram Bagh, Kanpur",
      Mobile_No: 9839068999,
      Landline_No: "",
      Email: "info@agmarketing.co.in",
      Pin_Code: 208012,
      DT: "NULL",
      Active: 0,
      Latitude: 26.472636,
      Longitude: 80.326401,
    },
    {
      id: 2672,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Kanpur",
      Category: 1,
      Store_name: "Krishnoor Enterprises",
      Contact_name: "",
      Store_Address: "111A 402 Ashok Nagar, 80ft Road, Kanpur",
      Mobile_No: 9838502838,
      Landline_No: "",
      Email: "",
      Pin_Code: 208012,
      DT: "NULL",
      Active: 0,
      Latitude: 26.4725,
      Longitude: 80.31974,
    },
    {
      id: 2673,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Kanpur",
      Category: 1,
      Store_name: "The Kitchen Studio",
      Contact_name: "Hemant Sutwala",
      Store_Address: "7 17, 9-10 Parwati Bagla Road (Behind indian oil p",
      Mobile_No: 9336104313,
      Landline_No: "",
      Email: "hsutwala@gmail.com",
      Pin_Code: 208002,
      DT: "NULL",
      Active: 0,
      Latitude: 26.491117,
      Longitude: 80.318713,
    },
    {
      id: 2674,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 1,
      Store_name: "Birjumal Budhulal",
      Contact_name: "mr.mayank agarwal",
      Store_Address: "ring road near sbi kalyanpur branch",
      Mobile_No: 9936407050,
      Landline_No: "",
      Email: "mayank.faber44@gmail.com",
      Pin_Code: 226022,
      DT: "NULL",
      Active: 0,
      Latitude: 26.889387,
      Longitude: 80.977006,
    },
    {
      id: 2675,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 1,
      Store_name: "Birjumal Budhulal",
      Contact_name: "ritesh agarwal",
      Store_Address: "super shioping centre faizabad rd",
      Mobile_No: 9415164984,
      Landline_No: "",
      Email: "riteshlko010@gmail.com",
      Pin_Code: 226016,
      DT: "NULL",
      Active: 0,
      Latitude: 26.889387,
      Longitude: 80.977006,
    },
    {
      id: 2676,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 1,
      Store_name: "Shanti Enterprises Lucknow",
      Contact_name: "mr. madan agarwal",
      Store_Address: "super shopping complex",
      Mobile_No: 9415011390,
      Landline_No: "",
      Email: "shantienterprises09@rediffmail.com",
      Pin_Code: 226016,
      DT: "NULL",
      Active: 0,
      Latitude: 26.870169,
      Longitude: 80.9680433,
    },
    {
      id: 2677,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 1,
      Store_name: "Vaasons Enterprise",
      Contact_name: "ms.soniya vaid",
      Store_Address: "vip ring road, near sbi, telibagh, lucknow",
      Mobile_No: 8528614438,
      Landline_No: "",
      Email: "",
      Pin_Code: 226022,
      DT: "NULL",
      Active: 0,
      Latitude: 26.783593,
      Longitude: 80.935686,
    },
    {
      id: 2678,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Mathura",
      Category: 1,
      Store_name: "SINGHAL SONS ELECTRONICS AGENCIES",
      Contact_name: "",
      Store_Address: "71, URWASHI MARKET",
      Mobile_No: 9536900813,
      Landline_No: "",
      Email: "",
      Pin_Code: 281001,
      DT: "NULL",
      Active: 0,
      Latitude: 27.498462,
      Longitude: 77.684621,
    },
    {
      id: 2679,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Muzzafnagar",
      Category: 1,
      Store_name: "RAVI ENTERPRISES",
      Contact_name: "",
      Store_Address: "10 UDAY MARKET",
      Mobile_No: 9412212073,
      Landline_No: "",
      Email: "",
      Pin_Code: 251002,
      DT: "NULL",
      Active: 0,
      Latitude: 29.4726817,
      Longitude: 77.7085091,
    },
    {
      id: 2680,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Varanasi",
      Category: 1,
      Store_name: "Bala Ji Traders",
      Contact_name: "",
      Store_Address: "Sonia Sigra Road, Varanasi",
      Mobile_No: 9839055911,
      Landline_No: "",
      Email: "",
      Pin_Code: 221010,
      DT: "NULL",
      Active: 0,
      Latitude: 25.31365,
      Longitude: 82.99304,
    },
    {
      id: 2681,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Varanasi",
      Category: 1,
      Store_name: "Kumar Tiles & Sanitaries",
      Contact_name: "",
      Store_Address: "S-3 61 A Dithori Mahal Orderly Bazar ,Varanasi",
      Mobile_No: 9450541366,
      Landline_No: "",
      Email: "",
      Pin_Code: 221002,
      DT: "NULL",
      Active: 0,
      Latitude: 13.77411,
      Longitude: 100.64845,
    },
    {
      id: 2682,
      Area: "North",
      States: "Uttrakhand",
      City: "Haldwani",
      Category: 1,
      Store_name: "NEW KWALITY KITCHEN GALLERY",
      Contact_name: "",
      Store_Address:
        "NEW KWALITY KITCHEN GALLERY, near police chowki, mangal parao, city- haldwani, pincode- 263139",
      Mobile_No: 8938949445,
      Landline_No: "",
      Email: "tawansuri@yahoo.co.in",
      Pin_Code: 263139,
      DT: "NULL",
      Active: 0,
      Latitude: 29.2182644,
      Longitude: 79.5129767,
    },
    {
      id: 2683,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Najibabad",
      Category: 1,
      Store_name: "ABHINANDAN IMPEX",
      Contact_name: "Jain",
      Store_Address: "CHOWK BAZAR, INFRONTOF PNB ATM, Najibabad(246763)",
      Mobile_No: 9897044884,
      Landline_No: "",
      Email: "mudit_777@rediffmail.com",
      Pin_Code: 246763,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2684,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "AGARWAL FANCY LIGHT HOUSE",
      Contact_name: "Anuj",
      Store_Address: "E-10, Noida",
      Mobile_No: 9999699488,
      Landline_No: "",
      Email: "",
      Pin_Code: 201301,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5726442,
      Longitude: 77.3547609,
    },
    {
      id: 2685,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "Aggarwal electis & Galaxy",
      Contact_name: "Deepl Bansal",
      Store_Address: "441 1 Nyay khand-3 Indrapuram Ghaziabad",
      Mobile_No: 8178899221,
      Landline_No: "",
      Email: "",
      Pin_Code: 201012,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6407122,
      Longitude: 77.3572901,
    },
    {
      id: 2686,
      Area: "North",
      States: "Uttrakhand",
      City: "Rudrapur",
      Category: 1,
      Store_name: "ALANKAR BATH ASSETS",
      Contact_name: "Jaswinder",
      Store_Address:
        "Alankar Bath Assets C o Alankar Complex, Opp Indane Gas Agency , Kashipur Byepass Road , Rudrapur. Uttrakhand. Pin- 263153",
      Mobile_No: 9927177789,
      Landline_No: "",
      Email: "alankarbathassets@gmail.com",
      Pin_Code: 263153,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2687,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "ANKUR ELECTRICAL",
      Contact_name: "Naveen",
      Store_Address: "J-14, Sector -18, Opposite Burger King, Noida",
      Mobile_No: 9899862119,
      Landline_No: "",
      Email: "rakeshankur@gmail.com",
      Pin_Code: 201301,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5174431,
      Longitude: 77.12841,
    },
    {
      id: 2688,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "ANKUR ELECTRICAL",
      Contact_name: "Shahil",
      Store_Address: "C-6, Sector-9, Opposite House of Joshan, Noida",
      Mobile_No: 9899862134,
      Landline_No: "",
      Email: "rakeshankur@gmail.com",
      Pin_Code: 201301,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5174431,
      Longitude: 77.12841,
    },
    {
      id: 2689,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida Extension",
      Category: 1,
      Store_name: "ANKUR ELECTRICALS",
      Contact_name: "Pramod",
      Store_Address: "NA",
      Mobile_No: 9213604501,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5601674,
      Longitude: 77.2004483,
    },
    {
      id: 2690,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Agra",
      Category: 1,
      Store_name: "Building Cares",
      Contact_name: "Pawan Agarwal",
      Store_Address: "G-11, Nath Complex, Dhakran Crossing, MG Road, Agra",
      Mobile_No: 9897068811,
      Landline_No: "0562 2262376",
      Email: "sintex.agra@gmail.com",
      Pin_Code: 282003,
      DT: "NULL",
      Active: 0,
      Latitude: 27.18333,
      Longitude: 78.01667,
    },
    {
      id: 2691,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Aditya City Centre, Situated at Plot No.C GH-3, at Vaibhav Khand, Indrapuram, Ghaziabad - 201001",
      Mobile_No: "",
      Landline_No: "0120-4758204",
      Email: "",
      Pin_Code: 201001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6386253,
      Longitude: 77.3598625,
    },
    {
      id: 2692,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No. C218B, 1st Floor DLF Mall of India,Plot No. H-03, Sector 18, Noida,201301",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 201301,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5668983,
      Longitude: 77.3190606,
    },
    {
      id: 2693,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ansal Plaza, Atrium Ground Floor , Unit no A G-16 & 22,Pari Chowk, Greater Noida, Uttarpradesh - 201308",
      Mobile_No: "",
      Landline_No: "0120-4514666",
      Email: "",
      Pin_Code: 201308,
      DT: "NULL",
      Active: 0,
      Latitude: 28.4637644,
      Longitude: 77.5050742,
    },
    {
      id: 2694,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "CROMA Plot No. 1",
      Contact_name: "",
      Store_Address:
        "Plot No. 1, Dr. Burman Marg, Site IV, Sahibabad Industrial Area, Ghaziabad 201001",
      Mobile_No: "",
      Landline_No: "120-4180613",
      Email: "",
      Pin_Code: 201001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.649807,
      Longitude: 77.318635,
    },
    {
      id: 2695,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "CROPMA",
      Contact_name: "",
      Store_Address:
        "CROPMA,Unit No.9, Ground Floor, Gaur Central RDC, Ghaziabad – 201001.",
      Mobile_No: "",
      Landline_No: 9873064332,
      Email: "",
      Pin_Code: 201001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6735998,
      Longitude: 77.438296,
    },
    {
      id: 2696,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "DASGRIV DECOR PRIVATE LTD",
      Contact_name: "Pawan Gupta",
      Store_Address: "B-14 1ST FLOOR, SECTOR 9, Noida",
      Mobile_No: 9810217055,
      Landline_No: "",
      Email: "",
      Pin_Code: 201301,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5882079,
      Longitude: 77.3143235,
    },
    {
      id: 2697,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Saharanpur",
      Category: 1,
      Store_name: "DREAM HOMZ",
      Contact_name: "Amit Agarwal",
      Store_Address:
        "Dream Homz 1st Floor Bhan Complex Opp. Hati Gate Mission Market Saharanpur U.P, 247001 Mob No 09837121073.",
      Mobile_No: 9837121073,
      Landline_No: "",
      Email: "dreamhomzsre@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 29.9454836,
      Longitude: 77.5455966,
    },
    {
      id: 2698,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Moradabad",
      Category: 1,
      Store_name: "DREAM KITCHEN",
      Contact_name: "Gaurav",
      Store_Address: "26, AWAS VIKAS, Moradabad(244001)",
      Mobile_No: 9897755993,
      Landline_No: "",
      Email: "gsinghal39@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 28.8452202,
      Longitude: 78.7641067,
    },
    {
      id: 2699,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Bulandshar",
      Category: 1,
      Store_name: "DWARKADHISH ENTERPRISES",
      Contact_name: "Rahul",
      Store_Address: "NEAR RAMA ROYAL RESIDENCY",
      Mobile_No: 9456604040,
      Landline_No: "",
      Email: "",
      Pin_Code: 203001,
      DT: "NULL",
      Active: 0,
      Latitude: 28.5085775,
      Longitude: 77.9628638,
    },
    {
      id: 2700,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "GLOWFAST ENTERPRISES",
      Contact_name: "R C Chaudhary",
      Store_Address: "C-3 LOWER GROUND FLOOR",
      Mobile_No: 9810009183,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6691565,
      Longitude: 77.4537578,
    },
    {
      id: 2701,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Meerut",
      Category: 1,
      Store_name: "KASTOORI HOME SHOPPE PRIVATE LIMITE",
      Contact_name: "N P Gupta",
      Store_Address: "J D HOUSE",
      Mobile_No: "",
      Landline_No: "0121 277037",
      Email: "",
      Pin_Code: 250003,
      DT: "NULL",
      Active: 0,
      Latitude: 28.9667827,
      Longitude: 77.7308044,
    },
    {
      id: 2702,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Bareilly",
      Category: 3,
      Store_name: "KHANNA PLYWOOD EMPORIUM",
      Contact_name: "Sidharth",
      Store_Address:
        "Khanna Plywood Emporium, 88- Civillines, opposite Hind Talkies, Bareilly",
      Mobile_No: 9997770005,
      Landline_No: "",
      Email: "siddharthkhanna86@gmail.com",
      Pin_Code: 243001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2703,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "KSR Home Applinces",
      Contact_name: "Nitin",
      Store_Address: "HIG NO-18,Sec-4, Near shopprix Mall Vaishali Ghazi",
      Mobile_No: 9212199672,
      Landline_No: "",
      Email: "ksrhomeapplinces@gmail.com",
      Pin_Code: 201010,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6436703,
      Longitude: 77.3408894,
    },
    {
      id: 2704,
      Area: "North",
      States: "Uttrakhand",
      City: "Dehradun",
      Category: 3,
      Store_name: "BEHL ASSOCIATES",
      Contact_name: "Amit",
      Store_Address:
        "Behl Associates 26 Rajpur Road,Behl Chowk,First Floor Sony Center, Dehra Dun,248001",
      Mobile_No: "97190 00044",
      Landline_No: "0135-2741184",
      Email: "behl_associates@yahoo.co.in",
      Pin_Code: 248001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2705,
      Area: "North",
      States: "Uttrakhand",
      City: "Rudrapur",
      Category: 1,
      Store_name: "MANJEET ELECTRONICS PRIVATE LIMITED",
      Contact_name: "Gurmeet",
      Store_Address:
        "D 1 - D 2, MEPL COMPLEX, CIVIL LINES, RUDRAPUR. PINCODE - 263153",
      Mobile_No: 9897066134,
      Landline_No: "",
      Email: "manjeetepl@gmail.com",
      Pin_Code: 263153,
      DT: "NULL",
      Active: 0,
      Latitude: 28.9798455,
      Longitude: 79.3962927,
    },
    {
      id: 2706,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "Mansha Marketing",
      Contact_name: "A.K Jan",
      Store_Address: "2nd B1 Nehru Nagar Ghaziabad",
      Mobile_No: 9910181933,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 28.667856,
      Longitude: 77.438146,
    },
    {
      id: 2707,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "R P Garg & Sons",
      Contact_name: "Pawan Garg",
      Store_Address: "B-27,Ganesh Nagar,opp metro pillar No.542,Delhi",
      Mobile_No: 9811164280,
      Landline_No: "",
      Email: "",
      Pin_Code: 110018,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6345585,
      Longitude: 77.0872454,
    },
    {
      id: 2708,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Om Sai Galleria",
      Contact_name: "Barun",
      Store_Address:
        "shop No.256.2nd floor,Bhola market,Shiva market,Pitampura,Delhi",
      Mobile_No: 9811982838,
      Landline_No: "",
      Email: "",
      Pin_Code: 110034,
      DT: "NULL",
      Active: 0,
      Latitude: 28.7015963,
      Longitude: 77.127057,
    },
    {
      id: 2709,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "M B Distribution",
      Contact_name: "Mr Vikas",
      Store_Address: "81,Bhera Enclave,National Market,Paschim vihar,Delhi",
      Mobile_No: 9810006950,
      Landline_No: "",
      Email: "",
      Pin_Code: 110087,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6695859,
      Longitude: 77.0911847,
    },
    {
      id: 2710,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Ashu Trading Company",
      Contact_name: "Ashu",
      Store_Address: "K-1 6,main Road,Rajapuri,opp sector-5 Dwarka,Delhi",
      Mobile_No: 9818548798,
      Landline_No: "",
      Email: "",
      Pin_Code: 110059,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6024053,
      Longitude: 77.056078,
    },
    {
      id: 2711,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "H K Enterprise",
      Contact_name: "H S Khurana",
      Store_Address: "B-9 2 upper ground floor,Main Road,Rajouri garden,Delhi",
      Mobile_No: 9810313644,
      Landline_No: "",
      Email: "",
      Pin_Code: 110027,
      DT: "NULL",
      Active: 0,
      Latitude: 28.6475332,
      Longitude: 77.1244429,
    },
    {
      id: 2712,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 1,
      Store_name: "Jai Maa Electricals",
      Contact_name: "Parveen",
      Store_Address: "128,shiva market,Near madhuvan chowk,Delhi",
      Mobile_No: 9958757187,
      Landline_No: "",
      Email: "",
      Pin_Code: 110034,
      DT: "NULL",
      Active: 0,
      Latitude: 28.7020311,
      Longitude: 77.1270858,
    },
    {
      id: 2713,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 1,
      Store_name: "R K Kitchen",
      Contact_name: "",
      Store_Address:
        "First Floor Plot No 2 Vikalp Khand Gomti Nagar Near Chinhat Tiraha",
      Mobile_No: 9984401234,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 26.8635029,
      Longitude: 81.0347636,
    },
    {
      id: 2714,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Sitapur",
      Category: 1,
      Store_name: "Deepa Electonics",
      Contact_name: "",
      Store_Address: "Opp Railway Station Mall Godam,Station road Sitapur",
      Mobile_No: 9794677852,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 27.561093,
      Longitude: 80.6888558,
    },
    {
      id: 2715,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Shahjahanpur",
      Category: 1,
      Store_name: "Baba Hardware",
      Contact_name: "",
      Store_Address: "Near Ghantaghar Shahjahanpur",
      Mobile_No: 9506005157,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 27.8776527,
      Longitude: 79.9086187,
    },
    {
      id: 2716,
      Area: "North",
      States: "Rajasthan",
      City: "Jodhpur",
      Category: 1,
      Store_name: "Shriram Electricals",
      Contact_name: "Mr  Venugopal Vaidh",
      Store_Address: "Bombay Motor Circle Near Shaifi Petrol Pump Jodhpur",
      Mobile_No: 9928909969,
      Landline_No: "",
      Email: "vaidyavenugopal@yahoo.co.in",
      Pin_Code: 342001,
      DT: "NULL",
      Active: 0,
      Latitude: 26.2803145,
      Longitude: 73.0024673,
    },
    {
      id: 2717,
      Area: "North",
      States: "Rajasthan",
      City: "Bhilwara",
      Category: 1,
      Store_name: "Todi Cement",
      Contact_name: "Mr Ajit Todi",
      Store_Address: "Kawakeda Chouraha Shastri Nagar Bhilwara",
      Mobile_No: 9314020151,
      Landline_No: "",
      Email: "balajipainthouse@ymail.com",
      Pin_Code: 311001,
      DT: "NULL",
      Active: 0,
      Latitude: 25.3301569,
      Longitude: 74.634973,
    },
    {
      id: 2718,
      Area: "North",
      States: "Rajasthan",
      City: "Bhilwara",
      Category: 1,
      Store_name: "Sangam Aircon",
      Contact_name: "Mr Giriraj Agarwal",
      Store_Address: "G 28 Faith tower Opp Passport Office Nagure Garden",
      Mobile_No: 9783542069,
      Landline_No: "",
      Email: "sangamaircon@gmail.com",
      Pin_Code: 311001,
      DT: "NULL",
      Active: 0,
      Latitude: 25.3434866,
      Longitude: 74.6390717,
    },
    {
      id: 2719,
      Area: "North",
      States: "Rajasthan",
      City: "Shri Ganganagar",
      Category: 1,
      Store_name: "Sabarwal Electricals",
      Contact_name: "Mr Narender Sabarwal",
      Store_Address: "32 33 A Public Park Goal Bazar",
      Mobile_No: 9460141354,
      Landline_No: "",
      Email: "sabharwalelectricals2018@gmail.com",
      Pin_Code: 335001,
      DT: "NULL",
      Active: 0,
      Latitude: 29.9285434,
      Longitude: 73.869459,
    },
    {
      id: 2720,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "Inotech Enterprises",
      Contact_name: "Amit Jindal",
      Store_Address: "# 783-C, Mota Singh Nagar Market",
      Mobile_No: "9876277267, 828",
      Landline_No: "",
      Email: "rishab.inotechenterprises@gmail.com",
      Pin_Code: 144003,
      DT: "NULL",
      Active: 0,
      Latitude: 31.310469,
      Longitude: 75.5882903,
    },
    {
      id: 2721,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "Premium Modular Kitchens",
      Contact_name: "Munish Joshi",
      Store_Address: "# 38, New Jawahar Nagar",
      Mobile_No: "9914215570, 700",
      Landline_No: "",
      Email: "premiummodular@yahoo.com",
      Pin_Code: 144001,
      DT: "NULL",
      Active: 0,
      Latitude: 31.3155308,
      Longitude: 75.5822501,
    },
    {
      id: 2722,
      Area: "North",
      States: "Punjab",
      City: "Nakodar",
      Category: 1,
      Store_name: "Ram Lubhaya Rakesh Chander",
      Contact_name: "Rishi",
      Store_Address: "Shankar Road, Near D.A.V College, Boys Wing",
      Mobile_No: "9592488000, 981",
      Landline_No: "",
      Email: "rlrcnkd@rediffmail.com",
      Pin_Code: 144040,
      DT: "NULL",
      Active: 0,
      Latitude: 31.1271018,
      Longitude: 75.4785059,
    },
    {
      id: 2723,
      Area: "North",
      States: "Punjab",
      City: "Kapurthala",
      Category: 1,
      Store_name: "National Radio Corporation",
      Contact_name: "Ankit Talwar",
      Store_Address: "Kanjli Road, Opp. Milan Palace",
      Mobile_No: "01822501895, 98",
      Landline_No: "",
      Email: "nationalradiocorpkpt@gmail.com",
      Pin_Code: 144601,
      DT: "NULL",
      Active: 1,
      Latitude: 31.3802219,
      Longitude: 75.3794709,
    },
    {
      id: 2724,
      Area: "North",
      States: "Punjab",
      City: "Amritsar",
      Category: 1,
      Store_name: "Home Gallery",
      Contact_name: "Shivam",
      Store_Address: "Main Ram Tirath Road, Opp Hotel Heaven Blu, Putlighar",
      Mobile_No: "7508936362, 788",
      Landline_No: "",
      Email: "homegallery0@gmail.com",
      Pin_Code: 43009,
      DT: "NULL",
      Active: 0,
      Latitude: 31.637905,
      Longitude: 74.8428753,
    },
    {
      id: 2725,
      Area: "North",
      States: "Punjab",
      City: "Rayya",
      Category: 1,
      Store_name: "BMD Design And Style",
      Contact_name: "Niraj Duggal",
      Store_Address: "Cheema Bath Chownk, G.T Road",
      Mobile_No: "7087010850, 946",
      Landline_No: "",
      Email: "bmddesignandstyle@gmail.com",
      Pin_Code: 143112,
      DT: "NULL",
      Active: 1,
      Latitude: 31.536271,
      Longitude: 75.2429403,
    },
    {
      id: 2726,
      Area: "North",
      States: "Punjab",
      City: "Mukerian",
      Category: 1,
      Store_name: "Ohri Hardware And Sanitary Store",
      Contact_name: "Ankur Ohri",
      Store_Address: "G.T Road, Near Bus Stand",
      Mobile_No: "9815872100, 814",
      Landline_No: "",
      Email: "sauravcementstore95@gmail.com",
      Pin_Code: 144211,
      DT: "NULL",
      Active: 0,
      Latitude: 31.5343129,
      Longitude: 75.2488334,
    },
    {
      id: 2727,
      Area: "East",
      States: "Assam",
      City: "Guwahati",
      Category: 1,
      Store_name: "NK Innovative",
      Contact_name: "Gayatri Dutta",
      Store_Address: "rgb road, near-ccd, guwahati",
      Mobile_No: 9854026353,
      Landline_No: "",
      Email: "nkinnovative55@gmail.com",
      Pin_Code: 781003,
      DT: "NULL",
      Active: 0,
      Latitude: 26.177798,
      Longitude: 91.775793,
    },
    {
      id: 2728,
      Area: "East",
      States: "Assam",
      City: "Guwahati",
      Category: 1,
      Store_name: "North East Trade Promoters",
      Contact_name: "Arvind Siotia",
      Store_Address: "c o ashok industrial enterprises ,srcb road ,near",
      Mobile_No: 9401535857,
      Landline_No: "0361-523841 544",
      Email: "netpservice@gmail.com",
      Pin_Code: 781001,
      DT: "NULL",
      Active: 0,
      Latitude: 26.18026,
      Longitude: 91.74093,
    },
    {
      id: 2729,
      Area: "East",
      States: "Assam",
      City: "Jorhat",
      Category: 1,
      Store_name:
        "Lifestyle Home Collection ( A unit of Jainco Lifestyle Ltd.)",
      Contact_name: "Anil Sigchi",
      Store_Address: "Na-Ali, Opp.: ASEB Building, Jorhat, Assam-785001",
      Mobile_No: "9435093704, 908",
      Landline_No: "",
      Email: "jaincolifestyleltd@gmail.com",
      Pin_Code: 785001,
      DT: "NULL",
      Active: 0,
      Latitude: 26.758119,
      Longitude: 94.215253,
    },
    {
      id: 2730,
      Area: "East",
      States: "Assam",
      City: "Nagaon",
      Category: 1,
      Store_name: "Trade India",
      Contact_name: "Mr. Om Prakash Jajodia",
      Store_Address: "Laokhowa road, Nagaon",
      Mobile_No: 9435060504,
      Landline_No: "",
      Email: "",
      Pin_Code: 782002,
      DT: "NULL",
      Active: 0,
      Latitude: 26.357314,
      Longitude: 92.6812941,
    },
    {
      id: 2736,
      Area: "East",
      States: "Manipur",
      City: "Imphal",
      Category: 1,
      Store_name: "Sanitary House",
      Contact_name: "Yogesh Jain",
      Store_Address: "Thangal Bazar",
      Mobile_No: 9436027366,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 24.8108604,
      Longitude: 93.9359026,
    },
    {
      id: 2737,
      Area: "East",
      States: "Mizoram",
      City: "Aizwal",
      Category: 1,
      Store_name: "Lena Plastic House",
      Contact_name: "Mrs.Baby  Monica",
      Store_Address: "g-25,chandmari",
      Mobile_No: "",
      Landline_No: "",
      Email: "lenaentp09@yahoo.in",
      Pin_Code: 796001,
      DT: "NULL",
      Active: 0,
      Latitude: 23.742107,
      Longitude: 92.718325,
    },
    {
      id: 2738,
      Area: "East",
      States: "Nagaland",
      City: "Dimapur",
      Category: 1,
      Store_name: "Interior Solutions",
      Contact_name: "mr Yongya Longkumar",
      Store_Address: "sacrament house, circular road",
      Mobile_No: 9436425678,
      Landline_No: "",
      Email: "yongya_78@yahoo.com",
      Pin_Code: 797117,
      DT: "NULL",
      Active: 0,
      Latitude: 25.912373,
      Longitude: 93.719194,
    },
    {
      id: 2739,
      Area: "East",
      States: "Odisha",
      City: "Angul",
      Category: 1,
      Store_name: "Kitchen Decorator",
      Contact_name: "Ashish Mishra",
      Store_Address: "Gandhi Marg, Near Reliance Trends, Angul",
      Mobile_No: 9937980493,
      Landline_No: "",
      Email: "kitchendecorator293@gmail.com",
      Pin_Code: 759122,
      DT: "NULL",
      Active: 0,
      Latitude: 20.8386836,
      Longitude: 85.0866702,
    },
    {
      id: 2740,
      Area: "East",
      States: "Odisha",
      City: "Balasore",
      Category: 1,
      Store_name: "J.P.Multiple & Services",
      Contact_name: "Er.Paramananda Mohapatra",
      Store_Address: "Telegasahi, Balasore",
      Mobile_No: 9437052545,
      Landline_No: "",
      Email: "pnmohapatra2013@gmail.com",
      Pin_Code: 756001,
      DT: "NULL",
      Active: 0,
      Latitude: 21.4869337,
      Longitude: 86.9246005,
    },
    {
      id: 2742,
      Area: "East",
      States: "Odisha",
      City: "Bhubaneswar",
      Category: 1,
      Store_name: "Happy Homes",
      Contact_name: "P K Mishra",
      Store_Address: "208, Malati Complex, Bapuji Nagar",
      Mobile_No: 9437076099,
      Landline_No: "0674 2597399",
      Email: "pkmbbs@rediffmail.com",
      Pin_Code: 751009,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2743,
      Area: "East",
      States: "Odisha",
      City: "Bhubaneswar",
      Category: 1,
      Store_name: "Home Xpressions",
      Contact_name: "Mr. Sharad Prusty",
      Store_Address: "Plot No. - 1306 , 1st Floor, Galaxy Mall, Nandanka",
      Mobile_No: 7873078742,
      Landline_No: "",
      Email: "sharad@homexpressions.in",
      Pin_Code: 751024,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2746,
      Area: "East",
      States: "Odisha",
      City: "Bhubaneswar",
      Category: 1,
      Store_name: "Nisha Enterprises",
      Contact_name: "Akhilesh Upadhyay",
      Store_Address:
        "Shop - 12 13, Ananta Vihar, B D A Market Complex, Pkhariput, Bhubaneswar",
      Mobile_No: 9337334793,
      Landline_No: "",
      Email: "akhileshu26@gmail.com",
      Pin_Code: 751020,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2747,
      Area: "East",
      States: "Odisha",
      City: "Bhubaneswar",
      Category: 1,
      Store_name: "Sai Kitchen",
      Contact_name: "Biren Kumar Das",
      Store_Address: "HIG-11, Phase-2, Khadagiri, Bhubaneswar",
      Mobile_No: "9337111896, 985",
      Landline_No: "",
      Email: "birenkumardas4911@eurosmile.in",
      Pin_Code: 751030,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2748,
      Area: "East",
      States: "Odisha",
      City: "Berhampur",
      Category: 1,
      Store_name: "KGH Ply N Décor",
      Contact_name: "Kuni Mishra",
      Store_Address:
        "At - Tata Benz Square, Near K.C. Public School, Berhampur - 760005, Ganjam",
      Mobile_No: "8280340001, 828",
      Landline_No: "0680-2228942",
      Email: "kghplyndecor@gmail.com",
      Pin_Code: 760005,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2749,
      Area: "East",
      States: "Odisha",
      City: "Jajpur road",
      Category: 1,
      Store_name: "Bharat Interio",
      Contact_name: "Abkash agarwal",
      Store_Address: "P.K.Ricemill compound, Jajpur road",
      Mobile_No: 9439497709,
      Landline_No: "",
      Email: "bharatinteriojpr@gmail.com",
      Pin_Code: 755019,
      DT: "NULL",
      Active: 0,
      Latitude: 20.948436,
      Longitude: 86.119197,
    },
    {
      id: 2750,
      Area: "East",
      States: "Odisha",
      City: "Paralakhemundi",
      Category: 1,
      Store_name: "Sri Krishan Buildmart",
      Contact_name: "V. Sanjay Raju",
      Store_Address: "New Bus Stand, Kashi Nagar Road, Paralakhemundi",
      Mobile_No: 8249318042,
      Landline_No: "",
      Email: "sanjay.rustham@gmail.com",
      Pin_Code: 761200,
      DT: "NULL",
      Active: 0,
      Latitude: 18.787176,
      Longitude: 84.0874602,
    },
    {
      id: 2751,
      Area: "East",
      States: "West Bengal",
      City: "Asansol",
      Category: 1,
      Store_name: "BHARAT TRADING AGENCY",
      Contact_name: "Mr Vikash Kumar Das",
      Store_Address: "28,Apcar Garden,G T Road, (Near Bhagat Singh More)",
      Mobile_No: 8170012299,
      Landline_No: "0341 2255599",
      Email: "bharatelec2006@yahoo.co.in",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 23.693413,
      Longitude: 86.95298,
    },
    {
      id: 2752,
      Area: "East",
      States: "West Bengal",
      City: "Bankura",
      Category: 1,
      Store_name: "Rajib Sales Corporation",
      Contact_name: "Subhas",
      Store_Address:
        "103 1,G.P. Singha Road, Sakharipara, Hareswarmela, Bankura",
      Mobile_No: "9434173327, 771",
      Landline_No: "",
      Email: "subhas2bqa123@gmail.com",
      Pin_Code: 722101,
      DT: "NULL",
      Active: 1,
      Latitude: 23.23241,
      Longitude: 87.0716,
    },
    {
      id: 2753,
      Area: "East",
      States: "West Bengal",
      City: "Bolpur",
      Category: 1,
      Store_name: "Banerjee Brothers",
      Contact_name: "Mr. Bhupati Banerjee",
      Store_Address: "Sri Niketan Road, Beside Mukherjee Petrol Pump Ban",
      Mobile_No: 9474411433,
      Landline_No: "",
      Email: "banerjeebrothers14@gmail.com",
      Pin_Code: 731204,
      DT: "NULL",
      Active: 0,
      Latitude: 23.663783,
      Longitude: 87.688971,
    },
    {
      id: 2754,
      Area: "East",
      States: "West Bengal",
      City: "Contai",
      Category: 1,
      Store_name: "Rahini Appliances World Pvt Ltd",
      Contact_name: "Nikhilesh Das",
      Store_Address: "Jalalka,Contai, Purba Medinipur, Pin No 721401,",
      Mobile_No: 7890000970,
      Landline_No: "",
      Email: "rahiniappliancesworld@gmail.com",
      Pin_Code: 721401,
      DT: "NULL",
      Active: 0,
      Latitude: 21.9167,
      Longitude: 87.51486,
    },
    {
      id: 2755,
      Area: "East",
      States: "West Bengal",
      City: "Hooghly",
      Category: 1,
      Store_name: "AMOUR INDIA",
      Contact_name: "",
      Store_Address:
        "DISTRIBUTOR - BITUMINUS ROAD, TALDANGA, CHINSURAH, HOOGHLY",
      Mobile_No: "9073329667, 933",
      Landline_No: "",
      Email: "",
      Pin_Code: 712101,
      DT: "NULL",
      Active: 0,
      Latitude: 22.599632,
      Longitude: 88.346968,
    },
    {
      id: 2756,
      Area: "East",
      States: "West Bengal",
      City: "Howrah",
      Category: 1,
      Store_name: "Amour India",
      Contact_name: "Mr Bankim Bose",
      Store_Address:
        "83 1 2, Approkash,N L Gandeshwari Sweet , Mukherjee Road, Howrah",
      Mobile_No: "8334948610   93",
      Landline_No: "",
      Email: "",
      Pin_Code: 711102,
      DT: "NULL",
      Active: 0,
      Latitude: 22.599632,
      Longitude: 88.346968,
    },
    {
      id: 2759,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "GALAXY",
      Contact_name: "Mr. Devesh Agarwal",
      Store_Address: "42, Gariahat Road south Kolkata, Kolkata 700029",
      Mobile_No: 9830129951,
      Landline_No: "",
      Email: "devesh@thegalaxyonline.com",
      Pin_Code: 700029,
      DT: "NULL",
      Active: 0,
      Latitude: 22.514307,
      Longitude: 88.367239,
    },
    {
      id: 2760,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Global Marketing",
      Contact_name: "Tapash Das",
      Store_Address: "1 1 , Bidhan pally , P.O. Nana Chandan Pukur , Bar",
      Mobile_No: 9851944576,
      Landline_No: "",
      Email: "kolkata.gms.bajaj@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 22.767075,
      Longitude: 88.370101,
    },
    {
      id: 2762,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Lokenath Systems",
      Contact_name: "Mr Ashoke Das",
      Store_Address: "2/ C Bapujinagar, Sulekha more",
      Mobile_No: 8478092527,
      Landline_No: "",
      Email: "lokenathsystem@gmail.com",
      Pin_Code: 700092,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2763,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "M L Roy Sanitation",
      Contact_name: "Mrs. Namita Roy",
      Store_Address: "188 A Rashbehari Avenue, Kolkata.",
      Mobile_No: 9830788107,
      Landline_No: "",
      Email: "mlroykolk@gmail.com",
      Pin_Code: 700029,
      DT: "NULL",
      Active: 1,
      Latitude: 22.518447,
      Longitude: 88.359976,
    },
    {
      id: 2764,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "PAHADI MARKETING PVT LTD",
      Contact_name: "Mr Akash Tayal",
      Store_Address: "Pahadi House,P-32 CIT Road, Scheme XM, Beleghata.",
      Mobile_No: 9831280248,
      Landline_No: "",
      Email: "pahadimarketing@gmail.com",
      Pin_Code: 700010,
      DT: "NULL",
      Active: 0,
      Latitude: 22.566012,
      Longitude: 88.39901,
    },
    {
      id: 2765,
      Area: "East",
      States: "West Bengal",
      City: "Malda",
      Category: 1,
      Store_name: "Prativa Enterprises",
      Contact_name: "Arghya Bhattacharya",
      Store_Address: "31 15, Raja Sarat Chandra Road, Puratuli, Malda, 7",
      Mobile_No: 9732103199,
      Landline_No: "",
      Email: "arghyamldt2010@yahoo.co.in",
      Pin_Code: 732101,
      DT: "NULL",
      Active: 0,
      Latitude: 25.0064321,
      Longitude: 88.1477114,
    },
    {
      id: 2766,
      Area: "East",
      States: "West Bengal",
      City: "PURULIA TOWN",
      Category: 1,
      Store_name: "HOMEZ",
      Contact_name: "Sudipto Mistri",
      Store_Address: "06,S.C Sen Road, M.S.A Complex, Purulia Town,Dist-",
      Mobile_No: "9932785231, 993",
      Landline_No: "",
      Email: "hello2homez@gmail.com",
      Pin_Code: 723101,
      DT: "NULL",
      Active: 0,
      Latitude: 23.32644,
      Longitude: 86.37099,
    },
    {
      id: 2767,
      Area: "East",
      States: "West Bengal",
      City: "Siliguri",
      Category: 1,
      Store_name: "CHIMNEY GALLERY",
      Contact_name: "Mr Rintu Saha",
      Store_Address: "2nd Floor, Balajee Complex, Opp. Sonali Bank Panit",
      Mobile_No: "NULL",
      Landline_No: "",
      Email: "chimneygallery@gmail.com",
      Pin_Code: 1,
      DT: "NULL",
      Active: 0,
      Latitude: 26.719879,
      Longitude: 88.426056,
    },
    {
      id: 2768,
      Area: "East",
      States: "West Bengal",
      City: "Sodepur",
      Category: 1,
      Store_name: "MRP Electric",
      Contact_name: "Rajesh Shaw",
      Store_Address: "1 Barasat Road Sodepur Station N L Opposite 4No Ti",
      Mobile_No: "8240615228 8017",
      Landline_No: "",
      Email: "Mrpelectrick2015@gmail.com",
      Pin_Code: 700110,
      DT: "NULL",
      Active: 0,
      Latitude: 22.69758,
      Longitude: 88.38813,
    },
    {
      id: 2769,
      Area: "East",
      States: "Odisha",
      City: "Bhubaneswar",
      Category: 1,
      Store_name: "A B Interior Solutions",
      Contact_name: "Er. Akshaya Kumar Mohanty",
      Store_Address: "LB – 13, Stage – 4, Jail Road, Jharpada, Bhubaneswar",
      Mobile_No: 7504914911,
      Landline_No: "",
      Email: "abis.kitchenworld@gmail.com",
      Pin_Code: 751006,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2771,
      Area: "East",
      States: "Odisha",
      City: "Rourkela",
      Category: 1,
      Store_name: "Kalinga Marketing Services",
      Contact_name: "Ansar Khan",
      Store_Address: "Shop No. - 61, J J Nac Market, Chhend, Rourkela",
      Mobile_No: 9437196687,
      Landline_No: "",
      Email: "ansarrkl3@rediffmail.com",
      Pin_Code: 769015,
      DT: "NULL",
      Active: 0,
      Latitude: 22.2402085,
      Longitude: 84.8253452,
    },
    {
      id: 2772,
      Area: "East",
      States: "Odisha",
      City: "Keonjhar",
      Category: 1,
      Store_name: "Nini Electricals",
      Contact_name: "Ajay Kumar Maharana",
      Store_Address:
        "D.D. College Road,Near Hotel The Sans,Serajuddin Chowk, Keonjhar",
      Mobile_No: 9437461392,
      Landline_No: "",
      Email: "ajaym636@gmail.com",
      Pin_Code: 758001,
      DT: "NULL",
      Active: 1,
      Latitude: 21.6412312,
      Longitude: 85.607518,
    },
    {
      id: 2773,
      Area: "West",
      States: "Chhattishgarh",
      City: "Raipur",
      Category: 1,
      Store_name: "Globe Marketing",
      Contact_name: "Mr.Sumit Meghani",
      Store_Address: "Old Vijay Sillicate Campus,Jai Bhole Complex,Panda",
      Mobile_No: 9303799000,
      Landline_No: "0771-4039318",
      Email: "menghanisumit@gmail.com",
      Pin_Code: 492001,
      DT: "NULL",
      Active: 0,
      Latitude: 21.254694,
      Longitude: 81.648714,
    },
    {
      id: 2775,
      Area: "West",
      States: "Goa",
      City: "Margao",
      Category: 1,
      Store_name: "G B S Talaulikar & sons",
      Contact_name: "prasant ischit",
      Store_Address: "fatima chamber, madgaon",
      Mobile_No: 8322733418,
      Landline_No: "NULL",
      Email: "",
      Pin_Code: 403601,
      DT: "NULL",
      Active: 0,
      Latitude: 15.271946,
      Longitude: 73.958331,
    },
    {
      id: 2776,
      Area: "West",
      States: "Goa",
      City: "Margao",
      Category: 1,
      Store_name: "Smart Home Lifestyles",
      Contact_name: "NULL",
      Store_Address: "S-5  pidede apts, Vidhyangar",
      Mobile_No: 9604722842,
      Landline_No: "NULL",
      Email: "",
      Pin_Code: 403602,
      DT: "NULL",
      Active: 0,
      Latitude: 15.280677,
      Longitude: 73.977631,
    },
    {
      id: 2777,
      Area: "West",
      States: "Goa",
      City: "Panjim",
      Category: 1,
      Store_name: "Apex Marketing",
      Contact_name: "harshad kurtarkar",
      Store_Address: "shop no. 6 kamat plza, nr. st. inez, panaji",
      Mobile_No: 9890249072,
      Landline_No: "NULL",
      Email: "fabercaregoa@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 15.48846,
      Longitude: 73.820381,
    },
    {
      id: 2778,
      Area: "West",
      States: "Maharashtra",
      City: "Ahmednagar",
      Category: 1,
      Store_name: "Pramod stove center",
      Contact_name: "Pramod",
      Store_Address: "(B1) Manik chowk,dange lane corner, (B2) Gulmohar",
      Mobile_No: 9822344387,
      Landline_No: "NULL",
      Email: "pramodgasstove@gmail.com",
      Pin_Code: 202001,
      DT: "NULL",
      Active: 0,
      Latitude: 53.60352,
      Longitude: -114.29569,
    },
    {
      id: 2779,
      Area: "West",
      States: "Maharashtra",
      City: "Aurangabad",
      Category: 1,
      Store_name: "Croma at Prozon Mall",
      Contact_name: "",
      Store_Address:
        "at Prozon Mall. Unit No. G-67, Plot No P-80, MIDC, Chikalthana Area, Airport Road, Aurangabad-431210",
      Mobile_No: "",
      Landline_No: "0240-6645713",
      Email: "",
      Pin_Code: 431210,
      DT: "NULL",
      Active: 0,
      Latitude: 19.876448,
      Longitude: 75.3699853,
    },
    {
      id: 2780,
      Area: "West",
      States: "Maharashtra",
      City: "Aurangabad",
      Category: 1,
      Store_name: "Karan Marketing Aurgangabad",
      Contact_name: "mr karva",
      Store_Address: "1 5, motiwala square jawahar colony rd",
      Mobile_No: 9890045166,
      Landline_No: "NULL",
      Email: "constroagencies@gmail.com",
      Pin_Code: 431001,
      DT: "NULL",
      Active: 0,
      Latitude: 19.8725097,
      Longitude: 75.3430165,
    },
    {
      id: 2781,
      Area: "West",
      States: "Maharashtra",
      City: "Aurangabad",
      Category: 1,
      Store_name: "Progressive Sales",
      Contact_name: "mahinder kabra",
      Store_Address: "plot no 29 a, ranjanvan housing society, n-9, hudc",
      Mobile_No: 9823103499,
      Landline_No: "NULL",
      Email: "kabra.mahendra@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 19.902074,
      Longitude: 75.356478,
    },
    {
      id: 2783,
      Area: "West",
      States: "Maharashtra",
      City: "Kolhapur",
      Category: 1,
      Store_name: "shree mangesh agency",
      Contact_name: "mr mangesh",
      Store_Address: "shree gajanan maharaj pushp sankul, shop no- d  c.",
      Mobile_No: "NULL",
      Landline_No: "NULL",
      Email: "mangesh.agency@yahoo.in",
      Pin_Code: 416001,
      DT: "NULL",
      Active: 0,
      Latitude: 16.703737,
      Longitude: 74.233566,
    },
    {
      id: 2784,
      Area: "West",
      States: "Maharashtra",
      City: "Kolhapur",
      Category: 1,
      Store_name: "Shree Mangesh Agency – Kolhapur",
      Contact_name: "mr suhash",
      Store_Address:
        "Shop No – D   C.T.S. No 414 Shree Gajanan Maharaj Pushp Sankul,Near Hotel Triveni,Basant – Bahar Road,” E” Ward Shahupuri , Kolhapur",
      Mobile_No: "94218 33438   9",
      Landline_No: "",
      Email: "mangesh.agency@yahoo.in,mangesh.agencykol@gmail.co",
      Pin_Code: 416001,
      DT: "NULL",
      Active: 0,
      Latitude: 1.308178,
      Longitude: 103.849353,
    },
    {
      id: 2786,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Arvee Enterprises",
      Contact_name: "NULL",
      Store_Address: "d- 3, bafna apartment mogoz lane matunga",
      Mobile_No: "NULL",
      Landline_No: 24305233,
      Email: "arveeentp@gmail.com",
      Pin_Code: 400016,
      DT: "NULL",
      Active: 0,
      Latitude: 19.034016,
      Longitude: 72.845026,
    },
    {
      id: 2789,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Creative kitchen",
      Contact_name: "Mr.Sunil Vijan",
      Store_Address: "85, CRD Samarth Bldg, Opp. HP Petrol pump and Saah",
      Mobile_No: "NULL",
      Landline_No: "022-26058647",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 19.066411,
      Longitude: 72.837124,
    },
    {
      id: 2790,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground Floor, Vasundhara CHS,Opp Utpal Shanghvi School,JVPD, Vile Parle West,Mumbai- 49.",
      Mobile_No: "",
      Landline_No: "022-61406339",
      Email: "",
      Pin_Code: 49,
      DT: "NULL",
      Active: 0,
      Latitude: 19.1133807,
      Longitude: 72.8257591,
    },
    {
      id: 2791,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Lords Bldg, Plot 35 & 35A, Sec-15, CBD Belapur, Navi Mumbai-400614",
      Mobile_No: "",
      Landline_No: "022 61508614",
      Email: "",
      Pin_Code: 400614,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0097666,
      Longitude: 73.0284612,
    },
    {
      id: 2792,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Plam Spring Center, Ground Floor, Malad Link Road, Mumbai -400064.",
      Mobile_No: "",
      Landline_No: "022-6150 8200 0",
      Email: "",
      Pin_Code: 400064,
      DT: "NULL",
      Active: 0,
      Latitude: 19.1866298,
      Longitude: 72.833005,
    },
    {
      id: 2793,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit no F-25 , First Floor ,Oberoi Mall Pvt Ltd,Off Western Express Highway,Goregaon (East) , Mumbai-400063",
      Mobile_No: "",
      Landline_No: "022-6748 8310",
      Email: "",
      Pin_Code: 400063,
      DT: "NULL",
      Active: 0,
      Latitude: 19.1735848,
      Longitude: 72.8577966,
    },
    {
      id: 2794,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No.G10,Ground Floor,Rcity,L.B.S Marg,Ghatkopar(W) Mumbai - 400086",
      Mobile_No: "",
      Landline_No: "022-61561 000",
      Email: "",
      Pin_Code: 400086,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0990231,
      Longitude: 72.9137897,
    },
    {
      id: 2795,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No.1 Lower Ground floor, Century Bhavan, Dr. Annie Besant Road, Worli, Mumbai 400 030",
      Mobile_No: "",
      Landline_No: "022-61304300",
      Email: "",
      Pin_Code: 400030,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0125544,
      Longitude: 72.8212691,
    },
    {
      id: 2796,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Dhun-Abad, 106, Bhulabai Desai Road, Junction of Warden Road and Nepean Sea Road, Mumbai-400 036",
      Mobile_No: "",
      Landline_No: "2369 0557",
      Email: "",
      Pin_Code: 400036,
      DT: "NULL",
      Active: 0,
      Latitude: 18.9648143,
      Longitude: 72.8018526,
    },
    {
      id: 2797,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Sion Garage Bldg.,Plot No. 112, Sion Koliwada Rd.,Near Cinemax, Mumbai – 400022.",
      Mobile_No: "",
      Landline_No: "022-65180075 69",
      Email: "",
      Pin_Code: 400022,
      DT: "NULL",
      Active: 0,
      Latitude: 19.040003,
      Longitude: 72.8630372,
    },
    {
      id: 2798,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Natraj, Ground & First Floor, Sodawala Lane, Near Chamunda Circle, Borivali (West), Mumbai - 400092",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 400092,
      DT: "NULL",
      Active: 0,
      Latitude: 19.2336527,
      Longitude: 72.8516122,
    },
    {
      id: 2799,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Block No.43,     Grand Galleria    , Pheonix Mills Compound, 462, Senapati Bapat Marg, Lower Parel, Mumbai -400013",
      Mobile_No: "",
      Landline_No: "022-61413701",
      Email: "",
      Pin_Code: 400013,
      DT: "NULL",
      Active: 0,
      Latitude: 18.994816,
      Longitude: 72.8215496,
    },
    {
      id: 2800,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Colour Scape,Mall Dhamaal Off LBS Road,Dumping Road ,Opp. R Mall, Next to Mulund Bus Depot,Opp. R Mall Near Mulund Checknaka ,Mulund (W),Mumbai 400080",
      Mobile_No: "",
      Landline_No: "022-61508413",
      Email: "",
      Pin_Code: 400080,
      DT: "NULL",
      Active: 0,
      Latitude: 19.1823437,
      Longitude: 72.9519798,
    },
    {
      id: 2801,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground & Lower Ground Floor, V Souk, B-2, Sector-10, Opposite Kamla Vihar Sports Club, Mahavir Nagar, Kandivali (West), Mumbai-400 067",
      Mobile_No: "",
      Landline_No: "0226454 0034",
      Email: "",
      Pin_Code: 400067,
      DT: "NULL",
      Active: 0,
      Latitude: 19.212978,
      Longitude: 72.8403733,
    },
    {
      id: 2802,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Showroom no.002,003,004,005, and 006, Ground and First Floor, The Landmark, at Plot No.26A, Sector 07, Kharghar, Navi Mumbai: 410210.",
      Mobile_No: "",
      Landline_No: "022-61449713",
      Email: "",
      Pin_Code: 410210,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0335005,
      Longitude: 73.0644904,
    },
    {
      id: 2803,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground & First Floor,Plot No. 26 & 27, Sector 19 C,Palm Beach Road,Vashi, Navi Mumbai 400 705.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 400705,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0817723,
      Longitude: 73.0030809,
    },
    {
      id: 2804,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Rashesh Mall,Near Maxus Mall ,Sri Vallabhacharyaji Marg,Near New fly over Bridge,Next Venkatesh Hall,Bhayander -401101",
      Mobile_No: "",
      Landline_No: "022-64560964",
      Email: "",
      Pin_Code: 401101,
      DT: "NULL",
      Active: 0,
      Latitude: 19.2952877,
      Longitude: 72.8457945,
    },
    {
      id: 2805,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Lower Ground floor,    Link Square mall     Plot no.490 & 491 ,33rd Road ,off linking Road Bandra(W),Mumbai - 400 050",
      Mobile_No: "",
      Landline_No: "022-66233764",
      Email: "",
      Pin_Code: 400050,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0651362,
      Longitude: 72.831461,
    },
    {
      id: 2806,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Level 1,Big Shopping Center, Above Hyper City,Ghodbunder Rd, Thane (W),Mumbai,400601",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 400601,
      DT: "NULL",
      Active: 0,
      Latitude: 19.2682761,
      Longitude: 72.9630958,
    },
    {
      id: 2807,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No. G 21, G 23, G25, G27, G 29, F 21, F 23, F 25, F 27, F 29; Ground & 1st Floor, Growel 101 Mall, Akurli Road, Kandivali (E), Mumbai 400 101",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 400101,
      DT: "NULL",
      Active: 0,
      Latitude: 19.2032723,
      Longitude: 72.8573116,
    },
    {
      id: 2808,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Magnet Mall -Bhandup Ground Floor, Neptune Magnet Mall, Near Mangatram petrol pump, L.B.S Road, Bhandup West, (142) ,Mumbai, Maharashtra 400078",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 400078,
      DT: "NULL",
      Active: 0,
      Latitude: 19.1419923,
      Longitude: 72.9296325,
    },
    {
      id: 2809,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address: "R Mall,Godhbunder Road,Thane (West)Mumbai -400607",
      Mobile_No: "",
      Landline_No: "022-64564671",
      Email: "",
      Pin_Code: 400607,
      DT: "NULL",
      Active: 0,
      Latitude: 19.2298897,
      Longitude: 72.9752239,
    },
    {
      id: 2810,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Seawoods Grand Central, Plot No. R-1, Sector 40, Seawoods Railway Station, Navi Mumbai, India 400 706",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 400706,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0215039,
      Longitude: 73.0155745,
    },
    {
      id: 2811,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "UG- 41 & 42, Phoenix Market City,L.B.S.Marg, Kurla (W) Mumbai-400 070",
      Mobile_No: "",
      Landline_No: "022-61801684",
      Email: "",
      Pin_Code: 400070,
      DT: "NULL",
      Active: 0,
      Latitude: 19.0869923,
      Longitude: 72.8875365,
    },
    {
      id: 2813,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Schetan Home Appliances",
      Contact_name: "Mr. Chetan Sing",
      Store_Address: "Shop no.2, Dimple Arcade, Asha Nagar, Thakur Compl",
      Mobile_No: "",
      Landline_No: "022-28700004",
      Email: "",
      Pin_Code: 400101,
      DT: "NULL",
      Active: 0,
      Latitude: 19.21187,
      Longitude: 72.867549,
    },
    {
      id: 2814,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Shree Muthulaxmi",
      Contact_name: "Mr.Paras",
      Store_Address: "B 110,112,113, Laram Centre, M.A. Road, Opp Andher",
      Mobile_No: "",
      Landline_No: "022 -66951236 3",
      Email: "shreemuthulaxmi@gmail.com",
      Pin_Code: 400058,
      DT: "NULL",
      Active: 0,
      Latitude: 19.1183187,
      Longitude: 72.8459861,
    },
    {
      id: 2815,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Sony Enterprises",
      Contact_name: "Mr.Durga",
      Store_Address: "202, 2nd Floor,Deors Commercial Centre, Orlem Marv",
      Mobile_No: "",
      Landline_No: "022-28619229",
      Email: "",
      Pin_Code: 400084,
      DT: "NULL",
      Active: 0,
      Latitude: 19.194926,
      Longitude: 72.838736,
    },
    {
      id: 2818,
      Area: "West",
      States: "Maharashtra",
      City: "Nagpur",
      Category: 1,
      Store_name: "Shiva Enterprises",
      Contact_name: "mr. nitin mehadia",
      Store_Address: "galleria, mehadia bhawan, lokmat square , dhantoli",
      Mobile_No: 9373049386,
      Landline_No: 7122444849,
      Email: "shivabath@rediffmail.com",
      Pin_Code: 440012,
      DT: "NULL",
      Active: 0,
      Latitude: 21.135626,
      Longitude: 79.078785,
    },
    {
      id: 2819,
      Area: "West",
      States: "Maharashtra",
      City: "Nagpur",
      Category: 1,
      Store_name: "Shivansh Enterprises",
      Contact_name: "sandip shirname",
      Store_Address: "62,tilak path, rambagh square",
      Mobile_No: 9673377766,
      Landline_No: "",
      Email: "sandip_shirname@rediffmail.com",
      Pin_Code: 452007,
      DT: "NULL",
      Active: 0,
      Latitude: 21.1117,
      Longitude: 79.072979,
    },
    {
      id: 2820,
      Area: "West",
      States: "Maharashtra",
      City: "Nasik",
      Category: 1,
      Store_name: "Audio Video Enterprises",
      Contact_name: "sunil patil",
      Store_Address: "2,ravi kiran app vise mala b h niramaaya nursing h",
      Mobile_No: 8485040578,
      Landline_No: "",
      Email: "audiovideonashik@gmail.com",
      Pin_Code: 422005,
      DT: "NULL",
      Active: 1,
      Latitude: 20.005546,
      Longitude: 73.769001,
    },
    {
      id: 2821,
      Area: "West",
      States: "Maharashtra",
      City: "Nasik",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No.1, 2 and 101, Hari Prabha Solitario, Plot No. 87, 88, and 89, S.No.715 B, Final Plot No. 456 C  TPS II, CTS No.7411, Kulkarni Baug, Thatte Marg,Off College Road, Nashik 422 005",
      Mobile_No: "",
      Landline_No: "0253-6559 312",
      Email: "",
      Pin_Code: 422005,
      DT: "NULL",
      Active: 0,
      Latitude: 20.007941,
      Longitude: 73.7620529,
    },
    {
      id: 2822,
      Area: "West",
      States: "Maharashtra",
      City: "Nasik",
      Category: 1,
      Store_name: "sai asha",
      Contact_name: "amar shadija",
      Store_Address: "34, meg dhoot shopping centre, shivaji road,",
      Mobile_No: 9028888240,
      Landline_No: 2532314627,
      Email: "vandananasik2@gmail.com",
      Pin_Code: 422002,
      DT: "NULL",
      Active: 1,
      Latitude: 20.001001,
      Longitude: 73.783248,
    },
    {
      id: 2823,
      Area: "West",
      States: "Maharashtra",
      City: "Pimpri-Chinchwad",
      Category: 1,
      Store_name: "Radhika Electronics",
      Contact_name: "",
      Store_Address:
        "Rahatani Rd, Deepmala Society, Pimple Saudagar, Pimpri-Chinchwad, Maharashtra",
      Mobile_No: "",
      Landline_No: "020 6733 8800",
      Email: "",
      Pin_Code: 411027,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5995287,
      Longitude: 73.7908276,
    },
    {
      id: 2824,
      Area: "West",
      States: "Maharashtra",
      City: "Pimpri-Chinchwad",
      Category: 1,
      Store_name: "Vijay Sales: Pimpri",
      Contact_name: "",
      Store_Address:
        "Near Ranka Jewellers, CB 2 001, Empire Estate, Old Mumbai Rd, Pimpri Colony, Pimpri-Chinchwad, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411019,
      DT: "NULL",
      Active: 0,
      Latitude: 18.6335538,
      Longitude: 73.7967083,
    },
    {
      id: 2825,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Showroom No. 1 & 2, Ground Floor, Pride Gateway, S. No. 112 1 2 1, 112 1 2 3 (P), Baner, Pune - 411045.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411045,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5658403,
      Longitude: 73.7691319,
    },
    {
      id: 2826,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No. G- 20 & G-21, Season Mall, Magarpatta City, Hadapsar, Pune: 411028",
      Mobile_No: "",
      Landline_No: "020-668594009",
      Email: "",
      Pin_Code: 411028,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5191443,
      Longitude: 73.9297827,
    },
    {
      id: 2827,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground Floor, Showroom no.3, Showroom no.2, Building no. ‘A’, G. O. Square, Survey no.251 1C, Wakad, Pune:-411057.",
      Mobile_No: "",
      Landline_No: "020-66896100",
      Email: "",
      Pin_Code: 411057,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5904735,
      Longitude: 73.7678485,
    },
    {
      id: 2828,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Star Bazaar ,Plot No 517 E, Old Pune - Bangalore, Road, Kolhapur, Maharashtra 416001",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 416001,
      DT: "NULL",
      Active: 0,
      Latitude: 16.7011431,
      Longitude: 74.2493463,
    },
    {
      id: 2829,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "NSG IT Park ,Survey No.127 2B 1A,ITI Road,Near Sarjaa Restaurant Aundh Pune - 411007",
      Mobile_No: "",
      Landline_No: "020-67212811",
      Email: "",
      Pin_Code: 411007,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5536923,
      Longitude: 73.8047802,
    },
    {
      id: 2830,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Shubhan Galleria,Shop no.2,Ground Floor,Survey no.210 A CST No.4800 & 4801,209 Near Pimpri Bridge , Opp Judson High School,Next to Finolx Chowk,Pimpri , Pune - 411018",
      Mobile_No: "",
      Landline_No: "020 6730 2502",
      Email: "",
      Pin_Code: 411018,
      DT: "NULL",
      Active: 0,
      Latitude: 18.625417,
      Longitude: 73.7996078,
    },
    {
      id: 2831,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "CROMA Krome Mall",
      Contact_name: "",
      Store_Address:
        "Krome Mall, 32 1, Pune Solapur Road, Wanowari, Pune-411013",
      Mobile_No: "",
      Landline_No: "020-67212913 04",
      Email: "",
      Pin_Code: 411013,
      DT: "NULL",
      Active: 0,
      Latitude: 18.506665,
      Longitude: 73.9056253,
    },
    {
      id: 2832,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Galaxy Kitchen Studio",
      Contact_name: "",
      Store_Address:
        "Shop no. 3A E-Wing, Mohite Paradise S.No. 16 3 Hingane Khurd, Singhad Road, Tal. Haveli, Pune",
      Mobile_No: 9421749934,
      Landline_No: "",
      Email: "",
      Pin_Code: 411051,
      DT: "NULL",
      Active: 0,
      Latitude: 18.480379,
      Longitude: 73.827358,
    },
    {
      id: 2833,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "gruhini kitchen",
      Contact_name: "mr. anil londhe",
      Store_Address: "Shop no. 22, purandar soc. Maharshinagar, pune",
      Mobile_No: 9763729840,
      Landline_No: "",
      Email: "anil.gruhini@gmail.com",
      Pin_Code: 411037,
      DT: "NULL",
      Active: 0,
      Latitude: 18.476,
      Longitude: 73.85584,
    },
    {
      id: 2834,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Gruhini Kitchen Appliance",
      Contact_name: "Mr. Anil Londhe",
      Store_Address:
        "Shop no. 5, Indranil Apt. ,Nr. D-mart, opp. pNG Jewellers Padmavati Satara Road, pune",
      Mobile_No: 9763729840,
      Landline_No: "",
      Email: "anil.gruhini@gmail.com",
      Pin_Code: 411009,
      DT: "NULL",
      Active: 0,
      Latitude: 18.491816,
      Longitude: 73.857585,
    },
    {
      id: 2835,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Kitchen Ikon",
      Contact_name: "",
      Store_Address: "Shop No.138 Shangrila Garden, Bund Garden, Pune",
      Mobile_No: "",
      Landline_No: 7796466781,
      Email: "",
      Pin_Code: 411001,
      DT: "NULL",
      Active: 1,
      Latitude: 18.5404101,
      Longitude: 73.8846143,
    },
    {
      id: 2836,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Kitchen Ikon",
      Contact_name: "",
      Store_Address: "Shop No.4A,Dorabji Enclave,Opp,Super Mall,Kondhwa,Pune",
      Mobile_No: "",
      Landline_No: 7796766782,
      Email: "",
      Pin_Code: 411048,
      DT: "NULL",
      Active: 1,
      Latitude: 18.5404101,
      Longitude: 73.8846143,
    },
    {
      id: 2837,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Surya Electronics",
      Contact_name: "",
      Store_Address:
        "G O square, B-wing, Mankar Chowk, Wakad, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "93097 11017",
      Email: "",
      Pin_Code: 411057,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5904374,
      Longitude: 73.7686767,
    },
    {
      id: 2838,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Vijay Sales - Baner",
      Contact_name: "",
      Store_Address:
        "RMZ Icon, Pride Purple Accord, Next to Hotel Mahabaleswar, Opp. Symantic Building Near, Baner, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411045,
      DT: "NULL",
      Active: 0,
      Latitude: 18.555174,
      Longitude: 73.797379,
    },
    {
      id: 2839,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Vijay Sales – Bhosari",
      Contact_name: "",
      Store_Address:
        "24 25 26, Bhosari Industrial Area, MIDC, Bhosari, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411026,
      DT: "NULL",
      Active: 0,
      Latitude: 18.6337939,
      Longitude: 73.8262857,
    },
    {
      id: 2840,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Vijay Sales - Chandan Nagar",
      Contact_name: "",
      Store_Address:
        "Plot No. 9, Survey No. 48 2, Prabhakar Hights, Below Chate Classes Pune-Nagar Road, Chandan Nagar, Kharadi, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411014,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5625499,
      Longitude: 73.9295089,
    },
    {
      id: 2841,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "VIJAY SALES – HINJAWADI",
      Contact_name: "",
      Store_Address:
        "Shop No.4, Ground Floor, White Square, Hinjawadi - Wakad Rd, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411057,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5909645,
      Longitude: 73.7509691,
    },
    {
      id: 2842,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "VIJAY SALES – KOTHRUD",
      Contact_name: "",
      Store_Address:
        "Plot No.50, Manke Affluence, Paud Road, Opp Krushna Hospital, Rambaug Colony, Kothrud, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411038,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5096194,
      Longitude: 73.8104999,
    },
    {
      id: 2843,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Vijay Sales - Padmavati",
      Contact_name: "",
      Store_Address:
        "Sharada Arcade, Jai Tirth Society Opposite, Pune - Satara Rd, Padmavati Nagar, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411009,
      DT: "NULL",
      Active: 0,
      Latitude: 18.4794692,
      Longitude: 73.8545665,
    },
    {
      id: 2844,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "VIJAY SALES – RAHATNI",
      Contact_name: "",
      Store_Address:
        "Sr. no.5 6, Shop No.16 17 18 19, Divya Heights Aundh Annexe, Rahatani Rd, Jagtap Dairy, Pimple Saudagar, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411017,
      DT: "NULL",
      Active: 0,
      Latitude: 18.6014747,
      Longitude: 73.7923926,
    },
    {
      id: 2845,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Vijay Sales - Seasons Mall",
      Contact_name: "",
      Store_Address:
        "Unit-no-G-13+14+15 season mall, Magarpatta, Hadapsar, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411013,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5193079,
      Longitude: 73.9292239,
    },
    {
      id: 2846,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Vijay Sales - Tilak Road",
      Contact_name: "",
      Store_Address:
        "Plot No. CRT, 2008-A, Lokmanya Bal Gangadhar Tilak Rd, Sadashiv Peth, Pune",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411030,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5067062,
      Longitude: 73.8499904,
    },
    {
      id: 2847,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "Vijay Sales Station",
      Contact_name: "",
      Store_Address:
        "Survey No 115, PMT Building, Main Road, Station,Near B U Bhandari Honda Showroom & PMT Bus Depot ,Next to Gulmohar Hotel ,Sadhu Vaswani Chowk, Pune",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411001,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5265978,
      Longitude: 73.8743506,
    },
    {
      id: 2848,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 1,
      Store_name: "VIJAY SALES: Hadapsar",
      Contact_name: "",
      Store_Address:
        "Amar Manor, 32 3, Next to Krome Mall, Pune - Solapur Rd, Near Crome Furniture, Hadapsar, Pune, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411013,
      DT: "NULL",
      Active: 0,
      Latitude: 18.5067387,
      Longitude: 73.9065784,
    },
    {
      id: 2849,
      Area: "West",
      States: "Maharashtra",
      City: "Thane",
      Category: 1,
      Store_name: "Lucky Enterprises",
      Contact_name: "yogesh tiwari",
      Store_Address: "shop no 46, carnation building no 10, shri ji sple",
      Mobile_No: 9920582015,
      Landline_No: "",
      Email: "yogeshtiwari4u@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 19.249142,
      Longitude: 72.985219,
    },
    {
      id: 2850,
      Area: "West",
      States: "Maharashtra",
      City: "Thane",
      Category: 1,
      Store_name: "Prakash Combines Mumbai",
      Contact_name: "mr. tarun mehta",
      Store_Address: "14, sagar ratan industrial estate, thane belapur r",
      Mobile_No: 9820145103,
      Landline_No: "",
      Email: "prakashgroupcos@gmail.com",
      Pin_Code: 400705,
      DT: "NULL",
      Active: 0,
      Latitude: 19.017611,
      Longitude: 72.856128,
    },
    {
      id: 2851,
      Area: "West",
      States: "Maharashtra",
      City: "Indore",
      Category: 1,
      Store_name: "Harsh Sales",
      Contact_name: "Sumit Bora",
      Store_Address:
        "SK 1 compound near Mahindra workshop havells godown Dewas Naka Indore",
      Mobile_No: 7489200245,
      Landline_No: "",
      Email: "harshsales9@gmail.com",
      Pin_Code: 452010,
      DT: "NULL",
      Active: 0,
      Latitude: 22.71792,
      Longitude: 75.8333,
    },
    {
      id: 2852,
      Area: "West",
      States: "Maharashtra",
      City: "Indore",
      Category: 1,
      Store_name: "Sethi Enterprises",
      Contact_name: "",
      Store_Address: "407b1 shreevardhan complex RNT Marg  nIndore",
      Mobile_No: 9425318617,
      Landline_No: "",
      Email: "sethicement@yahoo.in",
      Pin_Code: 452001,
      DT: "NULL",
      Active: 0,
      Latitude: 22.7176946,
      Longitude: 75.8708551,
    },
    {
      id: 2853,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "Croma",
      Contact_name: "",
      Store_Address:
        "The Arena, Mani Nagar, Near Kankaria Lake Gate No. 3, Kankaria,Ahmedabad,380022",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 380022,
      DT: "NULL",
      Active: 0,
      Latitude: 23.0102681,
      Longitude: 72.5969401,
    },
    {
      id: 2854,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Basement of Himalaya Mall, Indraprasth Tower, Drive in Rod, Memnagar, Ahmadabad, 380052, Gujarat,",
      Mobile_No: "",
      Landline_No: "079-6609 5000 5",
      Email: "",
      Pin_Code: 380052,
      DT: "NULL",
      Active: 0,
      Latitude: 23.0466529,
      Longitude: 72.5288093,
    },
    {
      id: 2855,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Satyam 64 ,Ground & 1st Floor opp .Gujarat hight court near Red Carpet Cinema , S.G Highway , Ahmedabad - 380060",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 380060,
      DT: "NULL",
      Active: 0,
      Latitude: 23.0788775,
      Longitude: 72.5240911,
    },
    {
      id: 2856,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground and First Floor, The Emporio, Opposite 4D Square, Near Engineering College, Visat-Gandhinagar Highway, Motera, Ahmedabad-380 005, Gujrat",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 380005,
      DT: "NULL",
      Active: 0,
      Latitude: 23.1059856,
      Longitude: 72.5856402,
    },
    {
      id: 2857,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Dev Arc Mall, Junction of Sg Road and Satellite Road, Next to Fun Republic, Ahmadabad, 380053, Gujarat.",
      Mobile_No: "",
      Landline_No: "079-6609 6000",
      Email: "",
      Pin_Code: 380053,
      DT: "NULL",
      Active: 0,
      Latitude: 23.0269359,
      Longitude: 72.5057687,
    },
    {
      id: 2858,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ratna Business Square, Final Plot No.485, TP Scheme No.3, Near LD College ,Ashram Road, Ahmedabad- 380 009",
      Mobile_No: "",
      Landline_No: "079-65445361",
      Email: "",
      Pin_Code: 380009,
      DT: "NULL",
      Active: 0,
      Latitude: 23.0317802,
      Longitude: 72.549532,
    },
    {
      id: 2859,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "Green House",
      Contact_name: "Mr. Nanish Shah",
      Store_Address: "Skylarc Apt. B H- Siddhivinaya complex Shivranjani",
      Mobile_No: 7575803734,
      Landline_No: "079-40022602",
      Email: "greenhouseenterprise@gmail.com",
      Pin_Code: 380001,
      DT: "NULL",
      Active: 0,
      Latitude: 23.0235018,
      Longitude: 72.5289864,
    },
    {
      id: 2860,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "Keya Digitronics Pvt.Ltd.",
      Contact_name: "mr. Ajay Sinh Chudashma",
      Store_Address: "First Floor Aradhya Complex, Opp. Celebration",
      Mobile_No: 9586092451,
      Landline_No: "",
      Email: "KEYADIGITRONICS2018@GMAIL.COM",
      Pin_Code: 382721,
      DT: "NULL",
      Active: 0,
      Latitude: 23.105971,
      Longitude: 72.481262,
    },
    {
      id: 2861,
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 1,
      Store_name: "P&G interior Gallery",
      Contact_name: "Mr.Biren Gajjar",
      Store_Address: "10 Shivalic arcade, Prahladnagar Garden, 100 feet",
      Mobile_No: 9157747405,
      Landline_No: "",
      Email: "pg_hardware@yahoo.com",
      Pin_Code: 380015,
      DT: "NULL",
      Active: 0,
      Latitude: 23.0116753,
      Longitude: 72.5082066,
    },
    {
      id: 2862,
      Area: "West",
      States: "Gujarat",
      City: "Bhavnagar",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit Nos. G 3 and G 4, “Sun Exotica”, situated at Plot bearing No.16, 65-68, Iscon Megacity, Kalvibid Water Tank to Jewel Circle Road, Bhavnagar-364001, Gujarat.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 364001,
      DT: "NULL",
      Active: 0,
      Latitude: 21.7501354,
      Longitude: 72.1314858,
    },
    {
      id: 2863,
      Area: "West",
      States: "Gujarat",
      City: "Rajkot",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Crystal Mall , Kalvad Main Road , Opp Rani Tower , Rajkot - 360005",
      Mobile_No: "",
      Landline_No: "0281-6455801 8",
      Email: "",
      Pin_Code: 360005,
      DT: "NULL",
      Active: 0,
      Latitude: 22.279853,
      Longitude: 70.7609174,
    },
    {
      id: 2864,
      Area: "West",
      States: "Gujarat",
      City: "Rajkot",
      Category: 1,
      Store_name: "Kitchen Gallery Rajkot",
      Contact_name: "mr.sanjay bhai",
      Store_Address: "opp soham interior,near ashram chowk, tagore road",
      Mobile_No: 9824387588,
      Landline_No: "",
      Email: "kitchengalleryrajkot@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 22.285073,
      Longitude: 70.793084,
    },
    {
      id: 2865,
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Proton Plus, Opposite Khodiyar Temple, L.P. Savani Road, Adajan, Surat – 395 009.",
      Mobile_No: "",
      Landline_No: "0261-6544 760",
      Email: "",
      Pin_Code: 395009,
      DT: "NULL",
      Active: 0,
      Latitude: 21.1870352,
      Longitude: 72.7879764,
    },
    {
      id: 2866,
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Deepkamal Mall ,Beside Toyota showroom ,Sarthana Naka ,Varachha Main Road ,Surat - 395006",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 395006,
      DT: "NULL",
      Active: 0,
      Latitude: 21.2291848,
      Longitude: 72.894624,
    },
    {
      id: 2867,
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 1,
      Store_name: "Kitchen Trendz Surat",
      Contact_name: "mr.jigneshjikamlesh ji",
      Store_Address: "nr.sangam shopping centre parle point",
      Mobile_No: 9879290089,
      Landline_No: "",
      Email: "kitchentrendz@gmail.com",
      Pin_Code: 395007,
      DT: "NULL",
      Active: 0,
      Latitude: 21.170861,
      Longitude: 72.788617,
    },
    {
      id: 2868,
      Area: "West",
      States: "Gujarat",
      City: "Vadodara",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "EVA MALL, Vadodara on First Floor & Unit No. 2, 3, 4, 5, 6, 7 ,on Second Floor,Eva Mall, Patidar Crossing, Near Saraswati Complex, Manjalpur, Vadodara, Gujrat 390011",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 390011,
      DT: "NULL",
      Active: 0,
      Latitude: 22.2734009,
      Longitude: 73.1860785,
    },
    {
      id: 2869,
      Area: "West",
      States: "Gujarat",
      City: "Vadodara",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Centre Square Mall, Survey#54 A 2, Village Wadi, Taluka Vadodara, Near Sarabhai Circle, Opp. Vadodara Central, Vadodara – 390023.",
      Mobile_No: "",
      Landline_No: "0265-2290 155",
      Email: "",
      Pin_Code: 390023,
      DT: "NULL",
      Active: 0,
      Latitude: 22.3182205,
      Longitude: 73.167105,
    },
    {
      id: 2870,
      Area: "West",
      States: "Gujarat",
      City: "Vadodara",
      Category: 1,
      Store_name: "Darshan Hardware & Interior",
      Contact_name: "Mr.Nipam Patel",
      Store_Address: "GF sevorite Complex, SNDT college road, Manisha cr",
      Mobile_No: 9879207944,
      Landline_No: "",
      Email: "darshan.interiorsolution@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 22.2959413,
      Longitude: 73.1665705,
    },
    {
      id: 2871,
      Area: "West",
      States: "Gujarat",
      City: "Vadodara",
      Category: 1,
      Store_name: "Darshan Hardware & Interior",
      Contact_name: "Mr.Nipam Patel",
      Store_Address: "GF sevorite Complex, SNDT college road, Manisha cr",
      Mobile_No: 9879207944,
      Landline_No: "",
      Email: "darshan.interiorsolution@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 22.2959413,
      Longitude: 73.1665705,
    },
    {
      id: 2872,
      Area: "West",
      States: "Gujarat",
      City: "Vadodara",
      Category: 1,
      Store_name: "Swastik Sales",
      Contact_name: "Mr. Yogesh Katta",
      Store_Address: "4 B KIRTIKUNJ SOCIETY, OPP. BUDDHADEV COLONY KAREL",
      Mobile_No: 9824750295,
      Landline_No: "0265-2463605",
      Email: "yogesh katta <yskatta@yahoo.co.in",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 22.333634,
      Longitude: 73.181061,
    },
    {
      id: 2874,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "Gwalior",
      Category: 1,
      Store_name: "Bansal Kitchen App.",
      Contact_name: "Yogesh Bansal",
      Store_Address: "Apte ki payga, Nai Sadak, Lashkar, Gwalior MP-",
      Mobile_No: 8109400400,
      Landline_No: "0751-2429489",
      Email: "yogeshbansal229@gmail.com",
      Pin_Code: 474001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2875,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "Jabalpur",
      Category: 1,
      Store_name: "Shrivika Enterprises",
      Contact_name: "kamlesh vishwakarma",
      Store_Address: "1st floor, chauhans cuboid , beside indore sweets",
      Mobile_No: 9425151066,
      Landline_No: "",
      Email: "shrivikaenterprises@gmail.com",
      Pin_Code: 482001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2876,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "Indore",
      Category: 1,
      Store_name: "New Dimensions",
      Contact_name: "Sourabh Sohani",
      Store_Address: "C8 New Siyaganj  nIndore, Madhya Pradesh",
      Mobile_No: 8878814441,
      Landline_No: "",
      Email: "sourabh.sohani@gmail.com",
      Pin_Code: 452003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2877,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Anantpur",
      Category: 1,
      Store_name: "Ace Computer",
      Contact_name: "r ilyaz",
      Store_Address: "no 14 248, opp balaji complex, near dcms office ,",
      Mobile_No: 9989642076,
      Landline_No: "",
      Email: "acecomputers007@gmail.com",
      Pin_Code: 515001,
      DT: "NULL",
      Active: 0,
      Latitude: 14.682582,
      Longitude: 77.598447,
    },
    {
      id: 2878,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Guntur",
      Category: 1,
      Store_name: "Satavahana enterprises",
      Contact_name: "",
      Store_Address: "Shop no- 1,ramaraju towers, 8 2 arundelpet,guntur",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 16.303399,
      Longitude: 80.4392,
    },
    {
      id: 2879,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ratnaarcade-Kompally ,Ratna Arcade, Ground Floor Survey No. 128,National Highway 44, Kompally, Hyderabad 500014",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 500014,
      DT: "NULL",
      Active: 0,
      Latitude: 17.531735,
      Longitude: 78.4855934,
    },
    {
      id: 2880,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground Flr & First , Plot no.755 , Road no.36 ,Jubille Hills ,Hyderabad -500033",
      Mobile_No: "",
      Landline_No: "040-44778999",
      Email: "",
      Pin_Code: 500033,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4358866,
      Longitude: 78.3988294,
    },
    {
      id: 2881,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Prestige Towers     Ground Flr6-3-664,Panjagutta Main Road, Somajiguda, Hyderabad - 500018",
      Mobile_No: "",
      Landline_No: "040-66534850",
      Email: "",
      Pin_Code: 500018,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4221975,
      Longitude: 78.4530161,
    },
    {
      id: 2882,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground. Floor of building Nagarjuna Ikon, at Plot # 4 part of 5 & 6, Sy. No. 19,Kothaguda, Serlingampally Mandal, Ranga Reddy District, Kondapoor, Hyderabad- 500084.",
      Mobile_No: "",
      Landline_No: "040-64540305",
      Email: "",
      Pin_Code: 500084,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4634029,
      Longitude: 78.3653161,
    },
    {
      id: 2883,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "ATTA-Sirimallesquare-A152,Sirimalle Square Plot Nos.8 9 10,Survey No.523 B, Pillar no.160, Attapur, Rajendra Nagar Mandal,Hyderabad,500048",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 500084,
      DT: "NULL",
      Active: 0,
      Latitude: 17.3591795,
      Longitude: 78.4241545,
    },
    {
      id: 2884,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Croma",
      Contact_name: "",
      Store_Address:
        "Ground Floor, D.V.Cascade, Plot # 59A,59 B,59 C,59 D, In Survey # 9 9, Saroornagar Village, L.B.Nagar, Hyderabad 50007",
      Mobile_No: "",
      Landline_No: "040-69000150",
      Email: "",
      Pin_Code: 50007,
      DT: "NULL",
      Active: 0,
      Latitude: 17.352739,
      Longitude: 78.5444734,
    },
    {
      id: 2885,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Croma No.5-1-63",
      Contact_name: "",
      Store_Address:
        "No.5-1-63, Adjacent to BJP Office,Shanti Nagar, NH-65,Kukatpally, Hyderabad, Hyderabad,500072",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 500072,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4831134,
      Longitude: 78.4118463,
    },
    {
      id: 2886,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Rahul Degitech solution",
      Contact_name: "Suresh Samat",
      Store_Address:
        "Plot no.26, Devi Sharan apartment, Ground floor, S.D Road, Secunderabad",
      Mobile_No: 9849005007,
      Landline_No: "",
      Email: "rahuldevisharan@gmail.com",
      Pin_Code: 500003,
      DT: "NULL",
      Active: 0,
      Latitude: 17.440053,
      Longitude: 78.483095,
    },
    {
      id: 2887,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Kakinda",
      Category: 1,
      Store_name: "venkata chalapathi trades",
      Contact_name: "venkata chalapathi",
      Store_Address: "43-1-47, main road, near kumar bakery, kakinada, e",
      Mobile_No: 9248091116,
      Landline_No: "",
      Email: "vcglass2004@yahoo.com",
      Pin_Code: 533001,
      DT: "NULL",
      Active: 0,
      Latitude: 16.944753,
      Longitude: 82.233486,
    },
    {
      id: 2888,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Kakinda",
      Category: 1,
      Store_name: "Venkata chalapathi tredaers",
      Contact_name: "",
      Store_Address: "43-1-47,main road, Near kumar Bakary, KAKINADA 533",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 523002,
      DT: "NULL",
      Active: 0,
      Latitude: 15.512468,
      Longitude: 80.041536,
    },
    {
      id: 2889,
      Area: "South",
      States: "Andhra Pradesh",
      City: "khammam",
      Category: 1,
      Store_name: "V4 chimni world",
      Contact_name: "",
      Store_Address: "d.no 11-10-707 4 1, bus depot road, Burhanpuram, K",
      Mobile_No: 9246752005,
      Landline_No: "",
      Email: "",
      Pin_Code: 507001,
      DT: "NULL",
      Active: 0,
      Latitude: 17.258411,
      Longitude: 80.142643,
    },
    {
      id: 2890,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Kurnool",
      Category: 1,
      Store_name: "Satya Suma Marketers",
      Contact_name: "bala subramanyam",
      Store_Address: "40 377,vishal shankar , vidya nagar , kurnool",
      Mobile_No: 9440441447,
      Landline_No: "",
      Email: "satyasumaservice@gmail.com",
      Pin_Code: 518001,
      DT: "NULL",
      Active: 0,
      Latitude: 15.830876,
      Longitude: 78.041845,
    },
    {
      id: 2891,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Nellore",
      Category: 1,
      Store_name: "PNR bath house",
      Contact_name: "sarabu kantha rao",
      Store_Address:
        "PLOT NO, 450, D.NO, 23 1550 MINI BYPASS ROAD, OPP, KANCHIPURAM VARAMAHALAKSHMI SILK, MAGUNTA LAYOUT NELLORE-524001",
      Mobile_No: 8885581515,
      Landline_No: "",
      Email: "pnrsons.1@gmail.com",
      Pin_Code: 524001,
      DT: "NULL",
      Active: 0,
      Latitude: 14.447517,
      Longitude: 79.987851,
    },
    {
      id: 2892,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Ongole",
      Category: 1,
      Store_name: "Sri murali krishna enterprises",
      Contact_name: "",
      Store_Address: "Murali krishna enterprises chimakurthi eye hospita",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 523002,
      DT: "NULL",
      Active: 0,
      Latitude: 15.512468,
      Longitude: 80.041536,
    },
    {
      id: 2893,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Rajahmundri",
      Category: 1,
      Store_name: "H.V. Associates",
      Contact_name: "mr.ritesh thakkar",
      Store_Address: "shop no.15, block a, pujari chambers, pachpesi nak",
      Mobile_No: 9424200006,
      Landline_No: "",
      Email: "hvassociatesraipur@gmail.com",
      Pin_Code: 492001,
      DT: "NULL",
      Active: 0,
      Latitude: 21.222575,
      Longitude: 81.646702,
    },
    {
      id: 2894,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Rajahmundri",
      Category: 1,
      Store_name: "shine intex",
      Contact_name: "",
      Store_Address: "d.no 79-7-5, near old somalamma temple, Shyamalan",
      Mobile_No: "",
      Landline_No: "",
      Email: "shineintexind@gmail.com",
      Pin_Code: 533103,
      DT: "NULL",
      Active: 0,
      Latitude: 17.004505,
      Longitude: 81.791798,
    },
    {
      id: 2895,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Secunderabad",
      Category: 1,
      Store_name: "",
      Contact_name: "",
      Store_Address:
        "Ground and first Floor of Plot bearing number H.no: 3-7-222, & 3-7-223, Vikrampuri, Kharkhana, Kakaguda village, Secunderabad, Cantonment-500 009.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 500009,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4587569,
      Longitude: 78.4982693,
    },
    {
      id: 2896,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Tirupati",
      Category: 1,
      Store_name: "sri balaji kitchen concept",
      Contact_name: "munirathnam naidu",
      Store_Address: "d.no 13 7 79618d, tuda road",
      Mobile_No: 9949706878,
      Landline_No: "",
      Email: "vmrnaidu3@gmail.com",
      Pin_Code: 517501,
      DT: "NULL",
      Active: 1,
      Latitude: 13.624462,
      Longitude: 79.431006,
    },
    {
      id: 2897,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Tirupati",
      Category: 1,
      Store_name: "Sri Srinivasa Enterprises",
      Contact_name: "muniratnam",
      Store_Address: "door no : 13-5-531 a5 , thatha nagar , opp tmc , c",
      Mobile_No: 9440070610,
      Landline_No: "",
      Email: "srisrinivasaenterprisestpt@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 1,
      Latitude: 13.632081,
      Longitude: 79.417688,
    },
    {
      id: 2898,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vijaywada",
      Category: 1,
      Store_name: "Image marketing agencies",
      Contact_name: "",
      Store_Address: "image marketing agencies, opp. Gev radha madav, Pi",
      Mobile_No: 9866156677,
      Landline_No: "0866-2473494",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 16.502433,
      Longitude: 80.652581,
    },
    {
      id: 2899,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vijaywada",
      Category: 1,
      Store_name: "Image marketing agencies",
      Contact_name: "",
      Store_Address: "#29-37-87,near vijaya talkies center,eluru road,vi",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 16.502433,
      Longitude: 80.652581,
    },
    {
      id: 2900,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vijaywada",
      Category: 1,
      Store_name: "Kabinett modular furniture",
      Contact_name: "",
      Store_Address: "shop no.1, first floor,Bhaskar plaza, gopal reddyl",
      Mobile_No: 93962220004,
      Landline_No: "",
      Email: "",
      Pin_Code: 520002,
      DT: "NULL",
      Active: 0,
      Latitude: 16.51395,
      Longitude: 80.628529,
    },
    {
      id: 2901,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vijaywada",
      Category: 1,
      Store_name: "v4interiors",
      Contact_name: "",
      Store_Address: "Plot no 35G, 100 feet road, Jawahar auto Nagar, ne",
      Mobile_No: 8662541004,
      Landline_No: "",
      Email: "v4interiorz@gmail.com",
      Pin_Code: 520007,
      DT: "NULL",
      Active: 0,
      Latitude: 16.506169,
      Longitude: 80.675824,
    },
    {
      id: 2902,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vishakapatnam",
      Category: 1,
      Store_name: "instruments care",
      Contact_name: "k.devikarani",
      Store_Address: "ramatalkies road",
      Mobile_No: 8916666181,
      Landline_No: "",
      Email: "lifesolutionsic@gmail.com",
      Pin_Code: 530016,
      DT: "NULL",
      Active: 0,
      Latitude: 17.72781,
      Longitude: 83.311723,
    },
    {
      id: 2903,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vishakapatnam",
      Category: 1,
      Store_name: "svskml quality home mart",
      Contact_name: "Vizag",
      Store_Address:
        "Door no. 49-24-75,1 st floor, sanker matam road, opp sankermatam vishakapatanam, Andhra Pradesh",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 530003,
      DT: "NULL",
      Active: 0,
      Latitude: 14.762005,
      Longitude: 78.874889,
    },
    {
      id: 2904,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vishakapatnam",
      Category: 1,
      Store_name: "Target Marketing",
      Contact_name: "murlidhar k",
      Store_Address: "opp t s r complex",
      Mobile_No: 9246613788,
      Landline_No: "",
      Email: "targetmarketing@sify.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 1,
      Latitude: 17.724608,
      Longitude: 83.305295,
    },
    {
      id: 2905,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vishakapatnam",
      Category: 1,
      Store_name: "Target Marketing Vishakapatnam",
      Contact_name: "mr. muraladhar",
      Store_Address: "47 15 12, opp, tsr complex, dwark nagar, 530016.vi",
      Mobile_No: 9246613788,
      Landline_No: "",
      Email: "targetmarketing@sify.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.7248375,
      Longitude: 83.3028937,
    },
    {
      id: 2906,
      Area: "South",
      States: "Andhra Pradesh",
      City: "VIZAG",
      Category: 1,
      Store_name: "Target marketing",
      Contact_name: "",
      Store_Address: "47-15-12,opp-t.s.r complex , dwaraknagar,vizag -16",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.724967,
      Longitude: 83.304667,
    },
    {
      id: 2907,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Aakar services",
      Contact_name: "Mr Niranjan",
      Store_Address: "New tippasandra main Road. Bangalore",
      Mobile_No: 9845462349,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.972472,
      Longitude: 77.653625,
    },
    {
      id: 2908,
      Area: "south",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "ANUPAMA ENETRPRISES",
      Contact_name: "MR PRAVIN",
      Store_Address: "CS ORCHIDS,#2231 16 11th main Road. Jayanagar east",
      Mobile_No: 8553164260,
      Landline_No: "080-41307544",
      Email: "anupamamanak@gmail.com",
      Pin_Code: 560011,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9336736,
      Longitude: 77.589965,
    },
    {
      id: 2909,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Chaff Solution",
      Contact_name: "mani chowdary",
      Store_Address: "no 06, pr layout, munnekolala, marathahalli",
      Mobile_No: 8494951006,
      Landline_No: "",
      Email: "chaffsolutions@gmail.com",
      Pin_Code: 560037,
      DT: "NULL",
      Active: 0,
      Latitude: 12.950881,
      Longitude: 77.703641,
    },
    {
      id: 2910,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground and First Floor, Shravanee’s Krishna Mansion Plot No.31, 100 Feet Road, 2nd Block, Jayanagar, Bangalore-560 011",
      Mobile_No: "",
      Landline_No: "080-67330434",
      Email: "",
      Pin_Code: 560011,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9397669,
      Longitude: 77.582821,
    },
    {
      id: 2911,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground floor & First Floor ,Woodys ,45 1-1, 17th Main , 5th Cross , 2nd Phase , Marehalli Road , J.P Nagar , Bangalore - 560078",
      Mobile_No: "",
      Landline_No: "080-65395802",
      Email: "",
      Pin_Code: 560078,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9166022,
      Longitude: 77.5891083,
    },
    {
      id: 2912,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "S S Manor ,chelikere ring road,Chikka Tayapa Reddy Layout, Kalyana Nagar Post, Bangalore-560043.",
      Mobile_No: "",
      Landline_No: "080-67127288  6",
      Email: "",
      Pin_Code: 560043,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0258896,
      Longitude: 77.6387841,
    },
    {
      id: 2913,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Plot bearing No.32, Allalasandra Village, B.B.Road, Yelahanka, Bangalore-560064",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 560064,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0920181,
      Longitude: 77.5917311,
    },
    {
      id: 2914,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "P.R. Business Centre, Survey No.36 2 (p) and 37 1 (p), Kadubeesanahalli, Marathahalli, Sarjapur, Outer Ring Road, Bangalore-560034",
      Mobile_No: "",
      Landline_No: "080-67747600 01",
      Email: "",
      Pin_Code: 560034,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9431293,
      Longitude: 77.6956571,
    },
    {
      id: 2915,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Miraya Rose, Survey No.66 1 (Old No.66),Situated at Siddapura Village, Varthur Hobli ,Bangalore,560066",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 560066,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9568247,
      Longitude: 77.7302372,
    },
    {
      id: 2916,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground Floor, Total Mall, at Kaikondarhalli Village, Varthurhobli, Sarjapur Road, Bangalore:560035",
      Mobile_No: "",
      Landline_No: "080-67619500",
      Email: "",
      Pin_Code: 560035,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9167978,
      Longitude: 77.6693743,
    },
    {
      id: 2917,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground Floor , Indraprastha Equinox , Plot no.23 , 100 Feet Inner Ring Road Koramangala Bangalore - 560095",
      Mobile_No: "",
      Landline_No: "080-65395817 19",
      Email: "",
      Pin_Code: 560095,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9380356,
      Longitude: 77.6268423,
    },
    {
      id: 2918,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit Anchor No.1,Royal Meenakshi Mall,Opposite Meenakshi Temple, Bannergatta Road, Bangalore - 560076",
      Mobile_No: "",
      Landline_No: "080-67039130",
      Email: "",
      Pin_Code: 560076,
      DT: "NULL",
      Active: 0,
      Latitude: 12.8760657,
      Longitude: 77.5939496,
    },
    {
      id: 2919,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "S.R.P. Arcade, 30 31, 6th Phase, Banshankari, 3rd Stage, 100 ft Ring Road, Bangalore-560085",
      Mobile_No: "",
      Landline_No: "080-67880500",
      Email: "",
      Pin_Code: 560085,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9242749,
      Longitude: 77.5507641,
    },
    {
      id: 2920,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Rajaji nagar -Plot No-385 11, 19th G Main, 1st N Block, Rajaji Nagar, Bangalore – 560 010.",
      Mobile_No: "",
      Landline_No: "080-64540136",
      Email: "",
      Pin_Code: 560010,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0040302,
      Longitude: 77.5497593,
    },
    {
      id: 2921,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "CROMA Plot No.20 Samarth",
      Contact_name: "",
      Store_Address:
        "Plot No.20 Samarth , New BEL Road ,Jaladarshini Layout , Bangalore - 560054",
      Mobile_No: "",
      Landline_No: "080-67619500",
      Email: "",
      Pin_Code: 560054,
      DT: "NULL",
      Active: 0,
      Latitude: 13.03184,
      Longitude: 77.5677403,
    },
    {
      id: 2922,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Croma Unit No.1",
      Contact_name: "",
      Store_Address:
        "Unit No.1 UG 33 to UG 38, Upper Ground Floor, Mantri Square Mall, Malleshwaram, Bangalore",
      Mobile_No: 99,
      Landline_No: "",
      Email: "",
      Pin_Code: 560003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2923,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "FRANKE FABER ORIENTATION CENTRE",
      Contact_name: "Mr Karthik",
      Store_Address: "Near southindies Hotel. KH road.Basavangudi",
      Mobile_No: 9611165639,
      Landline_No: "",
      Email: "shivakumar.s@franke.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9390113,
      Longitude: 77.5756267,
    },
    {
      id: 2924,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Galleria IN",
      Contact_name: "mr. christine",
      Store_Address: "#159 2 40,15th cross,mts layout,80ft road,kengeri",
      Mobile_No: 9945784718,
      Landline_No: "",
      Email: "fabergalleria.in@gamil.com",
      Pin_Code: 560060,
      DT: "NULL",
      Active: 0,
      Latitude: 12.927441,
      Longitude: 77.486446,
    },
    {
      id: 2925,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Hitech Kitchens",
      Contact_name: "mr. fasiuallah khan",
      Store_Address: "RT Nagar Main road. Above raj Lassi bar",
      Mobile_No: 9845198617,
      Landline_No: "",
      Email: "fassiulla24khan@yahoo.com",
      Pin_Code: 560052,
      DT: "NULL",
      Active: 0,
      Latitude: 12.990154,
      Longitude: 77.591153,
    },
    {
      id: 2926,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Hosur Main Road Electronic City",
      Contact_name: "Mr Ravi Reddy",
      Store_Address: "1st Floor. Next to Purava west end, Kudlu gate. Op",
      Mobile_No: 9845533929,
      Landline_No: "",
      Email: "ravireddyfaber@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.884852,
      Longitude: 77.650303,
    },
    {
      id: 2927,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "HR Enterprises",
      Contact_name: "shreekanta",
      Store_Address: "no 347, ground floor, gangamma temple road, 1st ma",
      Mobile_No: 9901072626,
      Landline_No: "",
      Email: "hrenterprises6@gmail.com",
      Pin_Code: 560092,
      DT: "NULL",
      Active: 0,
      Latitude: 13.015663,
      Longitude: 77.542198,
    },
    {
      id: 2928,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Ideas",
      Contact_name: "mr. ajay parab",
      Store_Address: "204, 1st floor, 100 ft ring road, 2nd block, Bana",
      Mobile_No: 9342534865,
      Landline_No: "",
      Email: "ajayparab@hotmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.959822,
      Longitude: 77.645094,
    },
    {
      id: 2929,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Ideas",
      Contact_name: "mr. ajay parab",
      Store_Address: "30, anjeneya complex. next to mobile shop old ai",
      Mobile_No: "",
      Landline_No: 25274465,
      Email: "ajayparab@hotmail.com",
      Pin_Code: 560008,
      DT: "NULL",
      Active: 0,
      Latitude: 12.959822,
      Longitude: 77.645094,
    },
    {
      id: 2930,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Ideas",
      Contact_name: "mr. ajay parab",
      Store_Address: "site no 7, 1st foor,near marathalli bridge,opp k",
      Mobile_No: 7829710280,
      Landline_No: "",
      Email: "ajayparab@hotmail.com",
      Pin_Code: 560037,
      DT: "NULL",
      Active: 0,
      Latitude: 12.959822,
      Longitude: 77.645094,
    },
    {
      id: 2931,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "KR Enterprises",
      Contact_name: "sarath babu",
      Store_Address: "no-2, ground floor rahul mansion tata nagar- kodeg",
      Mobile_No: 9964256677,
      Landline_No: "",
      Email: "babusarath81@gmail.com",
      Pin_Code: 560092,
      DT: "NULL",
      Active: 0,
      Latitude: 13.055419,
      Longitude: 77.573273,
    },
    {
      id: 2932,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "KRISH INTERIORS",
      Contact_name: "Mr Kiran patel",
      Store_Address: "Opp John Distillaries. Mysore Road",
      Mobile_No: 9886305102,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.904151,
      Longitude: 77.564743,
    },
    {
      id: 2933,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "KRISHH INTERIOR DESIGN STUDIO",
      Contact_name: "Mr. Kiran",
      Store_Address: "18 4, Mysore Road, Nayandahalli,",
      Mobile_No: 9886305102,
      Landline_No: "",
      Email: "krishhidstudio@gmail.com",
      Pin_Code: 560039,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2934,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "KVR Franchises",
      Contact_name: "mr. kanaka raj",
      Store_Address: "273, amruthalli , new airport road bangalore",
      Mobile_No: 9886546039,
      Landline_No: "",
      Email: "kanakaraj.krk@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0634996,
      Longitude: 77.6477035,
    },
    {
      id: 2935,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Mahaveer",
      Contact_name: "Mr Mahaveer",
      Store_Address: "Bannergatta Main road,bangalore",
      Mobile_No: 9845030960,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.900891,
      Longitude: 77.6193205,
    },
    {
      id: 2936,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Maya Interiors",
      Contact_name: "Mr Sampath",
      Store_Address: "Panattur. Kadubisnalli",
      Mobile_No: 9632775326,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9382446,
      Longitude: 77.7150921,
    },
    {
      id: 2937,
      Area: "south",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Mutta appliances",
      Contact_name: "Mr Mukesh",
      Store_Address: "BVK ayengar road. Near Abhinaya theatre.",
      Mobile_No: 9986036666,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.973537,
      Longitude: 77.577553,
    },
    {
      id: 2938,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Neugen Marketing",
      Contact_name: "mr. srinivas",
      Store_Address: "no. 101   9 apple city, seegehalli, kadugodi main",
      Mobile_No: 9343754127,
      Landline_No: "",
      Email: "srinivas.neugen@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.922652,
      Longitude: 77.56975,
    },
    {
      id: 2939,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Neugen Marketing",
      Contact_name: "mr. srinivas",
      Store_Address: "1 st floor. Muthanallur Viigae Main Road",
      Mobile_No: 9343754127,
      Landline_No: "",
      Email: "srinivas.neugen@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.922652,
      Longitude: 77.56975,
    },
    {
      id: 2940,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Neugen Marketing",
      Contact_name: "",
      Store_Address:
        "Bldg no:69,Shop no:7,    AGR Tower    ,Kaikindanahalli,Sarjapur Main road,Bangalore",
      Mobile_No: "",
      Landline_No: 9343754127,
      Email: "srinivas.neugen@yahoo.com",
      Pin_Code: 560035,
      DT: "NULL",
      Active: 0,
      Latitude: 12.922652,
      Longitude: 77.56975,
    },
    {
      id: 2941,
      Area: "south",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "NEW SRIRAM CERAMICS",
      Contact_name: "Mr Ravindra",
      Store_Address: "No.12. 2nd Floor,Vishnu Plaza,Reservior street. Ka",
      Mobile_No: 7625094878,
      Landline_No: "080-26621026",
      Email: "info@sriramdistributors.com",
      Pin_Code: 560004,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9388988,
      Longitude: 77.5755519,
    },
    {
      id: 2942,
      Area: "south",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Sachin Light House",
      Contact_name: "Mr Sachin",
      Store_Address: "#9,2nd Cross KG road. Bangalore",
      Mobile_No: 9035283456,
      Landline_No: "",
      Email: "sachin@sachinlighthouse.com",
      Pin_Code: 560009,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9731643,
      Longitude: 77.5785277,
    },
    {
      id: 2943,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Sampurna Enterprises",
      Contact_name: "Mr Basavana Gowda",
      Store_Address: "no,3, deviplaza, 9th d cross, 4th blk, hbr layout,",
      Mobile_No: 9964698848,
      Landline_No: "",
      Email: "sampurna888@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 13.027953,
      Longitude: 77.632656,
    },
    {
      id: 2944,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Sampurna International",
      Contact_name: "Mr Mahesh Kumar",
      Store_Address: "20, unique corner, battarahalli, kr pura, old madr",
      Mobile_No: 9242898587,
      Landline_No: "",
      Email: "sampurnain9@gmail.com",
      Pin_Code: 560009,
      DT: "NULL",
      Active: 0,
      Latitude: 13.016825,
      Longitude: 77.661917,
    },
    {
      id: 2945,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Sampurna International",
      Contact_name: "mr. mahesh",
      Store_Address: "1st Floor. New Airport Road. Kogilur cross",
      Mobile_No: 9242898587,
      Landline_No: "",
      Email: "sampurna888@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 13.016825,
      Longitude: 77.661917,
    },
    {
      id: 2946,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Shringar electricals",
      Contact_name: "Mr pramod",
      Store_Address: "jayangar 4th block. Bangalore",
      Mobile_No: 9900242522,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.93075,
      Longitude: 77.5843056,
    },
    {
      id: 2947,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "SM INTERIORS",
      Contact_name: "MR Ramesh",
      Store_Address: "1st Floor. BTM Layout. Above Ambica Kitchen",
      Mobile_No: 9916268874,
      Landline_No: "",
      Email: "sminteriorstudio@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.916563,
      Longitude: 77.60296,
    },
    {
      id: 2948,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Sneha Solar",
      Contact_name: "Mr Dileep",
      Store_Address: "opp Udupi grand hotel. Near Nagarbhavi BDA COMPLEX",
      Mobile_No: 9845702666,
      Landline_No: "",
      Email: "dilipsolar@gmail.com",
      Pin_Code: 560091,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9743824,
      Longitude: 77.509358,
    },
    {
      id: 2949,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Sterling Incorporators",
      Contact_name: "mr. dinesh sharma",
      Store_Address: "5th Cross. Malleshwaram Main road. Newr Junction",
      Mobile_No: 9880067829,
      Landline_No: "",
      Email: "sterlingblr10@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.991729,
      Longitude: 77.55961,
    },
    {
      id: 2950,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "Whitefield Associates",
      Contact_name: "Mr Binish",
      Store_Address: "Raheja Arcade. Koramangala",
      Mobile_No: 9945773654,
      Landline_No: "",
      Email: "faberbangalore@gmail.com",
      Pin_Code: 560010,
      DT: "NULL",
      Active: 0,
      Latitude: 12.955719,
      Longitude: 77.720256,
    },
    {
      id: 2951,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 1,
      Store_name: "ZURICH KITCHEN",
      Contact_name: "Ms. Anitha",
      Store_Address:
        "1st Floor, No:12, Vishnu Plaza, reservoir street, Basavangudi, Bangalore",
      Mobile_No: 8553443359,
      Landline_No: "",
      Email: "zurichkitchen@gmail.com",
      Pin_Code: 560004,
      DT: "NULL",
      Active: 0,
      Latitude: 12.93764,
      Longitude: 77.57294,
    },
    {
      id: 2952,
      Area: "South",
      States: "Karnataka",
      City: "Belgaum",
      Category: 1,
      Store_name: "Green Ferns",
      Contact_name: "surendar patnekar",
      Store_Address: "1769, kelakar baug, near hotel vaishali",
      Mobile_No: 9448123980,
      Landline_No: "",
      Email: "customercare@greenferns.in",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 15.860355,
      Longitude: 74.508085,
    },
    {
      id: 2953,
      Area: "south",
      States: "Karnataka",
      City: "Bellary",
      Category: 1,
      Store_name: "Stylish living",
      Contact_name: "Mr Vishal",
      Store_Address: "Near saibaba Temple road. Bellary",
      Mobile_No: 9449075456,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 15.1418258,
      Longitude: 76.9413623,
    },
    {
      id: 2954,
      Area: "South",
      States: "Karnataka",
      City: "BANGALORE",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Unit No. F69, First Floor, Phoenix Market City, Mahadevpura, Nr. Krishnarajapuram Flyover,.",
      Mobile_No: "080-65690036",
      Landline_No: "080-65690036",
      Email: "",
      Pin_Code: 560048,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 2955,
      Area: "south",
      States: "Karnataka",
      City: "Bijapur",
      Category: 1,
      Store_name: "Homes solution",
      Contact_name: "Mr amit",
      Store_Address: "Near Basaveshwar temple. Bijapur",
      Mobile_No: 9448369811,
      Landline_No: "",
      Email: "home.solutions.bjp@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 16.8304977,
      Longitude: 75.7117414,
    },
    {
      id: 2956,
      Area: "South",
      States: "Karnataka",
      City: "Chickmangalore",
      Category: 1,
      Store_name: "MUDUMANE",
      Contact_name: "Mr.SHIVU",
      Store_Address:
        "Opp: Basava Mandira,1st stage, CDA layout, bye pass road, Kalyananagar, CHIKKAMANGALUR",
      Mobile_No: 7769951278,
      Landline_No: "",
      Email: "mudumane@gmail.com",
      Pin_Code: 577102,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9174,
      Longitude: 77.60086,
    },
    {
      id: 2957,
      Area: "south",
      States: "Karnataka",
      City: "Chickmangalore",
      Category: 1,
      Store_name: "Shoba Enterprises",
      Contact_name: "Mr Manu",
      Store_Address: "MG Road.Chickmangalore",
      Mobile_No: 9738126617,
      Landline_No: "",
      Email: "shobhaenterprisesckm@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 13.3207377,
      Longitude: 75.7740168,
    },
    {
      id: 2958,
      Area: "South",
      States: "Karnataka",
      City: "Davangare",
      Category: 1,
      Store_name: "Pujar Alluminium",
      Contact_name: "Mr Chetan",
      Store_Address: "PB road. Opp reliance Digital. Near BSNL Signal .",
      Mobile_No: 9731855225,
      Landline_No: "",
      Email: "chetangpujar26@gmail.com",
      Pin_Code: 577002,
      DT: "NULL",
      Active: 0,
      Latitude: 14.467284,
      Longitude: 75.91856,
    },
    {
      id: 2959,
      Area: "south",
      States: "Karnataka",
      City: "Davangare",
      Category: 1,
      Store_name: "Pujar Alluminium Company",
      Contact_name: "Mr Chetan",
      Store_Address: "#318 10 BG Plaza.Near devraj arus layout.A block.P",
      Mobile_No: 9980755224,
      Landline_No: "08192-250303",
      Email: "pujarpss@gmail.com",
      Pin_Code: 577006,
      DT: "NULL",
      Active: 0,
      Latitude: 14.4591038,
      Longitude: 75.9321194,
    },
    {
      id: 2960,
      Area: "south",
      States: "Karnataka",
      City: "Davangare",
      Category: 1,
      Store_name: "Rasoi",
      Contact_name: "Mr Deepak",
      Store_Address: "near bapuji Hospital. Davangere",
      Mobile_No: 8904535273,
      Landline_No: "",
      Email: "",
      Pin_Code: 577002,
      DT: "NULL",
      Active: 0,
      Latitude: 14.45699,
      Longitude: 75.919623,
    },
    {
      id: 2961,
      Area: "South",
      States: "Karnataka",
      City: "Gulburga",
      Category: 1,
      Store_name: "maniyar interior mall",
      Contact_name: "mr. md maniyar",
      Store_Address: "plot no. 21, super market,1st floor, hotel salwa ,",
      Mobile_No: 9342515732,
      Landline_No: "",
      Email: "",
      Pin_Code: 585101,
      DT: "NULL",
      Active: 0,
      Latitude: 17.339588,
      Longitude: 76.837429,
    },
    {
      id: 2962,
      Area: "south",
      States: "Karnataka",
      City: "Hospet",
      Category: 1,
      Store_name: "I Homes",
      Contact_name: "Mr Komal",
      Store_Address: "No 5. 11th ward.Opp mallige Hospital.ISR Road.Hosp",
      Mobile_No: 8762530987,
      Landline_No: "",
      Email: "ihomeshpt@gmail.com",
      Pin_Code: 583225,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9851511,
      Longitude: 77.5803788,
    },
    {
      id: 2963,
      Area: "South",
      States: "Karnataka",
      City: "Hubli",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address: "Signature Mall, Gokul Road - Hubli 580030",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 580030,
      DT: "NULL",
      Active: 0,
      Latitude: 15.3506613,
      Longitude: 75.1095096,
    },
    {
      id: 2964,
      Area: "South",
      States: "Karnataka",
      City: "Hubli",
      Category: 1,
      Store_name: "fast track",
      Contact_name: "sushant",
      Store_Address: "shop no. 212, i t park complex , opp, glass house",
      Mobile_No: 9448482699,
      Landline_No: "",
      Email: "",
      Pin_Code: 580020,
      DT: "NULL",
      Active: 0,
      Latitude: 15.351085,
      Longitude: 75.132921,
    },
    {
      id: 2965,
      Area: "South",
      States: "Karnataka",
      City: "Hubli",
      Category: 1,
      Store_name: "N K Enterprises Hubli",
      Contact_name: "Mr. rajubhai",
      Store_Address: "co sattapa khondanpur, 6, ullagaddi street",
      Mobile_No: 9448488699,
      Landline_No: "",
      Email: "nkenterprises9@yahoo.com",
      Pin_Code: 580020,
      DT: "NULL",
      Active: 0,
      Latitude: 15.3533692,
      Longitude: 75.1301635,
    },
    {
      id: 2966,
      Area: "South",
      States: "Karnataka",
      City: "Hubli",
      Category: 1,
      Store_name: "NK Enterprises",
      Contact_name: "amol naik",
      Store_Address: "# 212, opp to glass house, i t park",
      Mobile_No: 9448482699,
      Landline_No: "",
      Email: "nkenterprises@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 15.35337,
      Longitude: 75.132351,
    },
    {
      id: 2967,
      Area: "South",
      States: "Karnataka",
      City: "Mangalore",
      Category: 1,
      Store_name: "kitchens & hobs",
      Contact_name: "shubha n shetty",
      Store_Address: "janvi plaza,bunts hostel.mangalore",
      Mobile_No: "",
      Landline_No: "0824 4256421",
      Email: "kitchens&hobs@gmail.com",
      Pin_Code: 575004,
      DT: "NULL",
      Active: 0,
      Latitude: 12.876559,
      Longitude: 74.847298,
    },
    {
      id: 2968,
      Area: "south",
      States: "Karnataka",
      City: "Mangalore",
      Category: 1,
      Store_name: "Power solution",
      Contact_name: "Mr roshan d souza",
      Store_Address: "K.S.Rao Memorial Building,light house,Hill Road. M",
      Mobile_No: 9164577555,
      Landline_No: "0824-4277747,91",
      Email: "powersolution.mang@gmail.com",
      Pin_Code: 575001,
      DT: "NULL",
      Active: 0,
      Latitude: 12.8713889,
      Longitude: 74.8456389,
    },
    {
      id: 2969,
      Area: "South",
      States: "Karnataka",
      City: "Mangalore",
      Category: 1,
      Store_name: "RM enterprises",
      Contact_name: "mr.lanvil robin monteiro",
      Store_Address: "beetle arcade, near k.s.r.t.c bus stand ,bejai, ma",
      Mobile_No: 9916643841,
      Landline_No: "0824 4283484",
      Email: "rmenterprises90@gmail.com",
      Pin_Code: 575003,
      DT: "NULL",
      Active: 0,
      Latitude: 12.885772,
      Longitude: 74.842874,
    },
    {
      id: 2970,
      Area: "South",
      States: "Karnataka",
      City: "Mangalore",
      Category: 1,
      Store_name: "SR Enterprises",
      Contact_name: "prashanth",
      Store_Address: "2nd floor, emporium commercial complex, old pump w",
      Mobile_No: 9739716417,
      Landline_No: "",
      Email: "srenterpriseshsn@gmail.com",
      Pin_Code: 575002,
      DT: "NULL",
      Active: 0,
      Latitude: 12.867528,
      Longitude: 74.859117,
    },
    {
      id: 2971,
      Area: "South",
      States: "Karnataka",
      City: "Mysore",
      Category: 1,
      Store_name: "Global Enterprises",
      Contact_name: "abdul azeez",
      Store_Address: "shop no 1 , survey no 7 , n r mohalla , aj block",
      Mobile_No: 9035041368,
      Landline_No: "",
      Email: "globalentmysore@gmail.com",
      Pin_Code: 570007,
      DT: "NULL",
      Active: 0,
      Latitude: 12.32698,
      Longitude: 76.66129,
    },
    {
      id: 2972,
      Area: "south",
      States: "Karnataka",
      City: "Mysore",
      Category: 1,
      Store_name: "Sree Mahaveer distributor",
      Contact_name: "Mr Manu",
      Store_Address: "New no M-123. KRH ROAD,Near Cayvery emporium Cross",
      Mobile_No: 9845353626,
      Landline_No: "0821-2434845",
      Email: "smdmysore@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.31289,
      Longitude: 76.65394,
    },
    {
      id: 2973,
      Area: "South",
      States: "Karnataka",
      City: "Mysore",
      Category: 1,
      Store_name: "New Sriram Ceramics",
      Contact_name: "Mr. Ashwin Kumar",
      Store_Address: "# 1090, Sigma Complex, M G Road, Near Law Court Mysore",
      Mobile_No: 7625094878,
      Landline_No: "08212334448 49",
      Email: "sales@newsriramceramics.com",
      Pin_Code: 560005,
      DT: "NULL",
      Active: 0,
      Latitude: 12.299693,
      Longitude: 76.638845,
    },
    {
      id: 2974,
      Area: "South",
      States: "Karnataka",
      City: "Tumkur",
      Category: 1,
      Store_name: "Kitchen Solutions",
      Contact_name: "ms. bindu",
      Store_Address: "shivashree, mahalakshmi nagar, batwadi.",
      Mobile_No: 9900159293,
      Landline_No: "",
      Email: "kitchensolution20@gmail.com",
      Pin_Code: 572103,
      DT: "NULL",
      Active: 0,
      Latitude: 13.331419,
      Longitude: 77.128382,
    },
    {
      id: 2975,
      Area: "south",
      States: "Karnataka",
      City: "Tumkur",
      Category: 1,
      Store_name: "Sri Sai Distributors",
      Contact_name: "Mrs Bindhu",
      Store_Address: "1st floor,Prashantha Nagar.Tumkur",
      Mobile_No: 9900159293,
      Landline_No: 9449285906,
      Email: "srisaidistributors1702@gmail.com",
      Pin_Code: 572103,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9790324,
      Longitude: 77.532563,
    },
    {
      id: 2976,
      Area: "south",
      States: "Kerala",
      City: "Adoor",
      Category: 1,
      Store_name: "George Sons & Company",
      Contact_name: "",
      Store_Address: "K P Road, Adoor,",
      Mobile_No: "",
      Landline_No: "04734 228398, 3",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.152379,
      Longitude: 76.739124,
    },
    {
      id: 2977,
      Area: "south",
      States: "Kerala",
      City: "Aluva",
      Category: 1,
      Store_name: "Mattakkal Interior Home",
      Contact_name: "",
      Store_Address: "Moopan Building, Ground Floor,Company Padi, Aluva,",
      Mobile_No: "",
      Landline_No: 6511334,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.0744528,
      Longitude: 76.298128,
    },
    {
      id: 2978,
      Area: "south",
      States: "Kerala",
      City: "Anchal",
      Category: 1,
      Store_name: "HELANA AGENCIES, ANCHAL",
      Contact_name: "",
      Store_Address: "Ist Floor,Kallumkal Tower,, Anchal, Kollam",
      Mobile_No: 94474537,
      Landline_No: "0475 2273256",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.9270397,
      Longitude: 76.9201011,
    },
    {
      id: 2979,
      Area: "south",
      States: "Kerala",
      City: "Anchal",
      Category: 1,
      Store_name: "Jose Electricals (Anchal)",
      Contact_name: "",
      Store_Address: "Alithottathil Tower, R. O , Junction, Anchal",
      Mobile_No: 9447021927,
      Landline_No: "0475 2271927",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.9287706,
      Longitude: 76.9138482,
    },
    {
      id: 2980,
      Area: "south",
      States: "Kerala",
      City: "Angamaly",
      Category: 1,
      Store_name: "Kachapilly Agencies MS",
      Contact_name: "",
      Store_Address: "Highway, Angamaly",
      Mobile_No: 9495315931,
      Landline_No: "2452128 2456728",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.1919469,
      Longitude: 76.3866862,
    },
    {
      id: 2981,
      Area: "south",
      States: "Kerala",
      City: "Balussery",
      Category: 1,
      Store_name: "Calicut Glass House Plywood & Hardware",
      Contact_name: "",
      Store_Address: "Balusheri Mukku, Balusheri, Calicutt",
      Mobile_No: 9847562925,
      Landline_No: "0496 2642699",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.4457972,
      Longitude: 75.8350215,
    },
    {
      id: 2982,
      Area: "south",
      States: "Kerala",
      City: "Bathery",
      Category: 1,
      Store_name: "ABC HARDWARE",
      Contact_name: "",
      Store_Address: "Gandhi Junction,, Sulthan Batherry, Wayanad-673592",
      Mobile_No: 8606415485,
      Landline_No: "04936-224485",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.6607645,
      Longitude: 76.2566368,
    },
    {
      id: 2983,
      Area: "south",
      States: "Kerala",
      City: "Bye Pass",
      Category: 1,
      Store_name: "Forhome",
      Contact_name: "",
      Store_Address: "Opp. EMC,Bye Pass, Ernakulam",
      Mobile_No: "",
      Landline_No: "0484-2345629",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.9914231,
      Longitude: 76.3192037,
    },
    {
      id: 2984,
      Area: "south",
      States: "Kerala",
      City: "calicut",
      Category: 1,
      Store_name: "White Field Associates",
      Contact_name: "",
      Store_Address: "Bharath Towers , Opp Narayana Petrol Pump, YMCA Cr",
      Mobile_No: "",
      Landline_No: "0495-2360048",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9697999,
      Longitude: 77.7499467,
    },
    {
      id: 2985,
      Area: "south",
      States: "Kerala",
      City: "Chalakkudy",
      Category: 1,
      Store_name: "Kallarackals House of Hardwares & Kitchens",
      Contact_name: "",
      Store_Address: "Near St.James Hospital , Chalakudy,",
      Mobile_No: "",
      Landline_No: ":04802711929",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.3138379,
      Longitude: 76.3349329,
    },
    {
      id: 2986,
      Area: "south",
      States: "Kerala",
      City: "Changaramkulam",
      Category: 1,
      Store_name: "BUILDBASE TRADING COMPANY PRIVATE LIMITED",
      Contact_name: "",
      Store_Address: "17 757, CALICUT ROAD, CHANGARAMKULAM, P.O ALAMKODE",
      Mobile_No: 9995465500,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.1213216,
      Longitude: 76.111634,
    },
    {
      id: 2987,
      Area: "south",
      States: "Kerala",
      City: "Chelari",
      Category: 1,
      Store_name: "CHELARI TRADINGS",
      Contact_name: "",
      Store_Address: "THAZHE CHELARI, CALICUT ROAD, VELIMUKKU P.O, CHELA",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.105224,
      Longitude: 75.926165,
    },
    {
      id: 2988,
      Area: "south",
      States: "Kerala",
      City: "Cherpulashery",
      Category: 1,
      Store_name: "Classy Sleek",
      Contact_name: "",
      Store_Address: "Ottapalam Road, Cherppulassery, Palakkad Dist.",
      Mobile_No: 8592900099,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.8789059,
      Longitude: 76.3113655,
    },
    {
      id: 2989,
      Area: "south",
      States: "Kerala",
      City: "Cherthala",
      Category: 1,
      Store_name: "C V R SANIWARES",
      Contact_name: "",
      Store_Address: "Nadakkavu Road,, Cherthala",
      Mobile_No: "",
      Landline_No: "0478 2822150",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.6868992,
      Longitude: 76.336339,
    },
    {
      id: 2990,
      Area: "south",
      States: "Kerala",
      City: "Edakkara",
      Category: 1,
      Store_name: "KALYANI E MART",
      Contact_name: "",
      Store_Address: "Grace Tower,Ootty Road,, Near KSEB,, Edakkara,Mala",
      Mobile_No: 9946416216,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.3596825,
      Longitude: 76.3092763,
    },
    {
      id: 2991,
      Area: "south",
      States: "Kerala",
      City: "Edappal",
      Category: 1,
      Store_name: "CLASSICO HOME CENTRE",
      Contact_name: "",
      Store_Address: "OPP TELEPHONE EXCHANGE, THRISSUR RD, EDAPPAL,",
      Mobile_No: "",
      Landline_No: "0494 2683221  2",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.5276416,
      Longitude: 76.2144349,
    },
    {
      id: 2992,
      Area: "south",
      States: "Kerala",
      City: "Edavanna",
      Category: 1,
      Store_name: "Sigma Electronics Gallery",
      Contact_name: "",
      Store_Address: "Near Pvt Bus Stand,Edavanna,, Malappuram,",
      Mobile_No: "",
      Landline_No: 4832701314,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.2145908,
      Longitude: 76.1393577,
    },
    {
      id: 2993,
      Area: "south",
      States: "Kerala",
      City: "Ettumanoor",
      Category: 1,
      Store_name: "Mundamattam Glass House,Etmnr",
      Contact_name: "",
      Store_Address: "Ettumanoor",
      Mobile_No: "",
      Landline_No: "0481 2537278",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.6716331,
      Longitude: 76.5649994,
    },
    {
      id: 2994,
      Area: "south",
      States: "Kerala",
      City: "Guruvayoor",
      Category: 1,
      Store_name: "Capital Traders",
      Contact_name: "",
      Store_Address: "OuterRing Road, Guruvayoor (Tcr Dist),",
      Mobile_No: "",
      Landline_No: "0487 2558292",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.590558,
      Longitude: 76.039911,
    },
    {
      id: 2995,
      Area: "south",
      States: "Kerala",
      City: "Haripad",
      Category: 1,
      Store_name: "NEW KULACHIRAYIL GLASS HOUSE",
      Contact_name: "",
      Store_Address: "SOUTH NADA, NR, HARIPPAD TEMPLE, HARIPPAD, Alappuz",
      Mobile_No: 9947395748,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.2833216,
      Longitude: 76.4489027,
    },
    {
      id: 2996,
      Area: "south",
      States: "Kerala",
      City: "Irinjalakkuda",
      Category: 1,
      Store_name: "United Glass Emporium",
      Contact_name: "",
      Store_Address: "Tana ,Irinjalakuda, , United180@gmail.Com",
      Mobile_No: "",
      Landline_No: "0480-2822180",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.3507203,
      Longitude: 76.2176849,
    },
    {
      id: 2997,
      Area: "south",
      States: "Kerala",
      City: "Kadakkal",
      Category: 1,
      Store_name: "MERLION HOMEAPPLIANCESS",
      Contact_name: "",
      Store_Address: "Main Road , NR. PVT BUS STAND, Kadakkal, KOLLAM",
      Mobile_No: 9447056401,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.8252134,
      Longitude: 76.917268,
    },
    {
      id: 2998,
      Area: "south",
      States: "Kerala",
      City: "Kalarcode",
      Category: 1,
      Store_name: "Faber Galleria",
      Contact_name: "",
      Store_Address: "NH-47 , Kalarcode , Alleppey",
      Mobile_No: 9895971661,
      Landline_No: "0477-2269791",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.932538,
      Longitude: 80.232143,
    },
    {
      id: 2999,
      Area: "south",
      States: "Kerala",
      City: "kalathipady",
      Category: 1,
      Store_name: "Forhome",
      Contact_name: "",
      Store_Address: "Vadavathoor P.O , Kalathipady , Kottayam,",
      Mobile_No: 9526209888,
      Landline_No: "0481-2576373 74",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.9914231,
      Longitude: 76.3192037,
    },
    {
      id: 3000,
      Area: "south",
      States: "Kerala",
      City: "Kaloor",
      Category: 1,
      Store_name: "Franke Faber Galleria",
      Contact_name: "",
      Store_Address: "Deshabhimani Junction, Kaloor",
      Mobile_No: 9847104012,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.9981418,
      Longitude: 76.2967843,
    },
    {
      id: 3001,
      Area: "south",
      States: "Kerala",
      City: "Kalpetta",
      Category: 1,
      Store_name: "T P TILE CENTRE",
      Contact_name: "",
      Store_Address: "MAIN ROAD, KALPETTA, WAYANAD, Ph#04936 205417, Gee",
      Mobile_No: 9656411543,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.6199193,
      Longitude: 76.0852777,
    },
    {
      id: 3002,
      Area: "south",
      States: "Kerala",
      City: "Kanhangad",
      Category: 1,
      Store_name: "Koolikad Smart Kitchen",
      Contact_name: "",
      Store_Address: "R.S.Road, Kanhangad,",
      Mobile_No: 9961217722,
      Landline_No: "0467 220517",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.3240074,
      Longitude: 75.0846675,
    },
    {
      id: 3003,
      Area: "south",
      States: "Kerala",
      City: "Kanjirappally",
      Category: 1,
      Store_name: "Mundamattom Glass House,Knjply",
      Contact_name: "",
      Store_Address: "Kanjirapally",
      Mobile_No: "",
      Landline_No: 4828208021,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.55503,
      Longitude: 76.789714,
    },
    {
      id: 3004,
      Area: "south",
      States: "Kerala",
      City: "kannur",
      Category: 1,
      Store_name: "White Field Associates",
      Contact_name: "",
      Store_Address: "Near mele Chovva High School , Kannur",
      Mobile_No: 9656104012,
      Landline_No: "0497-2725537,",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9697999,
      Longitude: 77.7499467,
    },
    {
      id: 3005,
      Area: "south",
      States: "Kerala",
      City: "Karamana",
      Category: 1,
      Store_name: "Faber Galleria",
      Contact_name: "",
      Store_Address: "Kalpalayam Junction, Karamana, Trivandrum,Ph: ,",
      Mobile_No: 9995805249,
      Landline_No: "0471-2346233",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.932538,
      Longitude: 80.232143,
    },
    {
      id: 3006,
      Area: "south",
      States: "Kerala",
      City: "Karunagapally",
      Category: 1,
      Store_name: "GRAND MASTER",
      Contact_name: "",
      Store_Address: "KUNJAMMAVAN’S MEMMORIAL, LALAJI JUNCTION, KARUNAGA",
      Mobile_No: "",
      Landline_No: "0476 2622345",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.0486713,
      Longitude: 76.5355012,
    },
    {
      id: 3007,
      Area: "south",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "Sri Krishna Hardwares MS",
      Contact_name: "",
      Store_Address: "Anebangilu, M.C.Road, Kasaragod,",
      Mobile_No: "",
      Landline_No: "0499 4230645,22",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.313096,
      Longitude: 76.6218727,
    },
    {
      id: 3008,
      Area: "south",
      States: "Kerala",
      City: "Kattakada",
      Category: 1,
      Store_name: "Punchiri Glass House",
      Contact_name: "",
      Store_Address: "Market Road, Kattakkada, Trivandrum, PH#",
      Mobile_No: 9447102886,
      Landline_No: "0471 2290799",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.5093029,
      Longitude: 77.082228,
    },
    {
      id: 3009,
      Area: "south",
      States: "Kerala",
      City: "Kattappana",
      Category: 1,
      Store_name: "Kollamkudy Home Care Systems",
      Contact_name: "",
      Store_Address: "NIC Junction, Kattapana, Idukki Dist",
      Mobile_No: "",
      Landline_No: "04868 272199",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.7566218,
      Longitude: 77.1163617,
    },
    {
      id: 3010,
      Area: "south",
      States: "Kerala",
      City: "Kayamkulam",
      Category: 1,
      Store_name: "HHYS INFRAMART",
      Contact_name: "",
      Store_Address: "Mukkavala,Bank Road, Kayamkulam, (Alpy Dist)",
      Mobile_No: 9061908877,
      Landline_No: "0479 2445002 24",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.1778588,
      Longitude: 76.5036164,
    },
    {
      id: 3011,
      Area: "south",
      States: "Kerala",
      City: "Kazhakkoottam",
      Category: 1,
      Store_name: "UDAYA AGENCIES",
      Contact_name: "",
      Store_Address: "UDAYA BUILDINGS,, UDAYA SQUARE,, BYE PASS JN., KAZ",
      Mobile_No: "",
      Landline_No: "Ph: 0471 241540",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.5651675,
      Longitude: 76.8759493,
    },
    {
      id: 3012,
      Area: "south",
      States: "Kerala",
      City: "Koilandi",
      Category: 1,
      Store_name: "VICTORY TRADERS.",
      Contact_name: "",
      Store_Address: "Jayasree Building, Rly Station Road, Koyilandy",
      Mobile_No: "",
      Landline_No: 496262139,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.4440462,
      Longitude: 75.6936611,
    },
    {
      id: 3013,
      Area: "south",
      States: "Kerala",
      City: "Kolenchery",
      Category: 1,
      Store_name: "Kazhunilathil Sanitary House",
      Contact_name: "",
      Store_Address: "Kazhunilathil Buildings, Kolenchery - 682 311",
      Mobile_No: "",
      Landline_No: "2760585 2761185",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.9794285,
      Longitude: 76.4718799,
    },
    {
      id: 3014,
      Area: "south",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "J V 4 Home",
      Contact_name: "",
      Store_Address: "Bypass, Ayathil.P.O, Kollam -691 021",
      Mobile_No: "",
      Landline_No: "0474 3217096",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.8895157,
      Longitude: 76.6312292,
    },
    {
      id: 3015,
      Area: "south",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "PLASTOWARE TRADERS",
      Contact_name: "",
      Store_Address: "MULAMKADAKOM, KOLLAM - 6910121,",
      Mobile_No: 9387314361,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.8961406,
      Longitude: 76.566474,
    },
    {
      id: 3016,
      Area: "south",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "SAS Trading Company",
      Contact_name: "",
      Store_Address: "Opposite Civil Supplies Petrol Pump,Upasana Nagar,",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.886281,
      Longitude: 76.574616,
    },
    {
      id: 3017,
      Area: "south",
      States: "Kerala",
      City: "Kondotty",
      Category: 1,
      Store_name: "KALPAKA ELECTRONICS AND HOME BAZAR",
      Contact_name: "",
      Store_Address: "MAIN ROAD, KONDOTTY,",
      Mobile_No: "",
      Landline_No: "0483-2712718",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.1466164,
      Longitude: 75.9639258,
    },
    {
      id: 3018,
      Area: "south",
      States: "Kerala",
      City: "Koothatukulam",
      Category: 1,
      Store_name: "VTJ Home Decor",
      Contact_name: "",
      Store_Address: "VII 257B M C Road, Chorakuzhy, Koothattukulam",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.8444475,
      Longitude: 76.5896896,
    },
    {
      id: 3019,
      Area: "south",
      States: "Kerala",
      City: "Kothamangalam",
      Category: 1,
      Store_name: "CHELAKANDATHIL GLASS HOUSE",
      Contact_name: "",
      Store_Address: "OPP SOBHANA SCHOOL, KOZHIPILLY, KOTHAMANGALAM, DIS",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.0592124,
      Longitude: 76.6387746,
    },
    {
      id: 3020,
      Area: "south",
      States: "Kerala",
      City: "Kottakkal",
      Category: 1,
      Store_name: "VALAPPIL HOME STYLE PRIVATE LIMITED,",
      Contact_name: "",
      Store_Address: "CALICUT RD.,CHANGUVETTY, KOTTAKKAL, MALAPPURAM, ,",
      Mobile_No: 9656800700,
      Landline_No: "0483 2741700",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.9981268,
      Longitude: 75.9891995,
    },
    {
      id: 3021,
      Area: "south",
      States: "Kerala",
      City: "Kottarakara",
      Category: 1,
      Store_name: "Kitchen Solutions(Branch)",
      Contact_name: "",
      Store_Address: "Faber Galleria,C.S.Arcade, Ampalathumkala.P.O, Kot",
      Mobile_No: "",
      Landline_No: 2482111,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.9878027,
      Longitude: 76.7369604,
    },
    {
      id: 3022,
      Area: "south",
      States: "Kerala",
      City: "Kozhenchery",
      Category: 1,
      Store_name: "Aswathy Marbles",
      Contact_name: "",
      Store_Address: "Kochuthundil Complex, Thekkemala P.O., Kozhacherry",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.3267231,
      Longitude: 76.7062979,
    },
    {
      id: 3024,
      Area: "south",
      States: "Kerala",
      City: "Kunnamkulam",
      Category: 1,
      Store_name: "Kitchen World,Kunklm",
      Contact_name: "",
      Store_Address: "Nr.Town Juma Masjid, Vadakanchery Road, Kunnamkul",
      Mobile_No: 9846717850,
      Landline_No: "04885 212828",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.6516969,
      Longitude: 76.071911,
    },
    {
      id: 3025,
      Area: "south",
      States: "Kerala",
      City: "Mahe",
      Category: 1,
      Store_name: "Noble Hardwares",
      Contact_name: "",
      Store_Address: "Minar Complex, Main Road, Mahi,",
      Mobile_No: 9447683330,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.7052675,
      Longitude: 75.534302,
    },
    {
      id: 3026,
      Area: "south",
      States: "Kerala",
      City: "Malappuram",
      Category: 1,
      Store_name: "HI DESIGN",
      Contact_name: "",
      Store_Address: "VEE PEE TOWER VP-21 170 G.H,, N.H ROAD, KANCHIPPUR",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.9173002,
      Longitude: 76.0365808,
    },
    {
      id: 3027,
      Area: "south",
      States: "Kerala",
      City: "Manjery",
      Category: 1,
      Store_name: "TRIO INTERIORS",
      Contact_name: "",
      Store_Address: "KOOLIYOTT TOWER, WARD NO: 33, ROOM NO: 15J & 15K,",
      Mobile_No: 9846132624,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.0991339,
      Longitude: 76.1201094,
    },
    {
      id: 3028,
      Area: "south",
      States: "Kerala",
      City: "Mannarkkadu",
      Category: 1,
      Store_name: "SLEEK KITCHEN CLUB",
      Contact_name: "",
      Store_Address: "WELCOME PLAZA, HOSPITAL JUNCTION, MANNARKKAD – 678",
      Mobile_No: 9747555717,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.9930597,
      Longitude: 76.4669305,
    },
    {
      id: 3029,
      Area: "south",
      States: "Kerala",
      City: "Mavelikkara",
      Category: 1,
      Store_name: "Intway Interiors ( Branch)",
      Contact_name: "",
      Store_Address: "Puthiyakavu, Mavelikkara",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.3082759,
      Longitude: 76.5328703,
    },
    {
      id: 3030,
      Area: "south",
      States: "Kerala",
      City: "Mookkannur",
      Category: 1,
      Store_name: "CREATIVE INTERIOR SOLUTIONS",
      Contact_name: "",
      Store_Address: "ATTOKKARAN ARCADE, OPP SOUTH INDIAN BANK, MOOKKAN",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.2204831,
      Longitude: 76.413049,
    },
    {
      id: 3031,
      Area: "south",
      States: "Kerala",
      City: "Muvattupuzha",
      Category: 1,
      Store_name: "Dream Homes,Mvtpza",
      Contact_name: "",
      Store_Address: "Opp:St.Augustines Girls High School, Govt Model Hi",
      Mobile_No: 8547130804,
      Landline_No: "0485 2830286",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.9894229,
      Longitude: 76.5789749,
    },
    {
      id: 3032,
      Area: "south",
      States: "Kerala",
      City: "N Paravoor",
      Category: 1,
      Store_name: "Mannamthara Tile House (Br)",
      Contact_name: "",
      Store_Address: "Near Don Bosco Hospital North Paravoor, Pin-683513",
      Mobile_No: "",
      Landline_No: 4844044997,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.2276226,
      Longitude: 76.2014676,
    },
    {
      id: 3033,
      Area: "south",
      States: "Kerala",
      City: "Nedumangadu",
      Category: 1,
      Store_name: "Sanooj Enterprises",
      Contact_name: "",
      Store_Address: "Kulavikonam, Nedumangad,",
      Mobile_No: 9037182942,
      Landline_No: "0472 2812472",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.603145,
      Longitude: 77.004166,
    },
    {
      id: 3034,
      Area: "south",
      States: "Kerala",
      City: "Neyyattinkara",
      Category: 1,
      Store_name: "J J Glass Emporium",
      Contact_name: "",
      Store_Address: "Alumoodu Junction, Neyyatinkara,",
      Mobile_No: 9847098669,
      Landline_No: "0174-2225923",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.4022655,
      Longitude: 77.0863774,
    },
    {
      id: 3035,
      Area: "south",
      States: "Kerala",
      City: "Nilambur",
      Category: 1,
      Store_name: "SIGMA ELECTRONICS AND HOME BAZAR",
      Contact_name: "",
      Store_Address: "JANATHAPADI, NILAMBUR,",
      Mobile_No: 9745403232,
      Landline_No: "0493 1220400",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.2797292,
      Longitude: 76.2314852,
    },
    {
      id: 3036,
      Area: "south",
      States: "Kerala",
      City: "Nooranad",
      Category: 1,
      Store_name: "C B Electricals",
      Contact_name: "",
      Store_Address: "K.P.Road, Via Charummoodu, Nooranadu,",
      Mobile_No: "",
      Landline_No: "0479 2387188",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.1754323,
      Longitude: 76.6364998,
    },
    {
      id: 3037,
      Area: "south",
      States: "Kerala",
      City: "Ochira",
      Category: 1,
      Store_name: "Chennalloor Fashion Homes",
      Contact_name: "",
      Store_Address: "NH 47,Oachira,, Kollam 690526",
      Mobile_No: 9947593471,
      Landline_No: 4762698925,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.1233998,
      Longitude: 76.5177815,
    },
    {
      id: 3038,
      Area: "south",
      States: "Kerala",
      City: "Pala",
      Category: 1,
      Store_name: "Cochin Sani Wares (PALA)",
      Contact_name: "",
      Store_Address: "Near St.Thomas College, Arunapuram Tower, Arunapur",
      Mobile_No: "",
      Landline_No: "04822 215953 21",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.9312328,
      Longitude: 76.2673041,
    },
    {
      id: 3039,
      Area: "south",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "A ONE GLASS HOUSE (KONGHAD)",
      Contact_name: "",
      Store_Address: "PATHIRI PALA ROAD, KONGHAD,, PALAKKAD,",
      Mobile_No: 9447088066,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.8521045,
      Longitude: 76.5211245,
    },
    {
      id: 3040,
      Area: "south",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "HOME TRENDZ (PALAKKAD)",
      Contact_name: "",
      Store_Address: "17 992, VMS ARCADE, OPP. SHIKSHAK SADAN,, METTUPAL",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.7767152,
      Longitude: 76.656106,
    },
    {
      id: 3041,
      Area: "south",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "PRESTIGE PLY CENTRE",
      Contact_name: "",
      Store_Address: "EAST MANISSERY, OTTAPPALAM, PALAKKAD",
      Mobile_No: 8086669993,
      Landline_No: "0466224822,",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.7747018,
      Longitude: 76.3478669,
    },
    {
      id: 3042,
      Area: "south",
      States: "Kerala",
      City: "Palarivattom",
      Category: 1,
      Store_name: "Faber Galleria",
      Contact_name: "",
      Store_Address: "Opp HDFC Bank , Palarivattom",
      Mobile_No: 9995805248,
      Landline_No: 4049211,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.932538,
      Longitude: 80.232143,
    },
    {
      id: 3043,
      Area: "south",
      States: "Kerala",
      City: "Panampilly Nagar",
      Category: 1,
      Store_name: "Faber Galleria",
      Contact_name: "",
      Store_Address: "south square building , Panampilly Nagar",
      Mobile_No: 9895099233,
      Landline_No: 2322211,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.932538,
      Longitude: 80.232143,
    },
    {
      id: 3044,
      Area: "south",
      States: "Kerala",
      City: "Pandalam",
      Category: 1,
      Store_name: "MATRIX INTERIOR FURNISHING",
      Contact_name: "",
      Store_Address: "C S DivakaranMemorail Building,, Parakkal, Karakka",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.3024266,
      Longitude: 76.6599537,
    },
    {
      id: 3045,
      Area: "south",
      States: "Kerala",
      City: "Parippally",
      Category: 1,
      Store_name: "Indian Glass House (Paripally)",
      Contact_name: "",
      Store_Address: "NH. 47, Sreeramapuram, Paripally, Kollam,",
      Mobile_No: 9895338733,
      Landline_No: "0474 2576093, 2",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.8144895,
      Longitude: 76.7574647,
    },
    {
      id: 3046,
      Area: "south",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "Wudstar Lifestyles",
      Contact_name: "",
      Store_Address: "Changayil Building,T.K.Road,, Varyapuram, Pathanam",
      Mobile_No: 8606476822,
      Landline_No: ".0468 2226232",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.281256,
      Longitude: 76.748873,
    },
    {
      id: 3048,
      Area: "south",
      States: "Kerala",
      City: "Payyannur",
      Category: 1,
      Store_name: "DG Digital Galleria",
      Contact_name: "",
      Store_Address: "KSRTC Shopping Complex, Perumba,Payyannur,, Kannur",
      Mobile_No: 9207219219,
      Landline_No: "04985 297050,",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.1125196,
      Longitude: 75.2184375,
    },
    {
      id: 3049,
      Area: "south",
      States: "Kerala",
      City: "Perinthalmanna",
      Category: 1,
      Store_name: "PLY PALACE",
      Contact_name: "",
      Store_Address: "NEAR KSEB, PERINTHALMANNA RD, KOPPAM, VILAYUR PO-",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.978542,
      Longitude: 76.2248598,
    },
    {
      id: 3050,
      Area: "south",
      States: "Kerala",
      City: "Perinthalmanna",
      Category: 1,
      Store_name: "V4 HOMES PERINTHALMANNA",
      Contact_name: "",
      Store_Address: "Near Manazhi Bus Stand, Manarkadu P,O, Perinthalma",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.9764345,
      Longitude: 76.2407606,
    },
    {
      id: 3051,
      Area: "south",
      States: "Kerala",
      City: "perumbavoor",
      Category: 1,
      Store_name: "Faber Galleria",
      Contact_name: "",
      Store_Address: "mudikkal P.O, Perumbavoor",
      Mobile_No: 9526310888,
      Landline_No: 2593998,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.932538,
      Longitude: 80.232143,
    },
    {
      id: 3052,
      Area: "south",
      States: "Kerala",
      City: "Ponkunnam",
      Category: 1,
      Store_name: "Cochin Sani Wares,Pnknm (42)",
      Contact_name: "",
      Store_Address: "20 Th Mile, Ponkunnam, Kottayam Dist,",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.5651077,
      Longitude: 76.7447859,
    },
    {
      id: 3053,
      Area: "south",
      States: "Kerala",
      City: "Ponnani",
      Category: 1,
      Store_name: "Teekay HOMEAIDS",
      Contact_name: "",
      Store_Address: "Near:A.V.H.S, Ponnani, PH#0494 2666320,3208012, AC",
      Mobile_No: 9447166320,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.7838616,
      Longitude: 76.0075945,
    },
    {
      id: 3054,
      Area: "south",
      States: "Kerala",
      City: "Punaloor",
      Category: 1,
      Store_name: "Thottukadavil Traders",
      Contact_name: "",
      Store_Address: "Main Road, Punaloor,",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.009768,
      Longitude: 76.9297354,
    },
    {
      id: 3055,
      Area: "south",
      States: "Kerala",
      City: "Sulthan Bathery",
      Category: 1,
      Store_name: "TP Hardware Centre",
      Contact_name: "",
      Store_Address: "H.O. T P Associates,TP Arcade,, Chuliyode Road, Ja",
      Mobile_No: 8111887344,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.6599792,
      Longitude: 76.2562135,
    },
    {
      id: 3056,
      Area: "south",
      States: "Kerala",
      City: "Thengana",
      Category: 1,
      Store_name: "CHALACKAL KITCHEN SOLUTIONS",
      Contact_name: "",
      Store_Address: "Opp: S B I, Thengana, Changanassery.",
      Mobile_No: 9400294698,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.4742537,
      Longitude: 76.5760361,
    },
    {
      id: 3057,
      Area: "south",
      States: "Kerala",
      City: "Thirur",
      Category: 1,
      Store_name: "White Field Associates",
      Contact_name: "",
      Store_Address: "Pan Bazar, Tirur,",
      Mobile_No: 9656104012,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9697999,
      Longitude: 77.7499467,
    },
    {
      id: 3058,
      Area: "south",
      States: "Kerala",
      City: "Thiruvalla",
      Category: 1,
      Store_name: "C B Traders (Branch)",
      Contact_name: "",
      Store_Address: "Marygiri Shopping Complex, Opp:BSNL,Thiruvalla,",
      Mobile_No: 9447793386,
      Landline_No: "0469 2606620",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.3818636,
      Longitude: 76.5721607,
    },
    {
      id: 3059,
      Area: "south",
      States: "Kerala",
      City: "Thodupuzha",
      Category: 1,
      Store_name: "IDEAL HOME GALLERIA",
      Contact_name: "",
      Store_Address: "Mangattukavala Bye Pass, Thodupuzha",
      Mobile_No: 9495210097,
      Landline_No: "04862 227000",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.8985752,
      Longitude: 76.7238259,
    },
    {
      id: 3060,
      Area: "south",
      States: "Kerala",
      City: "Thodupuzha",
      Category: 1,
      Store_name: "THOTTUMKAL TRADING COMPAMY",
      Contact_name: "",
      Store_Address: "KARIMKUNNAM PO, THODUPUZHA, IDUKKI- 685 586",
      Mobile_No: 9745243999,
      Landline_No: "0486 2243999",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.8526645,
      Longitude: 76.6866948,
    },
    {
      id: 3061,
      Area: "south",
      States: "Kerala",
      City: "Thondayad",
      Category: 1,
      Store_name: "White Field Associates",
      Contact_name: "",
      Store_Address: "Thondayad , P.O, Calicut",
      Mobile_No: 9526101115,
      Landline_No: "0495-2352012",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9697999,
      Longitude: 77.7499467,
    },
    {
      id: 3062,
      Area: "south",
      States: "Kerala",
      City: "Thottabhagam",
      Category: 1,
      Store_name: "MELROSE KITCHNETTE(Branch)",
      Contact_name: "",
      Store_Address: "FABER GALARIA, SLEEBA ORTHODOX CHURCH BLDG, (ABOVE",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.385006,
      Longitude: 76.6148329,
    },
    {
      id: 3063,
      Area: "south",
      States: "Kerala",
      City: "Triprayar",
      Category: 1,
      Store_name: "Vogue Kitchen Studio",
      Contact_name: "",
      Store_Address: "Stadium Road,Behind Bus Stand, Triprayar, Thrissur",
      Mobile_No: 7025592336,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.4170788,
      Longitude: 76.1059004,
    },
    {
      id: 3064,
      Area: "south",
      States: "Kerala",
      City: "Tripunithura",
      Category: 1,
      Store_name: "Cochin Saniwares Poothotta(Branch)",
      Contact_name: "",
      Store_Address: "Cochin Saniwares Poothotta(Branch), Near KSFE , Po",
      Mobile_No: 9447661224,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.8506191,
      Longitude: 76.3825391,
    },
    {
      id: 3065,
      Area: "south",
      States: "Kerala",
      City: "Udayakulangara",
      Category: 1,
      Store_name: "Sri Sri Traders",
      Contact_name: "",
      Store_Address: "Noha Complex,Udayam Kulangara,, Amaravila P.O., Tr",
      Mobile_No: 8907206133,
      Landline_No: 4712231769,
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.3806732,
      Longitude: 77.1193068,
    },
    {
      id: 3066,
      Area: "south",
      States: "Kerala",
      City: "Vadakara",
      Category: 1,
      Store_name: "BHARAT OBALCO",
      Contact_name: "",
      Store_Address: "OPP. INDIAN COFFEE HOUSE, NUT STREET, VATAKARA",
      Mobile_No: 9847653108,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.6021179,
      Longitude: 75.5912966,
    },
    {
      id: 3067,
      Area: "south",
      States: "Kerala",
      City: "Vaikom",
      Category: 1,
      Store_name: "Krishnan Nair Enterprises",
      Contact_name: "",
      Store_Address: "Thekkenada.P.O, Vaikom,",
      Mobile_No: "",
      Landline_No: "04829 232616,",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.7451396,
      Longitude: 76.3961292,
    },
    {
      id: 3068,
      Area: "south",
      States: "Kerala",
      City: "Varkala",
      Category: 1,
      Store_name: "SEN INTERNATIONAL",
      Contact_name: "",
      Store_Address: "PUTHENCHANDA, VARKALA, KOLLAM DIST.",
      Mobile_No: "",
      Landline_No: "0470 2609800",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 8.7292631,
      Longitude: 76.7370581,
    },
    {
      id: 3069,
      Area: "south",
      States: "Kerala",
      City: "Venpalavattom",
      Category: 1,
      Store_name: "Forhome",
      Contact_name: "",
      Store_Address: "NH Bye Pass, Venpalavattom,",
      Mobile_No: 9526047888,
      Landline_No: "0471-3202220",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.9914231,
      Longitude: 76.3192037,
    },
    {
      id: 3070,
      Area: "south",
      States: "Kerala",
      City: "Wadakkanchery",
      Category: 1,
      Store_name: "VARNA GLASS AND PLYWOODS TRADING PRIVATE LIMITED",
      Contact_name: "",
      Store_Address: "5 71,5 71 1, KIZHAKUMPATUKARA, THRISSUR EAST -6800",
      Mobile_No: 9496065222,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.65602,
      Longitude: 76.22804,
    },
    {
      id: 3071,
      Area: "south",
      States: "Kerala",
      City: "Wandoor",
      Category: 1,
      Store_name: "Hilton Ply House",
      Contact_name: "",
      Store_Address: "Pandikad Road,Wandoor,Malappuram,",
      Mobile_No: 9072340007,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.192837,
      Longitude: 76.235158,
    },
    {
      id: 3072,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: ". AAA PEE Appliances",
      Contact_name: "mr. charan",
      Store_Address: "130, mint street, swocarpet, chennai-79, service a",
      Mobile_No: 9500003191,
      Landline_No: "044-25290857",
      Email: "Aadeshkumarpal@gmail.com",
      Pin_Code: 600079,
      DT: "NULL",
      Active: 0,
      Latitude: 13.094735,
      Longitude: 80.279748,
    },
    {
      id: 3073,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "AAA PEE Appliances",
      Contact_name: "",
      Store_Address: "47 22 Medavakkam tank road, Opp to ESI hospital bu",
      Mobile_No: 9840800998,
      Landline_No: "",
      Email: "",
      Pin_Code: 600012,
      DT: "NULL",
      Active: 0,
      Latitude: 13.094733,
      Longitude: 80.279749,
    },
    {
      id: 3074,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Ambica Enterprises",
      Contact_name: "mr. shiva",
      Store_Address: "no 187, 1st floor,velacherry main road,pallikkaran",
      Mobile_No: 9841411800,
      Landline_No: 22463032,
      Email: "siva009113@gmail.com",
      Pin_Code: 600100,
      DT: "NULL",
      Active: 0,
      Latitude: 12.935678,
      Longitude: 80.204106,
    },
    {
      id: 3075,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Amudha Enterprises",
      Contact_name: "mr. senthil",
      Store_Address: "old.no.32, n.no.148,kaliamman koil street,virugamb",
      Mobile_No: 9940291414,
      Landline_No: "",
      Email: "amudhaenterprises@yahoo.com",
      Pin_Code: 600092,
      DT: "NULL",
      Active: 0,
      Latitude: 13.050859,
      Longitude: 80.191963,
    },
    {
      id: 3076,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "BMC Home Needs",
      Contact_name: "mr. bajaj",
      Store_Address: "93,gangadeswarar koil street,purasawakkam",
      Mobile_No: "",
      Landline_No: 26433307,
      Email: "choicedecors@rediffmail.com",
      Pin_Code: 600084,
      DT: "NULL",
      Active: 0,
      Latitude: 13.139774,
      Longitude: 80.244657,
    },
    {
      id: 3077,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "BSR Mall",
      Contact_name: "",
      Store_Address:
        "BSR Mall, at 1 609, Old Mahabalipuram Road, Okkiyam, Thoraipakkam, Chennai - 600096.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 600096,
      DT: "NULL",
      Active: 0,
      Latitude: 12.9495624,
      Longitude: 80.2382475,
    },
    {
      id: 3078,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Khanna Building , AA-5, 2nd Avenue, Annanagar, Chennai-6000040",
      Mobile_No: "",
      Landline_No: "044-64589702",
      Email: "",
      Pin_Code: 6000040,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0843689,
      Longitude: 80.2147065,
    },
    {
      id: 3079,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground Floor ,Kences Towers No.1 ,Ramakrishnan Street ,North Usman Road, T Nagar , Chennai - 600017",
      Mobile_No: "",
      Landline_No: "044-64629816 17",
      Email: "",
      Pin_Code: 600017,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0486089,
      Longitude: 80.230841,
    },
    {
      id: 3080,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Plot no B24, Industrial Plot, at Dr. Puratchi Thalaivi Jayalalita Nagar ,West, Mogappair Chennai 600037",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 600037,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0855887,
      Longitude: 80.1673695,
    },
    {
      id: 3081,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Tarapore Towers ,826 Ground Floor, Mount Road ,Anna Salai ,Mount Road , Chennai - 600002",
      Mobile_No: "",
      Landline_No: "044-64589715",
      Email: "",
      Pin_Code: 600002,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0667473,
      Longitude: 80.2666564,
    },
    {
      id: 3082,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Plot bearing No. 6 PC2-4 & 5, TNHB 60 ft Road, Avadi , Chennai-600 054",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 600054,
      DT: "NULL",
      Active: 0,
      Latitude: 13.1139125,
      Longitude: 80.1005903,
    },
    {
      id: 3083,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Dynamic Marketing",
      Contact_name: "mr. nandha kumar",
      Store_Address: "no. 128, shanthi colony main road,anna nagar",
      Mobile_No: "",
      Landline_No: 26204779,
      Email: "ashok@dynamic.in",
      Pin_Code: 600040,
      DT: "NULL",
      Active: 0,
      Latitude: 13.082591,
      Longitude: 80.21161,
    },
    {
      id: 3084,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Vibrant Homz",
      Contact_name: "mr.adesh kumar",
      Store_Address:
        "SHOP #2, 1ST FLOOR, VGP AVENUE, IT ROAD,RAJIV GANDHI SALAI, OMR, METTUKUPPAM, THORAIPAKKAM, CHENNAI - 600097",
      Mobile_No: 9566001979,
      Landline_No: 24580077,
      Email: "vibranthomz@gmail.com",
      Pin_Code: 600097,
      DT: "NULL",
      Active: 0,
      Latitude: 12.932538,
      Longitude: 80.232143,
    },
    {
      id: 3085,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Vibrant Homz",
      Contact_name: "mr.kumar pal",
      Store_Address: "no.89, llyods road,royapettah",
      Mobile_No: 9500003191,
      Landline_No: 28110932,
      Email: "vibranthomz@gmail.com",
      Pin_Code: 600097,
      DT: "NULL",
      Active: 0,
      Latitude: 12.932538,
      Longitude: 80.232143,
    },
    {
      id: 3086,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Genuine Care",
      Contact_name: "anbu chelvan",
      Store_Address: "no.7a 3, balaji villa , bharatwaj street , east th",
      Mobile_No: 7299099299,
      Landline_No: "",
      Email: "tambaramgenuinecare@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 13.079216,
      Longitude: 80.240859,
    },
    {
      id: 3087,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Hoods & Hobs",
      Contact_name: "mr. jayachandran",
      Store_Address:
        "471,panpet 2nd street, mount road,nandanam,Chennai - 600035",
      Mobile_No: 9382124821,
      Landline_No: 24357484,
      Email: "hoodsandhobs@yahoo.com",
      Pin_Code: 600035,
      DT: "NULL",
      Active: 0,
      Latitude: 13.026445,
      Longitude: 80.232813,
    },
    {
      id: 3088,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Rathna Cools & CO",
      Contact_name: "mr. vijay",
      Store_Address: "no 1,raja bather street, t.nagar",
      Mobile_No: "",
      Landline_No: 28151266,
      Email: "rathnafanhouse@gmail.com",
      Pin_Code: 600017,
      DT: "NULL",
      Active: 0,
      Latitude: 13.041125,
      Longitude: 80.238312,
    },
    {
      id: 3089,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Smart Care",
      Contact_name: "varun vasu",
      Store_Address: "no.51, bashyakaralu street , kondithope, near sai",
      Mobile_No: 7299090006,
      Landline_No: "",
      Email: "chennaismartcare@yahoo.in",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 13.104638,
      Longitude: 80.277857,
    },
    {
      id: 3090,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "Thahir Designer Hardware",
      Contact_name: "mr. saleem",
      Store_Address: "no 117,118, 119,kodambakkam high road,nugambakkam",
      Mobile_No: "",
      Landline_No: 42100800,
      Email: "saleemtdh@yahoo.co.in",
      Pin_Code: 600034,
      DT: "NULL",
      Active: 0,
      Latitude: 13.052712,
      Longitude: 80.242098,
    },
    {
      id: 3091,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "V.S.P.Ceramic Centre",
      Contact_name: "mr. valarmathi",
      Store_Address: "19, 15th street, taramani road, velachery",
      Mobile_No: 9841430003,
      Landline_No: "22383735 224357",
      Email: "vspceramiccentre@gmail.com",
      Pin_Code: 600042,
      DT: "NULL",
      Active: 0,
      Latitude: 12.977946,
      Longitude: 80.224999,
    },
    {
      id: 3092,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "Beauty wares",
      Contact_name: "Ibhrahim",
      Store_Address: "396,sathy road ,ganapathy,coimbatore.",
      Mobile_No: 9750037333,
      Landline_No: "0422-4326666",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.03212,
      Longitude: 76.977717,
    },
    {
      id: 3093,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "Eastern Corporation Coimbtore",
      Contact_name: "mr. chakravorthy",
      Store_Address: "200, ramaswomy nagar, pankaja mill road, ramnath p",
      Mobile_No: 9940120879,
      Landline_No: "",
      Email: "easterncorporation@airtelmail.in",
      Pin_Code: 641045,
      DT: "NULL",
      Active: 1,
      Latitude: 10.9974329,
      Longitude: 77.0074403,
    },
    {
      id: 3094,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "G.S.Kitchen Solution",
      Contact_name: "mr.ganesh",
      Store_Address: "sai nilaiyam building, 75 92 krishnasamy road",
      Mobile_No: 9443334976,
      Landline_No: "0452-2234970",
      Email: "info@gscompany.in",
      Pin_Code: 641001,
      DT: "NULL",
      Active: 1,
      Latitude: 11.00675,
      Longitude: 76.960504,
    },
    {
      id: 3095,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "Raj Home Appliances",
      Contact_name: "kowsalya",
      Store_Address: "no4, kalingarayan st, ramnagar, cbe",
      Mobile_No: 4222230105,
      Landline_No: 4222230105,
      Email: "",
      Pin_Code: 641001,
      DT: "NULL",
      Active: 0,
      Latitude: 11.011925,
      Longitude: 76.966,
    },
    {
      id: 3096,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "T.S.S Marketing",
      Contact_name: "mr.ramachndran",
      Store_Address: "90, race course rd, near, k.g.theatre",
      Mobile_No: 9843751119,
      Landline_No: "0422-2218634",
      Email: "",
      Pin_Code: 641001,
      DT: "NULL",
      Active: 0,
      Latitude: 11.000899,
      Longitude: 76.972747,
    },
    {
      id: 3097,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "V.P.Marketing",
      Contact_name: "mr.rajaram",
      Store_Address: "no:321 d3 , mettupalayam road, opp murugan mills,",
      Mobile_No: 9894922002,
      Landline_No: "0422-4371002",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.023757,
      Longitude: 76.951705,
    },
    {
      id: 3098,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "Vinayaga Enterpises",
      Contact_name: "manikandan",
      Store_Address: "1156 , dr radha krishna road, 6th street extn, gan",
      Mobile_No: 9585554595,
      Landline_No: "",
      Email: "vinayagacare@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 1,
      Latitude: 11.022327,
      Longitude: 76.966405,
    },
    {
      id: 3100,
      Area: "South",
      States: "Tamil Nadu",
      City: "Madurai",
      Category: 1,
      Store_name: "Sri Raghavendra Enterprises",
      Contact_name: "vel murugan",
      Store_Address: "no.15, raja muthiah nagar, thomas road, opp cwc go",
      Mobile_No: 9943212345,
      Landline_No: "",
      Email: "sriragavendramaduraicare@yahoo.in",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 9.954687,
      Longitude: 78.106564,
    },
    {
      id: 3101,
      Area: "South",
      States: "Tamil Nadu",
      City: "Madurai",
      Category: 1,
      Store_name: "Surya Metal Art",
      Contact_name: "sendhil",
      Store_Address: "75257, goods shed street",
      Mobile_No: 9842852891,
      Landline_No: "0452-2350377",
      Email: "suryasmetal@rediffmail.com",
      Pin_Code: 625001,
      DT: "NULL",
      Active: 0,
      Latitude: 9.922111,
      Longitude: 78.113321,
    },
    {
      id: 3102,
      Area: "South",
      States: "Tamil Nadu",
      City: "Puducherry",
      Category: 1,
      Store_name: "Guruchakra Enterprises",
      Contact_name: "r muraleedharan",
      Store_Address: "no.10, 1st floor, jothi ramalingam street, sakthi",
      Mobile_No: 9585594040,
      Landline_No: "",
      Email: "guruchakraa@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.940417,
      Longitude: 79.812776,
    },
    {
      id: 3103,
      Area: "South",
      States: "Tamil Nadu",
      City: "Puducherry",
      Category: 1,
      Store_name: "Sri Ganesh Electricals",
      Contact_name: "",
      Store_Address: "368, Anna Salai,",
      Mobile_No: "",
      Landline_No: "0413 2339037, 2",
      Email: "sriganeshpondy@gmail.com",
      Pin_Code: 605001,
      DT: "NULL",
      Active: 0,
      Latitude: 11.934001,
      Longitude: 79.824538,
    },
    {
      id: 3104,
      Area: "South",
      States: "Tamil Nadu",
      City: "Salem",
      Category: 1,
      Store_name: "Lakshmi Distributors Salem",
      Contact_name: "mr. sarvanakumar",
      Store_Address: "155c 46a, rajaram nagar, tamil sangam road",
      Mobile_No: 9994999566,
      Landline_No: "",
      Email: "lcsaro@rediffmail.com",
      Pin_Code: 636007,
      DT: "NULL",
      Active: 0,
      Latitude: 11.66063,
      Longitude: 78.155563,
    },
    {
      id: 3105,
      Area: "South",
      States: "Tamil Nadu",
      City: "Salem",
      Category: 1,
      Store_name: "Smarrt Kichen & interier",
      Contact_name: "mr.gopinath",
      Store_Address: "24 1-a,pnr complex,near new bus stand,salem",
      Mobile_No: 9443229976,
      Landline_No: "0427-2211445",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.66892,
      Longitude: 78.139265,
    },
    {
      id: 3106,
      Area: "South",
      States: "Tamil Nadu",
      City: "Salem",
      Category: 1,
      Store_name: "Sri Sapthagiri Ceramics",
      Contact_name: "singaravel",
      Store_Address: "3071,junction main road,five roads",
      Mobile_No: 9843027360,
      Landline_No: 3242499,
      Email: "",
      Pin_Code: 636003,
      DT: "NULL",
      Active: 0,
      Latitude: 11.671815,
      Longitude: 78.132836,
    },
    {
      id: 3107,
      Area: "South",
      States: "Tamil Nadu",
      City: "Salem",
      Category: 1,
      Store_name: "Sri Thirumurugan Agencies",
      Contact_name: "mr.subramani",
      Store_Address: "124,paramathi road,namakkal",
      Mobile_No: 9443333561,
      Landline_No: "04286-233561",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.218532,
      Longitude: 78.167158,
    },
    {
      id: 3108,
      Area: "South",
      States: "Tamil Nadu",
      City: "Salem",
      Category: 1,
      Store_name: "SRS Electronics",
      Contact_name: "a siddheswaran",
      Store_Address: "17 3, east street, kumarasamypatty",
      Mobile_No: 9790496096,
      Landline_No: "",
      Email: "srsfaber@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 11.077545,
      Longitude: 77.002938,
    },
    {
      id: 3109,
      Area: "South",
      States: "Tamil Nadu",
      City: "Trichy",
      Category: 1,
      Store_name: "ASB agencies trichy",
      Contact_name: "mr.shaik abdhulla",
      Store_Address: "oldno.15 b,new no.100 evr road,puthur,trichy",
      Mobile_No: "",
      Landline_No: "",
      Email: "asbagencies2006@gmail.com",
      Pin_Code: 620017,
      DT: "NULL",
      Active: 0,
      Latitude: 10.811916,
      Longitude: 78.678906,
    },
    {
      id: 3110,
      Area: "South",
      States: "Tamil Nadu",
      City: "Trichy",
      Category: 1,
      Store_name: "Sri Ram Enterprises",
      Contact_name: "sarvanan",
      Store_Address: "no.11, chinna kadaivethi, 1st floor, ananda buildi",
      Mobile_No: 9585599506,
      Landline_No: "",
      Email: "sriramenterprises23@yahoo.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 10.820792,
      Longitude: 78.688178,
    },
    {
      id: 3111,
      Area: "South",
      States: "Tamil Nadu",
      City: "Vellore",
      Category: 1,
      Store_name: "Sri Raghavendra Associates",
      Contact_name: "r jayaram",
      Store_Address: "no14, thendral nagar, sathuvachari",
      Mobile_No: 9655443958,
      Landline_No: "",
      Email: "vellorefaberservice@gmail.com",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 12.935033,
      Longitude: 79.149412,
    },
    {
      id: 3112,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Baths & Kitchen",
      Contact_name: "",
      Store_Address: "vyasComplex,Opp; Sundaram moters(TVS) M.G Road Ran",
      Mobile_No: 9866284777,
      Landline_No: "",
      Email: "baths.kitchen@gmail.com",
      Pin_Code: 500003,
      DT: "NULL",
      Active: 0,
      Latitude: 17.430175,
      Longitude: 78.487955,
    },
    {
      id: 3113,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Casa Marketing Pvt Ltd",
      Contact_name: "",
      Store_Address: "1-70 c Rajeev nagar,Gachibowli Main road- 500032",
      Mobile_No: 9246833315,
      Landline_No: "",
      Email: "cmplhyd@gmail.com",
      Pin_Code: 500032,
      DT: "NULL",
      Active: 0,
      Latitude: 17.443503,
      Longitude: 78.363015,
    },
    {
      id: 3114,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Geeta Gastech",
      Contact_name: "",
      Store_Address: "Plot no- 137 Naga Nivas.Beside; HDFCBank,Nacharam",
      Mobile_No: 9618025225,
      Landline_No: "",
      Email: "geethagastech@gmail.com",
      Pin_Code: 500076,
      DT: "NULL",
      Active: 0,
      Latitude: 17.412821,
      Longitude: 78.545385,
    },
    {
      id: 3115,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Mahendra Enterprises",
      Contact_name: "",
      Store_Address: "Main Road TroopBazar Abids- 500001",
      Mobile_No: 9246580180,
      Landline_No: "",
      Email: "mahendraentp@yahoo.co.in",
      Pin_Code: 500001,
      DT: "NULL",
      Active: 0,
      Latitude: 17.385137,
      Longitude: 78.476493,
    },
    {
      id: 3116,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Mom Agencies",
      Contact_name: "",
      Store_Address: "7-1-79 c 2 D.K Road Ameerpet.-500016",
      Mobile_No: 9885900806,
      Landline_No: "",
      Email: "venu.vv@gmail.com",
      Pin_Code: 500016,
      DT: "NULL",
      Active: 0,
      Latitude: 17.438565,
      Longitude: 78.450656,
    },
    {
      id: 3117,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SKC Appliances & Marketing",
      Contact_name: "",
      Store_Address: "38-37, Near; Ambedkar Statue,Sainikpuri X Roads se",
      Mobile_No: 9440915111,
      Landline_No: "",
      Email: "chowdarykgaddam@gmail.com",
      Pin_Code: 500094,
      DT: "NULL",
      Active: 0,
      Latitude: 17.512726,
      Longitude: 78.562755,
    },
    {
      id: 3118,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SVS Stilux & Marketing",
      Contact_name: "",
      Store_Address: "3-11-153 4,p.no-93,opp: SBIbank,Kamineni Hospital",
      Mobile_No: 9390407494,
      Landline_No: "",
      Email: "svsstiluxmarketing163@gmail.com",
      Pin_Code: 500074,
      DT: "NULL",
      Active: 0,
      Latitude: 17.349712,
      Longitude: 78.553264,
    },
    {
      id: 3119,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "BELL ELECTRONICS",
      Contact_name: "Mr.Suresh kheemani",
      Store_Address: "7-2-614 R.P ROAD SECUNDERABAD",
      Mobile_No: "2770 0933",
      Landline_No: "",
      Email: "",
      Pin_Code: 500003,
      DT: "NULL",
      Active: 0,
      Latitude: 17.433305,
      Longitude: 78.4912753,
    },
    {
      id: 3120,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "CASA APPLAINCES",
      Contact_name: "Mr.Pavan",
      Store_Address:
        "PLOT # MIG-162, KPHB COLONY ROAD NO.01 OPP.PRIME HOSPITAL HYDERABAD",
      Mobile_No: "9908466466 040-",
      Landline_No: "",
      Email: "",
      Pin_Code: 500085,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4888096,
      Longitude: 78.3979232,
    },
    {
      id: 3121,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "CHIMNEY WORLD",
      Contact_name: "Mr.Surender Reddy",
      Store_Address: "OPP.GANAGRUM BUS STOP CHANDANAGAR HYDERABAD",
      Mobile_No: "040-40191892",
      Landline_No: "",
      Email: "",
      Pin_Code: 500033,
      DT: "NULL",
      Active: 0,
      Latitude: 17.494484,
      Longitude: 78.3297643,
    },
    {
      id: 3122,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "GAUTAM MARKETING",
      Contact_name: "Mr.Kishan Patel",
      Store_Address:
        "GAUTAM MARKETING PRASHANTHI NAGAR, BESIDE REGISTRATION OFFICE, KUKATPALLY HYDERABAD",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 500085,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4944717,
      Longitude: 78.2619125,
    },
    {
      id: 3123,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "GLOBAL ENTERPRISES",
      Contact_name: "Mr.Raghu",
      Store_Address:
        "#1-26-1 A, GACHIBOWLI X ROAD TOWARDS KONDAPUR BESIDE TATA MOTORS HYDERABAD",
      Mobile_No: "040-65979799 80",
      Landline_No: "",
      Email: "",
      Pin_Code: 500081,
      DT: "NULL",
      Active: 0,
      Latitude: 12.32698,
      Longitude: 76.66129,
    },
    {
      id: 3124,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "HOMEVISTA DECOR & FURNISHING PVT LTD",
      Contact_name: "Mr.Naveen",
      Store_Address:
        "HOMEVISTA DECOR & FURNISHING PVT LTD janardhana Hills, Gachibowli HYDERABAD",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 500081,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4360008,
      Longitude: 78.3658631,
    },
    {
      id: 3125,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "HYD INSTOHOT",
      Contact_name: "Mr.Ravi",
      Store_Address:
        "#1-26-1 A, GACHIBOWLI X ROAD TOWARDS KONDAPUR BESIDE TATA MOTORS HYDERABAD",
      Mobile_No: "8008826164 9032",
      Landline_No: "",
      Email: "",
      Pin_Code: 500013,
      DT: "NULL",
      Active: 0,
      Latitude: 17.44282,
      Longitude: 78.3607573,
    },
    {
      id: 3126,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "INTEX CONCEPTS",
      Contact_name: "Mr.Anil",
      Store_Address: "SHOP NO 3 & 4 UPTOWN CYBERABAD AYYAPPA SOCIETY HYDERABAD",
      Mobile_No: "6551 2015",
      Landline_No: "",
      Email: "",
      Pin_Code: 500008,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4428192,
      Longitude: 78.3454364,
    },
    {
      id: 3127,
      Area: "South",
      States: "Telangana",
      City: "Adilabad",
      Category: 1,
      Store_name: "JAGANNATH BUILDERS & INTERIORS",
      Contact_name: "Srikanthpathiwar",
      Store_Address: "JAGANNATH COMPLEX BHUKTAPUR, ADILABAD ADILABAD",
      Mobile_No: "08732-233689 73",
      Landline_No: "",
      Email: "",
      Pin_Code: 504001,
      DT: "NULL",
      Active: 0,
      Latitude: 19.6759238,
      Longitude: 78.5293833,
    },
    {
      id: 3128,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "JALARAM ENTERPRISES",
      Contact_name: "Mr.Rakesh",
      Store_Address:
        "D.NO.7-3-76, BHAIRAMALGUDA LB NAGAR N SAGAR ROAD HYDERABAD",
      Mobile_No: "99490 18231 900",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.3406445,
      Longitude: 78.5455781,
    },
    {
      id: 3129,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "LUCENTE KITCHENSLLP",
      Contact_name: "Mr.Srinivas",
      Store_Address: "SHOP NO 3 & 4 UPTOWN CYBERABAD AYYAPPA SOCIETY HYDERABAD",
      Mobile_No: "6551 2015",
      Landline_No: "",
      Email: "",
      Pin_Code: 500034,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4473013,
      Longitude: 78.3756204,
    },
    {
      id: 3130,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "MAHALAKSHMI COLLECTIONS",
      Contact_name: "Mr,Deepak",
      Store_Address: "6-3-850 3 SHOP # 1 SRINIVASA PLAZA, AMEERPET HYDERABAD",
      Mobile_No: "040-23411813 89",
      Landline_No: "",
      Email: "",
      Pin_Code: 500016,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4370159,
      Longitude: 78.4450975,
    },
    {
      id: 3131,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "MAHALAXMI HOME NEEDS",
      Contact_name: "Mr.Darshan",
      Store_Address:
        "4-6-69 1 BT FF 2 BALWANT TOWERS.PILLAR # 141 ATTAPUR, HYDERABAD HYDERABAD",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.3646245,
      Longitude: 78.4261491,
    },
    {
      id: 3132,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "R.K. ENTERPRISES",
      Contact_name: "Mr. Naveen",
      Store_Address:
        "H.NO: 2 92 2 1 NR, S.NO.333 JEEDIMETLA VILLAGE QUTUBULLAPUR MANDAL HYDERABAD",
      Mobile_No: "90300 45013",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.5639939,
      Longitude: 78.4848607,
    },
    {
      id: 3133,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "RAJ ENTERPRISES",
      Contact_name: "Mr.Sudheer",
      Store_Address:
        "2-3-235, ROAD NO.2 ADARSH NAGAR COLONY NEAR RTA NAGOLE OFFICE, NAGOLE HYDERABAD",
      Mobile_No: "99631 01534 924",
      Landline_No: "",
      Email: "",
      Pin_Code: 500074,
      DT: "NULL",
      Active: 0,
      Latitude: 17.370829,
      Longitude: 78.5557583,
    },
    {
      id: 3134,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SHANKER PLYWOOD & HARDWARE",
      Contact_name: "Mr.Narayan Choudary",
      Store_Address:
        "D.NO: 4-89, PLOT # 39, PRASHANTI NAGAR COLONY JEEDIMETLA VILLAGE HYDERABAD",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.5097995,
      Longitude: 78.4212844,
    },
    {
      id: 3135,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SIRVI ENTERPRISES",
      Contact_name: "Mr.Naresh",
      Store_Address:
        "D.NO. 1-4-73 2 D 1ST & 2ND FLOOR, SNEHA NAGAR STREET NO.8 HABSIGUDA, ABOVE HDFC BANK HYDERABAD",
      Mobile_No: 9160468499,
      Landline_No: "",
      Email: "",
      Pin_Code: 500076,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4165758,
      Longitude: 78.5404815,
    },
    {
      id: 3136,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SREE SREENIVASA BUILDING NEEDS",
      Contact_name: "Mr.Srinivas",
      Store_Address:
        "PLOT NO.8, SY NO.15 TO 18, BAHADURGUDA, HYDERABAD BETWEEN LB NAGAR & SAGAR X ROAD, HYDERABAD",
      Mobile_No: "98492 99906 040",
      Landline_No: "",
      Email: "",
      Pin_Code: 500074,
      DT: "NULL",
      Active: 0,
      Latitude: 17.34383,
      Longitude: 78.5456263,
    },
    {
      id: 3137,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SRI GOPAL PLYWOODS",
      Contact_name: "Mr.Harish",
      Store_Address: "3-4-150 VIJAYWADA ROAD OPP. HANUMAN TEMPLE HYDERABAD",
      Mobile_No: 9000808117,
      Landline_No: "",
      Email: "",
      Pin_Code: 500079,
      DT: "NULL",
      Active: 0,
      Latitude: 17.3484926,
      Longitude: 78.5470939,
    },
    {
      id: 3138,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SRI GUJARAT PLYWOOD",
      Contact_name: "Mr.Suresh Choudary",
      Store_Address: "GYATRI NAGAR, SAGAR RING ROAD, HYDERABAD",
      Mobile_No: 9000808117,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.338088,
      Longitude: 78.5265434,
    },
    {
      id: 3139,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SRI VEDA ENTERPRISES",
      Contact_name: "Mr.Ganesh",
      Store_Address:
        "FLAT G-3, SHOP NO-3, PLOT-1234, SUDHAKAR TOWERS PRAGATHI NAGAR,OPP JNTU, KUKATPALLY HYDERABAD",
      Mobile_No: "89191 20886",
      Landline_No: "",
      Email: "",
      Pin_Code: 500085,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4986037,
      Longitude: 78.3919315,
    },
    {
      id: 3140,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "Radhe Sales",
      Contact_name: "Mr,Vijay Reddy",
      Store_Address: "Near -Ratnadeep suoer Market- Nallagundla",
      Mobile_No: 9848047333,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.4741627,
      Longitude: 78.3070763,
    },
    {
      id: 3141,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 1,
      Store_name: "SRIVEDIC ELECTRONICS",
      Contact_name: "Mr.Balaji",
      Store_Address:
        "BESIDE CHIREC PUBLIC SCHOOL BOTANICAL GARDEN SCHOOL KADIRI APURUPA URBAN BUILDING, KONDAPUR HYDERABAD",
      Mobile_No: "99894 53251",
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 17.48509,
      Longitude: 78.56322,
    },
    {
      id: 3142,
      Area: "South",
      States: "Telangana",
      City: "Siddipet",
      Category: 1,
      Store_name: "VINAYAKA BATH DESIGN",
      Contact_name: "",
      Store_Address: "SIDDIPET, TELANGANA.",
      Mobile_No: 9959987562,
      Landline_No: "",
      Email: "",
      Pin_Code: 0,
      DT: "NULL",
      Active: 0,
      Latitude: 18.08183,
      Longitude: 78.8541,
    },
    {
      id: 3143,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 2,
      Store_name: "Aarco One",
      Contact_name: "Naveen",
      Store_Address: "J-36, Lajpat Nagar-II",
      Mobile_No: 9910757779,
      Landline_No: "",
      Email: "",
      Pin_Code: 110024,
      DT: "NULL",
      Active: 0,
      Latitude: 77.2433747,
      Longitude: 28.5681043,
    },
    {
      id: 3145,
      Area: "North",
      States: "Rajasthan",
      City: "Jaipur",
      Category: 2,
      Store_name: "Safex International",
      Contact_name: "Mr Kishor advani",
      Store_Address:
        "A - 3, New Atish Market, Behind Ganga Jamuna Petrol Pump, Mansarover,Jaipur",
      Mobile_No: "9314621405, 931",
      Landline_No: "",
      Email: "laxmanadvani@rdiffmail.com",
      Pin_Code: 302020,
      DT: "NULL",
      Active: 0,
      Latitude: 75.764455,
      Longitude: 26.880193,
    },
    {
      id: 3146,
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 2,
      Store_name: "Chaudhry Sensible Kitchen",
      Contact_name: "Mr. Sumit",
      Store_Address:
        "Near Dodha Sweet, Heera Singh Road, Ghumar Mandi, Ludhiana",
      Mobile_No: 9872800328,
      Landline_No: "0161-5011711",
      Email: "sumitchaudhry1981@gmail.com",
      Pin_Code: 141001,
      DT: "NULL",
      Active: 0,
      Latitude: 30.90015,
      Longitude: 75.85229,
    },
    {
      id: 3147,
      Area: "North",
      States: "Chandigarh",
      City: "Chandigarh",
      Category: 2,
      Store_name: "Dharam Chand Aggarwal",
      Contact_name: "Rajiv Goyal",
      Store_Address: "Plot No. 109, Ind. Area Phase-1, Chandigarh",
      Mobile_No: 8284864163,
      Landline_No: "",
      Email: "rajivgoyal1@gmail.com",
      Pin_Code: 160018,
      DT: "NULL",
      Active: 0,
      Latitude: 76.789212,
      Longitude: 30.7316699,
    },
    {
      id: 3148,
      Area: "South",
      States: "Telangana State",
      City: "Hyderabad",
      Category: 2,
      Store_name: "My Kitchen",
      Contact_name: "Mr.Amjad",
      Store_Address: "RTC cross road, Hyderabad",
      Mobile_No: 9490011611,
      Landline_No: "",
      Email: "faberhyderabad@gmail.com",
      Pin_Code: 500020,
      DT: "NULL",
      Active: 0,
      Latitude: 78.4845567,
      Longitude: 17.4106751,
    },
    {
      id: 3149,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sterling Incorporators",
      Contact_name: "mr. dinesh sharma",
      Store_Address: "Dr Rajkumar road. Prakash nagar.",
      Mobile_No: 9880067829,
      Landline_No: "",
      Email: "sterlingblr10@gmail.com",
      Pin_Code: 560010,
      DT: "NULL",
      Active: 0,
      Latitude: 77.55961,
      Longitude: 12.991729,
    },
    {
      id: 3150,
      Area: "North",
      States: "Haryana",
      City: "Panchkula",
      Category: 2,
      Store_name: "Surindra Agencies",
      Contact_name: "Mr. Surinder",
      Store_Address: "SCF 143-144, Sector – 17, Panchkula",
      Mobile_No: 9417048004,
      Landline_No: "",
      Email: "kansal_surinder@yahoo.co.in",
      Pin_Code: 134109,
      DT: "NULL",
      Active: 0,
      Latitude: 76.8355622,
      Longitude: 30.6965415,
    },
    {
      id: 3151,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Anupama Home world",
      Contact_name: "",
      Store_Address: "364 1,10th B Main Road, 3rd Block,Jayanagar,Bangalore",
      Mobile_No: "",
      Landline_No: "9844754448, 080",
      Email: "anupamahomeworld@gmail.com",
      Pin_Code: 560011,
      DT: "NULL",
      Active: 0,
      Latitude: 77.5837293,
      Longitude: 12.9327929,
    },
    {
      id: 3152,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Anupama Home world",
      Contact_name: "",
      Store_Address:
        "19 1,Venkataswamy Naidu Road,opp: Ramada Hotel. near Om shakti temple,Shivaji Nagar,Bangalore",
      Mobile_No: "",
      Landline_No: "9844754448, 080",
      Email: "anupamahomeworld@gmail.com",
      Pin_Code: 560051,
      DT: "NULL",
      Active: 0,
      Latitude: 77.6103927,
      Longitude: 12.9837087,
    },
    {
      id: 3153,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "IDEAS",
      Contact_name: "",
      Store_Address:
        "#117, Anand Nagar, Service Road, Outer Ring Road, Marathalli, Karnataka",
      Mobile_No: 7829710280,
      Landline_No: "",
      Email: "ideasmrtl@yahoo.com",
      Pin_Code: 560037,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3154,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Prestige Global Trades",
      Contact_name: "",
      Store_Address:
        "11,80ft road,8th Block, near Pass post office , Koramangala ,Bangalore",
      Mobile_No: "",
      Landline_No: "08041659888  98",
      Email: "prestigeglobaltrades@gmail.com",
      Pin_Code: 560095,
      DT: "NULL",
      Active: 0,
      Latitude: 77.6181992,
      Longitude: 12.9455031,
    },
    {
      id: 3155,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Manoj Enterprises",
      Contact_name: "",
      Store_Address:
        "13,Teachers Colony,Nagarbhavi Main Road,Nagarbhavi,Bangalore",
      Mobile_No: "",
      Landline_No: "99800 23706",
      Email: "manojsf31@gmail.com",
      Pin_Code: 560072,
      DT: "NULL",
      Active: 0,
      Latitude: 77.5330379,
      Longitude: 12.9156876,
    },
    {
      id: 3156,
      Area: "West",
      States: "Goa",
      City: "Goa",
      Category: 2,
      Store_name: "Apex Marketing Goa",
      Contact_name: "mr. harshad",
      Store_Address: "shop no.2, sameer apartments, st.inez",
      Mobile_No: 9890249072,
      Landline_No: "",
      Email: "hkapex@rediffmail.com",
      Pin_Code: 403001,
      DT: "NULL",
      Active: 0,
      Latitude: 73.761687,
      Longitude: 15.550802,
    },
    {
      id: 3157,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sampurna International",
      Contact_name: "",
      Store_Address:
        "GF773 1,1st floor,Taralabalu Enclave,BB Road, Opp RMZ Mall, above Sony center,Yelankha",
      Mobile_No: "9242898587/ 9972",
      Landline_No: "",
      Email: "sampurnain9@gmail.com",
      Pin_Code: 560064,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3158,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sampurna International",
      Contact_name: "mr. mahesh",
      Store_Address: "Rammurthy Nagar. Banaswadi ring road",
      Mobile_No: 9242898587,
      Landline_No: "",
      Email: "sampurna888@gmail.com",
      Pin_Code: 560043,
      DT: "NULL",
      Active: 0,
      Latitude: 77.661917,
      Longitude: 13.016825,
    },
    {
      id: 3159,
      Area: "East",
      States: "Assam",
      City: "Guwahati",
      Category: 2,
      Store_name: "Kitchen Concept",
      Contact_name: "Ashok Siotia",
      Store_Address: "b.k.kakoti road, rehabari, guwahati",
      Mobile_No: 9435109253,
      Landline_No: "",
      Email: "kitchenconcept.ghy@gmail.com",
      Pin_Code: 781007,
      DT: "NULL",
      Active: 0,
      Latitude: 91.75032,
      Longitude: 26.168496,
    },
    {
      id: 3160,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Neugen Marketing",
      Contact_name: "mr. srinivas",
      Store_Address:
        "no. 147, 1st floor, ags complex, kaikondanahalli cross, carmelaram post, sarjapur main road,",
      Mobile_No: 9343754127,
      Landline_No: "",
      Email: "",
      Pin_Code: 560035,
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3161,
      Area: "West",
      States: "Chattisgarh",
      City: "Raipur",
      Category: 2,
      Store_name: "Ashirwad Marketing",
      Contact_name: "Vivek Motwani",
      Store_Address:
        "New Timber Market, Opposite Radha timber, Trimurti Nagar Road, Fafadih, Raipur,Chattisgarh",
      Mobile_No: 9300067000,
      Landline_No: "",
      Email: "vivekmotwani1@gmail.com",
      Pin_Code: 492009,
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3162,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 2,
      Store_name: "Rathna Fan House Pvt. Ltd.",
      Contact_name: "",
      Store_Address:
        "No 36, Rajabathar Street, T Nagar (Behind naidu hall), Chennai",
      Mobile_No: "28153068   2815",
      Landline_No: "044 28155535 28",
      Email: "sankarrfh@yahoo.com",
      Pin_Code: 600017,
      DT: "NULL",
      Active: 0,
      Latitude: 13.08784,
      Longitude: 80.27847,
    },
    {
      id: 3163,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 2,
      Store_name: "Vibrant Homz",
      Contact_name: "",
      Store_Address: "#7, AD BLOCK, 2ND AVENUE,Anna Nagar,CHENNAI - 600040",
      Mobile_No: 9500003191,
      Landline_No: "",
      Email: "vibranthomz@gmail.com",
      Pin_Code: 600040,
      DT: "NULL",
      Active: 0,
      Latitude: 13.0872004,
      Longitude: 80.2164421,
    },
    {
      id: 3164,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 2,
      Store_name: "Signet Kitchen Studio",
      Contact_name: "Aarti",
      Store_Address:
        "Shop No.5, Mulund Goregaon Link Rd, Opposite D Mart, Rajiv Gandhi Nagar, Mulund West, Mumbai, Maharashtra",
      Mobile_No: "098214 55360",
      Landline_No: "",
      Email: "",
      Pin_Code: 400080,
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3165,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 2,
      Store_name: "Wood secret",
      Contact_name: "Ravi",
      Store_Address:
        "B - 199, Mansarover Garden, Near Revital Gym, Kirti Nagar, Delhi",
      Mobile_No: "96508 98783",
      Landline_No: "",
      Email: "",
      Pin_Code: 110015,
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3166,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 2,
      Store_name: "Uni Electro",
      Contact_name: "Sumit",
      Store_Address:
        "Kohat Enclave -Near Sargam Avantika, Pitampura, Kohat Enclav, Delhi",
      Mobile_No: "99900 29119",
      Landline_No: "",
      Email: "",
      Pin_Code: 110034,
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3167,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "HAFFE KITCHEN",
      Contact_name: "Mr Fayaz",
      Store_Address: "Double Road. Opp Shanti Nagr Bus stop",
      Mobile_No: 9986661234,
      Landline_No: "",
      Email: "hafeekitchens@gmail.com",
      Pin_Code: 560038,
      DT: "NULL",
      Active: 0,
      Latitude: 77.5922107,
      Longitude: 12.9543433,
    },
    {
      id: 3168,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "C S Studio",
      Contact_name: "Mr Shreenath",
      Store_Address: "No 14, 27th Main road, Sectore 1, HSR Layout Bangalore",
      Mobile_No: 9741123364,
      Landline_No: "",
      Email: "",
      Pin_Code: 560102,
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3169,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 2,
      Store_name: "Kitchen Ikon (SS Retail venture)",
      Contact_name: "",
      Store_Address: "Shop No: ½ Chetna Apt,24 23,East Street,Camp, Pune",
      Mobile_No: "",
      Landline_No: "98221 07995",
      Email: "ssretailventure@gmail.com",
      Pin_Code: 411001,
      DT: "NULL",
      Active: 0,
      Latitude: 73.9225636,
      Longitude: 18.4757371,
    },
    {
      id: 3170,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "BDM marketing",
      Contact_name: "",
      Store_Address:
        "Faber Platinum Studion63, KH Road, Sudhama Nagar ,Bangalore",
      Mobile_No: 9980797979,
      Landline_No: "",
      Email: "",
      Pin_Code: 560027,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3171,
      Area: "East",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "Y S Enterprises",
      Contact_name: "Mr. Alok Kumar",
      Store_Address:
        "Chapra Niwas, Near Krishna Niketan School, Buddha Colony, Patna-800001",
      Mobile_No: "8877446600, 933",
      Landline_No: "",
      Email: "",
      Pin_Code: 800001,
      DT: "03-12-2019",
      Active: 1,
      Latitude: 25.60222,
      Longitude: 85.11936,
    },
    {
      id: 3172,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "Indore",
      Category: 1,
      Store_name: "NKS Marketing",
      Contact_name: "Nitendra Jaiswal",
      Store_Address: "LG-25,Mangal city Mall Vijay nagar Square Indore",
      Mobile_No: 9009060125,
      Landline_No: "",
      Email: "",
      Pin_Code: 452010,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3173,
      Area: "North",
      States: "Punjab",
      City: "Rayya",
      Category: 1,
      Store_name: "BMD Design And Style",
      Contact_name: "Niraj Duggal",
      Store_Address: "Cheema Bath Chownk, G.T Road, Rayya, Punjab",
      Mobile_No: "7087010850, 946",
      Landline_No: "",
      Email: "bmddesignandstyle@gmail.com",
      Pin_Code: 143112,
      DT: "07-01-2020",
      Active: 0,
      Latitude: 30.91667,
      Longitude: 75.41667,
    },
    {
      id: 3174,
      Area: "North",
      States: "Punjab",
      City: "Kapurthala",
      Category: 1,
      Store_name: "National Radio Corporation",
      Contact_name: "Ankit Talwar",
      Store_Address: "Kanjli Road, Opp. Milan Palace, Kapurthala, Punjab",
      Mobile_No: "01822501895, 98",
      Landline_No: "",
      Email: "nationalradiocorpkpt@gmail.com",
      Pin_Code: 144601,
      DT: "07-01-2020",
      Active: 0,
      Latitude: 31.38011,
      Longitude: 75.38105,
    },
    {
      id: 3175,
      Area: "North",
      States: "Punjab",
      City: "Nakodar",
      Category: 1,
      Store_name: "Ram Lubhaya Rakesh Chander",
      Contact_name: "Rishi",
      Store_Address:
        "Shankar Road, Near D.A.V College, Boys Wing, Nakodar, Punjab",
      Mobile_No: "9592488000, 981",
      Landline_No: "",
      Email: "rlrcnkd@rediffmail.com",
      Pin_Code: 144040,
      DT: "07-01-2020",
      Active: 1,
      Latitude: 31.1259,
      Longitude: 75.47585,
    },
    {
      id: 3176,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "Mittar Paul Exclusive",
      Contact_name: "Mr. Sahil Mahindru",
      Store_Address: "188, Basement Landmarks, Model Town, Jalandhar, Punjab",
      Mobile_No: "9815000049, 981",
      Landline_No: "",
      Email: "sahilmahendru49@yahoo.com",
      Pin_Code: 144001,
      DT: "15-01-2020",
      Active: 0,
      Latitude: 31.32556,
      Longitude: 75.57917,
    },
    {
      id: 3177,
      Area: "North",
      States: "Punjab",
      City: "Batala",
      Category: 1,
      Store_name: "Manohar Lal Kewal Krishan",
      Contact_name: "Mr. Janesh",
      Store_Address: "Loha Mandi, City Road, Batala, Punjab",
      Mobile_No: "9814032399, 946",
      Landline_No: "",
      Email: "janeshmittal@gmail.com",
      Pin_Code: 143505,
      DT: "15-01-2020",
      Active: 0,
      Latitude: 31.81861,
      Longitude: 75.20278,
    },
    {
      id: 3178,
      Area: "North",
      States: "Punjab",
      City: "Kapurthala",
      Category: 1,
      Store_name: "Kitchen World",
      Contact_name: "Mr. Paramjit Singh",
      Store_Address:
        "Amar Complex, Mansoorwal Dona, Jalandhar Road, Kapurthala, Punjab",
      Mobile_No: "9815498092, 991",
      Landline_No: "",
      Email: "kitchenworld32@yahoo.com",
      Pin_Code: 144601,
      DT: "15-01-2020",
      Active: 0,
      Latitude: 31.38011,
      Longitude: 75.38105,
    },
    {
      id: 3181,
      Area: "East",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "SP ENTERPRISES",
      Contact_name: "Mukesh Kumar",
      Store_Address: "Gate no- 62 , Kurji more Patna - 10 Near P&M MALL, Bihar",
      Mobile_No: "7488325919, 983",
      Landline_No: "",
      Email: "",
      Pin_Code: 800010,
      DT: "27-01-2020",
      Active: 0,
      Latitude: 27.699862,
      Longitude: 85.34127,
    },
    {
      id: 3183,
      Area: "East",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "M/S Sankalp",
      Contact_name: "",
      Store_Address: "Dighi kalan, Mahua Road, Hajipur",
      Mobile_No: 6200885440,
      Landline_No: "06224-275610",
      Email: "",
      Pin_Code: 844101,
      DT: "27-01-2020",
      Active: 1,
      Latitude: 24.0095212,
      Longitude: 88.1164016,
    },
    {
      id: 3185,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 2,
      Store_name: "INCANDESCENT",
      Contact_name: "",
      Store_Address: "C-153 2 Okhla Phase-1, Delhi.",
      Mobile_No: "9811323060   98",
      Landline_No: "011-45027631",
      Email: "sales@incandescent.in",
      Pin_Code: 110020,
      DT: "11-02-2020",
      Active: 0,
      Latitude: 28.65381,
      Longitude: 77.22897,
    },
    {
      id: 3186,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 2,
      Store_name: "Décor point",
      Contact_name: "Vineet",
      Store_Address: "161 , Ponnurangam road east, R s puram, Coimbatore",
      Mobile_No: 9790560306,
      Landline_No: "",
      Email: "decorpoint@ymail.com",
      Pin_Code: 641002,
      DT: "11-02-2020",
      Active: 0,
      Latitude: 11.00555,
      Longitude: 76.96612,
    },
    {
      id: 3187,
      Area: "West",
      States: "Maharashtra",
      City: "Thane",
      Category: 2,
      Store_name: "Signet Kitchen Studio",
      Contact_name: "Deepak",
      Store_Address:
        "SHOP NO 12 13,PLOT NO 8 9,SHIVJI MARKET, SECTOR 19D,NEAR APMC POLICE STATION,VASHI,THANE,MAHARASHTRA, MUMBAI.",
      Mobile_No: 9323102792,
      Landline_No: "",
      Email: "",
      Pin_Code: 400703,
      DT: "11-02-2020",
      Active: 0,
      Latitude: 19.07283,
      Longitude: 72.88261,
    },
    {
      id: 3188,
      Area: "West",
      States: "Maharashtra",
      City: "Aurangabad",
      Category: 2,
      Store_name: "Constro Agencies",
      Contact_name: "",
      Store_Address:
        "Big Bazar Complex, Akashwani Signal, Jalna Road, Jalna Road, Aurangabad, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 431005,
      DT: "11-02-2020",
      Active: 0,
      Latitude: 24.75,
      Longitude: 84.5,
    },
    {
      id: 3189,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 2,
      Store_name: "Rajdeep enterprises",
      Contact_name: "",
      Store_Address:
        "Shop 388, Jawaharlal Nehru Rd, near Janta Foot Wear, Shastri Nagar, Pimpri Colony, Pimpri-Chinchwad, Maharashtra",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411017,
      DT: "11-02-2020",
      Active: 0,
      Latitude: 18.61867,
      Longitude: 73.80375,
    },
    {
      id: 3190,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 2,
      Store_name: "M s Global Entperises",
      Contact_name: "Mr.Raghu",
      Store_Address: "Gachibowli X Roads, Gachibowli, Hyderabad",
      Mobile_No: 9032539357,
      Landline_No: "",
      Email: "globalenterprisesgb@gmail.com",
      Pin_Code: 500032,
      DT: "11-02-2020",
      Active: 0,
      Latitude: 17.4436222,
      Longitude: 78.3519638,
    },
    {
      id: 3191,
      Area: "East",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "S.R Enterprises",
      Contact_name: "Sumeet Kumar",
      Store_Address:
        "Reliance Digital , Footprint Building , Basement , pillar no. 17 , Jagdeopath , Bailey Road Patna",
      Mobile_No: 919000000000,
      Landline_No: "",
      Email: "",
      Pin_Code: 800014,
      DT: "19-02-2020",
      Active: 0,
      Latitude: 25.632444,
      Longitude: 85.105672,
    },
    {
      id: 3192,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Kamal Enterprises",
      Contact_name: "Mr.Kamal Ahmed",
      Store_Address: "CG-63, Arcadia South City -II, Gurgaon",
      Mobile_No: 7838380520,
      Landline_No: "",
      Email: "99kamal@gmail.com",
      Pin_Code: 122018,
      DT: "23-02-2020",
      Active: 0,
      Latitude: 28.4601,
      Longitude: 77.02635,
    },
    {
      id: 3195,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 2,
      Store_name: "Ashana Enterprises",
      Contact_name: "Shivam",
      Store_Address: "SCO 321, First Floor, Sector 29, Gurgaon",
      Mobile_No: 9910393529,
      Landline_No: "",
      Email: "ashanaenterprises.com",
      Pin_Code: 122001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3196,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 2,
      Store_name: "Bansal Electrovision",
      Contact_name: "Bhoopender",
      Store_Address:
        "UG 08A-B,Raheja Mall,Sector 47, near Subhash Chowk, Gurugram, Haryana",
      Mobile_No: 7292005694,
      Landline_No: "",
      Email: "salesbansal12@gmail.com",
      Pin_Code: 122002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3198,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Himadri bath solutions",
      Contact_name: "bharat gupta",
      Store_Address: "sco 26 , huda jail complex sohna chowk , near sada",
      Mobile_No: 9910613355,
      Landline_No: "",
      Email: "himadri.bath@hotmail.com",
      Pin_Code: 122001,
      DT: "24-02-2020",
      Active: 0,
      Latitude: 28.458101,
      Longitude: 77.026541,
    },
    {
      id: 3199,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Himadri bath solutions",
      Contact_name: "bharat gupta",
      Store_Address: "sco 26 , huda jail complex sohna chowk , near sada",
      Mobile_No: 9910613355,
      Landline_No: "",
      Email: "himadri.bath@hotmail.com",
      Pin_Code: 122001,
      DT: "24-02-2020",
      Active: 1,
      Latitude: 28.458101,
      Longitude: 77.026541,
    },
    {
      id: 3200,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "MGM CUCINE",
      Contact_name: "Gaurav Malik",
      Store_Address: "sco 26 , huda jail complex sohna chowk , near sada",
      Mobile_No: 9999992220,
      Landline_No: "",
      Email: "mgmcucine@gmail.com",
      Pin_Code: 122009,
      DT: "24-02-2020",
      Active: 0,
      Latitude: 28.47279,
      Longitude: 77.06324,
    },
    {
      id: 3201,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Croma Ambience Mall",
      Contact_name: "",
      Store_Address:
        "Ambience Mall, S-207,208,2nd Floor,Ambience Mall,Ambience Island, NH-8,Gurgaon,122001",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 122001,
      DT: "24-02-2020",
      Active: 0,
      Latitude: 28.455473,
      Longitude: 77.021904,
    },
    {
      id: 3202,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground & Mezzanine Floor, Universal Trade Tower, Sector 49, Sohna Road, Gurgaon – 122018.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 122018,
      DT: "24-02-2020",
      Active: 0,
      Latitude: 28.418081,
      Longitude: 77.05069,
    },
    {
      id: 3203,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "CROMA",
      Contact_name: "",
      Store_Address:
        "Ground, First & Basement of SCO No.313 and First Floor,SCO No. 314, Sector 29, Gurgaon – 122002",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 122002,
      DT: "24-02-2020",
      Active: 0,
      Latitude: 28.47468,
      Longitude: 77.104897,
    },
    {
      id: 3204,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Tirupati",
      Category: 2,
      Store_name: "SREE CHIMNEY WORLD",
      Contact_name: "",
      Store_Address:
        "SHOP.NO. 4, NEAR CENTRAL PARK, OPP. MEESEVA,TIRUPATI, CHITTOOR DISTRICT ANDHRA PRADESH.",
      Mobile_No: 9700050713,
      Landline_No: "",
      Email: "",
      Pin_Code: 517507,
      DT: "06-03-2020",
      Active: 0,
      Latitude: 13.63551,
      Longitude: 79.41989,
    },
    {
      id: 3205,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 2,
      Store_name: "Asiatic Electric Trading Co.",
      Contact_name: "",
      Store_Address: "46-48, Jay Mahal Building,Lohar Chawal, Mumbai",
      Mobile_No: "2222069948, 224",
      Landline_No: "",
      Email: "aetco11@gmail.com",
      Pin_Code: 400002,
      DT: "06-03-2020",
      Active: 0,
      Latitude: 19.07283,
      Longitude: 72.88261,
    },
    {
      id: 3206,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 2,
      Store_name: "Raj Kitchen and Wardrobes",
      Contact_name: "",
      Store_Address:
        "67 669, M.H.B. Colony, Gulmohar CHS. LTD., Opp. Parijat CHS, Mahavir Nagar, Kandivali, Mumbai",
      Mobile_No: "9322264673 / 8097055152",
      Landline_No: "",
      Email: "hujefa@raajkitchen.com / info@raajkitchen.com",
      Pin_Code: 400067,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3207,
      Area: "North",
      States: "Jammu and Kashmir",
      City: "Srinagar",
      Category: 2,
      Store_name: "Electronic Brain",
      Contact_name: "Mr. Arif",
      Store_Address: "Hari Singh High Street, Srinagar",
      Mobile_No: "7006311697, 946",
      Landline_No: "",
      Email: "arif.bashir.mir@gmail.com",
      Pin_Code: 190001,
      DT: "06-03-2020",
      Active: 0,
      Latitude: 34.0696128,
      Longitude: 74.805945,
    },
    {
      id: 3208,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 2,
      Store_name: "Simran Agencies",
      Contact_name: "Mr. Jagmohan",
      Store_Address:
        "Shop No 32, Santosh Heights, Shankar Sheth Road, Shankar Sheth Road, opposite Aspara Theatre, Pune, Maharashtra",
      Mobile_No: 9890287374,
      Landline_No: "",
      Email: "",
      Pin_Code: 411037,
      DT: "06-03-2020",
      Active: 0,
      Latitude: 18.51957,
      Longitude: 73.85535,
    },
    {
      id: 3209,
      Area: "West",
      States: "Maharashtra",
      City: "Pune",
      Category: 2,
      Store_name: "Kitchen Ikon (Aditya Agencies)",
      Contact_name: "",
      Store_Address: "Shop No.138 Shangrila Garden, Bund Garden, Pune",
      Mobile_No: 7796466781,
      Landline_No: "",
      Email: "",
      Pin_Code: 411001,
      DT: "06-03-2020",
      Active: 0,
      Latitude: 18.5404101,
      Longitude: 73.8846143,
    },
    {
      id: 3210,
      Area: "North",
      States: "Punjab",
      City: "Amritsar",
      Category: 2,
      Store_name: "Home gallery",
      Contact_name: "",
      Store_Address:
        "Main Ram Tirath Road, Opposite Hotel Heaven blue, Putlighar, Amritsar Punjab",
      Mobile_No: "75089 36362, 78",
      Landline_No: "",
      Email: "",
      Pin_Code: 143009,
      DT: "06-03-2020",
      Active: 0,
      Latitude: 31.63661,
      Longitude: 74.87476,
    },
    {
      id: 3211,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 1,
      Store_name: "Gupta Traders",
      Contact_name: "Mr. Amit Gupta   Mr. Nitin Gupta",
      Store_Address:
        "Near Harmeet Transport, Kapurthala Road, Jalandhar, Punjab. Pin Code-144001",
      Mobile_No: 9814087442,
      Landline_No: "",
      Email: "guptatraders1999@yahoo.com",
      Pin_Code: 144001,
      DT: "16-03-2020",
      Active: 0,
      Latitude: 31.334953,
      Longitude: 75.5668845,
    },
    {
      id: 3212,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "RENOWNED CREATION",
      Contact_name: "Sajal Hazra",
      Store_Address: "1 No, Near Hanuman Mandir, Jawpur Road, Dum Dum Kolkata",
      Mobile_No: "+919830955386,",
      Landline_No: "",
      Email: "renownedcreation261@gmail.com",
      Pin_Code: 700074,
      DT: "13-04-2020",
      Active: 0,
      Latitude: 22.56263,
      Longitude: 88.36304,
    },
    {
      id: 3213,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Annapurna Furniture -Highland Park",
      Contact_name: "Partha Kundu",
      Store_Address:
        "Shop no-G 02A & 02B, Gr Floor, Hiland Park, Metropolis Mall, EM Bypass, Kolkata",
      Mobile_No: 9830006424,
      Landline_No: "",
      Email: "",
      Pin_Code: 700094,
      DT: "13-04-2020",
      Active: 0,
      Latitude: 22.56263,
      Longitude: 88.36304,
    },
    {
      id: 3214,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Annapurna Furniture - Nagerbazar",
      Contact_name: "Partha Kundu",
      Store_Address: "479,Jessore Road, Nagerbazar,Dum Dum ,Kolkata",
      Mobile_No: 9830006424,
      Landline_No: "033-25600295",
      Email: "",
      Pin_Code: 700074,
      DT: "13-04-2020",
      Active: 0,
      Latitude: 22.56263,
      Longitude: 88.36304,
    },
    {
      id: 3215,
      Area: "East",
      States: "West Bengal",
      City: "Hooghly",
      Category: 1,
      Store_name: "J TOSH SANITATION- DANKUNI",
      Contact_name: "Mr Sumit Mandol",
      Store_Address: "310,Subash Pally,Dankuni,Hoogly",
      Mobile_No: 8918128607,
      Landline_No: "",
      Email: "",
      Pin_Code: 712310,
      DT: "13-04-2020",
      Active: 0,
      Latitude: 22.90877,
      Longitude: 88.39674,
    },
    {
      id: 3216,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "CROMA-RAJARHUT",
      Contact_name: "Avisekh Garai",
      Store_Address: "CB 218, AA-1 Newtown, Rajarhut, Kolkata",
      Mobile_No: 8637384914,
      Landline_No: "",
      Email: "",
      Pin_Code: 700156,
      DT: "13-04-2020",
      Active: 1,
      Latitude: 22.56263,
      Longitude: 88.36304,
    },
    {
      id: 3217,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "HOMETOWN -Bhawanipore",
      Contact_name: "Dipankar",
      Store_Address: "18 B Ashutosh Mukherjee Road, Kolkata",
      Mobile_No: 7439127934,
      Landline_No: "",
      Email: "",
      Pin_Code: 700020,
      DT: "13-04-2020",
      Active: 0,
      Latitude: 22.56263,
      Longitude: 88.36304,
    },
    {
      id: 3218,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "HOME TOWN-Nagerbazar",
      Contact_name: "Somen Das",
      Store_Address: "68 ,Jessore Road, Diamond Plaza, Dum Dum Kolkata",
      Mobile_No: 9330001319,
      Landline_No: "",
      Email: "",
      Pin_Code: 700055,
      DT: "13-04-2020",
      Active: 0,
      Latitude: 22.56263,
      Longitude: 88.36304,
    },
    {
      id: 3219,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "CROMA-SARAT BOSE ROAD",
      Contact_name: "Sarat Bose   Rajarhut",
      Store_Address: "P.S. Residency Building, 57 Sarat Bose Road, Kolkata",
      Mobile_No: "06292216528  06",
      Landline_No: "",
      Email: "",
      Pin_Code: 700025,
      DT: "13-04-2020",
      Active: 1,
      Latitude: 22.5392062,
      Longitude: 88.3546328,
    },
    {
      id: 3220,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "AMBICA ENTERPRISES",
      Contact_name: "",
      Store_Address:
        "#6, SOUTH SIVAN KOIL STREET,100FT ROAD, VADAPALANI,CHENNAI - 600026",
      Mobile_No: "",
      Landline_No: "044-43551641",
      Email: "sivanathapandian90@yahoo.in",
      Pin_Code: 600026,
      DT: "24-05-2020",
      Active: 0,
      Latitude: 13.0511,
      Longitude: 80.2125,
    },
    {
      id: 3221,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "GANESH GRANITE CO",
      Contact_name: "",
      Store_Address:
        "#73 110, POONAMALLEE HIGH ROAD,MADURAVOYAL,CHENNAI - 600095",
      Mobile_No: 9841051723,
      Landline_No: "",
      Email: "ganesh_granite@yahoo.com",
      Pin_Code: 600095,
      DT: "24-05-2020",
      Active: 0,
      Latitude: 13.0601732,
      Longitude: 80.1665988,
    },
    {
      id: 3222,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "HOODS & HOBS",
      Contact_name: "",
      Store_Address: "#83, MEDAVAKKAM HIGH ROAD,KEELKATTALAI,CHENNAI - 600117",
      Mobile_No: 9382124821,
      Landline_No: "",
      Email: "hoods&hobs@yahoo.com",
      Pin_Code: 600117,
      DT: "24-05-2020",
      Active: 0,
      Latitude: 13.038,
      Longitude: 80.2301,
    },
    {
      id: 3223,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "GANESH TIMBER TRADING CO",
      Contact_name: "",
      Store_Address: "474, MTH ROAD, AMBATTUR,CHENNAI - 600053",
      Mobile_No: "",
      Landline_No: "044-26574147",
      Email: "ganesh_timber@yahoo.co.in",
      Pin_Code: 600053,
      DT: "24-05-2020",
      Active: 0,
      Latitude: 12.8537017,
      Longitude: 79.9125597,
    },
    {
      id: 3224,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 1,
      Store_name: "VIBRANT HOMZ",
      Contact_name: "",
      Store_Address:
        "#2 10, MOUNTY POONAMALLEE HIGH ROAD,GANDHI NAGAR, KARAMBAKKAM,PORUR, CHENNAI - 600116",
      Mobile_No: 8122016120,
      Landline_No: "",
      Email: "vibranthomz@gmail.com",
      Pin_Code: 600116,
      DT: "24-05-2020",
      Active: 0,
      Latitude: 13.0356,
      Longitude: 80.1582,
    },
    {
      id: 3225,
      Area: "South",
      States: "Tamil Nadu",
      City: "Chennai",
      Category: 2,
      Store_name: "VIBRANT HOMZ",
      Contact_name: "Adesh Kumar",
      Store_Address: "SHOP #2A, 1ST FLOOR,MTH ROAD, AMBATTUR,CHENNAI - 600053",
      Mobile_No: 9500003191,
      Landline_No: "",
      Email: "vibranthomz@gmail.com",
      Pin_Code: 600053,
      DT: "24-05-2020",
      Active: 0,
      Latitude: 13.1193746,
      Longitude: 80.1507648,
    },
    {
      id: 3226,
      Area: "West",
      States: "Gujarat",
      City: "Gandhidham",
      Category: 1,
      Store_name: "Shridhar Minerals  Pvt. Ltd.",
      Contact_name: "Harish Talreja",
      Store_Address:
        "Shridhar Minerals Pvt. Ltd.Plot no 15, Ward 10 A Opp. Iffco colony Gandhidham-kutch 370201",
      Mobile_No: 7567770707,
      Landline_No: "",
      Email: "smpl4023@gmail.com",
      Pin_Code: 370201,
      DT: "30-06-2020",
      Active: 0,
      Latitude: 23.08333,
      Longitude: 70.13333,
    },
    {
      id: 3227,
      Area: "West",
      States: "Maharashtra",
      City: "Nasik",
      Category: 1,
      Store_name: "Arihant Gifts & Crockeries",
      Contact_name: "amit kothari",
      Store_Address:
        "Showroom no.10 Business Bay Premises, Shree Hari Kute Marg near sopan hospital , Tidke colony Nashik -422002",
      Mobile_No: 9552676929,
      Landline_No: "",
      Email: "amit.kothari4344@gmail.com",
      Pin_Code: 422002,
      DT: "08-07-2020",
      Active: 0,
      Latitude: 20.4722,
      Longitude: 74.2229,
    },
    {
      id: 3228,
      Area: "North",
      States: "Delhi",
      City: "New Delhi",
      Category: 2,
      Store_name: "Dolly Electronics",
      Contact_name: "Mr. Sandeep",
      Store_Address:
        "G-9, Pushker enclave, Outer Ring Road, Near mc Donald, Paschim Vihar",
      Mobile_No: 9810155200,
      Landline_No: "",
      Email: "",
      Pin_Code: 110063,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3229,
      Area: "North",
      States: "Delhi",
      City: "New Delhi",
      Category: 2,
      Store_name: "RK Vision",
      Contact_name: "",
      Store_Address:
        "RK Vision,89 Khanna Market, Lodhi road, South Delhi, Delhi-110003",
      Mobile_No: "+91 98117 73055",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "24-07-2020",
      Active: 0,
      Latitude: 28.5910814,
      Longitude: 77.2289936,
    },
    {
      id: 3230,
      Area: "North",
      States: "Delhi",
      City: "New Delhi",
      Category: 2,
      Store_name: "The Electronics Pavillion",
      Contact_name: "Karan",
      Store_Address:
        "E-2, Bali nagar, opp.Metro pillar no.368, Nearby Ramesh Nagar Metro Station,New Delhi - 110025",
      Mobile_No: 9999198130,
      Landline_No: "",
      Email: "karankaushik1410@gmail.com",
      Pin_Code: 110025,
      DT: "24-07-2020",
      Active: 1,
      Latitude: 28.6541384,
      Longitude: 77.128178,
    },
    {
      id: 3231,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 1,
      Store_name: "Sadana Electric Store",
      Contact_name: "",
      Store_Address:
        "Chander Nagar Gate Near HDFC Bank Alam bagh Lucknow PIN 226005",
      Mobile_No: 9506030211,
      Landline_No: "",
      Email: "",
      Pin_Code: 226005,
      DT: "24-07-2020",
      Active: 0,
      Latitude: 26.83928,
      Longitude: 80.92313,
    },
    {
      id: 3232,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Allahabad",
      Category: 1,
      Store_name: "K K Sales Pvt Ltd",
      Contact_name: "",
      Store_Address:
        "K K Sales Pvt Ltd,17 33 M G Marg,Civil Lines,Near Sangam Place, Prayagraj, Uttar pradesh- 211001",
      Mobile_No: 9839900122,
      Landline_No: "",
      Email: "",
      Pin_Code: 211001,
      DT: "24-07-2020",
      Active: 0,
      Latitude: 25.44894,
      Longitude: 81.83329,
    },
    {
      id: 3233,
      Area: "East",
      States: "Odisha",
      City: "Berhampur-1",
      Category: 1,
      Store_name: "Kalki Trading Co.",
      Contact_name: "T sanat Kumar",
      Store_Address: "Kalki Trading Co. New Bus Stand Road Berhampur-1.",
      Mobile_No: 9437062235,
      Landline_No: "",
      Email: "kalki_bam@rediffmail.com",
      Pin_Code: 760004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3236,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Renowned Creation",
      Contact_name: "",
      Store_Address: "NA",
      Mobile_No: 9830955386,
      Landline_No: "",
      Email: "renownedcreation261@gmail.com",
      Pin_Code: "",
      DT: "29-07-2020",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3238,
      Area: "North",
      States: "Uttrakhand",
      City: "HARIDWAR",
      Category: 1,
      Store_name: "SHREE RADHEY ELECTRICALS",
      Contact_name: "",
      Store_Address:
        "Shree radhey electricals, 2 new market near rail chowky , jwalapur , Haridwar -249407",
      Mobile_No: 8979660004,
      Landline_No: "",
      Email: "rohitag291987@gmail.com",
      Pin_Code: 249407,
      DT: "06-08-2020",
      Active: 0,
      Latitude: 29.92426,
      Longitude: 78.10757,
    },
    {
      id: 3241,
      Area: "North",
      States: "Uttrakhand",
      City: "Rishikesh",
      Category: 1,
      Store_name: "R C ENTERPRISES",
      Contact_name: "",
      Store_Address:
        "Phone zone Shop no2 ,15 haridwar road Near city center, Rishikesh",
      Mobile_No: "",
      Landline_No: 9897022300,
      Email: "rahulchhabra28@gmail.com",
      Pin_Code: 249201,
      DT: "07-08-2020",
      Active: 0,
      Latitude: 30.1086537,
      Longitude: 78.2916193,
    },
    {
      id: 3242,
      Area: "North",
      States: "Uttrakhand",
      City: "Dehradun",
      Category: 1,
      Store_name: "AMIT ASSOCIATES",
      Contact_name: "",
      Store_Address: "AMIT ASSOCIATES RAJA ROAD DEHRADUN 248001",
      Mobile_No: 9760099189,
      Landline_No: "",
      Email: "amitsharmaddn@gmail.com",
      Pin_Code: 248001,
      DT: "07-08-2020",
      Active: 0,
      Latitude: 30.3164596,
      Longitude: 78.0387474,
    },
    {
      id: 3243,
      Area: "North",
      States: "Uttrakhand",
      City: "Dehradun",
      Category: 1,
      Store_name: "AQUATECK SALES & SERVICES",
      Contact_name: "",
      Store_Address: "Aranco Modulars,11 EC Road ,Dehradun,PIN 248001",
      Mobile_No: 9219508533,
      Landline_No: "",
      Email: "",
      Pin_Code: 248001,
      DT: "07-08-2020",
      Active: 0,
      Latitude: 30.32443,
      Longitude: 78.03392,
    },
    {
      id: 3244,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Agra",
      Category: 1,
      Store_name: "SLR DISTRIBUTORS PVT LTD",
      Contact_name: "",
      Store_Address: "Add:- 35 Basant Vihar, Kamla Nagar Agra 282004",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 282004,
      DT: "14-08-2020",
      Active: 0,
      Latitude: 27.18333,
      Longitude: 78.01667,
    },
    {
      id: 3245,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Agra",
      Category: 1,
      Store_name: "Yashu Enterprises",
      Contact_name: "",
      Store_Address:
        "Yashu Enterprises (Direct Deler) Add:- G-1,G-2 Raman Tower, Sanjay Place, Civil Lines, Agra 282002",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 282002,
      DT: "14-08-2020",
      Active: 0,
      Latitude: 27.2010283,
      Longitude: 78.0053271,
    },
    {
      id: 3246,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Agra",
      Category: 1,
      Store_name: "SP Enterprises",
      Contact_name: "",
      Store_Address:
        "SP Enterprises Add:- 25 50 Masjid Wali Gali, Gandhi Nagar, Agra 282003",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 282003,
      DT: "14-08-2020",
      Active: 0,
      Latitude: 27.7563,
      Longitude: 77.8815,
    },
    {
      id: 3247,
      Area: "East",
      States: "West Bengal",
      City: "Koutulpur(Dist-Bankura)",
      Category: 1,
      Store_name: "Shri Krishna Traders",
      Contact_name: "Koushik Mondol",
      Store_Address:
        "SHRI KRISHNA TRADERS. KOTULPUR MILL MORE KOTULPUR. Dist- Bankura. West Bengal.",
      Mobile_No: 9641455820,
      Landline_No: "",
      Email: "",
      Pin_Code: 722141,
      DT: "16-08-2020",
      Active: 0,
      Latitude: 23.23241,
      Longitude: 87.0716,
    },
    {
      id: 3248,
      Area: "North",
      States: "Haryana",
      City: "Karnal",
      Category: 1,
      Store_name: "Vishal Enterprises",
      Contact_name: "",
      Store_Address:
        "Address-120,Old Janta Anaj Mandi,Pali Market,Karnal,Haryana-132001 Mob. No.-9416056432,9813833432",
      Mobile_No: 9813833432,
      Landline_No: "",
      Email: "",
      Pin_Code: 132001,
      DT: "25-08-2020",
      Active: 0,
      Latitude: 29.69197,
      Longitude: 76.98448,
    },
    {
      id: 3249,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 2,
      Store_name: "K J Kitchen Appliances",
      Contact_name: "Mr. Satinder Kapur,  Mr. Amit Kumar Gupta",
      Store_Address:
        "Ground Floor, Shop 6-7, Kakkar Dreams Building, Gian Nagar Cool Road, Pin Code 144001",
      Mobile_No: "8283094666, 987",
      Landline_No: "",
      Email: "kjkitchenappliances@gmail.com",
      Pin_Code: 144001,
      DT: "01-09-2020",
      Active: 0,
      Latitude: 31.32556,
      Longitude: 75.57917,
    },
    {
      id: 3250,
      Area: "North",
      States: "Punjab",
      City: "Jalandhar",
      Category: 2,
      Store_name: "K J Kitchen Appliances",
      Contact_name: "Mr. Satinder Kapur,  Mr. Amit Kumar Gupta",
      Store_Address:
        "Ground Floor, Shop 6-7, Kakkar Dreams Building, Gian Nagar Cool Road, Pin Code 144001",
      Mobile_No: "8283094666, 987",
      Landline_No: "",
      Email: "kjkitchenappliances@gmail.com",
      Pin_Code: 144001,
      DT: "01-09-2020",
      Active: 0,
      Latitude: 31.32556,
      Longitude: 75.57917,
    },
    {
      id: 3251,
      Area: "North",
      States: "Punjab",
      City: "Amritsar",
      Category: 1,
      Store_name: "Ganpati Traders",
      Contact_name: "Mr. Vaneet Kumar",
      Store_Address: "37-A The Mall,Amritsar, Punjab - Pin Code 143001",
      Mobile_No: 9815575215,
      Landline_No: "",
      Email: "vaneet.kumar@yahoo.com.in",
      Pin_Code: 143001,
      DT: "01-09-2020",
      Active: 0,
      Latitude: 31.6343083,
      Longitude: 74.8736788,
    },
    {
      id: 3252,
      Area: "South",
      States: "Telangana",
      City: "Hyderabad",
      Category: 2,
      Store_name: "My Kitchen",
      Contact_name: "Mr Amjad Ali",
      Store_Address:
        "My Kitchen 1-1-100 & 101, RTC X-Road Hyderabad-500 020 Telengana",
      Mobile_No: 9490011611,
      Landline_No: "040-48541143",
      Email: "faberhyderabad@gmail.com",
      Pin_Code: "500 020",
      DT: "03-09-2020",
      Active: 0,
      Latitude: 17.4069869,
      Longitude: 78.4965166,
    },
    {
      id: 3253,
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 1,
      Store_name: "Kanaiya Hardware",
      Contact_name: "Aniket Singh",
      Store_Address:
        "37,38 Swaminarayan nagar, Lalita Chowdki, Katargam, Surat",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 395004,
      DT: "20-09-2020",
      Active: 0,
      Latitude: 20.91667,
      Longitude: 73.05,
    },
    {
      id: 3254,
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 1,
      Store_name: "Kanaiya Hardware",
      Contact_name: "Aniket Singh",
      Store_Address:
        "37,38 Swaminarayan nagar, Lalita Chowdki, Katargam, Surat",
      Mobile_No: "9825250917 9023",
      Landline_No: "",
      Email: "",
      Pin_Code: 395004,
      DT: "20-09-2020",
      Active: 0,
      Latitude: 20.91667,
      Longitude: 73.05,
    },
    {
      id: 3255,
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 1,
      Store_name: "G&B SERVICES",
      Contact_name: "Ashish",
      Store_Address: "Pindar Market ,Haibowal Kalan, Ludhiana",
      Mobile_No: "",
      Landline_No: "0161-4203100",
      Email: "",
      Pin_Code: "",
      DT: "12-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3256,
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 1,
      Store_name: "NEW ERA ELECTRONICS",
      Contact_name: "GP Singh",
      Store_Address: "Dhandra Road , Dugri, Ludhiana",
      Mobile_No: 9779908639,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "12-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3257,
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 1,
      Store_name: "GANPATI ELECTRONICS",
      Contact_name: "Rajeev Gupta",
      Store_Address: "Rishi Nagar,Hamran Road, Ludhiana",
      Mobile_No: 9855153521,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "12-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3258,
      Area: "West",
      States: "Maharashtra",
      City: "Nagpur",
      Category: 1,
      Store_name: "Power Links",
      Contact_name: "ASHISH KEDIA",
      Store_Address:
        "C A Road,Gandhibag,Sadoday complexShop no. 4.Next to Metro Chitaroli Station,Opp. Metro Pillar no. 101.Nr daroadkar sq,Next to DCB BANK.Nagpur-440032.",
      Mobile_No: 9370970616,
      Landline_No: "",
      Email: "",
      Pin_Code: 440032,
      DT: "15-10-2020",
      Active: 0,
      Latitude: 21.14631,
      Longitude: 79.08491,
    },
    {
      id: 3259,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "MALHOTRA REFRIGERATION WORKS",
      Contact_name: "MR. Aman Malhotra",
      Store_Address: "Kangra Pathankot Road ,BIRTA, Kangra- 176001",
      Mobile_No: "M - 9816074202,",
      Landline_No: "",
      Email: "",
      Pin_Code: 176001,
      DT: "20-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3260,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "KULDEEP ENTERPRISES",
      Contact_name: "MR. Sandeep Gupta",
      Store_Address: "NEAR OLD BUS STAND, JASSUR, KANGRA DISTRICT",
      Mobile_No: "M - 9816026328",
      Landline_No: "",
      Email: "",
      Pin_Code: 176201,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 32.2816237,
      Longitude: 75.8494473,
    },
    {
      id: 3261,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "Shiivam Electricals",
      Contact_name: "Mr. Ranjit Sodhi",
      Store_Address: "Main Bazzar,Saket Plaza, Kangra District",
      Mobile_No: "M -9418055825",
      Landline_No: "",
      Email: "",
      Pin_Code: 176061,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 32.16667,
      Longitude: 76.25,
    },
    {
      id: 3262,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "Electromec India",
      Contact_name: "MR. Vikarn Mehta",
      Store_Address: "Palampur Mandi Road, Paprola, Kanra District",
      Mobile_No: "M-9418057711",
      Landline_No: "",
      Email: "",
      Pin_Code: 176063,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 32.1119128,
      Longitude: 76.5358278,
    },
    {
      id: 3263,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "NORTH INDIA CO.",
      Contact_name: "MR.Arjun Mehra",
      Store_Address: "Main Bazzar, Kotwali Bazar, Dharamshala, Kangra",
      Mobile_No: "M - 9736289093,",
      Landline_No: "",
      Email: "",
      Pin_Code: 176215,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 32.22006,
      Longitude: 76.32013,
    },
    {
      id: 3264,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "M.R. ENTERPRISES",
      Contact_name: "MR. Vikas",
      Store_Address: "Main Bazar, Kangra District",
      Mobile_No: "M - 8894657895,",
      Landline_No: "",
      Email: "",
      Pin_Code: 177101,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 32.0272521,
      Longitude: 76.5408683,
    },
    {
      id: 3265,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Shimla",
      Category: 1,
      Store_name: "FURNITURE CARE",
      Contact_name: "MR. Parkash",
      Store_Address: "BOILEAUGANJ, SHOP NO.30.OLD POST OFFICE, SHIMLA",
      Mobile_No: "M-9418500087,70",
      Landline_No: "",
      Email: "",
      Pin_Code: 171005,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 31.16667,
      Longitude: 77.58333,
    },
    {
      id: 3266,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Shimla",
      Category: 1,
      Store_name: "FURNITURE CARE",
      Contact_name: "MR. Parkash",
      Store_Address: "BOILEAUGANJ, SHOP NO.30.OLD POST OFFICE, SHIMLA",
      Mobile_No: "M-9418500087,70",
      Landline_No: "",
      Email: "",
      Pin_Code: 171005,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 31.16667,
      Longitude: 77.58333,
    },
    {
      id: 3267,
      Area: "North",
      States: "Himachal Pradesh",
      City: "solan",
      Category: 1,
      Store_name: "MATHURA ELECTRONICS",
      Contact_name: "MR. Yogesh Gupta",
      Store_Address: "The Mall Road, Solan",
      Mobile_No: "M - 9625018494",
      Landline_No: "",
      Email: "",
      Pin_Code: 173212,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 30.9097001,
      Longitude: 77.1023918,
    },
    {
      id: 3268,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kullu Manali",
      Category: 1,
      Store_name: "SANITARY EMPORIUM",
      Contact_name: "MR. Amit",
      Store_Address: "Near SSB Shamshi, Kullu, Buntar",
      Mobile_No: "M-7807333322",
      Landline_No: "",
      Email: "",
      Pin_Code: 175126,
      DT: "20-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3269,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "SARSWATI ENTERPRISES",
      Contact_name: "MR. Varun Gupta",
      Store_Address: "Palampur Road , Sheela Chowk,Kangra, Dharamshala",
      Mobile_No: "M-9418068088",
      Landline_No: "",
      Email: "",
      Pin_Code: 176057,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 32.1972141,
      Longitude: 76.3439067,
    },
    {
      id: 3270,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Sirmaur",
      Category: 1,
      Store_name: "KAVISH TRADING CO.",
      Contact_name: "MR. Anup Aggarwal",
      Store_Address: "Main Bazar, Majra,Sirmaur, Paonta Sahi",
      Mobile_No: "M-9418477545,98",
      Landline_No: "",
      Email: "",
      Pin_Code: 173021,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 30.49008,
      Longitude: 77.52777,
    },
    {
      id: 3271,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Una",
      Category: 1,
      Store_name: "SIGMA MARKETING GROUP",
      Contact_name: "MR. Harjit Singh",
      Store_Address: "Main Road, Una road Amb",
      Mobile_No: "M-8679242424",
      Landline_No: "",
      Email: "",
      Pin_Code: 177203,
      DT: "20-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3272,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Shimla",
      Category: 1,
      Store_name: "SR ENTERPRISES",
      Contact_name: "Smriti Goel",
      Store_Address: "Main Bazzar, Ground Floor Leela Bhawan, Khalini, Shimla",
      Mobile_No: "M-93189-23458,",
      Landline_No: "",
      Email: "",
      Pin_Code: 171002,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 31.16667,
      Longitude: 77.58333,
    },
    {
      id: 3273,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "MANOHAR LAL SURINDER KUMAR",
      Contact_name: "MR. Gorav Kumar",
      Store_Address: "Main Road , Old Matour, Kangra",
      Mobile_No: "M-9817589999,98",
      Landline_No: "",
      Email: "",
      Pin_Code: 176001,
      DT: "20-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3274,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "MANOHAR LAL SURINDER KUMAR",
      Contact_name: "MR. Gorav Kumar",
      Store_Address: "Main Road , Old Matour, Kangra",
      Mobile_No: "M-9817589999,98",
      Landline_No: "",
      Email: "",
      Pin_Code: 176001,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 32.09087,
      Longitude: 76.26073,
    },
    {
      id: 3275,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Shimla",
      Category: 1,
      Store_name: "SEVTI ASSOCIATES",
      Contact_name: "MR. Manoj Verma",
      Store_Address: "Near Central Bank Of India, Kasumpti, Shimla",
      Mobile_No: "M-9418476885,94",
      Landline_No: "",
      Email: "",
      Pin_Code: 171009,
      DT: "20-10-2020",
      Active: 0,
      Latitude: 31.0771921,
      Longitude: 77.1831287,
    },
    {
      id: 3276,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Shimla",
      Category: 1,
      Store_name: "SEVTI ASSOCIATES",
      Contact_name: "MR. Manoj Verma",
      Store_Address: "Near Central Bank Of India, Kasumpti, Shimla",
      Mobile_No: "M-9418476885,94",
      Landline_No: "",
      Email: "",
      Pin_Code: 171009,
      DT: "21-10-2020",
      Active: 0,
      Latitude: 31.0771921,
      Longitude: 77.1831287,
    },
    {
      id: 3277,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "RANDHIR ELECTRONICS",
      Contact_name: "MR. Randhir",
      Store_Address: "Main Bazar, Kangra",
      Mobile_No: "M-9816439966",
      Landline_No: "",
      Email: "",
      Pin_Code: 177107,
      DT: "21-10-2020",
      Active: 0,
      Latitude: 32.0272521,
      Longitude: 76.5408683,
    },
    {
      id: 3278,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kinnaur",
      Category: 1,
      Store_name: "Rudraansh Electronics",
      Contact_name: "Mr. Pardeep Sood",
      Store_Address: "Rrckong Peo, main bazar,Reckong Peo, Kinnaur",
      Mobile_No: "M- 9816870000",
      Landline_No: "",
      Email: "",
      Pin_Code: 172107,
      DT: "21-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3279,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Kangra",
      Category: 1,
      Store_name: "Langesh Electricals",
      Contact_name: "Rajiv Thakur",
      Store_Address: "Chambi Dharamshala Road, V.P.O. Dodhamb, Kangra",
      Mobile_No: "M- 98164-47837,",
      Landline_No: "",
      Email: "",
      Pin_Code: 176217,
      DT: "21-10-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3280,
      Area: "North",
      States: "Himachal Pradesh",
      City: "Mandi",
      Category: 1,
      Store_name: "PARAM DAV AMRIT LAL",
      Contact_name: "Mr. yogesh",
      Store_Address: "Near post office, Gandhi Chowk, Mandi",
      Mobile_No: "M- 9418095603",
      Landline_No: "",
      Email: "",
      Pin_Code: 175001,
      DT: "21-10-2020",
      Active: 0,
      Latitude: 32.5365592,
      Longitude: 75.9760838,
    },
    {
      id: 3281,
      Area: "North",
      States: "Himachal Pradesh",
      City: "solan",
      Category: 1,
      Store_name: "AGNIHOTRI ELECTRICAL & MECH WORKS",
      Contact_name: "MR. AVINASHM",
      Store_Address: "NALAGARH -BADDI ROAD, SOLAN",
      Mobile_No: "M- 8261036103",
      Landline_No: "",
      Email: "",
      Pin_Code: 174101,
      DT: "21-10-2020",
      Active: 0,
      Latitude: 31.0366123,
      Longitude: 76.7104255,
    },
    {
      id: 3282,
      Area: "North",
      States: "Himachal Pradesh",
      City: "solan",
      Category: 1,
      Store_name: "AGNIHOTRI ELECTRICAL & MECH WORKS",
      Contact_name: "MR. AVINASHM",
      Store_Address: "NALAGARH -BADDI ROAD, SOLAN",
      Mobile_No: "M- 8261036103",
      Landline_No: "",
      Email: "",
      Pin_Code: 174101,
      DT: "21-10-2020",
      Active: 0,
      Latitude: 31.0366123,
      Longitude: 76.7104255,
    },
    {
      id: 3283,
      Area: "West",
      States: "Maharashtra",
      City: "Nagpur",
      Category: 1,
      Store_name: "Power Links.",
      Contact_name: "",
      Store_Address:
        "C A Road,Gandhibag, Sadoday complexShop no. 4.Next to Metro Chitaroli Station, Opp. Metro Pillar no. 101.Nr daroadkar sq ,Next to DCB BANK.Nagpur-440032.",
      Mobile_No: 9370970616,
      Landline_No: "",
      Email: "",
      Pin_Code: 440032,
      DT: "25-10-2020",
      Active: 0,
      Latitude: 21.14631,
      Longitude: 79.08491,
    },
    {
      id: 3284,
      Area: "East",
      States: "Bihar",
      City: "Darbhanga",
      Category: 1,
      Store_name: "Lalbagh Traders LLP",
      Contact_name: "",
      Store_Address: "K. K. Road, Lalbagh, Darbhanga (Bihar)",
      Mobile_No: "7004536599, 955",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "03-11-2020",
      Active: 1,
      Latitude: 26.15216,
      Longitude: 85.89707,
    },
    {
      id: 3285,
      Area: "East",
      States: "Bihar",
      City: "Darbhanga",
      Category: 1,
      Store_name: "Lalbagh Traders LLP",
      Contact_name: "",
      Store_Address: "K. K. Road, Lalbagh, Darbhanga (Bihar)",
      Mobile_No: "7004536599, 955",
      Landline_No: "",
      Email: "",
      Pin_Code: 846004,
      DT: "03-11-2020",
      Active: 0,
      Latitude: 26.15216,
      Longitude: 85.89707,
    },
    {
      id: 3289,
      Area: "North",
      States: "Uttrakhand",
      City: "Rudrapur",
      Category: 1,
      Store_name: "MANJEET ELECTRONICS PRIVATE LIMITED",
      Contact_name: "MANJEET ELECTRONICS PRIVATE LIMITED",
      Store_Address: "D 1 - D 2, MEPL COMPLEX, CIVIL LINES, RUDRAPUR",
      Mobile_No: 9897066134,
      Landline_No: "",
      Email: "manjeetepl@gmail.com",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3294,
      Area: "North",
      States: "Uttrakhand",
      City: "Rishikesh",
      Category: 1,
      Store_name: "R C ENTERPRISES",
      Contact_name: "R C ENTERPRISES",
      Store_Address:
        "Shop Nu.2, 15, Haridwar Road, Near City Centre, Rishikesh",
      Mobile_No: 9897022300,
      Landline_No: "",
      Email: "rahulchhabra28@gmail.com",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3295,
      Area: "North",
      States: "Uttrakhand",
      City: "Dehradun",
      Category: 1,
      Store_name: "AMIT ASSOCIATES",
      Contact_name: "AMIT ASSOCIATES",
      Store_Address: "RAJA ROAD DEHRADUN",
      Mobile_No: 9760099189,
      Landline_No: "",
      Email: "amitsharmaddn@gmail.com",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3299,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "KESHAV TILES",
      Contact_name: "",
      Store_Address: "B-39, Sector -9, Noida",
      Mobile_No: 9999251888,
      Landline_No: "",
      Email: "raghavbagla1212@gmail.com",
      Pin_Code: 201301,
      DT: "09-11-2020",
      Active: 1,
      Latitude: 28.5868527,
      Longitude: 77.3273926,
    },
    {
      id: 3300,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Noida",
      Category: 2,
      Store_name: "KESHAV TILES",
      Contact_name: "",
      Store_Address: "B-39, Sector -9, Noida",
      Mobile_No: 9999251888,
      Landline_No: "",
      Email: "",
      Pin_Code: 201301,
      DT: "09-11-2020",
      Active: 0,
      Latitude: 28.5868527,
      Longitude: 77.3273926,
    },
    {
      id: 3301,
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 1,
      Store_name: "AaoJee Stores",
      Contact_name: "",
      Store_Address:
        "S.C.F. 29-30, Sector 19C, Sector 19, Chandigarh, 160019 094175 75227",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 160019,
      DT: "09-11-2020",
      Active: 0,
      Latitude: 30.7278289,
      Longitude: 76.7911969,
    },
    {
      id: 3302,
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 1,
      Store_name: "AaoJee Stores",
      Contact_name: "",
      Store_Address:
        "S.C.F. 29-30, Sector 19C, Sector 19, Chandigarh, 160019 094175 75227",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 160019,
      DT: "09-11-2020",
      Active: 0,
      Latitude: 30.7278289,
      Longitude: 76.7911969,
    },
    {
      id: 3303,
      Area: "North",
      States: "Uttar pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "ADYANT ELECTRICALS",
      Contact_name: "Adyant",
      Store_Address:
        "Adyant electricals, Ust-08 Aura plaza market raj nagar ext, Ghaziabad",
      Mobile_No: 9711074987,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3304,
      Area: "North",
      States: "Uttar pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "ALDA HOME",
      Contact_name: "Aveez",
      Store_Address:
        "Opposite HDFC Bank and Punjab National Bank Delhi road Hapur",
      Mobile_No: 9971841909,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3305,
      Area: "North",
      States: "Uttar pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "ANKUR ELECTRICALS",
      Contact_name: "Pramod",
      Store_Address:
        "Sector 4 iteda gol chakkar opp indian oil petrol pump greater Noida West.",
      Mobile_No: 9213604501,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3306,
      Area: "North",
      States: "Uttar pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "GLOWFAST ENTERPRISES",
      Contact_name: "Rakesh",
      Store_Address:
        "Glowfast Enterprises C-3 Ground floor, Shalimar Garden Extn -2,Sahibabad(U.P.)-201005",
      Mobile_No: 9810009183,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3307,
      Area: "North",
      States: "Uttar pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "ISHU MODULAR",
      Contact_name: "Sonu",
      Store_Address:
        "Shop No. LGF -42 city plaza Gaur City -01 noida extension  G.B nagar",
      Mobile_No: 9990497562,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3308,
      Area: "North",
      States: "Uttar pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "JAINA KITCHEN WORLD",
      Contact_name: "Akashat",
      Store_Address: "CM 26 sector 122 noida , UP",
      Mobile_No: 9971361624,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3309,
      Area: "North",
      States: "Uttar pradesh",
      City: "Meerut",
      Category: 1,
      Store_name: "KASTOORI HOME SHOPPE PRIVATE LIMITE",
      Contact_name: "Mohan",
      Store_Address: "J.d house near mohan gas agency grad road meerut, Meerut",
      Mobile_No: 9837020205,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3310,
      Area: "North",
      States: "Uttar pradesh",
      City: "PILAKHWA",
      Category: 1,
      Store_name: "LAXMI SALES INDIA PVT LTD",
      Contact_name: "Devyanshu",
      Store_Address:
        "Pillar no 97, Shailesh farm, Near Nagar Palika, N.H-9 Pilkuwa - 245304, Distt, Hapur",
      Mobile_No: 9997306961,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3311,
      Area: "North",
      States: "Uttar pradesh",
      City: "Meerut",
      Category: 1,
      Store_name: "M S WINGS ELECTRIC CO.",
      Contact_name: "Sachin",
      Store_Address:
        "Shop No. 180, Agarwal complex near old Baghpat stand Delhi road meerut city, Meerut",
      Mobile_No: 9837085482,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3312,
      Area: "North",
      States: "Uttar pradesh",
      City: "Noida",
      Category: 1,
      Store_name: "S. K. NTERPRISES",
      Contact_name: "Sandeep",
      Store_Address: "Mo-9837131218",
      Mobile_No: 9958665494,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3313,
      Area: "North",
      States: "Uttar pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "S.S.ENTERPRISES",
      Contact_name: "Tyagi ji",
      Store_Address:
        "G, 79 ground floor D- Mall shaktikhand llnd Indirapuram Ghaziabad",
      Mobile_No: "97174 56276",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3314,
      Area: "North",
      States: "Uttar pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "USHMA TRADERS",
      Contact_name: "Shahank",
      Store_Address:
        "99 Ambedkar Road,1st floor,Ghaziabad, Near Kalka Gadi police chowki, Ghaziabad - 201001",
      Mobile_No: 9891740270,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3315,
      Area: "North",
      States: "Uttar pradesh",
      City: "HAPUR",
      Category: 1,
      Store_name: "VISHWA ELECTRONICS & BATTERIES",
      Contact_name: "Vipin",
      Store_Address:
        "Vishwa electronics and battery, Opposite HDFC Bank and Punjab National Bank Delhi road Hapur",
      Mobile_No: 9837131218,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3316,
      Area: "North",
      States: "Uttar pradesh",
      City: "Ghaziabad",
      Category: 1,
      Store_name: "WELLCOME HOUSE",
      Contact_name: "Vikash",
      Store_Address:
        "Shop no 9 Plot no III M 27, Nehru Nagar, Ambedker Road,  Ghaziabad",
      Mobile_No: 9811320858,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "NULL",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3317,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "Devsonss",
      Contact_name: "",
      Store_Address: "Trichi road, Coimbatore",
      Mobile_No: 9790825913,
      Landline_No: "",
      Email: "",
      Pin_Code: 641005,
      DT: "19-11-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3318,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "Surabhi Build Mart",
      Contact_name: "",
      Store_Address: "Thadagam Road, Coimbatore",
      Mobile_No: 9842251800,
      Landline_No: "",
      Email: "",
      Pin_Code: 641013,
      DT: "19-11-2020",
      Active: 0,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3319,
      Area: "East",
      States: "Odisha",
      City: "Bhubaneswar",
      Category: 1,
      Store_name: "Spectra Vision",
      Contact_name: "Mr. Debaraj Rath",
      Store_Address:
        "Plot No. – 235, Bapuji Nagar, Bhubaneswar, Khordha, Odisha – 751009",
      Mobile_No: 9937722277,
      Landline_No: "",
      Email: "spectravision.et@gmail.com",
      Pin_Code: 751009,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3320,
      Area: "East",
      States: "Odisha",
      City: "Berhampur",
      Category: 1,
      Store_name: "Archana Enterprises",
      Contact_name: "Satchidananda Gantayat",
      Store_Address:
        "Dalua Street, One Way Traffic Road, Berhampur, Ganjam, Odisha – 760001",
      Mobile_No: 9439802999,
      Landline_No: "",
      Email: "gantayat9@gmail.com",
      Pin_Code: 760001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3321,
      Area: "East",
      States: "Odisha",
      City: "Berhampur",
      Category: 1,
      Store_name: "M/s. Clean-N-Clear",
      Contact_name: "T. Sanat Kumar Patro",
      Store_Address: "Kalki Trading Co.New Bus Stand Road Berhampur-1",
      Mobile_No: 9437062235,
      Landline_No: "",
      Email: "kalki_bam@rediffmail.com",
      Pin_Code: 760004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3322,
      Area: "West",
      States: "Maharashtra",
      City: "Thane",
      Category: 1,
      Store_name: "ShreeJi Enterprises",
      Contact_name: "Mr. Chirag",
      Store_Address:
        "Gokhale Rd, near Gaondevi Temple, Naik Wadi, Naupada, Thane West, Thane, Maharashtra 400602",
      Mobile_No: 9769252811,
      Landline_No: "",
      Email: "",
      Pin_Code: 400602,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3323,
      Area: "West",
      States: "Maharashtra",
      City: "Bhiwandi",
      Category: 1,
      Store_name: "New Mahesh Enterprises",
      Contact_name: "Mr. Amit Shah",
      Store_Address:
        "Bidg No. AQ-01, Gala No. 113-117, Rajlaxmi Commercial Complex, Kalher Village, Bhiwandi 421302",
      Mobile_No: 9324511050,
      Landline_No: "",
      Email: "",
      Pin_Code: 421302,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3324,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Zee Electronics",
      Contact_name: "Mr. Rajesh",
      Store_Address:
        "Shop no. 101, Anand Amrut, Tejpal Rd, near Parle Biscuit Factory, Mumbai, Maharashtra 400057",
      Mobile_No: "2618 9927",
      Landline_No: "",
      Email: "",
      Pin_Code: 400057,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3325,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Kihinoor Lifestyle",
      Contact_name: "Mr. Rajesh Jaisiangh",
      Store_Address:
        "Shop No.2, Kamla Spaces, SV Rd, near HDFC Bank, Hasmukh Nagar, Santacruz West, Mumbai, Maharashtra 400054",
      Mobile_No: 9820551533,
      Landline_No: "",
      Email: "",
      Pin_Code: 400054,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3326,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 1,
      Store_name: "Mahendra Kitchen",
      Contact_name: "Mr. Mehendra Kothari",
      Store_Address:
        "345, Damania Bulding, S.V. Road, Opp BMC Market, Andheri West Mumbai - 400 058",
      Mobile_No: 9821443326,
      Landline_No: "",
      Email: "",
      Pin_Code: 400058,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3327,
      Area: "East",
      States: "Chhattisgarh",
      City: "Raipur",
      Category: 2,
      Store_name: "FABER Platinum Studio",
      Contact_name: "Ashirwad Ply Wood Agencies",
      Store_Address:
        "TRIMURTI NAGAR ROAD, New Timber Market Rd OPP RADHA TIMBER , Fafadih, Raipur, Chhattisgarh 492001",
      Mobile_No: 9300021666,
      Landline_No: "",
      Email: "",
      Pin_Code: 492001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3328,
      Area: "East",
      States: "Bihar",
      City: "Hajipur",
      Category: 1,
      Store_name: "M/S Sankalp",
      Contact_name: "",
      Store_Address: "Dighi Kalan, Mahua Road, Hajipur",
      Mobile_No: 6200885440,
      Landline_No: "06224-2756101",
      Email: "sankalp.hajipur@gmail.com",
      Pin_Code: 844101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3329,
      Area: "West",
      States: "Rajasthan",
      City: "Udaipur",
      Category: 1,
      Store_name: "Kyrstal Electro World",
      Contact_name: "",
      Store_Address:
        "100 ft. Shobhagpura, Main Road, Near - Jain Transport, Udaipur",
      Mobile_No: 9414168284,
      Landline_No: "",
      Email: "mahaveermehta74@gmail.com",
      Pin_Code: 313001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3330,
      Area: "North",
      States: "Delhi",
      City: "New Delhi",
      Category: 2,
      Store_name: "Home Decor",
      Contact_name: "NULL",
      Store_Address:
        "M-64, 2nd Floor, Lado Sarai, Near Green Kashmiri Haat, New Delhi",
      Mobile_No: 9717446396,
      Landline_No: 8595254585,
      Email: "NULL",
      Pin_Code: 110030,
      DT: "NULL",
      Active: 1,
      Latitude: "NULL",
      Longitude: "NULL",
    },
    {
      id: 3332,
      Area: "South",
      States: "Kerala",
      City: "TRIVANDRUM",
      Category: 2,
      Store_name: "FABER PLATINUM STUDIO",
      Contact_name: "",
      Store_Address:
        "TC 15/4250 TC 15/4251, GROUND FLOOR AND FIRST FLOOR BHASKAR BUILDING , BHASKAR LANE, NEAR ST MARYS CHURCH, PATTOM,TRIVANDRUM",
      Mobile_No: 9995805243,
      Landline_No: "0471 2558338",
      Email: "",
      Pin_Code: 695004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3333,
      Area: "South",
      States: "Kerala",
      City: "ALEPPEY",
      Category: 2,
      Store_name: "FABER GALLERIA",
      Contact_name: "",
      Store_Address: "30/457 A NH 47, KALARKODE ALLEPPEY",
      Mobile_No: 9526207888,
      Landline_No: "0477 -2269791",
      Email: "",
      Pin_Code: 688003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3334,
      Area: "South",
      States: "Kerala",
      City: "ERNAKULAM",
      Category: 2,
      Store_name: "FORHOME",
      Contact_name: "",
      Store_Address: "OPP. ERNAKULAM MEDICAL CENTRE, BYEPASS ERNAKULAM",
      Mobile_No: 9995808617,
      Landline_No: "",
      Email: "",
      Pin_Code: 682025,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3335,
      Area: "South",
      States: "Kerala",
      City: "ERNAKULAM",
      Category: 2,
      Store_name: "FABER GALLERIA",
      Contact_name: "",
      Store_Address:
        "SOUTH SQUARE BULIDING, 1ST FLOOR, Nr. SOUTH OVER BRIDGE, PANAMPILLY NAGAR, KOCHI",
      Mobile_No: 9895099233,
      Landline_No: "0484 2322211",
      Email: "",
      Pin_Code: 682036,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3336,
      Area: "South",
      States: "Kerala",
      City: "ERNAKULAM",
      Category: 2,
      Store_name: "FABER GALLERIA",
      Contact_name: "",
      Store_Address: "OPP. HDFC BANK, PALARIVATTOM, KOCHI",
      Mobile_No: 9995805248,
      Landline_No: "0484 4049211",
      Email: "",
      Pin_Code: 682025,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3337,
      Area: "South",
      States: "Kerala",
      City: "ERNAKULAM",
      Category: 2,
      Store_name: "FABER GALLERIA",
      Contact_name: "",
      Store_Address: "I/91 A, VANCHINAD, MUDIKKAL PO, PERUMBAVOOR",
      Mobile_No: 9526310888,
      Landline_No: "",
      Email: "",
      Pin_Code: 683547,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3338,
      Area: "South",
      States: "Kerala",
      City: "KOTTAYAM",
      Category: 2,
      Store_name: "FORHOME",
      Contact_name: "",
      Store_Address: "VALAYAIL BUILDING, VADAVATHOOR PO, KALATHIPADY, KOTTAYAM",
      Mobile_No: 9526010888,
      Landline_No: "",
      Email: "",
      Pin_Code: 686010,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3339,
      Area: "South",
      States: "Kerala",
      City: "TRIVANDRUM",
      Category: 2,
      Store_name: "FABER GALLERIA",
      Contact_name: "",
      Store_Address:
        "1st FLOOR, GEETHA TOWER, KALPALAYAM JUNCTION KARAMANA, TRIVANDRUM",
      Mobile_No: 9995805243,
      Landline_No: "",
      Email: "",
      Pin_Code: 695002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3340,
      Area: "South",
      States: "Kerala",
      City: "TRIVANDRUM",
      Category: 2,
      Store_name: "FORHOME",
      Contact_name: "",
      Store_Address:
        "TIMBER PLEX, TC-79/1206(1) & 79/1206(2) , NH BYE PASS, VENPALAVATTOM ANAYARA PO, TRIVANDRUM",
      Mobile_No: 9995805243,
      Landline_No: "0471 2558338",
      Email: "",
      Pin_Code: 695004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3341,
      Area: "South",
      States: "Andaman & Nicobar Islands",
      City: "Port Blair",
      Category: 1,
      Store_name: "Home Decor",
      Contact_name: "Pankaj Enterprises",
      Store_Address: "M G Road, Middle Point, Port Blair",
      Mobile_No: 8939268532,
      Landline_No: 9531862252,
      Email: "pankajenterprises.rs@gmail.com",
      Pin_Code: 744101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3342,
      Area: "West",
      States: "Rajasthan",
      City: "Jaipur",
      Category: 1,
      Store_name: "Safex Technologies",
      Contact_name: "",
      Store_Address:
        "Safex Technologies, Safex Arcade, A-3, New Atish Market, Near PNB, Behind Ganga Jamuna, Petrol Pump, Mansarovar, Jaipur, Rajasthan",
      Mobile_No: 9829084896,
      Landline_No: "",
      Email: "",
      Pin_Code: 302020,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3343,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 2,
      Store_name: "-",
      Contact_name: "",
      Store_Address:
        "Bharath Towers, Opp:Narayana Petrol Pump, YMCA Cross Road.",
      Mobile_No: 9207737341,
      Landline_No: "",
      Email: "",
      Pin_Code: 673011,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3344,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 2,
      Store_name: "White Field Associates (Branch)",
      Contact_name: "",
      Store_Address: "16/38, E,F,G,H, Mele Chovva, Nr.Mele Chovva High School.",
      Mobile_No: "9847101118, 9656104012",
      Landline_No: "0497 2725537",
      Email: "",
      Pin_Code: 670006,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3345,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 2,
      Store_name: "Whitefield Associates (Branch) Thondayad",
      Contact_name: "",
      Store_Address: "28/324 , Thondayad Bazar,, Thondayad",
      Mobile_No: "9526 101115",
      Landline_No: "0495-235 2012",
      Email: "",
      Pin_Code: 673017,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3346,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 2,
      Store_name: "WHITE FIELD ASSOCIATES ( TIRUR BRANCH )",
      Contact_name: "",
      Store_Address: "ROOM NO. 5/265 E,, PAN BAZAR.",
      Mobile_No: 9847748844,
      Landline_No: 4942421007,
      Email: "",
      Pin_Code: 676101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3347,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 2,
      Store_name: "WHITEFIELD ASSOCIATES (BRANCH - COCHIN)",
      Contact_name: "",
      Store_Address:
        "DOOR NO. 70/2672 B, B1, SREEPADMAM, DESHABHIMANI JN., KALOOR.",
      Mobile_No: 9847104012,
      Landline_No: "",
      Email: "",
      Pin_Code: 682017,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3348,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 2,
      Store_name: "WHITEFILED ASSOCIATES(TCR)",
      Contact_name: "",
      Store_Address:
        "Q TOWER, 1st Floor,, Near Achuthanmaidan park, West Fort, TRICHUR",
      Mobile_No: 9562101116,
      Landline_No: "",
      Email: "",
      Pin_Code: 680004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3349,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 2,
      Store_name: "IDEAL HOME GALLERIA",
      Contact_name: "",
      Store_Address: "XIII/271K, Thodupuzha East P.O., Idukki.",
      Mobile_No: 9447258000,
      Landline_No: "04862 2299999",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3350,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 2,
      Store_name: "IDENTITY INTERIORS AND EXTERIORS",
      Contact_name: "",
      Store_Address: "5/2416, 1, AMBALAMUKKU, KOWDIAR P O TRIVANDRUM.",
      Mobile_No: 8075629585,
      Landline_No: "",
      Email: "",
      Pin_Code: 695003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3351,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "House Point",
      Contact_name: "",
      Store_Address: "(UNIT OF GLASSPOINT,KATAKADA), KOCHAR ROAD,KILLIPALAM.",
      Mobile_No: "9847867728, 9388788787",
      Landline_No: "0471-6004422",
      Email: "",
      Pin_Code: 695036,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3352,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "George Kaitharan Buildware",
      Contact_name: "",
      Store_Address: "111/825 A, A M ROAD, KURUPPAM PADY.",
      Mobile_No: 9605393116,
      Landline_No: "",
      Email: "",
      Pin_Code: 683545,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3353,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "K.H. HOME APPLIANCES",
      Contact_name: "",
      Store_Address: "12/265, NEAR POLICE STATION, PATTAMBI.",
      Mobile_No: 7907210527,
      Landline_No: "0466-2212362",
      Email: "",
      Pin_Code: 679305,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3354,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES, ADOOPARAMBU",
      Contact_name: "",
      Store_Address:
        "13/249/A,B, ANNIKKAD, ADOOPARAMBU JN, THODUPUZHA-MUVATTUPUZHA ROAD, MUVATTUPUZHA.",
      Mobile_No: "",
      Landline_No: "0485-2969699,2834999,2836999",
      Email: "",
      Pin_Code: 686661,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3355,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES (Paruthippara)",
      Contact_name: "",
      Store_Address:
        "14/175-1,2,3, B G LUCYMALL OPP: IMMANUEL CHURCH, PARUTHIPARA, NALANCHIRA.",
      Mobile_No: 9495473307,
      Landline_No: "0471-2533755",
      Email: "",
      Pin_Code: 695015,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3356,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "NANDILATH G MART(TVLA)",
      Contact_name: "",
      Store_Address: "NEAR KSRTC BUS STAND, M.C.ROAD, MUTHUR P.O, THIRUVALLA.",
      Mobile_No: 9745519347,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3357,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "Cochin Sani Wares (PALA)",
      Contact_name: "",
      Store_Address:
        "NEAR ST.THOMAS COLLEGE, ARUNAPURAM TOWER, ARUNAPURAM,PALA.",
      Mobile_No: "9388367672, 9446016224,8943335901",
      Landline_No: "04822 215953/216953",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3358,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "SUNCITY, TCR",
      Contact_name: "",
      Store_Address:
        "15/163-B, GURUVAYOOR ROAD, PUNKUNNAM P.O, THRISSUR, KERALA.",
      Mobile_No: 9497772244,
      Landline_No: "",
      Email: "",
      Pin_Code: 680002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3359,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "CHAITHANYA CERAMIC SANITARY CORPN",
      Contact_name: "",
      Store_Address:
        "2141,  AGASTHYACOODAM,NEAR ST GEORGE SCHOOL, ANCHAL, KOLLAM.",
      Mobile_No: 9400002662,
      Landline_No: "0475-2275999",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3360,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "STUDIO-ONYX BUILDWARE LLP",
      Contact_name: "",
      Store_Address:
        "25/473 D,   MAIN ROAD, NEAR CO-OPERATIVE HOSPITAL, VATAKARA.",
      Mobile_No: 8089241496,
      Landline_No: "",
      Email: "",
      Pin_Code: 673101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3361,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "NANDILATH G-MART (KANHANGAD)",
      Contact_name: "",
      Store_Address:
        "5  /633, C, 2ND FLOOR,K V TOWER, ATHINHAL, MANIKOTH PO, KANHANGAD KASARAGODE ROAD, KANHANGAD, KERALA.",
      Mobile_No: "097457 66128",
      Landline_No: "",
      Email: "",
      Pin_Code: 671316,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3362,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCICES(PMBVR)",
      Contact_name: "",
      Store_Address: "A M ROAD, PERUMBAVOOR, ERNAKULAM DIST.",
      Mobile_No: 9446009885,
      Landline_No: "0484-2595901",
      Email: "",
      Pin_Code: 683542,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3363,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "INSIDE STORY",
      Contact_name: "",
      Store_Address:
        "A UNIT OF AL-FAS TRADING INTERNATIONAL(P)LTD, BUILDING NO. 3394, BUND ROAD, KILLIPALAM, KARAMANA P O,",
      Mobile_No: 8593883328,
      Landline_No: "",
      Email: "",
      Pin_Code: 695002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3364,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "Chandy's Lock Center",
      Contact_name: "",
      Store_Address: "A.A.A.CENTRE, ETTUMANOOR.P.O.",
      Mobile_No: 9447021871,
      Landline_No: "481 2532302/2533532",
      Email: "",
      Pin_Code: 686631,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3365,
      Area: "South",
      States: "Kerala",
      City: "Wayanad",
      Category: 1,
      Store_name: "E PLANET (Kalpetta)",
      Contact_name: "",
      Store_Address: "AL ZAHARA COMPLEX, MAIN ROAD, KALPETTA.",
      Mobile_No: "9497421828 ,7907309767",
      Landline_No: "",
      Email: "",
      Pin_Code: 673121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3366,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "Jose Electricals (Anchal)",
      Contact_name: "",
      Store_Address: "ALITHOTTATHIL TOWER, R. O , JUNCTION, ANCHAL.",
      Mobile_No: "9447021927, 0475 2271927",
      Landline_No: "",
      Email: "",
      Pin_Code: 691306,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3367,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 1,
      Store_name: "IDEAL HOME GALLERIA",
      Contact_name: "",
      Store_Address: "XIII/271K, THODUPUZHA EAST P.O., IDUKKI.",
      Mobile_No: 9447258000,
      Landline_No: "04862 229999",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3368,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "NANDILATH G MART(Nadakkavu)",
      Contact_name: "",
      Store_Address: "AL-NOOR COMPLEX, EAST NADAKAVU.",
      Mobile_No: 9745766395,
      Landline_No: "",
      Email: "",
      Pin_Code: 673006,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3369,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Kaitharan Buildware,Kurmsery",
      Contact_name: "",
      Store_Address: "ALUVA ROAD, KURUMASSERY-ATHANI, ERNAKULAM.",
      Mobile_No: "94958 52743",
      Landline_No: 2267784,
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3370,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "STOVE PALACE TRADE LINKS",
      Contact_name: "",
      Store_Address: "BISHOP JEROME NAGAR.",
      Mobile_No: 9446285396,
      Landline_No: "",
      Email: "",
      Pin_Code: 691001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3371,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "P SQUARE INTERIOR FURNISHING",
      Contact_name: "",
      Store_Address:
        "BRANCH OF PARAPPATTU GROUP, PARAPPATTU BUILDING, NEAR OLD PRIVATE BUS STAND, PATHANAMTHITTA",
      Mobile_No: 9447020750,
      Landline_No: "",
      Email: "",
      Pin_Code: 689645,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3372,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "SONY GLOBAL FURNITURE & HOME APPLIANCIES",
      Contact_name: "",
      Store_Address:
        "BRANCH OF SONY AGENCIES, NEAR PAZHAKUTTY PETROL PUMB, NEDUMANGAD, TRIVANDRUM.",
      Mobile_No: 8943405424,
      Landline_No: "0472-2960676",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3373,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "BISMI HOME APPLIANCES LLP",
      Contact_name: "",
      Store_Address:
        "72/1059,44/3017, OPP: MICRO TOWER, DESHABHIMANI ROAD,  KALOOR, KOCHI.",
      Mobile_No: 9249011111,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3374,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Kandeth Kitchen & Accessories",
      Contact_name: "",
      Store_Address: "BUND ROAD, THYKUDAM, VYTILA.",
      Mobile_No: "7012562778 , 98954 46504,9446986504",
      Landline_No: "",
      Email: "",
      Pin_Code: 682019,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3375,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES (Kalpathy)",
      Contact_name: "",
      Store_Address: "CALICUT BYE PASS ROAD, SHEKARIPURAM (KALPATHY).",
      Mobile_No: "0491-2576999/2576199",
      Landline_No: "",
      Email: "",
      Pin_Code: 678003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3376,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "D O C INTERIORS",
      Contact_name: "",
      Store_Address: "CHAPPARA, PULLUT, KODUNGALLUR, TRICHUR.",
      Mobile_No: 8943807777,
      Landline_No: "",
      Email: "",
      Pin_Code: 680663,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3377,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "NANDILATH G-MART (CHICAGO BUILDING)",
      Contact_name: "",
      Store_Address:
        "CHICAGO BUILDING, NEAR MALAYALAMANORAMA, IKKANDAWARIER ROAD.",
      Mobile_No: 9745769102,
      Landline_No: "",
      Email: "",
      Pin_Code: 680001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3378,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "KALLUVARAMBIL HOMES PRIVATE LIMITED",
      Contact_name: "",
      Store_Address:
        "T C 3/2717-2,  MARAPPALAM JUNCTION, PATTOM TRIVANDRUM -695004.",
      Mobile_No: "9446177070/7558902555/8644800080,9746607409",
      Landline_No: "",
      Email: "",
      Pin_Code: 695004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3379,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "MADHURANS Hardware Paint Sanitary",
      Contact_name: "",
      Store_Address: "CIVIL LINE ROAD, NEAR ST.MARY'S BRIDGE, CHERTHALA.",
      Mobile_No: 9497674828,
      Landline_No: "0478- 2820161, 2522375(R)",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3380,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "CRYSTAL SOLAR WORLD",
      Contact_name: "",
      Store_Address: "CRYSTAL CENTRE, 8/621-1,OPP:ROSI SCHOOL, CHATHAPURAM.",
      Mobile_No: 9447044912,
      Landline_No: "0491 2577990",
      Email: "",
      Pin_Code: 678003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3381,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "J.V. INTERIORS",
      Contact_name: "",
      Store_Address: "5/209/A, MANGADU.",
      Mobile_No: "9447071487/9037797547",
      Landline_No: "",
      Email: "",
      Pin_Code: 601015,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3382,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Irinjalakuda)",
      Contact_name: "",
      Store_Address: "CVM MALL, TANA JUNCTION, IRINJALAKUDA.",
      Mobile_No: 94477042470,
      Landline_No: "0480-2821399",
      Email: "",
      Pin_Code: 680121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3383,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "Cochin Sani Wares,Pnknm",
      Contact_name: "",
      Store_Address: "20 TH MILE, PONKUNNAM.",
      Mobile_No: "",
      Landline_No: "04828 217339",
      Email: "",
      Pin_Code: 686506,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3384,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "NATIONAL RADIO ELECTRONICS CORPORATION (KANNUR)",
      Contact_name: "",
      Store_Address: "NEAR SPECIALTY HOSPITAL.",
      Mobile_No: "",
      Landline_No: 4972704141,
      Email: "",
      Pin_Code: 670012,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3385,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "NIKSHAN ELECTRONICS",
      Contact_name: "",
      Store_Address: "CW-33/3577,3575 SAFAIR BUILDING, BANK ROAD.",
      Mobile_No: "",
      Landline_No: "0497 2704664",
      Email: "",
      Pin_Code: 670001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3386,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Chkdy)",
      Contact_name: "",
      Store_Address: "DIGI PARK, GEE CEE TOWERS, CHALAKUDY  TRICHUR DISTRICT.",
      Mobile_No: 9446096948,
      Landline_No: "0480-27026555",
      Email: "",
      Pin_Code: 680307,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3387,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "MATTAKKAL INTERIOR HOMES",
      Contact_name: "",
      Store_Address:
        "MOOPAN BUILDING, GROUND FLOOR,COMPANY PADI, ALUVA,ERNAKULAM.",
      Mobile_No: "98460 83130/6511334, 9539073130",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3388,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(TVLA)",
      Contact_name: "",
      Store_Address: "DIGI PARK, PERUMTHURUTHY, THIRUVALLA.",
      Mobile_No: 8547507388,
      Landline_No: "6469-2645099,",
      Email: "",
      Pin_Code: 689107,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3389,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "PITTAPPILLY AGENCIES (Kochi)",
      Contact_name: "",
      Store_Address: "DIGI PARK, TOLL JUNCTION  EDAPPALLY.",
      Mobile_No: 9447760835,
      Landline_No: 2557599,
      Email: "",
      Pin_Code: 682024,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3390,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "LULU HYPERMARKET",
      Contact_name: "",
      Store_Address:
        "DIVISION OF LULU GROUP INDIA PRIVATE LIMITED, DOOR NO. 34/1000, LULU INTERNATIONAL SHOPPING MALL, NH 47.",
      Mobile_No: "",
      Landline_No: "0484 2727777",
      Email: "",
      Pin_Code: 682024,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3391,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "NATIONAL RADIO ELECTRONICS CORPORATION (PAYYANNUR)",
      Contact_name: "",
      Store_Address: "NEAR OLD BUS STAND MAIN ROAD.",
      Mobile_No: 9288888813,
      Landline_No: 4985203021,
      Email: "",
      Pin_Code: 670307,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3392,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "Sri Krishna Hardwares MS",
      Contact_name: "",
      Store_Address: "ANEBANGILU, M.G.ROAD, KASARAGOD CITY.",
      Mobile_No: "9447384864,9447204581, 7736536100",
      Landline_No: "0499 4230645,223821",
      Email: "",
      Pin_Code: 671121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3393,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "NANDILATH G MART (Kollam)",
      Contact_name: "",
      Store_Address:
        "DOOR NO 111-1448/807(A),1449/807(B), Q S ROAD, KADAPPAKKADA.",
      Mobile_No: 974566686,
      Landline_No: "0474-2760070/2760012",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3394,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "Kitchen Solutions(Branch)",
      Contact_name: "",
      Store_Address: "FABER GALLERIA,C.S.ARCADE, AMPALATHUMKALA.P.O.",
      Mobile_No: "",
      Landline_No: "0474 2482111",
      Email: "",
      Pin_Code: 691505,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3395,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 1,
      Store_name: "BISMI HOME APPLIANCES LLP(Tdpzha)",
      Contact_name: "",
      Store_Address: "KALARICKAL BAZAR, PALA ROAD, THODUPUZHA.",
      Mobile_No: 9744455559,
      Landline_No: 9562888809,
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3396,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "HHYS INFRAMART,KOLLAM",
      Contact_name: "",
      Store_Address: "FASIA SHOPPING COMPLEX,PALLIMUKKU, KOLLAM.",
      Mobile_No: "PH.7025085577, 04792445955,9847229944",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3397,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "NANDILATH G-MART (KANNUR)",
      Contact_name: "",
      Store_Address: "G MART CORNER, CHOVVA, KANNUR.",
      Mobile_No: 9745766406,
      Landline_No: "",
      Email: "",
      Pin_Code: 670006,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3398,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "SunCity",
      Contact_name: "",
      Store_Address:
        "TC-12/689/3,4,5 , PANDARATHIL SHOPPING COMPLEX, POOTHOLE ROAD.",
      Mobile_No: 9061506292,
      Landline_No: "0487 2387191",
      Email: "",
      Pin_Code: 680004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3399,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "C.B.FURNITURE & INTERIORS",
      Contact_name: "",
      Store_Address: "K P ROAD, NOORANAD.",
      Mobile_No: "",
      Landline_No: "0479-2387332",
      Email: "",
      Pin_Code: 690504,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3400,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "NATIONAL RADIO ELECTRONICS CORPORATION (KANHANGAD)",
      Contact_name: "",
      Store_Address: "OPP CITY HOSPITAL,NORTH KOTTACHERY.",
      Mobile_No: 9745099539,
      Landline_No: 4672204011,
      Email: "",
      Pin_Code: 671315,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3401,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "VERTEX BUILDING GALLERY PVT LTD (FABER)",
      Contact_name: "",
      Store_Address:
        "GOWRI TOWER , TC38/181, CHENTHITTA  POWER HOUSE ROAD, CHALAI, P.O. TVM.",
      Mobile_No: "",
      Landline_No: "0471-2571777",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3402,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "NANDILATH G-MART (POONKUNNAM)",
      Contact_name: "",
      Store_Address: "GURUVAYUR ROAD, WEST  GATE, POONKUNNAM.",
      Mobile_No: 9633442616,
      Landline_No: "",
      Email: "",
      Pin_Code: 680002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3403,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Nediyath Sanitary Wares",
      Contact_name: "",
      Store_Address:
        "HILL PALACE ROAD, MARKET JN.,TRIPUNITHURA, THEKKUMBHAGOM P O, ERNAKULAM.",
      Mobile_No: "",
      Landline_No: 4842776464,
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3404,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "ZENITH SANITATIONS",
      Contact_name: "",
      Store_Address: "HOSPITAL ROAD, NILAMBUR.",
      Mobile_No: "9447120794,9495970794,0493 1220794",
      Landline_No: "",
      Email: "",
      Pin_Code: 679329,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3405,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "NATIONAL RADIO ELECTRONICS CORPORATION (KASARAGOD)",
      Contact_name: "",
      Store_Address: "NH 66 NEAR KASARAGOD NEW BUSSTAND.",
      Mobile_No: "",
      Landline_No: 4994220977,
      Email: "",
      Pin_Code: 671121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3406,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "Koolikad Smart Kitchen",
      Contact_name: "",
      Store_Address: "I/761-762, R.S.ROAD, KANHANGAD.",
      Mobile_No: 9961217722,
      Landline_No: "0467 2205177",
      Email: "",
      Pin_Code: 671315,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3407,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "Chennalloor Fashion Homes",
      Contact_name: "",
      Store_Address: "NH 47,OACHIRA.",
      Mobile_No: 9947593471,
      Landline_No: 4762698925,
      Email: "",
      Pin_Code: 690526,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3408,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "KURISINKAL STEELS",
      Contact_name: "",
      Store_Address: "IX/48-A, KURISINKAL BUILDINGS, MUTTUCHIRA.",
      Mobile_No: "9061248800/9447231513",
      Landline_No: "04829-282945",
      Email: "",
      Pin_Code: 686613,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3409,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "NANDILATH G MART (Kaloor)",
      Contact_name: "",
      Store_Address: "JUDGES AVENUE JUNCTION, KALOOR.",
      Mobile_No: 9745766109,
      Landline_No: "",
      Email: "",
      Pin_Code: 682018,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3410,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "NANDILATH G MART (KARAMANA)",
      Contact_name: "",
      Store_Address: "K J SQUARE , NEAR KARAMANA BRIDGE, KAIMANAM, TRIVANDRUM.",
      Mobile_No: 9745766412,
      Landline_No: "0471-2491133,249119",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3411,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Gas Mech Stove Centre",
      Contact_name: "",
      Store_Address:
        "NEAR SBT, CHRISTURAJ SHOPPING COMPLEX, M.C. ROAD, PERUMBAVOOR.",
      Mobile_No: 0.960588396,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3412,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Nemom)",
      Contact_name: "",
      Store_Address: "K R B N TOWERS, VELLAYANI JUNCTION, NEMOM PO.",
      Mobile_No: "",
      Landline_No: "0471-2394799/2394699",
      Email: "",
      Pin_Code: 695020,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3413,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "Pittappillil Agencies,Pala",
      Contact_name: "",
      Store_Address: "MARKET ROAD, OPP. KSEB OFFICE, PALA.",
      Mobile_No: "",
      Landline_No: "04822 216622",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3414,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "NANDILATH G-MART (THRISSUR)",
      Contact_name: "",
      Store_Address:
        "NADILATH BUILDING12/644 A, MAIN ROAD, VADANAPALLY, THRISSUR DIST.",
      Mobile_No: 9745766385,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3415,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "Homsi",
      Contact_name: "",
      Store_Address:
        "ANUGRAHA PLAZA, TC39/785(4),VETTAKADA JN, CHALAI,TRIVANDRUM DIST.",
      Mobile_No: 7510528810,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3416,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "KONATTU AGENCIES",
      Contact_name: "",
      Store_Address:
        "PALACKAPADY, KANGAZHA PIN: 686561, TEL:04812494987 , DELIVERY AT:KONATTU DIGI SMART, PEEL AVENUE, KVMS JU. PONKUNNAM.",
      Mobile_No: "0482 8223387",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3417,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Pittappillil Agencies (Agmly)",
      Contact_name: "",
      Store_Address: "DIGI PARK,OPPO. MADONA HOSPITAL.",
      Mobile_No: 9446060833,
      Landline_No: "",
      Email: "",
      Pin_Code: 683572,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3418,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "BISMI CONNECT PRIVATE LIMITED(Thiruvalla)",
      Contact_name: "",
      Store_Address: "KAPZON PLAZA, RAMANCHIRA, THIRUVALLA, PATHANAMTHITTA.",
      Mobile_No: 9562888814,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3419,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "Romana Granites & Tiles",
      Contact_name: "",
      Store_Address:
        "KOCHUPURACKAL BUILDINGS,III/177D, TALAPPARA ROAD, ILLITHONDU.",
      Mobile_No: 7559040555,
      Landline_No: 4829238825,
      Email: "",
      Pin_Code: 686605,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3420,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "NANDILATH G-MART(KTM)",
      Contact_name: "",
      Store_Address: "KAROTTUKUNNEL ARCADE, OPP. NEHRU STADIUM, NAGAMPADOM.",
      Mobile_No: 9745766620,
      Landline_No: "",
      Email: "",
      Pin_Code: 686002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3421,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "POTHYS",
      Contact_name: "",
      Store_Address: "KC 65/4875/ A-B, BANERJI ROAD, KALOOR, ERNAKULAM.",
      Mobile_No: 8943359364,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3422,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 1,
      Store_name: "HIGHRANGE HOME APPLIANCES",
      Contact_name: "",
      Store_Address:
        "KGEES BLDG., OPP. CHAZHIKATTU HOSPITAL, PALA ROAD, , KERALA.",
      Mobile_No: "",
      Landline_No: "0486 2221444",
      Email: "",
      Pin_Code: 685584,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3423,
      Area: "South",
      States: "Kerala",
      City: "Wayanad",
      Category: 1,
      Store_name: "CLASSIC",
      Contact_name: "",
      Store_Address: "KM8/110, SIVA TOWER, MAIN ROAD, KALPETTA.",
      Mobile_No: "9496506500, 04936207022, 9605040508",
      Landline_No: "",
      Email: "",
      Pin_Code: 673121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3424,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "BISMI CONNECT PVT LTD(Br.Kalmandapam)",
      Contact_name: "",
      Store_Address: "KALMANDAPAM, PALAKKAD-COIMBATORE ROAD.",
      Mobile_No: 9562888897,
      Landline_No: "",
      Email: "",
      Pin_Code: 678013,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3425,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "TRIO INTERIORS",
      Contact_name: "",
      Store_Address:
        "KOOLIYOTT TOWER, WARD NO: 33,  ROOM NO: 15J & 15K, THURUKKAL BYE PASS ROAD.",
      Mobile_No: 9846132624,
      Landline_No: "",
      Email: "",
      Pin_Code: 676121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3426,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "GASTECH KITCHEN APPLIANCES",
      Contact_name: "",
      Store_Address:
        "KOTTAKKAL BUILDING, ADOOR ROAD, NEAR COLLEGE JUNCTION, PATHANAMTHITTA .",
      Mobile_No: "920712 7718",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3427,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "LAMIS KITCHEN SOLUTIONS",
      Contact_name: "",
      Store_Address: "P A COMPLEX, N H ROAD, ADKATHBAIL, KASARAGOD.",
      Mobile_No: 9744855386,
      Landline_No: 4994231123,
      Email: "",
      Pin_Code: 671121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3428,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES (Kottarakkara)",
      Contact_name: "",
      Store_Address:
        "KOTTARAKKARA DIGI, THE CORNER STONE BUILDING, M G ROAD, OPP: PENTACOSTAL PRAYER HALL.",
      Mobile_No: 8072055830,
      Landline_No: "",
      Email: "",
      Pin_Code: 691531,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3429,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "NANDILATH G MART (Perinthalmanna)",
      Contact_name: "",
      Store_Address: "G MART TOWER, CALICUT ROAD.",
      Mobile_No: 9745766403,
      Landline_No: "",
      Email: "",
      Pin_Code: 679322,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3430,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES - KONDOTTY",
      Contact_name: "",
      Store_Address: "KOZHIKODE - PALAKKAD HIGHWAY, THURACKAL,KONDOTTY.",
      Mobile_No: 7356211199,
      Landline_No: "0483 2717799",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3431,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "C V R SANIWARES",
      Contact_name: "",
      Store_Address: "NADAKKAVU ROAD, CHERTHALA.",
      Mobile_No: "94477 81802",
      Landline_No: "0478 2822150",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3432,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "P.V.K VENTURES",
      Contact_name: "",
      Store_Address: "KP IX/288, IVERKALA  W/S  KUNNATHUR.",
      Mobile_No: "9072636420/8289965181",
      Landline_No: "",
      Email: "",
      Pin_Code: 691553,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3433,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "KAITHARAN GLASS HOUSE",
      Contact_name: "",
      Store_Address:
        "ALUVA -PRAVUR ROAD, MUNCIPAL SHOPPING COMPLEX, N PARAVUR.",
      Mobile_No: 8547195989,
      Landline_No: "0484-2444437",
      Email: "",
      Pin_Code: 691553,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3434,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Vellayambalam)",
      Contact_name: "",
      Store_Address: "KULATHAKKAL TOWERS, VELLAYAMBALAM, TRIVANDRUM.",
      Mobile_No: 9072038601,
      Landline_No: "",
      Email: "",
      Pin_Code: 695010,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3435,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "COCHIN SANIWARES (Perumthuruthy)",
      Contact_name: "",
      Store_Address:
        "M C ROAD,  NEAR HOTEL ACCADIA, THIRUVALLA-CHANGANSSERY ROAD,PERUMTHURUTHY.",
      Mobile_No: "9645098888/8943339419/8943339421",
      Landline_No: "",
      Email: "",
      Pin_Code: 689107,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3436,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "NANDILATH G MART(Irinjalakuda)",
      Contact_name: "",
      Store_Address: "MAIN ROAD, TANA IRINJALAKKUDA,",
      Mobile_No: 8086914347,
      Landline_No: "",
      Email: "",
      Pin_Code: 680121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3437,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "UNITED BLUE METALS",
      Contact_name: "",
      Store_Address: "MANGALATH TOWER, UPASANA NAGAR, Q S ROAD,  ,",
      Mobile_No: "",
      Landline_No: "0474 2765015, 2765050",
      Email: "",
      Pin_Code: 691001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3438,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "E-Planet,Khndg",
      Contact_name: "",
      Store_Address:
        "KANHANGAD NORTH, KOTTACHERRY, KANHANGAD., (KASARAGOD DIST), PH:",
      Mobile_No: "",
      Landline_No: "0467 2200900,04672206162",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3439,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "Pathoos Modular Kitchen",
      Contact_name: "",
      Store_Address: "MANIPUZHA, NATTAKOM P.O,",
      Mobile_No: 9995488819,
      Landline_No: "0481-2361166",
      Email: "",
      Pin_Code: 686013,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3440,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "MANGATTIL TRADE LINKS PVT LTD (Br)",
      Contact_name: "",
      Store_Address:
        "MARBLE LAND, OPPOSITE POLICE STATION, ALANKODE POST, CHANGARAMKULAM.",
      Mobile_No: 9072555561,
      Landline_No: "",
      Email: "",
      Pin_Code: 679585,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3441,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "POOYAPPALLIL TRADERS",
      Contact_name: "",
      Store_Address: "MARKET ROAD, PUTHIYAKAVU, KARUNAGAPPALLY.",
      Mobile_No: 9061765260,
      Landline_No: "0476-2624437",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3442,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "NANDILATH G MART(MVPZHA)",
      Contact_name: "",
      Store_Address: "NO.IX/461, M.C ROAD,VAZHAPPILLY JUNCTION, MUVATTUPUZHA",
      Mobile_No: "",
      Landline_No: "0485-6533301",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3443,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "NANDILATH G MART (Quilandy)",
      Contact_name: "",
      Store_Address:
        "BUILDING NO: 27/83A,  83B,  83D, CHAMAS BUILDING, MAIN ROAD.",
      Mobile_No: 8943342326,
      Landline_No: "",
      Email: "",
      Pin_Code: 673305,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3444,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "Appa Sons Electronices & Appliances",
      Contact_name: "",
      Store_Address: "NEAR BUS STAND, VADAKARA, CALICUT",
      Mobile_No: 9846124499,
      Landline_No: "0496 2522885",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3445,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "George  Kaitharan Buildware",
      Contact_name: "",
      Store_Address: "111/825 A, A M ROAD, KURUPPAM PADY .",
      Mobile_No: 9605938800,
      Landline_No: "0484 2658775,",
      Email: "",
      Pin_Code: 683545,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3446,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "C B Traders (Branch)",
      Contact_name: "",
      Store_Address: "MARYGIRI SHOPPING COMPLEX, OPP:BSNL.,",
      Mobile_No: 9447793386,
      Landline_No: "0469 2606620",
      Email: "",
      Pin_Code: 689101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3447,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name:
        "MAYOORI FURNITURE AND ELECTRONICS HOME APPLIANCES, PUTHIYAKAVU",
      Contact_name: "",
      Store_Address:
        "MAYOORI BUILDING, PUTHIYAKAVU SERVICE ROAD, PUTHIYAKAVU, KARUNAGAPPALLI, KOLLAM.",
      Mobile_No: 7593800100,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3448,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "MELCO ELECTRICAL SUPER MARKET",
      Contact_name: "",
      Store_Address: "MELETHIL BUILDING, MELE PATTAMBI PO.",
      Mobile_No: "",
      Landline_No: "0466-2211333",
      Email: "",
      Pin_Code: 679003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3449,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "PITTAPPALLIL AGENCIES (Pthnmta)",
      Contact_name: "",
      Store_Address:
        "MGM TOWERS, NEAR CATHOLIC BISHOP'S HOUSE, SH 17, T K ROAD,  NANNUVAKKAD.",
      Mobile_No: 7356720999,
      Landline_No: "0468-2320999/7356727999",
      Email: "",
      Pin_Code: 689645,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3450,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "HHYS INFRAMART",
      Contact_name: "",
      Store_Address:
        "MUKKAVALA,BANK ROAD, KAYAMKULAM, (ALPY DIST), (HARDWARE/TILE & SANITARY).",
      Mobile_No: "9061908877 , 808981810051 / 7736760051",
      Landline_No: "0479-2495002",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3451,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "SatBions Builders & Developers India Pvt Ltd",
      Contact_name: "",
      Store_Address: "SATBIONS HOUSE, PEROOR.",
      Mobile_No: 8157030011,
      Landline_No: "",
      Email: "",
      Pin_Code: 686637,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3452,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "PRESTIGE PLY CENTRE",
      Contact_name: "",
      Store_Address: "EAST MANISSERY, OTTAPPALAM.",
      Mobile_No: "",
      Landline_No: 466224822,
      Email: "",
      Pin_Code: 679101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3453,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "C J BUILDWARE (Kuttikol)",
      Contact_name: "",
      Store_Address: "NATIONAL HIGHWAY, KUTTIKKOL, THALIPARAMB.",
      Mobile_No: "9207777150 , 9207777151 ,9809805790",
      Landline_No: "",
      Email: "",
      Pin_Code: 670562,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3454,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "MALIEAKAL ELECTRONICS",
      Contact_name: "",
      Store_Address: "NEAR IRON BRIDGE.",
      Mobile_No: "",
      Landline_No: "0474-2750700 ,2743850",
      Email: "",
      Pin_Code: 691001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3455,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "CONCORD DESIGN STUDIO",
      Contact_name: "",
      Store_Address:
        "6/867 B SHIHAB THANGAL ROAD, POOJARI VALAVU, THRIKKAKKARA PO.",
      Mobile_No: 9656372229,
      Landline_No: "",
      Email: "",
      Pin_Code: 682021,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3456,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 1,
      Store_name: "Kollamkudy Home Care Systems",
      Contact_name: "",
      Store_Address: "NIC JUNCTION, KATTAPANA, IDUKKI DIST.",
      Mobile_No: "",
      Landline_No: "04868 272199,273599",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3457,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "MAYOORI FURNITURE AND ELECTRONICS HOME APPLIANCES",
      Contact_name: "",
      Store_Address: "3/479- 1 TO 16, PERINTHALMANNA.",
      Mobile_No: 9947907267,
      Landline_No: "",
      Email: "",
      Pin_Code: 679322,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3458,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Njaliyath Quality Tiles and Sanitaries",
      Contact_name: "",
      Store_Address: "NEAR K.G HOSPITAL, THRISSUR ROAD, ANGAMALY .",
      Mobile_No: 9946949139,
      Landline_No: "0484-2454847,",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3459,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "E Planet,Tlsry",
      Contact_name: "",
      Store_Address: "A.V.K.NAIR ROAD, THALASSERY.",
      Mobile_No: 8156889922,
      Landline_No: "0490 2343919,8156889944",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3460,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Cochin Saniwares Poothotta(Branch)",
      Contact_name: "",
      Store_Address: "NEAR KSFE ,Kollam",
      Mobile_No: 9645093333,
      Landline_No: "",
      Email: "",
      Pin_Code: 682307,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3461,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "POCHAYIL H.S. MALL",
      Contact_name: "",
      Store_Address: "NEAR MAHADEVA TEMPLE SOUTH, KARUNAGAPPALLY,  ,",
      Mobile_No: 9567233284,
      Landline_No: "",
      Email: "",
      Pin_Code: 690518,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3462,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "MELROSE KITCHNETTE(Branch)",
      Contact_name: "",
      Store_Address:
        "FABER GALARIA, SLEEBA ORTHODOX CHURCH BLDG, (ABOVE FEDERAL BANK), TK ROAD, THOTTABHAGAM, THIRUVALLA.",
      Mobile_No: "9446055717, 8589055717, 8589005717, 8589055717",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3463,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "NRE ELECTRONICS (TIRUR)",
      Contact_name: "",
      Store_Address: "POONGOTTUKULAM JUNCTION.",
      Mobile_No: "",
      Landline_No: 4942971956,
      Email: "",
      Pin_Code: 676101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3464,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "HOME CARE  (Cherthala)",
      Contact_name: "",
      Store_Address: "SOUTH OF COURT JUNCTION.",
      Mobile_No: "9847935582, 9496337154",
      Landline_No: "0484 2830509,0478 2830509",
      Email: "",
      Pin_Code: 688524,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3465,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "LE GAAMA TRADERS LLP",
      Contact_name: "",
      Store_Address: "15/237,  IRS ARCADE, PANTHEERANKAVU.",
      Mobile_No: "95441 14420, 95441 01878",
      Landline_No: "",
      Email: "",
      Pin_Code: 673019,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3466,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "National Electronics",
      Contact_name: "",
      Store_Address: "NATIONAL JUNCTION, THALIPARAMBU.",
      Mobile_No: "",
      Landline_No: "0460 2203081",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3467,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "Glass Point",
      Contact_name: "",
      Store_Address: "NEAR PETROL PUMP, POWER HOUSE ROAD, CHALAI.",
      Mobile_No: 9895328872,
      Landline_No: "0471 2468584/4013585",
      Email: "",
      Pin_Code: 695036,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3468,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "Kallarackals House of Hardwares & Kitchens",
      Contact_name: "",
      Store_Address: "NEAR ST.JAMES HOSPITAL , CHALAKUDY .",
      Mobile_No: 9846496927,
      Landline_No: 9745653277,
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3469,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES (MVKA)",
      Contact_name: "",
      Store_Address:
        "NEAR STATE WAREHOUSING DEPOT, MAVELIKKARA - THIRUVALA ROAD, CHERUKOL P.O., , KERALA.",
      Mobile_No: 9895381999,
      Landline_No: "9895781999,",
      Email: "",
      Pin_Code: 690104,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3470,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "BISMI CONNECT PVT LTD (Br.KMSRY)",
      Contact_name: "",
      Store_Address: "NEAR T V S JUNCTION, KALAMASSERY, ERNAKULAM DIST.",
      Mobile_No: 8113888872,
      Landline_No: "",
      Email: "",
      Pin_Code: 683104,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3471,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Dream Homes,Mvtpza (Advance)",
      Contact_name: "",
      Store_Address:
        "OPP:ST.AUGUSTINES GIRLS HIGH SCHOOL, GOVT MODEL HIGH SCHOOL ROAD.",
      Mobile_No: "8547130804, 9656488298",
      Landline_No: "0485 2830286",
      Email: "",
      Pin_Code: 686661,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3472,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Mannarkkad)",
      Contact_name: "",
      Store_Address: "NELLIPUZHA JUNCTION, NEAR K S R T C STATION, MANNARKKAD.",
      Mobile_No: "",
      Landline_No: "04924 2222599",
      Email: "",
      Pin_Code: 678582,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3473,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "NANDILATH G MART(Calicut)",
      Contact_name: "",
      Store_Address: "MAVOOR ROAD,CALICUT.",
      Mobile_No: "",
      Landline_No: "0495-2725982,2725981",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3474,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "NANDILATH G MART (KOTTAKKAL)",
      Contact_name: "",
      Store_Address: "NO. B1/2133, ERIYADAN TOWER, EDARIKODE . P.O, KOTTAKKAL.",
      Mobile_No: "",
      Landline_No: 7907153026,
      Email: "",
      Pin_Code: 676501,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3475,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "NANDILATH G MART (Pattambi Br)",
      Contact_name: "",
      Store_Address: "NO.11-6-1,  11-6-2, TOP GODOWN, PATTAMBI-PALAKKAD ROAD.",
      Mobile_No: 9946115857,
      Landline_No: "",
      Email: "",
      Pin_Code: 679303,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3476,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "NANDILATH G MART(Adoor)",
      Contact_name: "",
      Store_Address: "NO: XV/234-1,2,3 GODOWN, NEAR PWD  OFFICE.",
      Mobile_No: "",
      Landline_No: "04734 220 010",
      Email: "",
      Pin_Code: 691523,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3477,
      Area: "South",
      States: "Kerala",
      City: "Kasaragod",
      Category: 1,
      Store_name: "Salman House of Building Material",
      Contact_name: "",
      Store_Address: "MUNDLOE EST,NEW BUS STAND.",
      Mobile_No: "",
      Landline_No: "04994 224416, 224516",
      Email: "",
      Pin_Code: 671121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3478,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "NANDILATH G-MART(Pala)",
      Contact_name: "",
      Store_Address: "NO:XIX/241-1,P.P ROAD, PALA-",
      Mobile_No: 9745000237,
      Landline_No: 9287777552,
      Email: "",
      Pin_Code: 686575,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3479,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "DIYA TRADING COMPANY",
      Contact_name: "",
      Store_Address:
        "NP IX/797,798, MEEYANNOOR P.O., OPP.CO-OPERATIVE BANK, KOLLAM .",
      Mobile_No: 8589024622,
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3480,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "SIGMA ELECTRONICS AND HOME BAZAR",
      Contact_name: "",
      Store_Address: "JANATHAPADI, NILAMBUR.",
      Mobile_No: 9745403232,
      Landline_No: "0493/1220400",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3481,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES (KYKLM)",
      Contact_name: "",
      Store_Address:
        "OPP. ALLEPPY CO-OPERATIVE SPINNING MILLS LTD., KAREELAKULANGARA, KAYAMKULAM.",
      Mobile_No: "",
      Landline_No: "0479 2437177, 2437277",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3482,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "Ideal Home Appliances",
      Contact_name: "",
      Store_Address:
        "OPP. TELEPHONE EXCHANGE, KAITHAMUKKU JN., TRIVANDRUM-23, DEL@ULLOOR.",
      Mobile_No: "",
      Landline_No: "0471 2573535/ 2570012",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3483,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES (TPN)",
      Contact_name: "",
      Store_Address: "OPP: HILL PALACE POLICE STATION, VAIKOM ROAD.",
      Mobile_No: "",
      Landline_No: "0484-2785188/2782199",
      Email: "",
      Pin_Code: 682301,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3484,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "NRE ELECTRONICS (MANJERI)",
      Contact_name: "",
      Store_Address: "CH BYEPASS JUNCTION, PANDIKKAD ROAD.",
      Mobile_No: "",
      Landline_No: 4832971957,
      Email: "",
      Pin_Code: 676121,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3485,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Kuriachira)",
      Contact_name: "",
      Store_Address: "DIGI PARK, MARIA PARK, EKM-TCR HIGHWAY, KURIACHIRA.",
      Mobile_No: 9446261056,
      Landline_No: "0487-2252322",
      Email: "",
      Pin_Code: 680006,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3486,
      Area: "South",
      States: "Kerala",
      City: "Alapuzha",
      Category: 1,
      Store_name: "NANDILATH G-MART(ALPY)",
      Contact_name: "",
      Store_Address:
        "NEHRU BHAVAN,NEWBAZAR \t, ALAPPUZHA, PIN: 688001462 \t, (SHIHAB)",
      Mobile_No: "",
      Landline_No: "0477-2251461,2251",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3487,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "BISMI CONNECT PVT LTD( Pallimukku)",
      Contact_name: "",
      Store_Address: "OPP: PITTAPPILLI AGENCIES, PALLIMUKKU.",
      Mobile_No: 7560888891,
      Landline_No: "",
      Email: "",
      Pin_Code: 691021,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3488,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Adimaly)",
      Contact_name: "",
      Store_Address: "OPP: ST JUDE CHURCH, KALLARKUTTY  ROAD, ADIMALY, IDUKKI.",
      Mobile_No: 7356715999,
      Landline_No: "04864-223199",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3489,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Pallimukku)",
      Contact_name: "",
      Store_Address: "OPP: USHAS AUDITORIUM, PALLIMUKKU.",
      Mobile_No: 7034135221,
      Landline_No: "0474-2726499",
      Email: "",
      Pin_Code: 691021,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3490,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "Capital Traders",
      Contact_name: "",
      Store_Address: "OUTERRING ROAD, NEAR BSNL OFFICE, GURUVAYOOR.",
      Mobile_No: 9847054488,
      Landline_No: "",
      Email: "",
      Pin_Code: 680101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3491,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "COCHIN SANIWARES(Pakalomattom)",
      Contact_name: "",
      Store_Address: "PAKALOMATTAM.",
      Mobile_No: 9745073333,
      Landline_No: "",
      Email: "",
      Pin_Code: 686633,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3492,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "PANAVELILHARDWARES",
      Contact_name: "",
      Store_Address: "PANAVELIL BUILDINGS, MAIN ROAD,  (SH 08).",
      Mobile_No: "",
      Landline_No: "04735-226250/225250",
      Email: "",
      Pin_Code: 689673,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3493,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "AURA HOME CENTRE",
      Contact_name: "",
      Store_Address: "#NA",
      Mobile_No: "",
      Landline_No: 510800700,
      Email: "",
      Pin_Code: 695301,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3494,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "MAYOORI FURNITURE AND ELECTRONICS(Kaniyapuram)",
      Contact_name: "",
      Store_Address: "AP/X-342/343/344, NEAR K S R T C DEPOT, KANIYAPURAM.",
      Mobile_No: "",
      Landline_No: 510800700,
      Email: "",
      Pin_Code: 695301,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3495,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "BISMI HOME APPLIANCES LLP (Thondayad)",
      Contact_name: "",
      Store_Address: "29/1899 A , A1, A2, MAVOOR ROAD, THONDAYAD, POTTAMMAL.",
      Mobile_No: 8281178825,
      Landline_No: "",
      Email: "",
      Pin_Code: 673016,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3496,
      Area: "South",
      States: "Kerala",
      City: "Kottayam",
      Category: 1,
      Store_name: "Pittappillil Agencies, Ktm",
      Contact_name: "",
      Store_Address: "POOKUDIYIL BLDG. S H MOUNT P.O.,NAGAMPADAM.",
      Mobile_No: "",
      Landline_No: 4821565477,
      Email: "",
      Pin_Code: 686006,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3497,
      Area: "South",
      States: "Kerala",
      City: "Kannur",
      Category: 1,
      Store_name: "REENA ENTERPRISES",
      Contact_name: "",
      Store_Address:
        "PP-XIII/13,14,15B,15C, KOOTTANAL BUILDING, KADATHUMKADAVU, IRITTY-POST, KANNUR.",
      Mobile_No: 9544732299,
      Landline_No: "",
      Email: "",
      Pin_Code: 670703,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3498,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "Sai Plywoods & Glass Emporium",
      Contact_name: "",
      Store_Address: "PUNALOOR ROAD, KUMBAZA, KIZHAKKUPURAM P O.",
      Mobile_No: 9496654207,
      Landline_No: "9400474669,",
      Email: "",
      Pin_Code: 689653,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3499,
      Area: "South",
      States: "Kerala",
      City: "Wayanad",
      Category: 1,
      Store_name: "E Planet,S.Btry",
      Contact_name: "",
      Store_Address: "RAHILM MEMORIAL RAOD, SULTHAN BATHERY.",
      Mobile_No: 9746905828,
      Landline_No: 9746905828,
      Email: "",
      Pin_Code: 673592,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3500,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "PITTAPPALIL AGENCIES(Kdnglr)",
      Contact_name: "",
      Store_Address: "NEAR ASHOKA THEATRE, SRINGAPURAM, KODUNGALLUR.",
      Mobile_No: 9249979882,
      Landline_No: "",
      Email: "",
      Pin_Code: 680664,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3501,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "SAGAR AGENCIES",
      Contact_name: "",
      Store_Address: "SAGAR COMPLEX, PUNALUR, ,KOLLAM",
      Mobile_No: 9539010190,
      Landline_No: "0475-2220043",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3502,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "PITTAPPILLY AGENCIES (Calicut)",
      Contact_name: "",
      Store_Address:
        "ALHIND  GRANDE, OPP: KTC HEAD OFFICE, KANNUR ROAD, CALICUT .",
      Mobile_No: 9539010190,
      Landline_No: "0495-2762999,",
      Email: "",
      Pin_Code: 673001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3503,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "NANDILATH G MART (Pattom TVM)",
      Contact_name: "",
      Store_Address: "SREEDHANYA BUILDING, KESAVADASPURAM, PATTOM.",
      Mobile_No: 8592080806,
      Landline_No: "0471-2559199/2558199/",
      Email: "",
      Pin_Code: 695004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3504,
      Area: "South",
      States: "Kerala",
      City: "Pathanamthitta",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES(Chengannur)",
      Contact_name: "",
      Store_Address:
        "ST. THOMAS ORTHODOX VALIYAPALLY COMPLEX, UMAYATTUKARA, KALLISSERY, CHENGNNUR.",
      Mobile_No: 7356717999,
      Landline_No: "0479-2429999",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3505,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "M/S IDEAL HOME APPLIANCES (BRANCH)",
      Contact_name: "",
      Store_Address: "T.C 50/2469, NEMOM.",
      Mobile_No: "",
      Landline_No: "0471 2393535",
      Email: "",
      Pin_Code: 695020,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3506,
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 1,
      Store_name: "NEW CHALAI AGENCIES",
      Contact_name: "",
      Store_Address:
        "TC36/1187, OPP: KAIRALI FORD, ENCHAKKAL, VALLKKADAVU PO, TRIVANDRUM-8.",
      Mobile_No: 8589000375,
      Landline_No: "0471 2502230/31",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3507,
      Area: "South",
      States: "Kerala",
      City: "Palakkad",
      Category: 1,
      Store_name: "SANZ",
      Contact_name: "",
      Store_Address: "NEAR RAILWAY GATE, WEST YAKKARA.",
      Mobile_No: 9895299088,
      Landline_No: "",
      Email: "",
      Pin_Code: 678001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3508,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "ETILITE KITCHEN & INTERIORS",
      Contact_name: "",
      Store_Address: "THEJUS BUILDING, PANGODU, PUTHOOR.",
      Mobile_No: 6282500130,
      Landline_No: "",
      Email: "",
      Pin_Code: 691507,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3509,
      Area: "South",
      States: "Kerala",
      City: "Kollam",
      Category: 1,
      Store_name: "Nandilath G Mart (Kngply)",
      Contact_name: "",
      Store_Address:
        "THEVARA BLDG., NO.3/2880/2,3,5,6, HIGH SCHOOL JN.,NEAR K.C. CENTRE.",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 690518,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3510,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "PITTAPPILLIL AGENCIES (MANJERI)",
      Contact_name: "",
      Store_Address:
        "TKM COMPLEX, NEAR MALABAR HOSPITAL, RAJIV GANDHI BYPASS ROAD, THURACKAL.",
      Mobile_No: 9895981999,
      Landline_No: "0483 2974999,",
      Email: "",
      Pin_Code: 676123,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3511,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "Nandilath G Mart (Cochin Br.)",
      Contact_name: "",
      Store_Address: "TOLL JUNCTION, EDAPALLY, ERNAKULAM.",
      Mobile_No: 9895293420,
      Landline_No: "",
      Email: "",
      Pin_Code: 682024,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3512,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 1,
      Store_name: "NANDILATH G MART (KATTAPANA)",
      Contact_name: "",
      Store_Address: "V 60A,60B, TOP GODOWN, IDUKKI ROAD.",
      Mobile_No: 6282902983,
      Landline_No: "04868 296006,",
      Email: "",
      Pin_Code: 685508,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3513,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "MANGATTIL TRADE LINKS PVT LTD(Tirur)",
      Contact_name: "",
      Store_Address: "TANUR ROAD,  NEAR K S E B SUB STATION, POOKAYIL .",
      Mobile_No: "",
      Landline_No: "0494-2425835",
      Email: "",
      Pin_Code: 676107,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3514,
      Area: "South",
      States: "Kerala",
      City: "Trichur",
      Category: 1,
      Store_name: "SUNCITY-BRANCH",
      Contact_name: "",
      Store_Address: "V-428-5,43,44, TUDA ROAD, KOLOTHUMPADAM, PERIGAUVE .",
      Mobile_No: 8921122414,
      Landline_No: "",
      Email: "",
      Pin_Code: 680022,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3515,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "HI DESIGN",
      Contact_name: "",
      Store_Address:
        "VEE PEE TOWER VP-21/170 G.H, N.H ROAD, KANCHIPPURA, KARIPPOL.",
      Mobile_No: "858 905 9004, 9072379999, 9207718930",
      Landline_No: "",
      Email: "",
      Pin_Code: 676552,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3516,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "VTJ Home  Decor",
      Contact_name: "",
      Store_Address: "VII/257B M C ROAD, CHORAKUZHY, KOOTHATTUKULAM.",
      Mobile_No: "9,645,566,718",
      Landline_No: 9447813618,
      Email: "",
      Pin_Code: 686662,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3517,
      Area: "South",
      States: "Kerala",
      City: "Malapuram",
      Category: 1,
      Store_name: "MAYOORI FURNITURE AND ELECTRONICS(NILAMBUR)",
      Contact_name: "",
      Store_Address: "EP 1290-1309, OOTTY MAIN ROAD, EDAKKARA, NILAMBUR",
      Mobile_No: 7592800700,
      Landline_No: "9288700600, 04931-275103",
      Email: "",
      Pin_Code: 679331,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3518,
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 1,
      Store_name: "HIGHRANGE HOME APPLIANCES (ELAPPARA)",
      Contact_name: "",
      Store_Address:
        "XIII/1060A , HILL HIGHWAY ROAD, OPP. PETROL PUMB, ELAPPARA.",
      Mobile_No: 9497278301,
      Landline_No: "",
      Email: "",
      Pin_Code: 685501,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3519,
      Area: "South",
      States: "Kerala",
      City: "Ernakulam",
      Category: 1,
      Store_name: "BISMI HOME APPLIANCES LLP(Angmly)",
      Contact_name: "",
      Store_Address: "VIJAYA ARCADE, NR. PRIVATE BUS STAND, ANGAMALY.",
      Mobile_No: "9544424555, 683672",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3520,
      Area: "North",
      States: "Haryana",
      City: "Panipat",
      Category: 1,
      Store_name: "Shree Krishna Electronics",
      Contact_name: "",
      Store_Address:
        "Main G.T. Road, Opp. Old Telephonic Exchange, Near Next Showroom, Panipat",
      Mobile_No: "9034428000, 9466200333",
      Landline_No: "",
      Email: "",
      Pin_Code: 132103,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3521,
      Area: "East",
      States: "West Bengal",
      City: "Dinajpur",
      Category: 1,
      Store_name: "Cucina Appliances",
      Contact_name: "Suranjit Kabiraj",
      Store_Address: "Yubashree More, Balurghat, Dakshin Dinajpur",
      Mobile_No: "9,47,47,34,56,59,47,49,00,000",
      Landline_No: "",
      Email: "cucinaapliances@gmail.com",
      Pin_Code: 733101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3522,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 2,
      Store_name: "Faber Platium Studio",
      Contact_name: "",
      Store_Address:
        "Shop No.5, Ground Floor, BCC Shakti Heights, Ayodhya Road, Opposite Parshvnath City, Uttardhona, Chinhat, Lucknow",
      Mobile_No: 9958292211,
      Landline_No: "0522-7118343",
      Email: "anupamsadashiv@gmail.com",
      Pin_Code: 226082,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3523,
      Area: "North",
      States: "West Bengal",
      City: "Darjeeling",
      Category: 1,
      Store_name: "New Chimney House",
      Contact_name: "",
      Store_Address:
        "2nd Floor Balajee Complex, Opp-Sonali Bank, Panitankli More Sevoke Road, Siliguri. District- Darjeeling",
      Mobile_No: "9832063104, 9474873901",
      Landline_No: "",
      Email: "newchimneyhouse@gmail.com",
      Pin_Code: 734001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3524,
      Area: "South",
      States: "Kerala",
      City: "Calicut",
      Category: 1,
      Store_name: "White Field Associates",
      Contact_name: "",
      Store_Address:
        "Bharath Towers, Opp:Narayana Petrol Pump, YMCA Cross Road, Calicut",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: "",
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3525,
      Area: "North",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "Kitchen Universe",
      Contact_name: "",
      Store_Address:
        "Shop  No. G- 4, TAWHEED COMPLEX, Ramnagri More, Digha, Asiana Road, Patna-800025",
      Mobile_No: 8877446611,
      Landline_No: "",
      Email: "",
      Pin_Code: 800025,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3526,
      Area: "North",
      States: "Bihar",
      City: "Muzaffarpur",
      Category: 1,
      Store_name: "Chulha Ghar",
      Contact_name: "",
      Store_Address:
        "Doma Pokhar, Bank Road, near Sutapatti, Sutapatti, Muzaffarpur",
      Mobile_No: 9471974700,
      Landline_No: "",
      Email: "",
      Pin_Code: 842001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3527,
      Area: "North",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address: "M-20, SK NAGAR",
      Mobile_No: 9204344444,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 800001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3528,
      Area: "West",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address: "JUGAL SMRITI,KHAJPURA, BAILEY ROAD, RAJA BAZAR, PATNA.",
      Mobile_No: 7004160512,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 800001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3529,
      Area: "West",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address: "ZAKARIAYARPUR,ZERO MILE, BY PASS ROAD, PATNA.",
      Mobile_No: 9264455204,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 800001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3530,
      Area: "West",
      States: "Bihar",
      City: "Patna",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address: "SAGUNA MORE, PATNA",
      Mobile_No: 9204052525,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 801503,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3531,
      Area: "West",
      States: "Bihar",
      City: "Darbhanga",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address:
        "ASHUTOSH COMPLEX, GM ROAD, MOHALLA SEPHULLAH GANJ, TOWN THANA ,WARD NO-6",
      Mobile_No: 8083799980,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 846004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3532,
      Area: "West",
      States: "Bihar",
      City: "Gaya",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address:
        "HOUSE No.01 , WARD No.-23, Opp. Fire Bridget Office, Swarajpuri Road , Gaya",
      Mobile_No: 8083998341,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 823001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3533,
      Area: "West",
      States: "Bihar",
      City: "Purnia",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address: "GROUND FLOOR & FIRST FLOOR, LINE BAZAR, PURNIA, BIHAR",
      Mobile_No: 7519998801,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 854301,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3534,
      Area: "West",
      States: "Bihar",
      City: "Muzaffarpur",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address: "BLOCK -C, STAR MARKET,\tCLUB ROAD, P.O-RAMNA, MITHANPURA",
      Mobile_No: 9798414224,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 842002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3535,
      Area: "West",
      States: "Bihar",
      City: "BRAHMPURA",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address: "NAKA CHOWK ,BRAHMPURA-MUZAFFARPUR",
      Mobile_No: 9798414224,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 842003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3536,
      Area: "West",
      States: "Bihar",
      City: "Bhagalpur",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address:
        "THE CHINMAYEE, RAI BAHADUR SUKHRAJ PATH, P.S :  BARARI, WARD NO : 24, BHAGALPUR",
      Mobile_No: 8083799901,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 812001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3537,
      Area: "West",
      States: "Bihar",
      City: "DANAPUR",
      Category: 1,
      Store_name: "ADITYA VISION LIMITED",
      Contact_name: "",
      Store_Address:
        "TRIBHUWAN PARK ,GOLA ROAD, NEAR BANK OF BARODA, DANAPUR, PATNA",
      Mobile_No: 9264495431,
      Landline_No: "",
      Email: "headoffice@adityavision.in",
      Pin_Code: 801503,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3538,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "ANONYA ELECTRONICS",
      Contact_name: "PRASUN MITRA",
      Store_Address: "35 B ,BALLYGUNJ GARDENS, Near Garia- Golpark Auto Stand",
      Mobile_No: 9804841455,
      Landline_No: "",
      Email: "2009.ankona@gmail.com",
      Pin_Code: 700029,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3539,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "J TOSH SANITATION PVT LTD",
      Contact_name: "DIPANWITA PAUL",
      Store_Address:
        "18 B,Ashutosh Mukherjee Rd,3 rd Floor,Shop no -323 HOMELAND MALL,Bhawanipur,Kolkata",
      Mobile_No: 8232034208,
      Landline_No: 9674144866,
      Email: "jtosh2011@gmail.com",
      Pin_Code: 700020,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3540,
      Area: "West",
      States: "West Bengal",
      City: "Cooch Beher",
      Category: 1,
      Store_name: "KITCH-SAFE ASSOCIATES",
      Contact_name: "HIRAK BASU",
      Store_Address:
        "B S Road (NORTH),COOCH BEHAR, COOCH BEHAR Opp DADA VAI PRESS",
      Mobile_No: 9614250468,
      Landline_No: 9832057973,
      Email: "hirakbasuslg60@gmail.com",
      Pin_Code: 736101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3541,
      Area: "East",
      States: "West Bengal",
      City: "BARDDHAMAN",
      Category: 1,
      Store_name: "GLACIER REFRIGERATION",
      Contact_name: "GIRISH BHUTORIA",
      Store_Address:
        "22 K C BOSE LANE, RADHANAGAR,SASTI TALA, PURBA BARDDHAMAN.",
      Mobile_No: 9733258483,
      Landline_No: "",
      Email: "glacierrefrigeration20@gmail.com",
      Pin_Code: 713101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3542,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "FABER GALLERIA",
      Contact_name: "MS AMRITA",
      Store_Address:
        "SHOPE NO- A-217, CC-2 MALL, 2nd FLOOR, RAJARHAT. NEWTOWN ,KOLKATA-700156",
      Mobile_No: "7439635994 / 9088655590",
      Landline_No: "",
      Email: "faber.adm@gmail.com",
      Pin_Code: 700156,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3543,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "JAJABAR TRADING CORPORATION",
      Contact_name: "MR SANDEEP",
      Store_Address: "257/1 S.N.ROY ROAD. KOLKATA-700038.",
      Mobile_No: "7003680692/8335069840",
      Landline_No: "",
      Email: "jtc.jio@gmail.com",
      Pin_Code: 700038,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3544,
      Area: "East",
      States: "West Bengal",
      City: "Kalyani",
      Category: 1,
      Store_name: "MAA TARA ENTERPRISE",
      Contact_name: "MR HIMANSHU NANDI",
      Store_Address: "B-8/96 KALYANI.NADIA. NADIA-741235",
      Mobile_No: "9681084301/9433418464",
      Landline_No: "",
      Email: "himanshu.nandi@gmail.com",
      Pin_Code: 741235,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3545,
      Area: "East",
      States: "West Bengal",
      City: "Haldia",
      Category: 1,
      Store_name: "ROYAL AQUA SERVICE CENTRE",
      Contact_name: "MR TAPAN JANA",
      Store_Address: "BRAJANATHCHAK. 13 MORE . HALDIA PORT. HALDIA- 721605",
      Mobile_No: 9064402792,
      Landline_No: "",
      Email: "tapanjanarasc@gmail.com",
      Pin_Code: 721605,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3546,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "SUNY MARBLES & TIELS",
      Contact_name: "MR ABDUL JALAL",
      Store_Address: "FARTABAD. DAS PARA .SOUTH MIDDLE. KOLKATA",
      Mobile_No: 9830494821,
      Landline_No: "",
      Email: "sunymarbletiles@gmail.com",
      Pin_Code: 700084,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3547,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "M. G . ELECTRONICS",
      Contact_name: "MR MANISH GUPTA",
      Store_Address: "CA-7, DESHBANDHU NAGAR. BAGUIATI. KOLKATA- 700059",
      Mobile_No: 9831120868,
      Landline_No: "",
      Email: "mgelectronics10@gmail.com",
      Pin_Code: 700059,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3548,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "M. G . ELECTRONICS(VIP)",
      Contact_name: "MR SUVO GUPTA",
      Store_Address:
        "SHOP NO - 3.BLOCK-1. SHRIRAM NAGAR. VIP ROAD. KOLKATA-700052",
      Mobile_No: 9903332545,
      Landline_No: "",
      Email: "mgelectronics10@gmail.com",
      Pin_Code: 700052,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3549,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "M. G . ELECTRONICS",
      Contact_name: "MR SANDEEP PAUL",
      Store_Address: "32/506 M B ROAD. BIRATI. KOLKATA-700051",
      Mobile_No: "7439576617/7980207181",
      Landline_No: "",
      Email: "mgelectronics10@gmail.com",
      Pin_Code: 700051,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3551,
      Area: "North",
      States: "Haryana",
      City: "Ambala Cantt",
      Category: 2,
      Store_name: "Madaan Electronics",
      Contact_name: "",
      Store_Address:
        "S.C.O. 4&5, Near Punjab Kesri, Jagadhri Road, Ambala Cantt",
      Mobile_No: 9215603303,
      Landline_No: "",
      Email: "madaanelectronics@gmail.com",
      Pin_Code: 133001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3552,
      Area: "South",
      States: "Telangana",
      City: "Secunderabad",
      Category: 2,
      Store_name: "4 S Kitchen Galaxy",
      Contact_name: "Mr Suresh",
      Store_Address:
        "Plot no. 3, NCL Enclave, Near Dominus, Pet basheerbad, Kompally",
      Mobile_No: 9618180606,
      Landline_No: "040-35161090/35161091",
      Email: "sailajadamera@gmail.com",
      Pin_Code: 500067,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3553,
      Area: "East",
      States: "Odisha",
      City: "Balangir",
      Category: 1,
      Store_name: "Shree Shyamji Plywood",
      Contact_name: "Shaswat Kumar Agrawal",
      Store_Address:
        "Ground Floor, Shop No 2, Vijay Arcade, Rugudi Pada, Balangir, Odisha - 767001",
      Mobile_No: 9439208415,
      Landline_No: "",
      Email: "",
      Pin_Code: 767001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3554,
      Area: "North west",
      States: "Rajasthtan",
      City: "Jaipur",
      Category: 1,
      Store_name: "A. AGENCIES",
      Contact_name: "",
      Store_Address: "1/69, VIDYADHAR NAGAR, BEHIND AGRAWAL CATTERS,",
      Mobile_No: 9351952133,
      Landline_No: "",
      Email: "",
      Pin_Code: 302039,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3555,
      Area: "North west",
      States: "Rajasthan",
      City: "Alwar",
      Category: 1,
      Store_name: "Mittal Bath Collection",
      Contact_name: "",
      Store_Address: "Purana Station Road,",
      Mobile_No: 9351952133,
      Landline_No: "",
      Email: "",
      Pin_Code: 301001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3556,
      Area: "North",
      States: "Punjab",
      City: "Moga",
      Category: 1,
      Store_name: "Ganpati Enterprises",
      Contact_name: "Mr Pankaj Kumar",
      Store_Address:
        "Khasara No. 1308 ,3-18,Khewat No. 1185,Kahatuni No. 1646,Nehru mandi Road ,Bagha Purana",
      Mobile_No: 9814477443,
      Landline_No: "",
      Email: "",
      Pin_Code: 142038,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3557,
      Area: "North",
      States: "Punjab",
      City: "Abohar",
      Category: 1,
      Store_name: "Gian Chand Lakshman Dass",
      Contact_name: "Mr Raghav",
      Store_Address: "Lakarh Mandi, Main Bazar, Abohar",
      Mobile_No: 9780859900,
      Landline_No: "",
      Email: "",
      Pin_Code: 152116,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3558,
      Area: "North",
      States: "Punjab",
      City: "Khanna",
      Category: 1,
      Store_name: "RS Electronics",
      Contact_name: "Mr Sachin",
      Store_Address:
        "old cinema road, Ward Number 27, Shiv Puri Muhalla, Pratap Colony",
      Mobile_No: 9814520518,
      Landline_No: "",
      Email: "",
      Pin_Code: 141401,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3559,
      Area: "West",
      States: "Gujarat",
      City: "Ahemdabad",
      Category: 2,
      Store_name: "Faber Platinum Studios",
      Contact_name: "",
      Store_Address:
        "FF-109,Shivalik Arcade,  Below Skyz Restaurant, Opp.Timber Point, Prahladnagar,",
      Mobile_No: 8238118989,
      Landline_No: "",
      Email: "faberplatinumahd@gmail.com",
      Pin_Code: 380015,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3560,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 2,
      Store_name: "Digital Gadgets",
      Contact_name: "Amjad",
      Store_Address: "GF-16 The Plaza Mall, MG Road",
      Mobile_No: 9654997998,
      Landline_No: "",
      Email: "digitalgadgets.gurgaon@gmail.com",
      Pin_Code: 122002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3561,
      Area: "North",
      States: "Haryana",
      City: "Sirsa",
      Category: 2,
      Store_name: "Rama Electronics",
      Contact_name: "Newton",
      Store_Address: "Sadar Bazar- Sirsa",
      Mobile_No: 9254051154,
      Landline_No: "",
      Email: "Ramaelectronics@yahoo.com",
      Pin_Code: 125055,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3562,
      Area: "North",
      States: "Haryana",
      City: "Rohtak",
      Category: 1,
      Store_name: "National Traders",
      Contact_name: "Vikas",
      Store_Address: "Civil Road Near Misri Devi Hospital",
      Mobile_No: 9416053663,
      Landline_No: "",
      Email: "nationalrohtak@gmail.com",
      Pin_Code: 124406,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3563,
      Area: "North",
      States: "Delhi",
      City: "Delhi",
      Category: 2,
      Store_name: "Amba Prosperity",
      Contact_name: "",
      Store_Address:
        "34, Second Floor, Defence Enclave, (Main road, Opposite Preet Vihar Petrol pump) Delhi",
      Mobile_No: 9810060631,
      Landline_No: "",
      Email: "",
      Pin_Code: 110092,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3564,
      Area: "South",
      States: "Tamil Nadu",
      City: "SALEM",
      Category: 2,
      Store_name: "PARAMOUNT INDIA ASSOCIATES",
      Contact_name: "",
      Store_Address:
        "284, SARADHA COLLEGE ROAD, NEW FAIRLANDS, PILLAR.NO-38, SALEM",
      Mobile_No: 7399874998,
      Landline_No: "",
      Email: "",
      Pin_Code: 636016,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3565,
      Area: "North",
      States: "West Bengal",
      City: "Madhyamgram",
      Category: 1,
      Store_name: "R S Enterprise",
      Contact_name: "",
      Store_Address:
        "122/2,Sodepur Road, Madhyamgram, Beside United Bank of India.",
      Mobile_No: "9830955386 / 7980301881",
      Landline_No: "",
      Email: "",
      Pin_Code: 700129,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3566,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Life N style",
      Contact_name: "",
      Store_Address: "70, Theatre Road ( Shakespeare Sarani), Kolkata",
      Mobile_No: "8697261580 / 9231657941",
      Landline_No: 3340717104,
      Email: "",
      Pin_Code: 700016,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3567,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Kanpur",
      Category: 1,
      Store_name: "Dream Kitchen",
      Contact_name: "",
      Store_Address: "123/301, Kalpi Road, Fazalganj, Kanpur",
      Mobile_No: "8299338940/ 7905152122",
      Landline_No: "",
      Email: "dreamkitchenkanpur@gmail.com",
      Pin_Code: 208005,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3568,
      Area: "North",
      States: "Haryana",
      City: "Sonipat",
      Category: 1,
      Store_name: "Singla Hardware & Sanitary Interio",
      Contact_name: "",
      Store_Address:
        "Near Tata Motor Showroom, Opp. Industrial Area, Old Rohtak Road, Near Railway Over Bridge, Sonipat",
      Mobile_No: "8053477033 / 9354388555",
      Landline_No: "",
      Email: "",
      Pin_Code: 133001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3569,
      Area: "West",
      States: "West Bengal",
      City: "Raghunathganj",
      Category: 1,
      Store_name: "Himel Enterprise",
      Contact_name: "",
      Store_Address:
        "Paandey Market Complex, Opposite Raghunathganj  Bus Stop, Dist;- Murshidabad",
      Mobile_No: "9564244700 / 9732551250",
      Landline_No: "",
      Email: "mujaffarhossainflp@gmail.com",
      Pin_Code: 742225,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3570,
      Area: "South",
      States: "Karnataka",
      City: "Mysore",
      Category: 2,
      Store_name: "M/S.SUMUKHA ELECTRONICS & APPLIANCES",
      Contact_name: "",
      Store_Address:
        "280,1ST FLOOR,M-121,KR HOSPITAL MAIN ROAD,MANDI MOHALLA,\nMYSORE",
      Mobile_No: 9448075598,
      Landline_No: "",
      Email: "SUMUKHAELECTRONICSANDAPP@GMAIL.COM",
      Pin_Code: 570001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3571,
      Area: "West",
      States: "Gujarat",
      City: "Vadodara",
      Category: 1,
      Store_name: "Faber Gallery",
      Contact_name: "Mr. Ashok Gandhani & Mr. Jayant Gandhani",
      Store_Address:
        "101, Narayan Elegance, Beside Axis Bank, Near Sangam Char Rasta, Harni Road, Vadodara",
      Mobile_No: "9904837600 / 7567756717",
      Landline_No: "",
      Email: "jayantgandhani@gmail.com",
      Pin_Code: 390022,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3572,
      Area: "North East",
      States: "Jharkhand",
      City: "Ranchi",
      Category: 1,
      Store_name: "Kitchen Paradise",
      Contact_name: "Nilesh Chouhan",
      Store_Address: "Near Sarjana Chowk, Lalji Hirji Road & Main Road, Ranchi",
      Mobile_No: 8406800325,
      Landline_No: "",
      Email: "kitchen.paradise1@gmail.com",
      Pin_Code: 834001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3573,
      Area: "North East",
      States: "Jharkhand",
      City: "Ranchi",
      Category: 1,
      Store_name: "M/S KITCHEN KONCEPT",
      Contact_name: "Tushit Thard",
      Store_Address: "Line tank road, Ranchi, Jharkhand",
      Mobile_No: "9431101059 , 9570070704",
      Landline_No: "",
      Email: "director@kitchenkoncept.in",
      Pin_Code: 834001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3574,
      Area: "North East",
      States: "Jharkhand",
      City: "Jamshedpur",
      Category: 1,
      Store_name: "KITCHEN WORLD",
      Contact_name: "Somnath Bala",
      Store_Address:
        "107, Jambu Tower Near Hunumanjee Mandir Main road bhalubasa, Jamshedpur",
      Mobile_No: 9234465748,
      Landline_No: "",
      Email: "kitchenworldjsr@gmail.com",
      Pin_Code: 831009,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3575,
      Area: "North East",
      States: "Jharkhand",
      City: "Hazaribagh",
      Category: 1,
      Store_name: "KITCHEN KINGDOM",
      Contact_name: "Hitlar Sahi",
      Store_Address:
        "Sawarnkar Bhawan Building Gola Road Baddam Bazar, Hazaribagh Plot No Part A-340, Pin..",
      Mobile_No: 7004093687,
      Landline_No: "",
      Email: "shahibabu2012@gmail.com",
      Pin_Code: 825301,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3576,
      Area: "North East",
      States: "Jharkhand",
      City: "Jamshedpur",
      Category: 1,
      Store_name: "JAIN CLASSES",
      Contact_name: "Dimple Jain",
      Store_Address:
        "2nd Floor, HOLDING No. NIL,  Dey COMPLEX, OUTER CIRCLE ROAD, JAMESHDPUR",
      Mobile_No: 8409436880,
      Landline_No: "",
      Email: "urbanspacesjsr@gmail.com",
      Pin_Code: 831001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3578,
      Area: "East",
      States: "Jharkhand",
      City: "Bokaro",
      Category: 1,
      Store_name: "AMRAPALI",
      Contact_name: "SANJAY GUPTA",
      Store_Address:
        "Plot No. E/04, City Centre, Sector -4, Bokaro Steel City, Bokaro",
      Mobile_No: 9798060763,
      Landline_No: "",
      Email: "sanjay.amrapali@gmail.com",
      Pin_Code: 827004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3579,
      Area: "East",
      States: "Jharkhand",
      City: "Jamshedpur",
      Category: 1,
      Store_name: "STC ASSOCIATES",
      Contact_name: "Rahman",
      Store_Address:
        "Upper Side of HDFC Bank,Main road, Azad Nagar, Chepapul,Mango, Jameshdpur",
      Mobile_No: 7004376229,
      Landline_No: "",
      Email: "stc111213@gmail.com",
      Pin_Code: 831012,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3580,
      Area: "East",
      States: "Jharkhand",
      City: "Dhanbad",
      Category: 1,
      Store_name: "SRI SHYAM PLY",
      Contact_name: "Prakash Agarwal",
      Store_Address:
        "PLOT No. 1442, Mauza-Nawadih No - 02, Hirak Road, Binod Bihari Mahato Chowk, Nawadih, Dhanbad,",
      Mobile_No: 7004085497,
      Landline_No: "",
      Email: "agarwalprakesh@gmail.com",
      Pin_Code: 828105,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3581,
      Area: "East",
      States: "Jharkhand",
      City: "Daltongunj",
      Category: 1,
      Store_name: "RATAN ELECTRONICS",
      Contact_name: "Prem  Namdhari",
      Store_Address: "Ratan electronics, Vishnu Mandir",
      Mobile_No: 9771201987,
      Landline_No: "",
      Email: "ratanelectronic@gmail.com",
      Pin_Code: 822101,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3583,
      Area: "South",
      States: "Karnataka",
      City: "BANGALORE",
      Category: 2,
      Store_name: "AKANSHA ENTERPRISES",
      Contact_name: "",
      Store_Address:
        "97/2,APOORVA COMPLEX,BANNERGHATTA ROAD\nOPP-D MART,GOTTIGERE",
      Mobile_No: 8217884706,
      Landline_No: "",
      Email: "",
      Pin_Code: 560083,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3584,
      Area: "South",
      States: "Karnataka",
      City: "BANGALORE",
      Category: 2,
      Store_name: "VEDH INTERIORS",
      Contact_name: "",
      Store_Address: "74,BELLARY MAIN ROAD,GANGANAGAR",
      Mobile_No: 9380525134,
      Landline_No: "",
      Email: "",
      Pin_Code: 560024,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3585,
      Area: "South",
      States: "Karnataka",
      City: "BANGALORE",
      Category: 2,
      Store_name: "OUTINTERIORS STUDIO",
      Contact_name: "",
      Store_Address: "VENKATASWAMY REDDY LAYOUT, KORAMANGALA, 80FT ROAD",
      Mobile_No: 9019961814,
      Landline_No: "",
      Email: "",
      Pin_Code: 560034,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3586,
      Area: "South",
      States: "Karnataka",
      City: "BANGALORE",
      Category: 2,
      Store_name: "OAK VILLE",
      Contact_name: "",
      Store_Address:
        "19/20/21,CN COMPLEX,1ST FLOOR,DR.VISHNUVARDHAN ROAD, CHANNASANDRA,NEAT RNS COLLEGE,RAJARAJESHWARI NAGAR",
      Mobile_No: 9606028318,
      Landline_No: "",
      Email: "",
      Pin_Code: 560098,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3587,
      Area: "South",
      States: "Karnataka",
      City: "BANGALORE",
      Category: 2,
      Store_name: "IDEAS",
      Contact_name: "",
      Store_Address:
        "#5,GROUND FLOOR,100 FEET MAIN ROAD, OPP BARBEQUE NATION,HAL 2ND STAGE\nINDIRANAGAR",
      Mobile_No: 9900863033,
      Landline_No: "",
      Email: "",
      Pin_Code: 560038,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3588,
      Area: "South",
      States: "Karnataka",
      City: "BANGALORE",
      Category: 1,
      Store_name: "GOWTHAM ENTERPRISES",
      Contact_name: "",
      Store_Address:
        "SHOP NO 7,GROUND FLOOR PUTTADAS COMMERICAL COMPLEX, NO:42,13TH CROSS ROAD,WKP ROAD,7TH BLOCK JAYANAGAR",
      Mobile_No: 7483468062,
      Landline_No: "",
      Email: "",
      Pin_Code: 560070,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3589,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 1,
      Store_name: "Kamal Enterprises",
      Contact_name: "",
      Store_Address: "CG -63 Arcadia South City 2",
      Mobile_No: "7,00,48,84,38,17,83,83,00,000",
      Landline_No: "",
      Email: "99kamal@gmail.com",
      Pin_Code: 122018,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3590,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Agra",
      Category: 1,
      Store_name: "Habova store",
      Contact_name: "",
      Store_Address: "Shop no-7 Taj Road sadar bazar",
      Mobile_No: 9756954665,
      Landline_No: "",
      Email: "",
      Pin_Code: 282001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3591,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Agra",
      Category: 1,
      Store_name: "VK Bartan Bhandhar",
      Contact_name: "",
      Store_Address:
        "Shop no:1-B/1 ram nagar colony church road, sursadan chauraha",
      Mobile_No: 9319206649,
      Landline_No: "",
      Email: "",
      Pin_Code: 282002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3592,
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Smiley Kitchen",
      Contact_name: "",
      Store_Address:
        "2/22B. Vidyasagar Upanibesh,Ganguly Bagan (South  Kolkata)",
      Mobile_No: "9748931412/7003793382",
      Landline_No: "",
      Email: "smileykitchen05@gmail.com",
      Pin_Code: 700047,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3593,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Agra",
      Category: 3,
      Store_name: "SLR distributor",
      Contact_name: "",
      Store_Address:
        "Bypass road opp. NRL hyundai langde ki chawki , Agra, Uttar Pradesh-",
      Mobile_No: 9808951970,
      Landline_No: "",
      Email: "",
      Pin_Code: 282004,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3594,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Bulandshahr",
      Category: 3,
      Store_name: "Mohit Muskan",
      Contact_name: "",
      Store_Address:
        "mohit muskan moti bagh telephone exchange , Bulandshahr, Uttar Pradesh -202123",
      Mobile_No: 9358008000,
      Landline_No: "",
      Email: "",
      Pin_Code: 202123,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3595,
      Area: "East",
      States: "West Bengal",
      City: "Durgapur",
      Category: 1,
      Store_name: "Orchid",
      Contact_name: "Tapan Shutradhar",
      Store_Address: "Harshabardhan Road, Benachity, Durgapur",
      Mobile_No: 8436242173,
      Landline_No: "",
      Email: "orchid.durgapur@gmail.com",
      Pin_Code: 713213,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3596,
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 2,
      Store_name: "Mother Kitchen Appliances",
      Contact_name: "",
      Store_Address:
        "Shop No-4, Near Mahavir Timber, Bhatar Char Rasta, Bhatar, Surat-7",
      Mobile_No: 9327074562,
      Landline_No: "",
      Email: "surat.motherkitchen@gmail.com",
      Pin_Code: 395017,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3597,
      Area: "West",
      States: "Gujarat",
      City: "Gandhidham",
      Category: 2,
      Store_name: "Shridhar Minerals Pvt Ltd",
      Contact_name: "",
      Store_Address: "Opp. IFFCO Colony, Uday Nagar, Gandhidham",
      Mobile_No: "+91 7567770707",
      Landline_No: "",
      Email: "smpl4023@gmail.com",
      Pin_Code: 370201,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3598,
      Area: "West",
      States: "Gujarat",
      City: "Bhavnagar",
      Category: 3,
      Store_name: "Manisha enterprise",
      Contact_name: "",
      Store_Address:
        "Shop no g- 9, swarankan complex, divdi chowk, rupani, Bhavnagar",
      Mobile_No: 9376515454,
      Landline_No: "",
      Email: "",
      Pin_Code: 364001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3599,
      Area: "West",
      States: "Maharashtra",
      City: "Malegaon",
      Category: 3,
      Store_name: "Prashant Electronics & Appliances",
      Contact_name: "",
      Store_Address:
        "Shop No. 1,2 , Santosh Arcade , Near icici bank Sivaji Putla, Malegaon",
      Mobile_No: 9823265107,
      Landline_No: "",
      Email: "prashantele07@gmail.com",
      Pin_Code: 423203,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3600,
      Area: "West",
      States: "Maharashtra",
      City: "Dhule",
      Category: 1,
      Store_name: "Kalyani Electronics",
      Contact_name: "",
      Store_Address:
        "Shop No 57- Municipal Complex, Lalbaug, Dhule, Near Municipal Corporation, Near Jhansi Rani Statue",
      Mobile_No: 9420439111,
      Landline_No: "",
      Email: "kalyanielectronics@rediffmail.com",
      Pin_Code: 424001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3601,
      Area: "East",
      States: "West Bengal",
      City: "Basirhat",
      Category: 1,
      Store_name: "Nazma Water Solution",
      Contact_name: "",
      Store_Address: "S N Majumdar Road, Sain Pala, Moylakhola,North 24 Pgs",
      Mobile_No: "8420203999/8420203777",
      Landline_No: "",
      Email: "",
      Pin_Code: 743412,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3602,
      Area: "East",
      States: "West Bengal",
      City: "Habra",
      Category: 1,
      Store_name: "Bharat Gas",
      Contact_name: "M/S Mita Biswas",
      Store_Address: "Habra",
      Mobile_No: "8277831177/8335069840",
      Landline_No: "",
      Email: "",
      Pin_Code: 743263,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3603,
      Area: "East",
      States: "Odisha",
      City: "Talcher",
      Category: 1,
      Store_name: "Kitchen Decorator",
      Contact_name: "",
      Store_Address: "Hatatota By Pass Chawk",
      Mobile_No: "7894427389/9937480085",
      Landline_No: "",
      Email: "",
      Pin_Code: 759100,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3604,
      Area: "East",
      States: "Odisha",
      City: "Bhubaneswar",
      Category: 1,
      Store_name: "Sai Shree Traders",
      Contact_name: "Mr. Dusmanta Kumar Singh",
      Store_Address:
        "Plot No. - 458, K-3, Near Chandaka Fresh, Ghatikia, Kalinga Nagar, Bhubaneswar",
      Mobile_No: 6372774055,
      Landline_No: "",
      Email: "saishreetraders19@gmail.com",
      Pin_Code: 751019,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3605,
      Area: "East",
      States: "Odisha",
      City: "Jharsuguda",
      Category: 1,
      Store_name: "Khandelwal Pipes 'N' Tiles",
      Contact_name: "Mr. Himanshu Khandelwal",
      Store_Address: "Opposite HDFC Bank, Sarbahal Road, Jharsuguda",
      Mobile_No: 8018883024,
      Landline_No: "",
      Email: 8018883024,
      Pin_Code: 768201,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3606,
      Area: "South",
      States: "Tamil Nadu",
      City: "Coimbatore",
      Category: 1,
      Store_name: "SREE HOME SOLUTION",
      Contact_name: "",
      Store_Address:
        "No-300 Chithambaram Nagar , Sathy road ,Saravanampatty , Coimbatore",
      Mobile_No: 9363150509,
      Landline_No: "",
      Email: "",
      Pin_Code: 641035,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3607,
      Area: "North",
      States: "West Bengal",
      City: "Kolkata",
      Category: 1,
      Store_name: "Bosky Furniture Modular Kitchen & Interior",
      Contact_name: "",
      Store_Address:
        "Axis mall, Shop No 237 & 238 2nd floor, Street Number 106, Action Area I, Newtown,",
      Mobile_No: "098300 06424",
      Landline_No: "",
      Email: "",
      Pin_Code: 700156,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3608,
      Area: "North",
      States: "Haryana",
      City: "PANIPAT",
      Category: 2,
      Store_name: "GROVER ENTERPRISES",
      Contact_name: "",
      Store_Address: "SHOP No.1,NEAR RED LIGHT CHOWK,ASSANDH ROAD,",
      Mobile_No: "9812063223 , 9812432303",
      Landline_No: "",
      Email: "",
      Pin_Code: 132103,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3609,
      Area: "North",
      States: "Haryana",
      City: "AMBALA CANTT",
      Category: 2,
      Store_name: "MADAAN ELECTRONICS",
      Contact_name: "",
      Store_Address: "SHOP No.2,NEAR PUNJAB KESRI,JAGADHRI ROAD",
      Mobile_No: "9215603303, 9817353036",
      Landline_No: "",
      Email: "",
      Pin_Code: 133001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3610,
      Area: "North",
      States: "Haryana",
      City: "SONIPAT",
      Category: 3,
      Store_name: "SHIVYUG ENTERPRISES",
      Contact_name: "",
      Store_Address: "GROUND FLOOR,SHOP No.197,SIKKA COLONY,DELHI ROAD",
      Mobile_No: "9810630739, 9911095849",
      Landline_No: "",
      Email: "",
      Pin_Code: 131001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3611,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "Bhopal",
      Category: 2,
      Store_name: "Prayas Commercial",
      Contact_name: "Mr Aggarwal",
      Store_Address: "2/2 Shanti Niketan Near Chetak Bridge, Bhopal (M.P.)",
      Mobile_No: 9827057876,
      Landline_No: "",
      Email: "prayascommercial@yahoo.com",
      Pin_Code: 400023,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3612,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "Jabalpur",
      Category: 2,
      Store_name: "Shrivika Enterprises",
      Contact_name: "",
      Store_Address: "2/2 Shanti Niketan Near Chetak Bridge, Bhopal (M.P.)",
      Mobile_No: 9827057876,
      Landline_No: "",
      Email: "",
      Pin_Code: 400023,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3613,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "INDORE",
      Category: 2,
      Store_name: "S.R. TRADE & MARKETING",
      Contact_name: "ROHAN SETHI",
      Store_Address:
        "UG-4 PLOT NO. 8 PU4 BEHIND INDIAN OIL PETROL PUMP RASOMA SQUARE SCH.NO. 54",
      Mobile_No: "94253-17662, 94253-18617",
      Landline_No: "",
      Email: "srtradeandmarketing@gmail.com",
      Pin_Code: 452001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3614,
      Area: "Central",
      States: "Madhya Pradesh",
      City: "Indore",
      Category: 1,
      Store_name: "Sethi Enterprises",
      Contact_name: "",
      Store_Address:
        "Shop no 103 \nPlot no 8, PU4 behind indian oil petrol pump rasoma choraha , scheme no 54",
      Mobile_No: 9425318617,
      Landline_No: "",
      Email: "sethicement@yahoo.in",
      Pin_Code: 452010,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3615,
      Area: "North East",
      States: "Jharkhand",
      City: "Deoghar",
      Category: 1,
      Store_name: "M/S SWAMI PLY",
      Contact_name: "Ashish",
      Store_Address: "R R BAKSHI ROAD, DEOGHAR",
      Mobile_No: 7991133962,
      Landline_No: "",
      Email: "alwaysasish@gmail.com",
      Pin_Code: 814112,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3616,
      Area: "North East",
      States: "Jharkhand",
      City: "Giridih",
      Category: 1,
      Store_name: "M/S PRADIP ELECTRIC STORES",
      Contact_name: "Nishant",
      Store_Address: "Vidya Laxmi Tower Makatpur Giridih",
      Mobile_No: 7631060900,
      Landline_No: "",
      Email: "pes.grd@gmail.com",
      Pin_Code: 815301,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3617,
      Area: "North East",
      States: "Jharkhand",
      City: "Dhanbad",
      Category: 1,
      Store_name: "RAMAYAN TILES",
      Contact_name: "Suman",
      Store_Address: "C/O BASUDEO MAHTO, TELI TOLA, BARORA, DHANBAD,",
      Mobile_No: 7838851153,
      Landline_No: "",
      Email: "ksuman1018@gmail.com",
      Pin_Code: 828306,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3618,
      Area: "North East",
      States: "Jharkhand",
      City: "Dhanbad",
      Category: 1,
      Store_name: "SWASTIK ENTERPRISES",
      Contact_name: "Sahu",
      Store_Address: "G.T.Road Nirsa, Nirsa, Dhanbad",
      Mobile_No: 9334224999,
      Landline_No: "",
      Email: "sahutelecom.nirsha@gmail.com",
      Pin_Code: 828205,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3619,
      Area: "East",
      States: "Odisha",
      City: "Berhampur",
      Category: 1,
      Store_name: "Shristi Distributors",
      Contact_name: "",
      Store_Address: "Bisoyi House, Dalua Street, Berhampur,",
      Mobile_No: 8270388888,
      Landline_No: "",
      Email: "shristidistributors888@gmail.com",
      Pin_Code: 760001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3620,
      Area: "East",
      States: "Odisha",
      City: "Berhampur",
      Category: 1,
      Store_name: "G S Enterprises",
      Contact_name: "",
      Store_Address:
        "Khata No. 257/396, Plot No. - 179,Tulasi Nagar, 5th Lane, Aska Road, Berhampur",
      Mobile_No: 7978646833,
      Landline_No: "",
      Email: "gsenterprises.berhampur@gmail.com",
      Pin_Code: 760001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3621,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Lucknow",
      Category: 2,
      Store_name: "Faber Platinum Studio",
      Contact_name: "",
      Store_Address:
        "First Floor, Hanumant Tower ,Arjunganj Market, Near HDFC Bank,\n\nSultanpur Road",
      Mobile_No: "7379777674 , 9315321813",
      Landline_No: "",
      Email: "faberstudio@ecosolutionslucknow.com",
      Pin_Code: 226002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3622,
      Area: "North",
      States: "Haryana",
      City: "Rohtak",
      Category: 1,
      Store_name: "City Palace",
      Contact_name: "Surender",
      Store_Address: "Shop no 51 , Civil Road, Palika Bazar,",
      Mobile_No: 9416349745,
      Landline_No: "",
      Email: "citypalace51@gmail.com",
      Pin_Code: 124001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3623,
      Area: "North",
      States: "Haryana",
      City: "Hisar",
      Category: 2,
      Store_name: "Trimurti Enterprises",
      Contact_name: "Atul",
      Store_Address: "Jindal Hospital Road, near Jindal Chowk",
      Mobile_No: 98120077244,
      Landline_No: "",
      Email: "trimurtienterprises@ymail.com",
      Pin_Code: 125001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3624,
      Area: "North",
      States: "Haryana",
      City: "Gurgaon",
      Category: 2,
      Store_name: "AB Enterperises",
      Contact_name: "Abhishek",
      Store_Address:
        "First Floor Shop No 104, Pal Tower, MG Road\nMetro Piller No 53 Sikanderpur",
      Mobile_No: "9354735843/ 01244952347",
      Landline_No: "",
      Email: "abenterprises1021@gmail.com",
      Pin_Code: 122002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3625,
      Area: "North",
      States: "Haryana",
      City: "Rewari",
      Category: 1,
      Store_name: "Hindustan Bath Tiles & Light Emporium Dharuhera",
      Contact_name: "Arvind",
      Store_Address: "Opp Ambedkar Park Sohna Road , Dharuheda",
      Mobile_No: 9896521110,
      Landline_No: "",
      Email: "arvindrao7319@gmail.com",
      Pin_Code: 123106,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3626,
      Area: "North",
      States: "Haryana",
      City: "Bhiwani",
      Category: 1,
      Store_name: "RK Chemicals & Tools",
      Contact_name: "Ratankumar",
      Store_Address:
        "Near Bhagat Singh Chowk, Meham Road,\nIndra Colony, Opp Sector 23, Bhiwani",
      Mobile_No: 8708678127,
      Landline_No: "",
      Email: "ratankumartilemaster@gmail.com",
      Pin_Code: 127021,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3627,
      Area: "North",
      States: "Uttrakhand",
      City: "Dehradun",
      Category: 2,
      Store_name: "KRIVI & COMAPANY",
      Contact_name: "",
      Store_Address: "6 CROSS ROAD,DEHRADUN",
      Mobile_No: 9760785410,
      Landline_No: "",
      Email: "",
      Pin_Code: 248001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3628,
      Area: "North",
      States: "Uttar Pradesh",
      City: "SAHARANPUR",
      Category: 1,
      Store_name: "NARANG HARDWARE",
      Contact_name: "",
      Store_Address: "opposite police chowki civil Lines court Road Saharanpur",
      Mobile_No: 7895585800,
      Landline_No: "",
      Email: "",
      Pin_Code: 247001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3629,
      Area: "North",
      States: "Uttarakhand",
      City: "Dehradun",
      Category: 1,
      Store_name: "AAKASH ENTERPRISES",
      Contact_name: "",
      Store_Address:
        "near Axis Bank GARHI CANTT, Dhan Singh Thapa marg, Dehradun",
      Mobile_No: 8191962222,
      Landline_No: "",
      Email: "",
      Pin_Code: 248003,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3630,
      Area: "North",
      States: "Uttar Pradesh",
      City: "SAHARANPUR",
      Category: 1,
      Store_name: "AK TRADING CO",
      Contact_name: "",
      Store_Address: "Mangalnagar, near Post office, Beribagh",
      Mobile_No: 6396550887,
      Landline_No: "",
      Email: "",
      Pin_Code: 247001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3631,
      Area: "North",
      States: "Uttar Pradesh",
      City: "MORADABAD",
      Category: 1,
      Store_name: "DREAM KITCHENS",
      Contact_name: "",
      Store_Address: "SHOP NO. 26, AWAA VIKAS MARKET NEAR PILI KOTHI,",
      Mobile_No: 9897755993,
      Landline_No: "",
      Email: "",
      Pin_Code: 244001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3632,
      Area: "North",
      States: "Uttar Pradesh",
      City: "SHAMLI",
      Category: 1,
      Store_name: "PARAS PLYWOOD",
      Contact_name: "",
      Store_Address: "NEAR HANUMAN TILLA SHAMLI",
      Mobile_No: 9760315060,
      Landline_No: "",
      Email: "",
      Pin_Code: 247776,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3633,
      Area: "North",
      States: "Uttarakhand",
      City: "Dehradun",
      Category: 1,
      Store_name: "ACE HARDWARES",
      Contact_name: "",
      Store_Address: "SAHARANPUR, ISBT ROAD DEHRADUN",
      Mobile_No: 9837054500,
      Landline_No: "",
      Email: "",
      Pin_Code: 248001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3634,
      Area: "North",
      States: "Uttarakhand",
      City: "Dehradun",
      Category: 1,
      Store_name: "PASHUPATI ASSOCIATES",
      Contact_name: "",
      Store_Address:
        "Pashupati Associates C/O Kitchen Galleria, near Amardeep Gas Service (Bharat Gas ) Opp Hotel K Blessing, GMS Road",
      Mobile_No: 8755890576,
      Landline_No: "",
      Email: "",
      Pin_Code: 248001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3635,
      Area: "North",
      States: "Uttrakhand",
      City: "Dehradun",
      Category: 1,
      Store_name: "KAPIL SINGH ENTERPRISES",
      Contact_name: "",
      Store_Address: "PREMNAGAR THAKURPUR ROAD , NEAR MALIK DAIRY",
      Mobile_No: 9219213163,
      Landline_No: "",
      Email: "",
      Pin_Code: 248007,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3636,
      Area: "North",
      States: "Uttar Pradesh",
      City: "Pilibhit",
      Category: 1,
      Store_name: "MODERN CROCKERY",
      Contact_name: "",
      Store_Address: "Station Road near Laxmi Talkies Pilibhit",
      Mobile_No: "98371 08356",
      Landline_No: "",
      Email: "",
      Pin_Code: 262001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3637,
      Area: "North",
      States: "Uttar Pradesh",
      City: "MUZAFFARNAGAR",
      Category: 1,
      Store_name: "VEETRAAG TRADING CO",
      Contact_name: "",
      Store_Address: "OPPOSITE BABURAM GATE RAJWAHA ROAD MUZAFFARNAGAR",
      Mobile_No: 7409488589,
      Landline_No: "",
      Email: "",
      Pin_Code: 251001,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3638,
      Area: "North",
      States: "Uttarakhand",
      City: "RISHIKESH",
      Category: 2,
      Store_name: "PUNJAB SALES",
      Contact_name: "",
      Store_Address: "NEAR ASHOKA HOTEL, HERA LAL ROAD",
      Mobile_No: 7830070009,
      Landline_No: "",
      Email: "",
      Pin_Code: 249201,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3639,
      Area: "East",
      States: "West Bengal",
      City: "ASANSOL",
      Category: 1,
      Store_name: "Bharat Trading Agency",
      Contact_name: "",
      Store_Address: "28, APCAR GARDEN, ASANSOL",
      Mobile_No: "8170012299, 9749478096",
      Landline_No: "",
      Email: "kanhaiyalalburnwal@gmail.com",
      Pin_Code: 713304,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3640,
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 2,
      Store_name: "Padmavati Links",
      Contact_name: "Mr. Rushab Bhatt",
      Store_Address:
        "7E/ Laxmi Industrial Estate, New Link Road, Andheri West,",
      Mobile_No: "022-41238346 / 8369747342",
      Landline_No: "",
      Email: "bhatt.rushab@gmail.com",
      Pin_Code: 400053,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3641,
      Area: "West",
      States: "Maharashtra",
      City: "Thane West",
      Category: 2,
      Store_name: "Golden Kitchen Studio",
      Contact_name: "Mr. Yasin Khan",
      Store_Address:
        "Shop No.1, Datta Towers, Dr. Moose Road, Opp. Talaupali, Next Sun Scan Center, Mumbai",
      Mobile_No: 8433763447,
      Landline_No: "",
      Email: "goldenservice443@gmail.com",
      Pin_Code: 400601,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3642,
      Area: "East",
      States: "West Bengal",
      City: "Hooghly",
      Category: 3,
      Store_name: "Electro Tech",
      Contact_name: "Shyamsundar Bhattacherjee",
      Store_Address:
        "346/A Indira Gandhi Road, Near Red Sun Club, Konnagar, Hooghly",
      Mobile_No: "8777024968 / 9163253879",
      Landline_No: "",
      Email: "electro.bijoy@gmail.com",
      Pin_Code: 712235,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3643,
      Area: "East",
      States: "West Bengal",
      City: "Hooghly",
      Category: 1,
      Store_name: "Sunny's Lifestyle",
      Contact_name: "Mr.Bhaskar Dey",
      Store_Address:
        "43/93 G.T Road(East), Axis Bank Building, Near Konnagar Bata more, Konnagar,",
      Mobile_No: "8582985421 / 8100458408",
      Landline_No: "",
      Email: "sunnyslifestyle@gmail.com",
      Pin_Code: 712235,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3644,
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Sumukha Enterprises",
      Contact_name: "Nagesh / Sunil N",
      Store_Address:
        "185 , krishnaveni Appahia Complex, Doddkallasandra,\n Kanakapura Road",
      Mobile_No: 9731513562,
      Landline_No: "",
      Email: "",
      Pin_Code: 560062,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3645,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Kadapa",
      Category: 3,
      Store_name: "Kitchen solutions",
      Contact_name: "",
      Store_Address:
        "36/263-31, Chinna Chowk, By pass Road, Beside Aditya Kalyanamandapam,",
      Mobile_No: "8143913001/8143913002",
      Landline_No: "",
      Email: "kitchensolutionskdp@gmail.com",
      Pin_Code: 516002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3646,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Rajahmundry",
      Category: 3,
      Store_name: "Visishta Enterprises",
      Contact_name: "",
      Store_Address:
        "79-17-25, Ground floor, Old Somalamma Temple road, Raja Street, Shyamala Nagar",
      Mobile_No: "9963584228, 9849280684",
      Landline_No: "",
      Email: "visishtaentprs@gmail.com",
      Pin_Code: 533103,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3647,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Tirupati",
      Category: 3,
      Store_name: "Sai Chimney World",
      Contact_name: "",
      Store_Address: "8-1-126, Chinna Bazaar Street, Tirupati",
      Mobile_No: 9951126505,
      Landline_No: "",
      Email: "saichimneyworld@gmail.com",
      Pin_Code: 517501,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: 3648,
      Area: "South",
      States: "Andhra Pradesh",
      City: "Vijayawada",
      Category: 3,
      Store_name: "Sri Swamy Ayyappa Enterprises",
      Contact_name: "",
      Store_Address: "27-23-100, Gopal Reddy Road ,  Governorpet,  Vijayawada",
      Mobile_No: 7842513151,
      Landline_No: "",
      Email: "swamyayyappa2018@gmail.com",
      Pin_Code: 520002,
      DT: "",
      Active: 1,
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Gandhidham",
      Category: 2,
      Store_name: "Shridhar Minerals Pvt Ltd",
      Contact_name: "Hareshbhai Talreja",
      Store_Address:
        "Plot no. 15 Ward 10/a, opp. IFFCO Colony, Gandhidham, Gujarat 370201",
      Mobile_No: 7567770707,
      Landline_No: "",
      Email: "smpl4023@gmail.com",
      Pin_Code: 370201,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Rajkot",
      Category: 2,
      Store_name: "Unique Kitchen Studio",
      Contact_name: "Amit Kataria",
      Store_Address:
        "102 and 103 , platinum arcade, Kalawad Rd, beside Jalaram petrol pump, Rajkot, 360005",
      Mobile_No: 9426202535,
      Landline_No: "",
      Email: "amitkataria30@yahoo.com",
      Pin_Code: 360005,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 2,
      Store_name: "Keya Digitronics",
      Contact_name: "Ajaysinh Chudasama",
      Store_Address:
        "Shivalik Arcade, F -109, 100 Feet Rd, near prhaladnagar garden, Prahlad Nagar, Ahmedabad, Gujarat 380015",
      Mobile_No: 9586092451,
      Landline_No: "",
      Email: "faberplatinumahd@gmail.com",
      Pin_Code: 380015,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 2,
      Store_name: "Keya Digitronics",
      Contact_name: "Ajaysinh Chudasama",
      Store_Address:
        "12, Fairdeal House, near, Swastik Cross Rd, Shital Kunj Society, Vasant Vihar, Navrangpura, Ahmedabad, Gujarat 380009",
      Mobile_No: 9586092451,
      Landline_No: "",
      Email: "faberplatinumahd@gmail.com",
      Pin_Code: 380009,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 2,
      Store_name: "Keya Digitronics",
      Contact_name: "Ajaysinh Chudasama",
      Store_Address:
        "101, Sopan Complex, New CG Rd, Shrinath Bungalows-I, Nigam Nagar, Chandkheda, Ahmedabad, Gujarat 382424",
      Mobile_No: 9586092451,
      Landline_No: "",
      Email: "faberplatinumahd@gmail.com",
      Pin_Code: 382424,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Baroda",
      Category: 2,
      Store_name: "Parshwa Sales",
      Contact_name: "Viken Shah",
      Store_Address:
        "Tilak Complex, Faber Platinum Studio FF101, Jetalpur Rd, opp. SBI, NearPrakash colony, Vadodara, Gujarat 390020",
      Mobile_No: 9824026502,
      Landline_No: "",
      Email: "parshwa.viken108@gmail.com",
      Pin_Code: 390020,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 2,
      Store_name: "Mother Kitchen Appliances",
      Contact_name: "Virendra Patel",
      Store_Address:
        "Shop No.4, Mother Kitchen, UM Rd, near Mahavir Timber, Bhatar Char Rasta, Surat, Gujarat 395007",
      Mobile_No: 9327510744,
      Landline_No: "",
      Email: "surat.motherkitchen@gmail.com",
      Pin_Code: 395007,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Baroda",
      Category: 3,
      Store_name: "The Home Shoppee",
      Contact_name: "Jayantbhai Gandhani",
      Store_Address:
        "101 Narayan Eligance, Harni Rd, beside Axis Bank, near Sangam Char Rasta, Vadodara, Gujarat 390022",
      Mobile_No: 9904837600,
      Landline_No: "",
      Email: "jayantgandhani@gmail.com",
      Pin_Code: 390022,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Rajkot",
      Category: 3,
      Store_name: "Kitchen Gallery",
      Contact_name: "Girishbhai Parsana",
      Store_Address:
        "2, Shalimar Complex, Tagore Rd, Near Astron Cinema, Sardarnagar, Rajkot, Gujarat 360001",
      Mobile_No: 9824442742,
      Landline_No: "",
      Email: "kitchengalleryrajkot@gmail.com",
      Pin_Code: 360001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 3,
      Store_name: "Kitchen Trendz",
      Contact_name: "Kamplesh Pandya",
      Store_Address:
        "Shop No. M- 18/19, Anmol Shopping Center Near Sargam Shopping Center Parle, Poi, Surat - Dumas Road, Surat, Gujarat 394001",
      Mobile_No: 9825299771,
      Landline_No: "",
      Email: "kitchentrendz@gmail.com",
      Pin_Code: 394001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Surat",
      Category: 3,
      Store_name: "Kanaiya Hardware",
      Contact_name: "Kaushikbhai Ginoya",
      Store_Address:
        "37,38, swaminarayan nagar soc near lalita chokdi, Katargam, Surat, Gujarat 395004",
      Mobile_No: 9825250917,
      Landline_No: "",
      Email: "kanaiyahs@gmail.com",
      Pin_Code: 395004,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Madhya pradesh",
      City: "Indore",
      Category: 2,
      Store_name: "SR Trade and Marketing",
      Contact_name: "Rohan sethi",
      Store_Address:
        "plot no 5-6-7, Shop no G4, PU4 Scheme no 54, Rasoma Square, Indore-452010",
      Mobile_No: 9425317662,
      Landline_No: "",
      Email: "srtradeandmarketing@gmail.com",
      Pin_Code: 452010,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Madhya pradesh",
      City: "Indore",
      Category: 2,
      Store_name: "SR Trade and Marketing-2",
      Contact_name: "Rohan sethi",
      Store_Address:
        "Lake view complex, Ground floor Plot no 25FA Scheme no 94, Ring road, Indore",
      Mobile_No: 9425317662,
      Landline_No: "",
      Email: "srtradeandmarketing@gmail.com",
      Pin_Code: 452016,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Baroda",
      Category: 3,
      Store_name: "Darshan Hardware",
      Contact_name: "Nipambhai Patel",
      Store_Address:
        "GF, Floor, Savorite complex , Opp. S n d t College, Manisha cross road, Old Padra Rd, Akota, Vadodara, Gujarat 390020",
      Mobile_No: 9879207944,
      Landline_No: "",
      Email: "darshan.interiorsolution@gmail.com",
      Pin_Code: 390020,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Madhya pradesh",
      City: "Indore",
      Category: 3,
      Store_name: "New Dimensions",
      Contact_name: "Yash Verma",
      Store_Address: "A8 New Siyaganj, Maal Godown Road Indore",
      Mobile_No: 8889044496,
      Landline_No: "",
      Email: "snewdimensions@gmail.com",
      Pin_Code: 452007,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Bhavnagar",
      Category: 3,
      Store_name: "Manisha Enterprise",
      Contact_name: "Swagat Oza",
      Store_Address:
        "G-9, Swarankan Complex, Divdi Chowk, Rupani Circle, Bhavnagar - 364001",
      Mobile_No: 9376515454,
      Landline_No: "",
      Email: "",
      Pin_Code: 364001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Madhya pradesh",
      City: "Bhopal",
      Category: 2,
      Store_name: "Green Marketing",
      Contact_name: "Shraddha Dixit",
      Store_Address: "S no 17 Zone-2, MP Nagar, Near Hotel G.K Palace, Bhopal",
      Mobile_No: 9301257754,
      Landline_No: "",
      Email: "gmarketing804@gmail.com",
      Pin_Code: 462011,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Gujarat",
      City: "Ahmedabad",
      Category: 3,
      Store_name: "Vishw Electronics",
      Contact_name: "Hemalbhai Patel",
      Store_Address:
        "2nd Floor, Sahaj Risidency Complex, Narayan Chok, Opp. Karnavati Mega Mall, Takshashila School Rd, above Vishw Electronics, Pranami Nagar, Vastral, Ahmedabad, Gujarat 382418",
      Mobile_No: 7490017275,
      Landline_No: "",
      Email: "",
      Pin_Code: 382418,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Madhya pradesh",
      City: "Jabalpur",
      Category: 2,
      Store_name: "Shrivika Enterprises",
      Contact_name: "",
      Store_Address: "1st Floor Chouhan Cuboid, Narmada Road, Rampur Jabalpur",
      Mobile_No: 7566669910,
      Landline_No: "",
      Email: "shrivikaenterprises@gmail.com",
      Pin_Code: 482008,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Madhya pradesh",
      City: "Rewa",
      Category: 2,
      Store_name: "Smart Kitchen Appliances",
      Contact_name: "Ajay Baghel",
      Store_Address: "In front of Model School, Ward no 12, Rewa",
      Mobile_No: 9685060075,
      Landline_No: "",
      Email: "ajaybaghel42@gmail.com",
      Pin_Code: 486001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Madhya pradesh",
      City: "Gwalior",
      Category: 2,
      Store_name: "Bansal Appliances",
      Contact_name: "Dipendra Jadaun",
      Store_Address: "Uma Plaza kailsh Vihar, City center",
      Mobile_No: 9265495850,
      Landline_No: "",
      Email: "yogeshbansal229@gmail.com",
      Pin_Code: 474011,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Maharashtra",
      City: "Navi Mumbai",
      Category: 2,
      Store_name: "Shree Jain Traders",
      Contact_name: "Jayesh Jivavat",
      Store_Address:
        "Store no 12 Palm Beach Galleria Mall, Sector 19D, Palm Beach Road, Vashi, Navi Mumbai, ...",
      Mobile_No: 8976259675,
      Landline_No: "",
      Email: "fabervashi@gmail.com",
      Pin_Code: 400703,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Maharashtra",
      City: "Thane",
      Category: 2,
      Store_name: "Golden services",
      Contact_name: "Yasin Khan",
      Store_Address:
        "Shop no 1, DATTA TOWER, Dr Moose Marg, opp. Talaupali, Naupada, Thane West, Thane, Maharashtra 400601",
      Mobile_No: "8433763447/ 8976221677",
      Landline_No: "",
      Email: "goldenservice443@gmail.com",
      Pin_Code: 400601,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 2,
      Store_name: "Padmavati links",
      Contact_name: "Rahul Bhatt / Rushab Bhatt",
      Store_Address:
        "7E, LAXMI INDUSTRIAL ESTATE, NEW LINK ROAD, ROAD, opp. VEERA DESAI, Andheri West, Mumbai, Maharashtra 400053",
      Mobile_No: 7977642115,
      Landline_No: "",
      Email: "faberpadmavatilinks@gmail.com",
      Pin_Code: 400053,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 2,
      Store_name: "Raj Kitchen & Wardrobe",
      Contact_name: "Hujefa",
      Store_Address:
        "67/669, M.H.B. Colony, Gulmohar Chs.Ltd Opposite Parijat CHS, Mahavir Nagar, Kandivali West, Mumbai, Maharashtra 400067",
      Mobile_No: 9322264673,
      Landline_No: "",
      Email: "hujefa@raajkitchen.com",
      Pin_Code: 400067,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "West",
      States: "Maharashtra",
      City: "Mumbai",
      Category: 3,
      Store_name: "Asiatic Electric Trading Company",
      Contact_name: "Sanjay Dabari",
      Store_Address:
        "Jay Mahal Building, 46-48, Near Crawford Market, Lohar Chawl, Mumbai, Maharashtra 400002",
      Mobile_No: 9892301207,
      Landline_No: "",
      Email: "aetco11@gmail.com",
      Pin_Code: 400002,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 2,
      Store_name: "KITCHEN ICON",
      Contact_name: "Sandeep Mehra",
      Store_Address: "11, East St, Camp, Pune, Maharashtra 411001",
      Mobile_No: 7261998998,
      Landline_No: "",
      Email: "",
      Pin_Code: 411001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 2,
      Store_name: "KITCHEN ICON",
      Contact_name: "Sandeep Mehra",
      Store_Address:
        "Shop 13b, Shangrila garden, Bund Garden, Maharashtra 411001",
      Mobile_No: 7261998998,
      Landline_No: "",
      Email: "",
      Pin_Code: 411001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 3,
      Store_name: "KITCHEN ICON",
      Contact_name: "Sandeep Mehra",
      Store_Address:
        "Bhrama Chambers, 2010, Sadashiv Peth, Tilak Road, Opp. Bank of Maharashtra, Pune, Maharashtra - 411030",
      Mobile_No: 7261998998,
      Landline_No: "",
      Email: "",
      Pin_Code: 411002,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 2,
      Store_name: "HOMETECH KITCHEN APPLIANCES",
      Contact_name: "SANJAY JAKHOTIA",
      Store_Address:
        "Bhoomi Allium, Kokane Chowk, near Ranka Jweller, Pimple Saudagar, Pune, Maharashtra 411017",
      Mobile_No: 9404722346,
      Landline_No: "",
      Email: "",
      Pin_Code: 411017,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 2,
      Store_name: "GRUHINI KITCHEN APPLIANCES",
      Contact_name: "BHUJANG",
      Store_Address:
        "SHOP NO 1, Vitthal Heights, opp. RADISSON HOTEL, Yashwant Nagar, Kharadi, Pune, Maharashtra 411014",
      Mobile_No: 9763729842,
      Landline_No: "",
      Email: "",
      Pin_Code: 411014,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 2,
      Store_name: "RAJDEEP ENTERPRISES",
      Contact_name: "SUNNY",
      Store_Address:
        "Shop no, Gaylord chowk, 390, J N Road, next to janta footwear, opp. ayappa temple, Shastri Nagar, Pimpri Colony, Pune, Maharashtra 411017",
      Mobile_No: 9960606010,
      Landline_No: "",
      Email: "",
      Pin_Code: 411017,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 3,
      Store_name: "GRUHINI KITCHEN",
      Contact_name: "BABSAHEB",
      Store_Address:
        "SHOP NO 4 UNDRI CITY CENTER UPPER GROUND HOLE WASTI NEAR BISHOPS SCHOOL UNDRI PUNE 411060",
      Mobile_No: 9604404901,
      Landline_No: "",
      Email: "",
      Pin_Code: 411060,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 3,
      Store_name: "UNIQUE KITCHEN",
      Contact_name: "MININATH",
      Store_Address:
        "Saraswati market, pune-nagar road life line hospital, near Yewale Tea, Pune, Maharashtra 412207",
      Mobile_No: 8007565418,
      Landline_No: "",
      Email: "",
      Pin_Code: 412207,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 3,
      Store_name: "GALAXY KITCHEN",
      Contact_name: "",
      Store_Address:
        "Mohite Paradise, Shope No. 3 Near Kasat Saree Center, Sinhgad Rd, Hingne Khurd, Pune, Maharashtra 411051",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 411024,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "PUNE",
      Category: 3,
      Store_name: "SAPPHIRE SALES CO",
      Contact_name: "SONALI",
      Store_Address:
        "19, Katraj - Kondhwa Rd, opp. Shatrunjay Temple, Kondhwa, Pune, Maharashtra 411046",
      Mobile_No: 7887859228,
      Landline_No: "",
      Email: "",
      Pin_Code: 411048,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "NASHIK",
      Category: 2,
      Store_name: "FAIR WIND KITCHEN APPLIANCES",
      Contact_name: "",
      Store_Address:
        "SHOP NO 01 PUSHKRAJ BUNGLOW OPP,TULIP HOSPITAL NEAR PRASAD CIRCLE GANGAPUR ROAD NASHIK , Maharashtra 422013",
      Mobile_No: "#ERROR!",
      Landline_No: "",
      Email: "fair.windkitchen@gmail.com",
      Pin_Code: 422013,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "NASHIK",
      Category: 3,
      Store_name: "ARIHANT GIFT & CROCKRIES",
      Contact_name: "",
      Store_Address:
        "Plot no 129 , Bussiness Bay showroom no 10 first floor Sandeep hotel road, Shri Hari Narayan Kute Marg, Near Rainbow HOSPITAL, Tidke Colony, Nashik, Maharashtra 422002",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 422002,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "BARAMATI",
      Category: 3,
      Store_name: "ARYA ENTERPRISES",
      Contact_name: "ABHAY",
      Store_Address:
        "shop no, Shalimar Corner, 19, Baramati Bhigwan Road, Shiva Nagar, Baramati, Maharashtra 413102",
      Mobile_No: 9011541458,
      Landline_No: "",
      Email: "",
      Pin_Code: 413102,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "KOLHAPUR",
      Category: 3,
      Store_name: "SRI MANGESH AGENCIES",
      Contact_name: "DHANRAJ",
      Store_Address:
        "HOTEL-TRIVENI,BASANT-BAHAR RD, SHOP NO- D/ C.T.S. NO. 414, E Ward, Shahupuri, Kolhapur, Maharashtra 416001",
      Mobile_No: 9421833438,
      Landline_No: "",
      Email: "",
      Pin_Code: 412207,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "AURANGABAD",
      Category: 2,
      Store_name: "CONSTRO AGENCIES",
      Contact_name: "MUSHTAQ",
      Store_Address:
        "M square akashwani signal, Jalna Road, Aurangabad, Maharashtra 431001",
      Mobile_No: 9823777086,
      Landline_No: "",
      Email: "constroagencies@gmail.com",
      Pin_Code: 431001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "GOA",
      City: "PANJIM",
      Category: 2,
      Store_name: "APEX MARKETING",
      Contact_name: "Ganesh",
      Store_Address: "Silvio Heights, Santa Inez, Panaji, Goa",
      Mobile_No: "#ERROR!",
      Landline_No: "",
      Email: "harshadapex@rediffmail.com",
      Pin_Code: 403001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "GOA",
      City: "MARGAO",
      Category: 3,
      Store_name: "SMART HOME LIFESTYLE",
      Contact_name: "Priyanka",
      Store_Address: "Vidhyanagr, Gogol, Margao, Goa 403601",
      Mobile_No: "#ERROR!",
      Landline_No: "",
      Email: "swifttrade.electric@gmail.com",
      Pin_Code: 403601,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "GOA",
      City: "MARGAO",
      Category: 3,
      Store_name: "TALAULIKAR",
      Contact_name: "",
      Store_Address:
        "Fatima Chambers, Shop 2 & 3, near ICICI Bank, Margao, Goa 403601",
      Mobile_No: "99757 00012",
      Landline_No: "",
      Email: "gautamt@live.com",
      Pin_Code: 403601,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "WEST",
      States: "MAHARASHTRA",
      City: "NASHIK",
      Category: 3,
      Store_name: "ARIHANT GIFT & CROCKRIES",
      Contact_name: "",
      Store_Address:
        "shree, Plot no 129 , Bussiness Bay showroom no 10 first floor Sandeep hotel road, Shri Hari Narayan Kute Marg, Near Rainbow HOSPITAL, Tidke Colony, Nashik, Maharashtra 422002",
      Mobile_No: "",
      Landline_No: "",
      Email: "",
      Pin_Code: 422002,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Haryana",
      City: "Near HDFC Bank",
      Category: 2,
      Store_name: "Ashna Enterprise",
      Contact_name: "PAWAN",
      Store_Address: "1st florr, SCO 321, Sector 29, Gurgaon, Haryana",
      Mobile_No: 9871733735,
      Landline_No: "",
      Email: "JATIN@ASHANAENTERPRISES.COM",
      Pin_Code: 122001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Opposite Dda Sports Complex Dwarka",
      Category: 2,
      Store_name: "New Berco Electronics",
      Contact_name: "NARESH",
      Store_Address: "Shop No-3 Plot No 5 Central Market Sector 10",
      Mobile_No: 9891618881,
      Landline_No: "",
      Email: "bercoindia01@yahoo.com",
      Pin_Code: 110075,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "New Delhi",
      Category: 2,
      Store_name: "Aarco One",
      Contact_name: "JAWAHAR",
      Store_Address: "J 36 Lajpat Nagar 2",
      Mobile_No: 9910757777,
      Landline_No: "",
      Email: "sales@aarco.in",
      Pin_Code: 110024,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Pitampura",
      Category: 2,
      Store_name: "Shri Mangla Electronics",
      Contact_name: "SANDEEP GUPTA",
      Store_Address: "Basement 3 Vaishali Pitampura",
      Mobile_No: 9891479999,
      Landline_No: "",
      Email: "shrimangla2002@gmail.com",
      Pin_Code: 110034,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Opp. Metro Pillar No. 368",
      Category: 2,
      Store_name: "The Electronics Pavillion",
      Contact_name: "RAJIV GUPTA",
      Store_Address: "E-2, Bali Nagar",
      Mobile_No: 9818451793,
      Landline_No: "",
      Email: "pavilion_rajiv@yahoo.co.in",
      Pin_Code: 110015,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Yusuf Sarai Delhi",
      Category: 2,
      Store_name: "Mangla Electronics Yusuf Sarai",
      Contact_name: "SANDEEP GUPTA",
      Store_Address: "Shop No. -5 Dav School Building",
      Mobile_No: 9891479999,
      Landline_No: "",
      Email: "manglaelectronics1995@gmail.com",
      Pin_Code: 110013,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Pachim Vihar",
      Category: 2,
      Store_name: "Dolly Electronics",
      Contact_name: "SANDEEP RATHI",
      Store_Address: "G-9 PUSHKAR ENCLAVE OUTER RING ROAD PASCHIM VIHAR",
      Mobile_No: 9810155200,
      Landline_No: "",
      Email: "dollyelectronicsbs@yahoo.com",
      Pin_Code: 110063,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "Noida",
      Category: 2,
      Store_name: "Keshav Tiles",
      Contact_name: "RAGHAV",
      Store_Address: "Keshav Tiles B-39 Sector Sector- 9 Noida",
      Mobile_No: 9289257354,
      Landline_No: "",
      Email: "raghav@keshavtiles.com",
      Pin_Code: 201301,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Lodhi Road New Delhi",
      Category: 2,
      Store_name: "R K Vision",
      Contact_name: "RAJESH LUTHRA",
      Store_Address: "89 Khanna Market Lodhi Colony",
      Mobile_No: 9811779055,
      Landline_No: "",
      Email: "rkvision_89@rediffmail.com",
      Pin_Code: 110003,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Lado Sarai",
      Category: 2,
      Store_name: "Home Decor",
      Contact_name: "RAHUL",
      Store_Address: "M - 64 Ground Floor Lado Sarai New Delhi",
      Mobile_No: 9810983229,
      Landline_No: "",
      Email: "homedecor.india2020@gmail.com",
      Pin_Code: 110030,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "Kriti Nagar",
      Category: 2,
      Store_name: "Wood Secrets",
      Contact_name: "SARABJEET SINGH",
      Store_Address: "B-199, Mansarover Garden Kriti Nagar New Delhi 110015",
      Mobile_No: 9910320000,
      Landline_No: "",
      Email: "woodsecrets@gmail.com",
      Pin_Code: 110015,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "DELHI",
      City: "PREET VIHAR",
      Category: 2,
      Store_name: "Amba Prosperity-Preet Vihar",
      Contact_name: "KARTIK",
      Store_Address:
        "34,1ST FLOOR DEFENCE ENCLAVE,PREET VIHAR NEW DELHI 110092",
      Mobile_No: 9958230555,
      Landline_No: "",
      Email: "ambaprosperity@gmail.com",
      Pin_Code: 110092,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Haryana",
      City: "Panchkula",
      Category: 2,
      Store_name: "Surindra Agencies",
      Contact_name: "surinder kansal",
      Store_Address: "SCF 144 sector 17 panchkula",
      Mobile_No: 0.1722565004,
      Landline_No: "",
      Email: "kansal_surinder@yahoo.co.in",
      Pin_Code: 134109,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Himachal pardesh",
      City: "Solan",
      Category: 2,
      Store_name: "Maini electronics",
      Contact_name: "Rajesh maini",
      Store_Address:
        "maini electronics Krishna complex near new Bus stand solan Himachal Pradesh",
      Mobile_No: 9816037137,
      Landline_No: "",
      Email: "mainielectronicssolan@gmail.com",
      Pin_Code: 173212,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Punjab",
      City: "Chandigarh",
      Category: 2,
      Store_name: "DHARAM CHAND",
      Contact_name: "Rajiv goyal",
      Store_Address: "Plot no. 109 Industrial area phase 1 Chandigarh",
      Mobile_No: 7888802031,
      Landline_No: "",
      Email: "Rajivgoyal1@gmail.com",
      Pin_Code: 160002,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Punjab",
      City: "Jallandhar",
      Category: 2,
      Store_name: "KJ Kitchen Appliances",
      Contact_name: "Satinder kapur",
      Store_Address:
        "Shop no. 6/7 KD square building , gian nagar cool road Liberty chowk jallandhar",
      Mobile_No: 9988641340,
      Landline_No: "",
      Email: "kjkitchenappliances@gmail.com",
      Pin_Code: 144001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Punjab",
      City: "Amritsar",
      Category: 2,
      Store_name: "Home Gallery",
      Contact_name: "Shivam tayal",
      Store_Address: "Main ram tirth road near gawal Mandi chownk",
      Mobile_No: 7508936362,
      Landline_No: "",
      Email: "homegallery0@gmail.com",
      Pin_Code: 143001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Punjab",
      City: "Ludhiana",
      Category: 2,
      Store_name: "Chaudhry'a sensible kitchen",
      Contact_name: "Sumit Chaudhary",
      Store_Address: "384 satluj complex Dr. heera singh road",
      Mobile_No: 9212530006,
      Landline_No: "",
      Email: "cskplatinumstudio@gmail.com",
      Pin_Code: 141001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Jammu nd Kashmir",
      City: "Sri nagar",
      Category: 2,
      Store_name: "Electronics brain",
      Contact_name: "Arif Bashir mir",
      Store_Address: "Hari Singh high street lal chowk",
      Mobile_No: 7006311697,
      Landline_No: "",
      Email: "arif.bashir.mir@gmail.com",
      Pin_Code: 190001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "NORTH",
      States: "UP",
      City: "MATHURA",
      Category: 3,
      Store_name: "BAATH COLLECTION",
      Contact_name: "Rajiv agrawal",
      Store_Address: "",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "",
      Pin_Code: 281001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "NORTH",
      States: "UP",
      City: "AGRA",
      Category: 3,
      Store_name: "YASHU ENTERPRISES",
      Contact_name: "Yashu Goyal",
      Store_Address: "",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "",
      Pin_Code: 282003,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "LUCKNOW",
      Category: 2,
      Store_name: "Birju Mal Budhu Lal",
      Contact_name: "RITESH AGARWAL",
      Store_Address: "",
      Mobile_No: "",
      Landline_No: "",
      Email: "SHANTIENTERPRISES09@REDIFFMAIL.COM",
      Pin_Code: 226016,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "LUCKNOW",
      Category: 2,
      Store_name: "eco solution- platinum studio",
      Contact_name: "puneet dubey",
      Store_Address: "",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "ecosales@ecosolutionslucknow.com",
      Pin_Code: 226002,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "LUCKNOW",
      Category: 3,
      Store_name: "VASSION ENTERPRICES",
      Contact_name: "SONIYA",
      Store_Address: "",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "vaasons.enterprise@gmail.com",
      Pin_Code: 226025,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "LUCKNOW",
      Category: 3,
      Store_name: "Birju Mal Budhu Lal",
      Contact_name: "MAYANK AGARWAL",
      Store_Address: "",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "SHANTIENTERPRISES09@REDIFFMAIL.COM",
      Pin_Code: 226022,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "Uttarakhand",
      City: "HALDWANI",
      Category: 3,
      Store_name: "NEW KWALITY KITCHEN",
      Contact_name: "MR RISHU",
      Store_Address: "MANGAL PADAO",
      Mobile_No: "",
      Landline_No: "",
      Email: "tawansuri@yahoo.co.in",
      Pin_Code: 263139,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "Saharanpur",
      Category: 3,
      Store_name: "NARANG HARDWARE STORE",
      Contact_name: "Tarun Narang",
      Store_Address: "Shop no.0",
      Mobile_No: 8171612347,
      Landline_No: "",
      Email: "naranghardware82@gmail.com",
      Pin_Code: 247001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "KANPUR",
      Category: 2,
      Store_name: "FABER",
      Contact_name: "Ritesh gupta",
      Store_Address: "63/2C",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "legendelectronicsknp@rediffmail.com",
      Pin_Code: 208001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "KANPUR",
      Category: 3,
      Store_name: "FABER",
      Contact_name: "Upendra Sachan",
      Store_Address: "",
      Mobile_No: "",
      Landline_No: "",
      Email: "dreamkitchenkanpur@gmail.com",
      Pin_Code: 208005,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "KANPUR",
      Category: 3,
      Store_name: "FABER",
      Contact_name: "Ramesh Kumar",
      Store_Address: "",
      Mobile_No: "",
      Landline_No: "",
      Email: "rameshgasservicekup@gmail.com",
      Pin_Code: 208012,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "Lucknow",
      Category: 2,
      Store_name: "Faber Platinum Studio",
      Contact_name: "Anupam Tripathi",
      Store_Address: "Shop no.5",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "anupamsadashiv@gmail.com",
      Pin_Code: 226028,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "NORTH",
      States: "Uttarakhand",
      City: "Dehradun",
      Category: 2,
      Store_name: "Ethical Deals",
      Contact_name: "Ujjwal",
      Store_Address: "Dehradun",
      Mobile_No: "NA",
      Landline_No: "",
      Email: "neeraj.ats@rediffimail.com",
      Pin_Code: 248001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "NORTH",
      States: "Uttarakhand",
      City: "Dehradun",
      Category: 2,
      Store_name: "KRIVI AND CO",
      Contact_name: "Mayank Tayal",
      Store_Address: "6 Corss Road Dehradun",
      Mobile_No: "",
      Landline_No: "",
      Email: "Tayalvijay@gmail.com",
      Pin_Code: 248001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "North",
      States: "UP",
      City: "BULANDSHAHAR",
      Category: 3,
      Store_name: "MOHIT MUSKAN",
      Contact_name: "MOHIT",
      Store_Address: "",
      Mobile_No: "",
      Landline_No: "",
      Email: "mohitmuskan@rediffmail.com",
      Pin_Code: 203001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 2,
      Store_name: "Greencity Vincom Pvt Ltd",
      Contact_name: "Biplab",
      Store_Address: "68B, Ballygunge Circular Road",
      Mobile_No: 9830050074,
      Landline_No: "",
      Email: "greencityvincom@gmail.com",
      Pin_Code: 700019,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 3,
      Store_name: "Galaxy",
      Contact_name: "Devesh Agarwal",
      Store_Address: "42,Gariahat Road",
      Mobile_No: 9830129951,
      Landline_No: "",
      Email: "devesh@thegalaxyonline.com",
      Pin_Code: 700029,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 3,
      Store_name: "Scintilla Studio",
      Contact_name: "Ashok Das",
      Store_Address: "35,Sashi Bhushan Mukherjee Rd",
      Mobile_No: 9831667435,
      Landline_No: "",
      Email: "scintillaindia@gmail.com",
      Pin_Code: 700034,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Kalyani",
      Category: 3,
      Store_name: "Maa Tara Enterprise",
      Contact_name: "Himanshu Nandi",
      Store_Address: "B-8/96, Kalyani,Nadia",
      Mobile_No: 9681084301,
      Landline_No: "",
      Email: "himanshu.nandi@gmail.com",
      Pin_Code: 741235,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 3,
      Store_name: "Taj Marketing",
      Contact_name: "Amrita Kaur",
      Store_Address: "Shop no:-A 217, 2nd Floor, Block A",
      Mobile_No: 9088655590,
      Landline_No: "",
      Email: "faebergallery.adm@gmail.com",
      Pin_Code: 700156,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Kolkata",
      Category: 3,
      Store_name: "Smiley Kitchen",
      Contact_name: "Koushik Das",
      Store_Address: "109, Raja S C Mullick Road",
      Mobile_No: 7003793382,
      Landline_No: "",
      Email: "smileykitchen05@gmail.com",
      Pin_Code: 700086,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Bihar",
      City: "Patna",
      Category: 3,
      Store_name: "Radhika Interiors",
      Contact_name: "Deepak Shanyal",
      Store_Address: "Gola Road, Fornt of St Karens High School",
      Mobile_No: 9386751746,
      Landline_No: "",
      Email: "",
      Pin_Code: 800025,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Bihar",
      City: "Madhepura",
      Category: 3,
      Store_name: "Jaya mala Enterprises",
      Contact_name: "Raman Kumar",
      Store_Address: "Paschim Bay Pass Road,",
      Mobile_No: 8409827949,
      Landline_No: "",
      Email: "ramanlic1471@gmail.com",
      Pin_Code: 852113,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Bihar",
      City: "Patna",
      Category: 3,
      Store_name: "Kitchen Univers",
      Contact_name: "Surbhi",
      Store_Address: "Tauheed Complex ,Ramnagri More",
      Mobile_No: 8877446611,
      Landline_No: "",
      Email: "kitchenunivers2020@gmail.com",
      Pin_Code: 800014,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Bihar",
      City: "Chhapra",
      Category: 3,
      Store_name: "Gitanjali Marbal",
      Contact_name: "Niraj Singh",
      Store_Address: "Methwaliya, Chhapra Mashrakh Road",
      Mobile_No: 8797099710,
      Landline_No: "",
      Email: "kumarniraj75@yahoo.co.in",
      Pin_Code: 802101,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Hooghly",
      Category: 3,
      Store_name: "Sunny's Lifestyle",
      Contact_name: "Bhaskar Dey",
      Store_Address: "43/93, G T Road ( East)",
      Mobile_No: 8582985421,
      Landline_No: "",
      Email: "sunnyslifestyle@gmail.com",
      Pin_Code: 712235,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Bankura",
      Category: 3,
      Store_name: "Sri Krishna Traders",
      Contact_name: "Koushik Mandal",
      Store_Address: "Kotulpur",
      Mobile_No: 9641455820,
      Landline_No: "",
      Email: "koushikkotulpur@gmail.com",
      Pin_Code: 722141,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "West Bengal",
      City: "Durgapur",
      Category: 3,
      Store_name: "ORCHID",
      Contact_name: "Tapan",
      Store_Address: "5TH STREET,Harshabardhan",
      Mobile_No: 8436242173,
      Landline_No: "",
      Email: "orchid.durgapur@gmail.com",
      Pin_Code: 722122,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Jharkhand",
      City: "Ranchi",
      Category: 3,
      Store_name: "Kitchen Koncept",
      Contact_name: "Kushal Thard",
      Store_Address: "Commerce House ,Line Tank Road",
      Mobile_No: 9570070704,
      Landline_No: "",
      Email: "purchase@kitchenkoncept.in",
      Pin_Code: 834001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Jharkhand",
      City: "Hazaribag",
      Category: 3,
      Store_name: "K KItchen kingdom",
      Contact_name: "H. sahi JI",
      Store_Address: "Gola Road,Boddom Bazar,",
      Mobile_No: 7004093687,
      Landline_No: "",
      Email: "",
      Pin_Code: 825301,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Assam",
      City: "Guwahati",
      Category: 2,
      Store_name: "Kitchen Concept",
      Contact_name: "Ms. Anju Goswami",
      Store_Address: "B.K.Kakati Road, Rehabari",
      Mobile_No: 6000070499,
      Landline_No: "",
      Email: "kitchen concept.ghy@gmail.com",
      Pin_Code: 781007,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Assam",
      City: "Guwahati",
      Category: 3,
      Store_name: "Losio",
      Contact_name: "Ms. Bhaswasti",
      Store_Address: "Binovanagar, Kalapahar",
      Mobile_No: 6000073009,
      Landline_No: "",
      Email: "aiekp@gmail.com",
      Pin_Code: 781018,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Assam",
      City: "Guwahati",
      Category: 3,
      Store_name: "NK Innovative",
      Contact_name: "Ms. Gayatri Dutta",
      Store_Address: "RGB Road,",
      Mobile_No: 7002520897,
      Landline_No: "",
      Email: "nkinnovative55@gmail.com",
      Pin_Code: 781024,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Nagaland",
      City: "Dimapur",
      Category: 3,
      Store_name: "Interior Solutions",
      Contact_name: "Mr. Tushi",
      Store_Address: "Circular Road, Dimapur",
      Mobile_No: 7005741883,
      Landline_No: "",
      Email: "yongya_78@yahoo.com",
      Pin_Code: 797103,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Manipur",
      City: "Imphal",
      Category: 3,
      Store_name: "Sanitary House",
      Contact_name: "Mr. Yogesh Jain",
      Store_Address: "M.G.Avenue",
      Mobile_No: 9436027366,
      Landline_No: "",
      Email: "yogeshimphal@yahoo.co.in",
      Pin_Code: 795001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Mizoram",
      City: "Aizawl",
      Category: 3,
      Store_name: "Lena Plastic House",
      Contact_name: "Ms. Monica",
      Store_Address: "Sairang road, Bawngkawn",
      Mobile_No: 9436760144,
      Landline_No: "",
      Email: "lenaentp09@yahoo.in",
      Pin_Code: 796014,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Tripura",
      City: "Agartala",
      Category: 3,
      Store_name: "Giriraj Furniture",
      Contact_name: "Mr. Biswajit",
      Store_Address: "Sankar Chowmuhani",
      Mobile_No: 8837056451,
      Landline_No: "",
      Email: "girirajshopping@rediffmail.com",
      Pin_Code: 799001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "East",
      States: "Chattisgarh",
      City: "Durg",
      Category: 3,
      Store_name: "Satkar gas & Home Appliances",
      Contact_name: "Mr.Gurmeet Singh",
      Store_Address: "Shop No-99,Akashganga Complex,Supela",
      Mobile_No: 9827114007,
      Landline_No: "",
      Email: "satkargas99@gmail.com",
      Pin_Code: 490023,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Tamil nadu",
      City: "Trichy",
      Category: 2,
      Store_name: "PHOENIX",
      Contact_name: 9632320002,
      Store_Address: "45/1,Sivaprakasam salai,Anna nagar",
      Mobile_No: "",
      Landline_No: "",
      Email: "Phoenix.fabertrichy@gmail.com",
      Pin_Code: 620017,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "MADURAI",
      Category: 2,
      Store_name: "THE KITCHEN GALLERY",
      Contact_name: 9360713819,
      Store_Address: "HIG 20,80 FEET ROAD,ANNA NAGAR,MADURAI",
      Mobile_No: 9360713819,
      Landline_No: "",
      Email: "thekitchengallery2021@gmail.com",
      Pin_Code: 625020,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "KANYAKUMARI",
      Category: 2,
      Store_name: "SHALOM KITCHEN WORLD",
      Contact_name: 8056606602,
      Store_Address: "193E, FIRST FLOOR,K.P ROAD,R.V PURAM",
      Mobile_No: 8056606602,
      Landline_No: "",
      Email: "shalomkitchenworld@gmail.com",
      Pin_Code: 629001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "TIRUNELVELI",
      Category: 2,
      Store_name: "THE KITCHEN WORLD",
      Contact_name: 8072603359,
      Store_Address: "110,FIRST FLOOR,NORTH BYE PASS ROAD",
      Mobile_No: 8072603359,
      Landline_No: "",
      Email: "thekitchenworldtvl@gmail.com",
      Pin_Code: 627003,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "RAMNATHAPURAM",
      Category: 2,
      Store_name: "THE IDEAL KITCHEN",
      Contact_name: 6369881617,
      Store_Address: "146/1,FIRST FLOOR,ARIGNAR ANNA SALAI",
      Mobile_No: 6369881617,
      Landline_No: "",
      Email: "theidealkitchenrmd@gmail.com",
      Pin_Code: 623501,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU AA to",
      City: "DINDIGUL",
      Category: 2,
      Store_name: "SMART KITCHEN SOLUTION",
      Contact_name: 8098451378,
      Store_Address: "100-101,PENSIONAR STREET",
      Mobile_No: 8098451378,
      Landline_No: "",
      Email: "smartkitchensolutiondgl@gmail.com",
      Pin_Code: 624001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "RTC X Road",
      Category: 2,
      Store_name: "My Kitchen",
      Contact_name: "Shaik Amzad Ali",
      Store_Address: "#1-1-100 & 101, Musheerabad, RTC X Road,Hyderabad.",
      Mobile_No: 9490011611,
      Landline_No: "",
      Email: "faberhyderabad@gmail.com",
      Pin_Code: 500020,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Gachibowli",
      Category: 2,
      Store_name: "Global Enterprises",
      Contact_name: "T. Raghu",
      Store_Address: "3rd Floor, TM Yadav Gokul Plaza, Gachibowli, Hyderabad.",
      Mobile_No: 9032539357,
      Landline_No: "",
      Email: "globalenterprisesgb@gmail.com",
      Pin_Code: 500032,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Suchitra",
      Category: 2,
      Store_name: "Four S Kitchen Galaxy",
      Contact_name: "Sailaja Damera",
      Store_Address:
        "Plot no. 03, NCL Enclave, Near Dominos, Pet Basheerbad, Kompally.",
      Mobile_No: 9160222402,
      Landline_No: "",
      Email: "faberplatinumstudio.kompally@gmail.com",
      Pin_Code: 500015,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Kphb",
      Category: 2,
      Store_name: "SVS Gayatri Enterprises",
      Contact_name: "Revan Siddu",
      Store_Address: "MIG 172, Road No 1, KPHB, Hyderabad.",
      Mobile_No: 8121131312,
      Landline_No: "",
      Email: "svsgayatrienterprises2021@gmail.com",
      Pin_Code: 500072,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "ANDHRA PRADESH",
      City: "Kurnool",
      Category: 2,
      Store_name: "Sree Satya Suma Marketers",
      Contact_name: "Satya",
      Store_Address:
        "First floor,87/1388, shesadri nagar,Opp:Javaharapuram, Nandikotkur Road,Kurnool-518004",
      Mobile_No: 8217206637,
      Landline_No: "",
      Email: "sreesatyasumamarketer@gmail.com",
      Pin_Code: 518004,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "ANDHRA PRADESH",
      City: "Gajuwaka",
      Category: 2,
      Store_name: "Skandanshi Traders",
      Contact_name: "CA Ramesh",
      Store_Address:
        "D No 26/1/2/5, Padmasree Arcade, Gajuwaka, Visakhapatnam, Andhra Pradesh 530026",
      Mobile_No: 6302848722,
      Landline_No: "",
      Email: "caramesh16@gmail.com",
      Pin_Code: 530026,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Attapur",
      Category: 3,
      Store_name: "Mourya Enterprises",
      Contact_name: "Reddy Shankar",
      Store_Address: "6-432, Main Road, Hyderguda, Attapur.",
      Mobile_No: 7207265598,
      Landline_No: "",
      Email: "shankar.reddy27@gmail.com",
      Pin_Code: 500048,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Ameerpet",
      Category: 3,
      Store_name: "Mahalakshmi Collections",
      Contact_name: "Deepak Jain",
      Store_Address: "6-3-850/3/1, Srinivasa Plaza, Ameerpet.",
      Mobile_No: 9804841455,
      Landline_No: "",
      Email: "mahalakshmicollections0@gmail.com",
      Pin_Code: 500016,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "LB Nagar",
      Category: 3,
      Store_name: "SVS Stilux & Marketing",
      Contact_name: "Revan Siddu",
      Store_Address: "Opp: SBI, Chandrapuri Colony, Bahadurguda",
      Mobile_No: 9390407494,
      Landline_No: "",
      Email: "svsstiluxmarketing163@gmail.com",
      Pin_Code: 500074,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Sainikpuri",
      Category: 3,
      Store_name: "SKC Appliances & Marketing",
      Contact_name: "Chowday",
      Store_Address: "Beside Amba Furnitures, Neredmet.",
      Mobile_No: 9614250468,
      Landline_No: "",
      Email: "chowdarykgaddam@gmail.com",
      Pin_Code: 500094,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Nacharam",
      Category: 3,
      Store_name: "Geetha Gas Tech",
      Contact_name: "K. Narender Reddy",
      Store_Address: "Plot No. 137, Beside HDFC Bank, Nacharam, Hyderabad.",
      Mobile_No: 9248025225,
      Landline_No: "",
      Email: "geethagastech@gmail.com",
      Pin_Code: 500076,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Chanda Nagar",
      Category: 3,
      Store_name: "Chimney Gallery",
      Contact_name: "CH. Surender Reddy",
      Store_Address: "H. No: 4-68, Chanda Nagar, Hyderabad.",
      Mobile_No: 8712307998,
      Landline_No: "",
      Email: "surender6030.reddy@gmail.com",
      Pin_Code: 500050,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Boduppal",
      Category: 3,
      Store_name: "Chimney Studio",
      Contact_name: "Devender",
      Store_Address:
        "F No S1, Medipally, Boduppal, Pillar no. 93, Vaishnavi Towers, Hyderabad.",
      Mobile_No: 8179595911,
      Landline_No: "",
      Email: "devender3231@gmail.com",
      Pin_Code: 500039,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Warangal",
      Category: 3,
      Store_name: "Sri Bhadrakali Home Appliances",
      Contact_name: "M. Pranoop Reddy",
      Store_Address: "Ngo's Colony Road, Indira Nagar, Hanamkonda.",
      Mobile_No: 9028896755,
      Landline_No: "",
      Email: "sribhadrakalihomeappliances@gmail.com",
      Pin_Code: 506001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Siddipet",
      Category: 3,
      Store_name: "Sleek Kitchen",
      Contact_name: "A. Priyanka",
      Store_Address: "Opp: Bus Depot, Siddipet.",
      Mobile_No: 7989629142,
      Landline_No: "",
      Email: "faber.siddipet@gmail.com",
      Pin_Code: 502103,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TELANGANA",
      City: "Karimnagar",
      Category: 3,
      Store_name: "Balaji Enterprises",
      Contact_name: "Naveen",
      Store_Address: "#2-10-1086, NR Complex, JyothiNagar, Karimnagar.",
      Mobile_No: 7993103038,
      Landline_No: "",
      Email: "faberkarimnagar@gmail.com",
      Pin_Code: 505001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "Coimbatore",
      Category: 2,
      Store_name: "DECORPOINT",
      Contact_name: "vineeth",
      Store_Address:
        "161, Ponnurangam Road,East R.s. puram, Coimbatore -641002",
      Mobile_No: 9790650306,
      Landline_No: "",
      Email: "decorpoint@ymail.com",
      Pin_Code: 641002,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "Coimbatore",
      Category: 3,
      Store_name: "DEVSONS",
      Contact_name: "CIBI",
      Store_Address:
        "1990 TRICHY ROAD, OPPOSITE CENTRAL STUDIO, NEAR KRISNA COLONY, SINGANALLUR",
      Mobile_No: 9790825913,
      Landline_No: "",
      Email: "devsonss@gmail.com",
      Pin_Code: 641005,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "Coimbatore",
      Category: 3,
      Store_name: "SREE HOME SOLUTION",
      Contact_name: "VISHNU PRABHU",
      Store_Address:
        "NO-300 CHITHAMBARAM NAGAR, SARAVANAMPATTY, COIMBATORE-641035",
      Mobile_No: 9363150509,
      Landline_No: "",
      Email: "sreehomesolution@gmail.com",
      Pin_Code: 641035,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "Erode",
      Category: 3,
      Store_name: "KITCHEN SOLUTION",
      Contact_name: "Sathiyan",
      Store_Address:
        "8/1, SP COMPLEX,VCTV ROAD, SATHY ROAD,NEAR MALLIGAI ARANGAM,ERODE -638003",
      Mobile_No: 9488518080,
      Landline_No: "",
      Email: "kitchensolutions@gmail.com",
      Pin_Code: 638003,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "Tiruppur",
      Category: 3,
      Store_name: "KAILASTRADERS",
      Contact_name: "Mukesh",
      Store_Address:
        "4/193, bharathi nagar,veera pandi (po) ,palladam road,Tiruppur - 641605",
      Mobile_No: 9894134340,
      Landline_No: "",
      Email: "kailashtraderskt@gmail.com",
      Pin_Code: 641605,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "TAMIL NADU",
      City: "Tiruppur",
      Category: 3,
      Store_name: "ORCHID CHIMNEY STUDIO",
      Contact_name: "Sasikumar",
      Store_Address:
        "5/83,TIRUPUR MAIN ROAD,AVINASHI LINGAM PALYAM,TIRUPPUR-641654",
      Mobile_No: 9790352563,
      Landline_No: "",
      Email: "orchidchimneystudio@gmail.com",
      Pin_Code: 641654,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Tamil Nadu",
      City: "SALEM",
      Category: 2,
      Store_name: "PARAMOUNT INDIA ASSOCIATE",
      Contact_name: "MOHAN",
      Store_Address: "NEW FAIRLANDS , SARADHA COLLEGE ROAD, SALEM",
      Mobile_No: 7399874998,
      Landline_No: "",
      Email: "paramountindiaassociate@gmail",
      Pin_Code: 636016,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Tamil Nadu",
      City: "SALEM",
      Category: 3,
      Store_name: "LAKSHMI APPLIANCES",
      Contact_name: "SARAVANAN",
      Store_Address: "166 A TAMIL SANGAM ROAD , RAJARAM NAGAR,SALEM",
      Mobile_No: 9994999566,
      Landline_No: "",
      Email: "Ldslm007@gmail.com",
      Pin_Code: 636007,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Tamil Nadu",
      City: "NAMAKKAL",
      Category: 2,
      Store_name: "LAKSHMI APPLIANCES",
      Contact_name: "SARAVANAN",
      Store_Address:
        "200/1/175,FIRST FLOOR , SELLAMMAL COMPLEX,SALEM MAIN ROAD ,NAMAKKAL",
      Mobile_No: 9994999566,
      Landline_No: "",
      Email: "Ldslm007@gmail.com",
      Pin_Code: 637001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Anupama Home World",
      Contact_name: "Rishab Bhansali",
      Store_Address:
        "364/1,10TH ,B MAIN ROAD,3RD BLOCK JAYANAGAR,BANGALORE-560011",
      Mobile_No: 9844754448,
      Landline_No: "",
      Email: "anupamahomeworld@gmail.com",
      Pin_Code: 560011,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Neugen Marketing",
      Contact_name: "Srinivas",
      Store_Address:
        "BLDG NO:69,SHOP NO:7,AGR TOWER,NEAR ST.PETER SCHOOL,KAIKONDRAHALLI,SARJAPUR MAIN ROAD,CARMELARAM POST, BANGALORE-560035,",
      Mobile_No: 9343754127,
      Landline_No: "",
      Email: "srinivas.neugen@yahoo.com",
      Pin_Code: 560035,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Out Interiors",
      Contact_name: "Kuldeep Shetty",
      Store_Address:
        "GROUND FLOOR,NO 11,KR GARDEN,1ST MAIN,VENKATASWAMY REDDY LAYOUT,KORAMANGALA 80FT ROAD,BENGALURU-560034",
      Mobile_No: 9483541300,
      Landline_No: "",
      Email: "outinteriors@gmail.com",
      Pin_Code: 560034,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Saini World",
      Contact_name: "Devaram",
      Store_Address:
        "192/6, Marathahalli - Sarjapur Rd, opp. to Indian Petrol Pump, Dommasandra, Bengaluru, Karnataka 562125",
      Mobile_No: 7795581106,
      Landline_No: "",
      Email: "sales.sainiworld@gmail.com",
      Pin_Code: 562125,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Ideas",
      Contact_name: "Ashwini suresh",
      Store_Address:
        "117,ANAND NAGAR,SERVICE ROAD,OUTER RING ROAD,MARATHALLI,BANGALORE-560037",
      Mobile_No: 7829710280,
      Landline_No: "",
      Email: "ideasmrtl@yahoo.com",
      Pin_Code: 560037,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "CS Studio",
      Contact_name: "Srinath",
      Store_Address: "14,27TH MAIN ,SECTOR 1,HSR LAYOUT,BANGALORE-560102",
      Mobile_No: 9741123364,
      Landline_No: "",
      Email: "csstudio31@gmail.com",
      Pin_Code: 560102,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Zurich Kitchen",
      Contact_name: "Yogendra",
      Store_Address:
        "NO.12,1ST FLOOR,VISHNU PLAZA,RESERVOIR STREET,KARIYAPPA ROAD, NEAR KS RAO PARK,BASAVANGUDI,BENGALURU-560004",
      Mobile_No: 8073924379,
      Landline_No: "",
      Email: "zurichkitchen@gmail.com",
      Pin_Code: 560004,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Ideas",
      Contact_name: "Sumathi",
      Store_Address:
        "5,GROUND FLOOR,100 FEET MAIN ROAD, OPP BARBECUE NATION, HAL 2ND STAGE,INDRANAGAR,BANGALORE,560038",
      Mobile_No: 9900863033,
      Landline_No: "",
      Email: "ideasblr@yahoo.com",
      Pin_Code: 560038,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Akanksha Enterprise",
      Contact_name: "Neelakantan",
      Store_Address:
        "97/2,APOORVA COMPLEX,BANNERGHATTA ROAD,OPPOSITE D MART,OTTIGERE,BENALURU-560083",
      Mobile_No: 7619180428,
      Landline_No: "",
      Email: "akansha2021enterpireses@gmail.com",
      Pin_Code: 560083,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Manoj Enterprises",
      Contact_name: "Thandavesh",
      Store_Address:
        "13, TEACHERS COLONY,NAGARBHAVI MAIN ROAD, NAGARBHAVI,BANGALORE-560072",
      Mobile_No: 9980023706,
      Landline_No: "",
      Email: "manojsf31@gmail.com",
      Pin_Code: 560072,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sampurna International",
      Contact_name: "Mahesh",
      Store_Address:
        "NO:773/1,1ST FLOOR, ABOVE SONY STORE, OPP RMZ MALL, YELANKHA , BANGALORE - 560064",
      Mobile_No: 9964868759,
      Landline_No: "",
      Email: "sampurnamani9@gmail.com",
      Pin_Code: 560064,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sachin Light House",
      Contact_name: "Divij",
      Store_Address:
        "1425/497,4TH BLOCK,HRBR LAYOUT,SERVICE ROAD,OUTER RING ROAD,HENNUR, BENGALURU-560043",
      Mobile_No: 8904704006,
      Landline_No: "",
      Email: "divij@sachinlighthouse.com",
      Pin_Code: 560043,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sampurna International",
      Contact_name: "Mahesh",
      Store_Address:
        "695,5TH MAIN, BANASWADI OUTER RING ROAD, RAMAMURTHY NAGAR CIRCLE, BANGALORE-560043",
      Mobile_No: 9964868759,
      Landline_No: "",
      Email: "sampurnamani9@gmail.com",
      Pin_Code: 560043,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Vedh Interior",
      Contact_name: "Chinnappa",
      Store_Address: "74,BELLARY MAIN ROAD,GANGANAGAR,BNEGALURU - 560024",
      Mobile_No: 9380525134,
      Landline_No: "",
      Email: "Vedhinterior8505@gmail.com",
      Pin_Code: 560024,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Mysore",
      Category: 2,
      Store_name: "Sumukha Electronics & Appliances",
      Contact_name: "Somashekar",
      Store_Address:
        "280/1,KRH MAIN ROAD,KT STREET, MANDI MOHALLA, BESIDE GANAPATHI TEMPLE,MYSORE-570001",
      Mobile_No: 9448075598,
      Landline_No: "",
      Email: "sumukhaelectronicandapp@gmail.com",
      Pin_Code: 570001,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sterling Incorporators",
      Contact_name: "Dinesh Sharma",
      Store_Address:
        "596/601,ground floor Dr.rajkumar road opposite federal bank rajajajinagar, near navrang kabab corner, Prakash Nagar signal, Bengaluru- 560010",
      Mobile_No: 9880067829,
      Landline_No: "",
      Email: "sterlingblr10@gmail.com",
      Pin_Code: 560010,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Mandya",
      Category: 2,
      Store_name: "Sumukha Electronics & Appliances",
      Contact_name: "Somashekar",
      Store_Address: "100ft Road,Ashok Nagar,Opp Indian Oil Petrol Bunk,Mandya",
      Mobile_No: 9448075598,
      Landline_No: "",
      Email: "sumukhaelectronicandapp@gmail.com",
      Pin_Code: 571401,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "OakVille",
      Contact_name: "Jyoti",
      Store_Address:
        "1st Floor,No>34/2,Site No.19/20/21,CN Complex,Dr.Vishnuvardhan Road,Channasandra, RR Nagar,Bangalore",
      Mobile_No: 8867760602,
      Landline_No: "",
      Email: "tsjyothi26@gmail.com",
      Pin_Code: 560098,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 2,
      Store_name: "Sumukha Enterprises",
      Contact_name: "Nagesh",
      Store_Address: "# 185 Doddakllasnadra ,kanankpaura Road, Bangalore",
      Mobile_No: 9353788425,
      Landline_No: "",
      Email: "sumukhaent85@gmail.com",
      Pin_Code: 560062,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "New Kitchen Zone",
      Contact_name: "Ravi Reddy",
      Store_Address:
        "55/8,shop no:1,1st floor,Gurumurthy Reddy Compound,Kudlu Gate,Pillar No:68,Opp to Trident Hyundai,Hosur Main Road, Bangalore",
      Mobile_No: 9845533929,
      Landline_No: "",
      Email: "ravireddyfaber@gmail.com",
      Pin_Code: 560058,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Whitefield Associates",
      Contact_name: "Binnish",
      Store_Address:
        "S-07,Ground Floor,Raheja Arcade,Near Forum Mall,Koramangala,Bangalore",
      Mobile_No: 9945773654,
      Landline_No: "",
      Email: "faberbangalore@gmail.com",
      Pin_Code: 560095,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Gowtham Enterprises",
      Contact_name: "Satish Gowtham",
      Store_Address:
        "Shop No:7,Ground Floor,Puttadas Commercial Complex,No:42,(old No:825),13th Cross Road,WKP Road, 7th Block ,Jayanagar,Bangalore",
      Mobile_No: 7483468062,
      Landline_No: "",
      Email: "gowthamenterprises21@gmail.com",
      Pin_Code: 560070,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Sai Sumukha Enterprises",
      Contact_name: "Uma",
      Store_Address:
        "483,shop no G6 & G7, Swetha Mansion,5th Cross sampige Road, Malleshwaram Bangalore",
      Mobile_No: 9663174714,
      Landline_No: "",
      Email: "saisumukhaenterprises@gmail.com",
      Pin_Code: 560003,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Designify Studio",
      Contact_name: "Kuldeep Shetty",
      Store_Address: "No:268,Chennappa, Anchepalya,Kengeri Hobli,Bangalore",
      Mobile_No: 9483541300,
      Landline_No: "",
      Email: "designifystudio2022@gmail.com",
      Pin_Code: 560074,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Ramanagara",
      Category: 3,
      Store_name: "N.N. Enterprises",
      Contact_name: "Naveen",
      Store_Address: "URS COMPLEX,BM ROAD,OPP HP PETROL BUND,RAMANAGAR",
      Mobile_No: 8197666665,
      Landline_No: "",
      Email: "naveenkumarairtel@yahoo.com",
      Pin_Code: 562159,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bijapur",
      Category: 3,
      Store_name: "Raj Digitals",
      Contact_name: "Burhan",
      Store_Address: "Ling Road,beside Ananya Hospital,Bijapur",
      Mobile_No: 9060117645,
      Landline_No: "",
      Email: "rajelectronics_bijapur@rediffmail.com",
      Pin_Code: 586101,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Shri Varshini Enterprises",
      Contact_name: "Murali Kumar",
      Store_Address:
        "No.186/9,Renuka Complex,Muthanallur Cross,Marathalli-Sarjapur Road, Near Bharat Petrol Bund,Bangalore",
      Mobile_No: 9445515970,
      Landline_No: "",
      Email: "successsolarhosur@gmail.com",
      Pin_Code: 562125,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Venus Kitchen World",
      Contact_name: "Praveen",
      Store_Address:
        "79/1,1st floor, New BEL road, Opp Ramiah Hospital,Bangalore",
      Mobile_No: 9986055566,
      Landline_No: "",
      Email: "venuskitchenworld.dakshayini@gmail.com",
      Pin_Code: 560094,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "KVR Enterprises",
      Contact_name: "Nachappa",
      Store_Address:
        "No.273, International Airport Road, BYATARAYANAPURA, BANGALORE-",
      Mobile_No: 9449446728,
      Landline_No: "",
      Email: "ib.nachappa@gmail.com",
      Pin_Code: 560092,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Maruthi & Sons",
      Contact_name: "Kumar",
      Store_Address:
        "#186/1,Sri Banashankari Complex, Bettadasnapura Main road, Chamundi Phase 2, E.City Phase -1, Bangalore",
      Mobile_No: 97319519395,
      Landline_No: "",
      Email: "maruthisons365@gmail.com",
      Pin_Code: 560100,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Shimogga",
      Category: 3,
      Store_name: "RMJ Associates",
      Contact_name: "Zabeer",
      Store_Address:
        "01, 1st Floor, Berlynoak Beside St. Joseph Forance Church, Sagar Road, Shimogga.",
      Mobile_No: 9844814303,
      Landline_No: "",
      Email: "rmjassociate@gmail.com",
      Pin_Code: 577204,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Tumkur",
      Category: 3,
      Store_name: "KITCHEN SOLUTIONS",
      Contact_name: "Bindu",
      Store_Address: "shivashree, mahalakshmi nagar, Batwadi",
      Mobile_No: 9900159293,
      Landline_No: "",
      Email: "kitchensolution20@gmail.com",
      Pin_Code: 572103,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Chikmanglur",
      Category: 3,
      Store_name: "SHOBHA ENTERPRISES",
      Contact_name: "Manu",
      Store_Address:
        "Beside Sharada Pai Kalynamantapa,Basavanahalli Main Road,Shop No: 3,Chikkamagaluru",
      Mobile_No: 9738126617,
      Landline_No: "",
      Email: "shobhaenterprisesckm@gmail.com",
      Pin_Code: 577101,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Ideas Banshankari",
      Contact_name: "Syed",
      Store_Address:
        "204,1st floor, 100 feet ring road,2nd block, Banshankari 3d stage, Bangalore -",
      Mobile_No: 9986088573,
      Landline_No: "",
      Email: "ajayparab@hotmail.com",
      Pin_Code: 560085,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Deepam Trading Company",
      Contact_name: "Vishwanath",
      Store_Address:
        "No:162,6th Cross,MEI Layout,Next to Century Mart,Hessaraghatta Main Road,Bangalore",
      Mobile_No: 9590530616,
      Landline_No: "",
      Email: "deepamtradingcompany@yahoo.com",
      Pin_Code: 560073,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Karnataka",
      City: "Bangalore",
      Category: 3,
      Store_name: "Sampurna International",
      Contact_name: "Mahesh",
      Store_Address:
        "No 4, Butterahalli, Medahalli, opp udupi Guarden, Shanthiniketan Extension, Near sjss college, Hoskote road, Bangalore",
      Mobile_No: 9964868759,
      Landline_No: "",
      Email: "sampurnamani9@gmail.com",
      Pin_Code: 560049,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Kerala",
      City: "Trivandrum",
      Category: 2,
      Store_name: "Mehnaz Associates",
      Contact_name: "Yasar Nazeer",
      Store_Address:
        "TC 15/4250 TC 15/4251,GROUND & FIRST FLOOR , BHASKAR BUILDING, BHASKAR LANE,NR ST MARYS CHURCH,PATTOM,TRIVANDRUM-695004",
      Mobile_No: 7994323399,
      Landline_No: "",
      Email: "manager.pattom@bscpl,in",
      Pin_Code: 695004,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Kerala",
      City: "Cochin",
      Category: 2,
      Store_name: "FORHOME",
      Contact_name: "Arfan Sait R",
      Store_Address:
        "51/28C, Salafi Masjid Complex,Near Vyttila junction, NH bye pass, Vyttila, Cochin",
      Mobile_No: 8848019957,
      Landline_No: "",
      Email: "faberplatinum@forhome.in",
      Pin_Code: 682019,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
    {
      id: "",
      Area: "South",
      States: "Kerala",
      City: "Idukki",
      Category: 2,
      Store_name: "BEST SELLERS COCHIN (P) LIMITED",
      Contact_name: "",
      Store_Address: "5/545A, Vengalloor PO, Thodupuzha",
      Mobile_No: 9207635122,
      Landline_No: "",
      Email: "sales.thodupuzha@faberplatinum.com",
      Pin_Code: 685608,
      DT: "",
      Active: "",
      Latitude: "",
      Longitude: "",
    },
  ];
////////////////////////////////////
     let url = window.location.href.toLocaleLowerCase();
  let state;
  let cards = document.querySelector(".cards");
  let cardArray = [];
  const getState = () => {
    state = url.substr(url.indexOf("state=") + "state=".length);
    console.log(state);
  };
  const getData = () => {
    for (let dt of json_) {
      let dtState = dt.States.replaceAll(" ", "-").toLowerCase();
      if (dtState == state) {
        cardArray.push(dt);
      }
    }
  };
  function displayCards() {
    $(".cards_blocks")[0].innerHTML = "";
    $(cardArray).each(function (ind, el) {
      let store_name = el.Store_name != null ? el.Store_name : "";
      let contact_name = el.Contact_name != null ? el.Contact_name : "";
      let address = el.Store_Address != null ? el.Store_Address : "";
      let phone = el.Mobile_No != null ? el.Mobile_No : "";
      let email = el.Email != null ? el.Email : "";
      let html = `<div class="cards_block col-md-4 col-xs-12">
          <p class="store_name"><strong>${store_name}</strong></p>
          <p class="contact_name">${contact_name}</p>
          <p class="address_">${address}</p>
          <p class="phone_number">Phone No.:${phone}</p>
          <p class="email_">E-Mail:${email}</p>
          </div>`;
      $(".cards_blocks")[0].insertAdjacentHTML("beforeend", html);
    });
  }
  getState();
  getData();
displayCards()